
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kPKkS", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<d1ad3f7b76ca5ffb0b2543b94c3a689d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bbe8efded3428efa$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "EndOfPageRecommendation_spaceStatus",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "recommendedPagesEnabled"
        },
        {
            "kind": "ScalarField",
            "name": "defaultBehavior"
        }
    ],
    "type": "RecommendedPagesSpaceStatus"
};
$bbe8efded3428efa$var$node.hash = "e2dc5b6313f03efeee343a0956606000";
var $bbe8efded3428efa$export$2e2bcd8739ae039 = $bbe8efded3428efa$var$node;


/**
 * @generated SignedSource<<8ad60c8b68d1ff3abe4ecaae10f36cc6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cbad05d852d0acd8$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "key"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "EndOfPageRecommendation_recommendedPages",
        "selections": [
            {
                "concreteType": "RecommendedPagesItem",
                "kind": "LinkedField",
                "name": "recommendedPages",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "Content",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "title"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "type"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "subType"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "creatorId"
                            },
                            {
                                "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                "kind": "LinkedField",
                                "name": "links",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "webui"
                                    }
                                ]
                            },
                            {
                                "concreteType": "History",
                                "kind": "LinkedField",
                                "name": "history",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "ownedBy",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "displayName"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "concreteType": "Space",
                                "kind": "LinkedField",
                                "name": "space",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    }
                                ]
                            },
                            {
                                "alias": "emoji",
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "key",
                                        "value": "emoji-title-published"
                                    }
                                ],
                                "concreteType": "PaginatedJsonContentPropertyList",
                                "kind": "LinkedField",
                                "name": "properties",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JsonContentProperty",
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "value"
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "properties(key:\"emoji-title-published\")"
                            }
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "strategy"
                    }
                ]
            }
        ],
        "type": "RecommendedPages"
    };
}();
$cbad05d852d0acd8$var$node.hash = "841aea27c92c5de2d816297d86d5ab50";
var $cbad05d852d0acd8$export$2e2bcd8739ae039 = $cbad05d852d0acd8$var$node;



var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $b8pma = parcelRequire("b8pma");


var $jtuBN = parcelRequire("jtuBN");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7boqA = parcelRequire("7boqA");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $4PPzL = parcelRequire("4PPzL");


var $6mKj3 = parcelRequire("6mKj3");


var $4bm59 = parcelRequire("4bm59");


var $luv00 = parcelRequire("luv00");


var $isEtk = parcelRequire("isEtk");


var $5Abqh = parcelRequire("5Abqh");


var $3dOiI = parcelRequire("3dOiI");


var $2HQyh = parcelRequire("2HQyh");


var $8dbvt = parcelRequire("8dbvt");

/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $6627c994dbd6ecf6$export$5e3c7f13be5cbe17 = /*#__PURE__*/ function(RecommendedPagesSpaceBehavior) {
    RecommendedPagesSpaceBehavior["HIDDEN"] = "HIDDEN";
    RecommendedPagesSpaceBehavior["SHOWN"] = "SHOWN";
    return RecommendedPagesSpaceBehavior;
}({});



var $ihn35 = parcelRequire("ihn35");


var $dOvHJ = parcelRequire("dOvHJ");

const $b7fe165a47ee5163$export$9729e4323fbe4860 = (0, $cbad05d852d0acd8$export$2e2bcd8739ae039);
const $b7fe165a47ee5163$export$35596ba2d6b93752 = (0, $bbe8efded3428efa$export$2e2bcd8739ae039);
const $b7fe165a47ee5163$var$endOfPageRecWrapperStyles = null;
const $b7fe165a47ee5163$var$EndOfPageRecommendation = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(40);
    const { entityType: entityType, entityId: entityId, pageWidthType: pageWidthType, spaceKey: spaceKey, isLivePage: t1 } = t0;
    const isLivePage = t1 === undefined ? false : t1;
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const [state] = (0, $isEtk.useContentState)();
    const skip = entityType !== "page" && entityType !== "blogpost";
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $6mKj3.expVal)("cc_ai_discovery_linked_pages_on_related_pages", "experience", "end_of_page_v5");
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== entityId || $[2] !== entityType || $[3] !== spaceKey) {
        t3 = {
            type: entityType,
            id: entityId,
            exp: t2,
            key: spaceKey,
            keyString: spaceKey
        };
        $[1] = entityId;
        $[2] = entityType;
        $[3] = spaceKey;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            single: true
        };
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== skip || $[7] !== t3) {
        t5 = {
            variables: t3,
            context: t4,
            errorPolicy: "all",
            skip: skip
        };
        $[6] = skip;
        $[7] = t3;
        $[8] = t5;
    } else t5 = $[8];
    const baseQueryOptions = t5;
    const { error: error, loading: loading, data: data } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $2HQyh.default), {
        ...baseQueryOptions,
        __callerPackage__: "page-recommendations"
    });
    const { state: promptState } = (0, $4bm59.useThirdPartyPromptState)(entityId);
    const isGridLoading = loading || promptState.kind === "pending";
    const t6 = data?.getRecommendedPages?.recommendedPages;
    let t7;
    if ($[9] !== t6) {
        t7 = (0, $8dbvt.transformAndOrderRecs)(t6);
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    const pageCardData = t7;
    const isEnabled = data?.getRecommendedPagesSpaceStatus?.recommendedPagesEnabled && data?.getRecommendedPagesSpaceStatus?.defaultBehavior === (0, $6627c994dbd6ecf6$export$5e3c7f13be5cbe17).SHOWN;
    let t8;
    let t9;
    if ($[11] !== experienceTracker || $[12] !== isEnabled) {
        t8 = ()=>{
            if (isEnabled) experienceTracker.start({
                name: (0, $irVI7.EOP_RECS_EXPERIENCE)
            });
        };
        t9 = [
            experienceTracker,
            isEnabled
        ];
        $[11] = experienceTracker;
        $[12] = isEnabled;
        $[13] = t8;
        $[14] = t9;
    } else {
        t8 = $[13];
        t9 = $[14];
    }
    (0, $cozmU.useEffect)(t8, t9);
    let t10;
    let t11;
    if ($[15] !== error || $[16] !== experienceTracker || $[17] !== isEnabled || $[18] !== loading) {
        t10 = ()=>{
            if (isEnabled && !loading) {
                if (error) experienceTracker.stopOnError({
                    name: (0, $irVI7.EOP_RECS_EXPERIENCE),
                    error: error
                });
                else experienceTracker.succeed({
                    name: (0, $irVI7.EOP_RECS_EXPERIENCE)
                });
            }
        };
        t11 = [
            experienceTracker,
            isEnabled,
            loading,
            error
        ];
        $[15] = error;
        $[16] = experienceTracker;
        $[17] = isEnabled;
        $[18] = loading;
        $[19] = t10;
        $[20] = t11;
    } else {
        t10 = $[19];
        t11 = $[20];
    }
    (0, $cozmU.useEffect)(t10, t11);
    if (error) {
        let t12;
        if ($[21] !== error) {
            t12 = (0, $1uFM6.isUnauthorizedError)(error) ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
            $[21] = error;
            $[22] = t12;
        } else t12 = $[22];
        return t12;
    }
    if (skip || !pageCardData || pageCardData.length < 2 || !isEnabled) {
        let t12;
        if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Abqh.SetSSRPartialSuccess), {
                name: (0, $5Abqh.SSR_PARTIAL_COMPONENT).EndOfPageRecommendation
            });
            $[23] = t12;
        } else t12 = $[23];
        return t12;
    }
    const isContentReady = Boolean(undefined) || window.__SSR_RENDERED__ || state.isContentReady || isLivePage;
    const t12 = isLivePage && "_313842yFLW";
    let t13;
    if ($[24] !== t12) {
        t13 = (0, $hekY6.default)([
            t12,
            "end-of-page-rec-wrapper"
        ]);
        $[24] = t12;
        $[25] = t13;
    } else t13 = $[25];
    let t14;
    if ($[26] !== data || $[27] !== entityId || $[28] !== entityType || $[29] !== isContentReady || $[30] !== isEnabled || $[31] !== isGridLoading || $[32] !== isLivePage || $[33] !== pageCardData || $[34] !== pageWidthType) {
        t14 = isEnabled && isContentReady && (isGridLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "EndOfPageRecommendation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihn35.EndOfPageRecPlaceholderContainer), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            key: entityId,
            metric: (0, $3dOiI.END_OF_PAGE_RECOMMENDATIONS_METRIC),
            isCustomStart: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOvHJ.EndOfPageRecommendationComponent), {
            entityId: entityId,
            entityType: entityType,
            pageCardData: pageCardData,
            data: data,
            pageWidthType: pageWidthType,
            isLivePage: isLivePage
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Abqh.SetSSRPartialSuccess), {
            name: (0, $5Abqh.SSR_PARTIAL_COMPONENT).EndOfPageRecommendation
        })));
        $[26] = data;
        $[27] = entityId;
        $[28] = entityType;
        $[29] = isContentReady;
        $[30] = isEnabled;
        $[31] = isGridLoading;
        $[32] = isLivePage;
        $[33] = pageCardData;
        $[34] = pageWidthType;
        $[35] = t14;
    } else t14 = $[35];
    let t15;
    if ($[36] !== ssrPlaceholderIdProp || $[37] !== t13 || $[38] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t13,
            "data-testid": "end-page-rec-wrapper",
            "data-vc": "end-of-page-recommendation",
            ...ssrPlaceholderIdProp
        }, t14);
        $[36] = ssrPlaceholderIdProp;
        $[37] = t13;
        $[38] = t14;
        $[39] = t15;
    } else t15 = $[39];
    return t15;
});
const $b7fe165a47ee5163$export$bf75a220d4f45be1 = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).SMARTS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7fe165a47ee5163$var$EndOfPageRecommendation, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
module.exports["EndOfPageRecommendationRecommendedPagesFragment"] = $b7fe165a47ee5163$export$9729e4323fbe4860;
module.exports["EndOfPageRecommendationSpaceStatusFragment"] = $b7fe165a47ee5163$export$35596ba2d6b93752;
module.exports["EndOfPageRecommendation"] = $b7fe165a47ee5163$export$bf75a220d4f45be1;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $bDgLe.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("2HQyh", function(module, exports) {
/**
 * @generated SignedSource<<3ccde3616734a111f53da6e5e1f8991e>>
 * @relayHash ab13c035f40ba0298bd82a325ff2c401
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e58f63c20fdf70f91a40059b6e32935f05ca4978a7c84ffed3e0dfca58f47c41
const $5b8dbd4fd00aa380$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "exp"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "key"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "keyString"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "keyString"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ 
        ]
    }, v7 = [
        {
            "kind": "Variable",
            "name": "entityId",
            "variableName": "id"
        },
        {
            "kind": "Variable",
            "name": "entityType",
            "variableName": "type"
        },
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "exp"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v11 = {
        "kind": "ScalarField",
        "name": "creatorId"
    }, v12 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v16 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    v14 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v17 = {
        "kind": "ScalarField",
        "name": "strategy"
    }, v18 = {
        "args": [
            {
                "kind": "Variable",
                "name": "entityId",
                "variableName": "key"
            }
        ],
        "concreteType": "RecommendedPagesSpaceStatus",
        "kind": "LinkedField",
        "name": "getRecommendedPagesSpaceStatus",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "recommendedPagesEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "defaultBehavior"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EndOfPageRecommendationQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "RecommendedPages",
                    "kind": "LinkedField",
                    "name": "getRecommendedPages",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "RecommendedPagesItem",
                            "kind": "LinkedField",
                            "name": "recommendedPages",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        }
                    ]
                },
                v18 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EndOfPageRecommendationQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "RecommendedPages",
                    "kind": "LinkedField",
                    "name": "getRecommendedPages",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "RecommendedPagesItem",
                            "kind": "LinkedField",
                            "name": "recommendedPages",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        }
                    ]
                },
                v18 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "ab13c035f40ba0298bd82a325ff2c401",
            "id": "e58f63c20fdf70f91a40059b6e32935f05ca4978a7c84ffed3e0dfca58f47c41",
            "metadata": {},
            "name": "EndOfPageRecommendationQuery",
            "operationKind": "query",
            "text": "query EndOfPageRecommendationQuery($type:String!,$id:ID!,$exp:String!,$key:ID!,$keyString:String!){space(key:$keyString){id},getRecommendedPages(entityType:$type,entityId:$id,experience:$exp){recommendedPages{content{id,title,type,subType,creatorId,links{webui},history{ownedBy{__typename,displayName}},space{id,key,name},emoji:properties(key:\"emoji-title-published\"){nodes{id,key,value}}},strategy}},getRecommendedPagesSpaceStatus(entityId:$key){recommendedPagesEnabled,defaultBehavior}}"
        }
    };
}();
$5b8dbd4fd00aa380$var$node.hash = "e939560761a450cc2ece30ee9466334e";
var $5b8dbd4fd00aa380$export$2e2bcd8739ae039 = $5b8dbd4fd00aa380$var$node;
module.exports["default"] = $5b8dbd4fd00aa380$export$2e2bcd8739ae039;

});

parcelRegister("8dbvt", function(module, exports) {

var $cxMI6 = parcelRequire("cxMI6");

const $d8f8e39152f0bc27$export$19f6fc45ac74736 = (data, strategiesCounter)=>{
    const pageCardData = (0, $cxMI6.transformGlobalContent)(data.content);
    pageCardData.likesCount = 0;
    pageCardData.commentsCount = 0;
    pageCardData.recommendationStrategy = $d8f8e39152f0bc27$export$7c50bf2d337b5c51(data, strategiesCounter);
    return pageCardData;
};
const $d8f8e39152f0bc27$export$7c50bf2d337b5c51 = (data, strategiesCounter)=>{
    const strategies = data.strategy;
    if (strategies.includes('CONTENT_TO_CONTENT')) return 'CONTENT_TO_CONTENT';
    const currentCounter = new Map();
    strategies.forEach((entry)=>{
        const entryCount = strategiesCounter.get(entry) || 0;
        currentCounter.set(entry, entryCount);
    });
    const sortedCounter = new Map([
        ...currentCounter.entries()
    ].sort((a, b)=>a[1] - b[1]));
    const strategy = [
        ...sortedCounter.keys()
    ][0];
    const count = strategiesCounter.get(strategy) || 0;
    strategiesCounter.set(strategy, count + 1);
    return strategy;
};
const $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7 = (recs)=>{
    if (!recs) return;
    const strategiesCounter = new Map();
    const recsSortedByStrategyCount = [
        ...recs
    ].sort((a, b)=>a.strategy.length > b.strategy.length ? 1 : -1);
    const transformedRecs = recsSortedByStrategyCount.map((rec)=>$d8f8e39152f0bc27$export$19f6fc45ac74736(rec, strategiesCounter));
    // return to initial order
    const pageCards = new Array();
    recs.forEach((rec)=>{
        const contentId = rec?.content?.id;
        if (!contentId) return;
        const el = transformedRecs.find((card)=>card?.id === contentId);
        if (el) pageCards.push(el);
    });
    return pageCards;
};
module.exports["transformEndOfPageRecContent"] = $d8f8e39152f0bc27$export$19f6fc45ac74736;
module.exports["transformAndOrderRecs"] = $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7;

});

parcelRegister("cxMI6", function(module, exports) {

var $brn6e = parcelRequire("brn6e");


var $8rneB = parcelRequire("8rneB");


var $huWyw = parcelRequire("huWyw");


var $c7GB4 = parcelRequire("c7GB4");

const $c6273926c8df4325$var$ALL_CONTENT_TYPE = [
    'page',
    'blogpost',
    'whiteboard',
    'database',
    'embed',
    'folder',
    'slide'
];
const $c6273926c8df4325$var$resumeDraftWebUiBypass = (urlPath, content)=>{
    const bypassUrl = (0, $huWyw.getURLBypassingResumeDraftAction)({
        url: urlPath || '',
        spaceKey: content?.space?.alias || content?.space?.key || '',
        contentType: content?.type,
        editorVersion: content?.editorVersion?.nodes?.[0]?.value?.replace(/['"]+/g, ''),
        contentId: content?.id || '',
        noContextPath: true
    });
    return bypassUrl;
};
const $c6273926c8df4325$export$a0bd4958aceee288 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent)=>{
    const EMOJI_CONTENT_TYPE = isWhiteboardEmojiFGEnabled ? [
        'page',
        'blogpost',
        'embed',
        'whiteboard',
        'slide'
    ] : [
        'page',
        'blogpost',
        'embed'
    ];
    const contentType = $c6273926c8df4325$var$ALL_CONTENT_TYPE.includes(content?.type) ? content.type : 'page';
    if (isActivityV3HomeRecent) return {
        id: (0, $c7GB4.getIdFromConfluenceContentAri)({
            ari: content?.id,
            resourceType: contentType
        }) || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, content?.metadata?.titleEmojiPublished?.value || '', content?.metadata?.titleEmojiDraft?.value || '', content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subtype,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editUi, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webUi, content)
        },
        isStarred: content?.viewer?.favoritedSummary?.isFavorite || false,
        likesCount: content?.likesSummary?.count || 0,
        commentsCount: content?.commentCountSummary?.total || 0,
        excerpt: content?.body?.excerpt?.trim()
    };
    return {
        id: content?.id || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, (0, $8rneB.getEmojiPublishedFromProperties)(content), (0, $8rneB.getEmojiDraftFromProperties)(content), content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subType,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editui, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webui, content)
        },
        isStarred: content?.metadata?.currentuser?.favourited?.isFavourite || false,
        likesCount: content?.likes?.count || 0,
        commentsCount: content?.metadata?.comments?.commentsCount || 0,
        excerpt: content?.excerpt?.trim(),
        lastAction: {
            when: content?.metadata?.lastModifiedDate || '',
            action: 'updated'
        }
    };
};
const $c6273926c8df4325$export$898674fde3fd0597 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent = false)=>{
    const spaceAlias = content?.space?.alias || content?.space?.key;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent),
        space: {
            spaceKey: spaceAlias || '',
            name: content?.space?.name || ''
        },
        creatorId: content?.creatorId || '',
        history: {
            ownedBy: {
                displayName: content?.history?.ownedBy?.displayName || ''
            }
        }
    };
};
const $c6273926c8df4325$export$1e1d4cb60561af2b = (content, untitledDraftText = '', isWhiteboardEmojiFGEnabled = false)=>{
    const createdBy = content?.status === 'draft' ? content?.version?.by : content?.history?.createdBy;
    const ownedBy = content?.status === 'draft' ? content?.version?.by : content?.history?.ownedBy;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled),
        createdBy: {
            displayName: createdBy?.displayName || '',
            profilePicture: createdBy?.profilePicture?.path || '',
            accountId: createdBy?.accountId || ''
        },
        ownedBy: {
            displayName: ownedBy?.displayName || '',
            profilePicture: ownedBy?.profilePicture?.path || '',
            accountId: ownedBy?.accountId || ''
        }
    };
};
const $c6273926c8df4325$export$ee67d5d6f48183b0 = (card)=>Boolean(card.createdBy);
module.exports["transformGlobalContent"] = $c6273926c8df4325$export$898674fde3fd0597;
module.exports["transformSpaceContent"] = $c6273926c8df4325$export$1e1d4cb60561af2b;
module.exports["isSpacePageCard"] = $c6273926c8df4325$export$ee67d5d6f48183b0;

});

parcelRegister("brn6e", function(module, exports) {

var $g6QPm = parcelRequire("g6QPm");


var $7PLO8 = parcelRequire("7PLO8");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $6mKj3 = parcelRequire("6mKj3");


var $3shHM = parcelRequire("3shHM");


var $8rneB = parcelRequire("8rneB");


var $5DJsZ = parcelRequire("5DJsZ");


var $5amrO = parcelRequire("5amrO");

const $a7a7184e7345058e$export$8807f1cb55bf77de = async ({ userId: userId, cloudId: cloudId, emojiId: emojiId })=>{
    const provider = await (0, $8rneB.getEmojiProvider)(cloudId, userId);
    if (provider) {
        const emoji = await provider.findById(emojiId);
        if (emoji) return provider.loadMediaEmoji(emoji);
    }
    return Promise.resolve(null);
};
const $a7a7184e7345058e$export$66e71aac8865f81a = /([a-z\d_-]+):/;
let $a7a7184e7345058e$var$hasSetFavicon = false;
let $a7a7184e7345058e$var$previousFavicon = null;
const $a7a7184e7345058e$var$updateFaviconHref = (href)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const favIcons = document.querySelectorAll("link[rel~='icon']");
    favIcons.forEach((linkEl)=>{
        // remember default favicon on first change in case we need to revert
        if (!$a7a7184e7345058e$var$hasSetFavicon) {
            $a7a7184e7345058e$var$previousFavicon = linkEl.href;
            $a7a7184e7345058e$var$hasSetFavicon = true;
        }
        linkEl.href = href;
    });
};
const $a7a7184e7345058e$export$4bb2c221b7e4cc0 = (emoji)=>{
    if (!(0, $6mKj3.isExperimentEnabled)('confluence_expt_emoji_title_favicon')) return;
    if (!emoji) {
        if ($a7a7184e7345058e$var$hasSetFavicon && $a7a7184e7345058e$var$previousFavicon) $a7a7184e7345058e$var$updateFaviconHref($a7a7184e7345058e$var$previousFavicon);
        return;
    }
    $a7a7184e7345058e$var$updateFaviconHref(emoji);
};
const $a7a7184e7345058e$export$ea48fb6f63107646 = async ({ selectedEmoji: selectedEmoji, emojiProvider: emojiProvider, onUpdateStartEmoji: onUpdateStartEmoji, createAnalyticsEvent: createAnalyticsEvent, emojiTitleState: emojiTitleState, onEmojiUpdated: onEmojiUpdated, onUpdateEndEmoji: onUpdateEndEmoji, updateContentProperty: updateContentProperty, contentId: contentId, componentName: componentName, isLivePage: isLivePage, emojiStatusFieldName: emojiStatusFieldName, aiSuggestedEmojiId: aiSuggestedEmojiId, isSmartCreate: isSmartCreate, hasReplacedAIFCEmoji: hasReplacedAIFCEmoji, setHasReplacedAIFCEmoji: setHasReplacedAIFCEmoji, aiEmojiSuggestionSource: aiEmojiSuggestionSource }, _event)=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    // Snapshot before overwrite to detect if the AIFC-suggested emoji was replaced.
    const previouslySelectedEmoji = emojiTitleState.state.selectedEmoji;
    const previouslySelectedEmojiId = typeof previouslySelectedEmoji === 'string' ? previouslySelectedEmoji : previouslySelectedEmoji?.id;
    const replacedAIFCSuggestedEmoji = !hasReplacedAIFCEmoji && !!isSmartCreate && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedAIFCSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    const replacedBlankPageAutoSuggestedEmoji = !hasReplacedAIFCEmoji && aiEmojiSuggestionSource === 'pasteAutoTitle' && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedBlankPageAutoSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    const replacedSuggestTitleSuggestedEmoji = !hasReplacedAIFCEmoji && aiEmojiSuggestionSource === 'suggestTitle' && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedSuggestTitleSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    // Snapshot the shared flag at fire time so the value reflects the latest
    // state regardless of when/where the picker JSX was created.
    const justRestoredEmoji = !!emojiTitleState.justRestoredEmoji;
    (0, $3shHM.sendAnalyticsEvent)(createAnalyticsEvent, {
        eventType: 'sendUIEvent',
        element: 'button',
        action: 'clicked',
        actionSubject: 'emojiPicker',
        actionSubjectId: 'emoji',
        attributes: {
            emojiId: selectedEmoji?.id,
            inputMethod: 'title',
            isLivePage: isLivePage,
            replacedAIFCSuggestedEmoji: replacedAIFCSuggestedEmoji,
            replacedBlankPageAutoSuggestedEmoji: replacedBlankPageAutoSuggestedEmoji,
            replacedSuggestTitleSuggestedEmoji: replacedSuggestTitleSuggestedEmoji,
            aiEmojiSuggestionSource: aiEmojiSuggestionSource,
            isRestoreLatestEmojiEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji'),
            replacedRestoredEmoji: justRestoredEmoji
        }
    });
    // Reset after firing so the next selection correctly reports
    // replacedRestoredEmoji=false.
    emojiTitleState.justRestoredEmoji = false;
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    const loadedEmoji = await emojiProvider.loadMediaEmoji(selectedEmoji, true);
    emojiTitleState.setOpenSecondEmojiPicker(false);
    emojiTitleState.setSelectedEmoji(loadedEmoji);
    return onEmojiUpdated().then(({ data: data })=>{
        const versionNumber = (0, $8rneB.getVersionNumber)(data, emojiStatusFieldName);
        const newVersionNumber = versionNumber ? versionNumber + 1 : 1;
        const emojiValue = selectedEmoji?.id?.replace(/['"]+/g, '') ?? '';
        return updateContentProperty({
            propertyKey: propertyKey,
            propertyValue: emojiValue,
            hasExistingProperty: versionNumber > 0,
            options: {
                update: ()=>{
                    try {
                        const cacheData = (0, $l1uFv.readQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: (0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true) ? {
                                ...(0, $g6QPm.createEditorContentUnifiedQueryVariables)({
                                    contentId: contentId,
                                    draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                                }),
                                skipPublishedFragment: true
                            } : {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)(),
                                skipPublishedFragment: true
                            },
                            __callerPackage__: "emoji-title"
                        });
                        if (cacheData.content.nodes[0][emojiStatusFieldName]) cacheData.content.nodes[0][emojiStatusFieldName].nodes[0] = {
                            ...cacheData.content.nodes[0][emojiStatusFieldName].nodes[0],
                            id: contentId,
                            key: propertyKey,
                            value: emojiValue,
                            version: {
                                number: newVersionNumber,
                                __typename: 'Version'
                            }
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: (0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true) ? {
                                ...(0, $g6QPm.createEditorContentUnifiedQueryVariables)({
                                    contentId: contentId,
                                    draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                                }),
                                skipPublishedFragment: true
                            } : {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)(),
                                skipPublishedFragment: true
                            },
                            data: data,
                            __callerPackage__: "emoji-title"
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating ${propertyKey} content property after user selecting emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).then(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
            emojiTitleState.setSelectedEmoji(loadedEmoji);
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user selecting emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$fbfb144f0da80edc = (_event, { onUpdateStartEmoji: onUpdateStartEmoji, onUpdateEndEmoji: onUpdateEndEmoji, onEmojiUpdated: onEmojiUpdated, contentId: contentId, updateContentProperty: updateContentProperty, componentName: componentName = '', emojiStatusFieldName: emojiStatusFieldName })=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    return onEmojiUpdated().then(()=>{
        return updateContentProperty({
            propertyKey: propertyKey,
            isDelete: true,
            options: {
                update: ()=>{
                    try {
                        const data = (0, $l1uFv.readQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: (0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true) ? {
                                ...(0, $g6QPm.createEditorContentUnifiedQueryVariables)({
                                    contentId: contentId,
                                    draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                                }),
                                skipPublishedFragment: true
                            } : {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)(),
                                skipPublishedFragment: true
                            },
                            __callerPackage__: "emoji-title"
                        });
                        data.content.nodes[0][emojiStatusFieldName] = {
                            nodes: [],
                            __typename: 'PaginatedJsonContentPropertyList'
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: (0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true) ? {
                                ...(0, $g6QPm.createEditorContentUnifiedQueryVariables)({
                                    contentId: contentId,
                                    draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                                }),
                                skipPublishedFragment: true
                            } : {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)(),
                                skipPublishedFragment: true
                            },
                            data: data,
                            __callerPackage__: "emoji-title"
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating content property after user removing emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).finally(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user removing emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$8c0236acf4c550c0 = RegExp("^(\\p{RI}\\p{RI}|\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?(\\u{200D}\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?)*)", "u");
const $a7a7184e7345058e$export$cb9bb843138d9261 = (title)=>title && title.replace($a7a7184e7345058e$export$8c0236acf4c550c0, '').trimLeft() || '';
const $a7a7184e7345058e$export$9d1875ac2476f6b6 = (title)=>title && $a7a7184e7345058e$export$8c0236acf4c550c0.exec(title)?.[0] || '';
const $a7a7184e7345058e$export$388f90f8e727e4d5 = (rawTitle = '', rawPublishedEmoji = '', rawDraftEmoji = '', status = '', untitledDraftText = '', getEmoji = true)=>{
    const nativeEmoji = getEmoji ? $a7a7184e7345058e$export$9d1875ac2476f6b6(rawTitle) : '';
    let selectedEmoji = '';
    if (getEmoji) selectedEmoji = status?.toLowerCase() === 'draft' ? rawDraftEmoji : rawPublishedEmoji;
    const hasNativeEmoji = nativeEmoji.length > 0;
    const hasSelectedEmoji = selectedEmoji.length > 0;
    const emoji = hasSelectedEmoji ? selectedEmoji : nativeEmoji;
    let text = hasNativeEmoji && !hasSelectedEmoji ? $a7a7184e7345058e$export$cb9bb843138d9261(rawTitle) : rawTitle;
    if (status === 'draft' && !text) text = untitledDraftText;
    return {
        text: text,
        emoji: emoji,
        selectedEmoji: selectedEmoji
    };
};
module.exports["getEmojiFromEmojiId"] = $a7a7184e7345058e$export$8807f1cb55bf77de;
module.exports["maybeOverrideFaviconWithEmoji"] = $a7a7184e7345058e$export$4bb2c221b7e4cc0;
module.exports["onSelectEmoji"] = $a7a7184e7345058e$export$ea48fb6f63107646;
module.exports["onRemoveEmoji"] = $a7a7184e7345058e$export$fbfb144f0da80edc;
module.exports["emojiExp"] = $a7a7184e7345058e$export$8c0236acf4c550c0;
module.exports["removeEmojiFromTitle"] = $a7a7184e7345058e$export$cb9bb843138d9261;
module.exports["getEmojiFromTitle"] = $a7a7184e7345058e$export$9d1875ac2476f6b6;
module.exports["getTitleAndEmoji"] = $a7a7184e7345058e$export$388f90f8e727e4d5;

});

parcelRegister("l1uFv", function(module, exports) {

var $eqEJl = parcelRequire("eqEJl");


var $jclGA = parcelRequire("jclGA");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $7M67g = parcelRequire("7M67g");

function $65c7b8940c778902$export$627cb922211284f(params) {
    const operationName = (0, $7M67g.getRelayOperationName)(params.query);
    const source = (0, $iffSy.isRelayEnabled)(params.__callerPackage__, {
        operationName: operationName,
        phase: 'cache'
    }) ? 'relay' : 'apollo';
    // Cache reads stay native to the selected route. The cache bridge only
    // mirrors successful writes/results into the other cache.
    return $65c7b8940c778902$var$readQueryInteropOriginal(params, source);
}
function $65c7b8940c778902$var$readQueryInteropOriginal(params, source) {
    return source === 'relay' ? $65c7b8940c778902$var$readQueryInteropRelay(params) : $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropRelay(params) {
    const relayEnv = typeof window !== 'undefined' ? window.GLOBAL_RELAY_ENV : undefined;
    if (!relayEnv) throw new Error(`[Relay migration] Missing GLOBAL_RELAY_ENV for readQueryInterop; ${params.__callerPackage__}.`);
    const queryNode = params.query;
    if (!queryNode?.fragment || !queryNode?.operation) return null;
    const variables = params.variables ?? {};
    const operation = (0, $eqEJl.createOperationDescriptor)(queryNode, variables);
    const snapshot = relayEnv.lookup(operation.fragment);
    return snapshot.isMissingData ? null : (0, $jclGA.cloneRelayQueryResult)(snapshot.data);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("3shHM", function(module, exports) {

var $g6QPm = parcelRequire("g6QPm");


var $6mKj3 = parcelRequire("6mKj3");


var $7PLO8 = parcelRequire("7PLO8");


var $c0rhi = parcelRequire("c0rhi");


var $8rneB = parcelRequire("8rneB");


var $5amrO = parcelRequire("5amrO");


var $5DJsZ = parcelRequire("5DJsZ");

const $d6c558249b167bda$export$5e53520e517ec9ab = (createAnalyticsEvent, { eventType: eventType, element: element, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes = {} })=>{
    createAnalyticsEvent({
        type: eventType,
        data: {
            action: action,
            source: 'EmojiTitleSection',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                element: element,
                ...attributes
            }
        }
    }).fire();
};
const $d6c558249b167bda$export$1fa99c5c7c4cc530 = async ({ createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isLivePage: isLivePage })=>{
    const { data: data } = await (0, $c0rhi.queryInterop)({
        query: (0, $5DJsZ.default),
        variables: (0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true) ? {
            ...(0, $g6QPm.createEditorContentUnifiedQueryVariables)({
                contentId: contentId,
                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
            }),
            skipPublishedFragment: false
        } : {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false
        },
        __callerPackage__: "emoji-title"
    });
    const emojiId = (0, $8rneB.getEmojiId)(data, (0, $5amrO.EMOJI_TITLE_DRAFT_FIELD));
    const hasDraftEmoji = emojiId.length >= 0 && emojiId !== '';
    // only track draft with emoji
    if (hasDraftEmoji) $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: '',
        action: 'created',
        actionSubject: 'draftWithEmoji',
        actionSubjectId: '',
        attributes: {
            emojiId: emojiId,
            isLivePage: isLivePage
        }
    });
};
const $d6c558249b167bda$export$5a8401d422e6e576 = ({ createAnalyticsEvent: createAnalyticsEvent, emoji: emoji, context: context, error: error = {
    message: ''
}, isLivePage: isLivePage })=>{
    $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: 'emoji',
        action: 'error',
        actionSubject: 'renderEmoji',
        actionSubjectId: 'renderEmojiError',
        attributes: {
            emojiShortName: emoji && emoji.shortName,
            emojiId: emoji && emoji.id,
            context: context,
            errorMessage: error.message,
            isLivePage: isLivePage
        }
    });
};
module.exports["sendAnalyticsEvent"] = $d6c558249b167bda$export$5e53520e517ec9ab;
module.exports["trackDraftCreatedWithEmoji"] = $d6c558249b167bda$export$1fa99c5c7c4cc530;
module.exports["onFailedToLoadEmoji"] = $d6c558249b167bda$export$5a8401d422e6e576;

});

parcelRegister("8rneB", function(module, exports) {

var $kwzZh = parcelRequire("kwzZh");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: 'version' in property && property.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node?.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    let nodes;
    if (data && 'content' in data) nodes = data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0];
    else nodes = data?.emojiTitlePublished?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$496af73e8e85fd08 = (data)=>{
    return $61659933fe71a4ee$export$b8852397200defa1(data, 'emojiTitlePublished');
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["doesContentHaveEmojiPublished"] = $61659933fe71a4ee$export$496af73e8e85fd08;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["DefaultTitleEmojiValues"] = $61659933fe71a4ee$export$66d7571a7d7aad65;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("32x2E", function(module, exports) {

var $1UWNP = parcelRequire("1UWNP");


var $bwAnG = parcelRequire("bwAnG");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    // For signed-in users, allowAnonymousAccess does not change the provider config. Sharing the
    // resource lets uploads propagate immediately between editor, title, and reaction pickers.
    const allowAnonymousAccessCacheKey = userId ? false : allowAnonymousAccess;
    return `${cloudId}_${userId}_${allowAnonymousAccessCacheKey}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $bwAnG.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("bwAnG", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $l4yrE = parcelRequire("l4yrE");


var $drRzc = parcelRequire("drRzc");

class $dfb1108de4ce4e19$export$67106c51beb59865 extends (0, $drRzc.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $4iudd.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $4iudd.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $l4yrE.defaultEmojiHeight),
                    width: (0, $l4yrE.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $dfb1108de4ce4e19$export$67106c51beb59865;

});

parcelRegister("5amrO", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("5DJsZ", function(module, exports) {
/**
 * @generated SignedSource<<8b96b7ca504d956e62c9a3c7888eb72c>>
 * @relayHash 736318216100158fedfd1efdb0277723
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee7b55ba4a12d84512c880cfd1a46392ff785081052c438befeefd868cef06a6
const $4dc353069380bea7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipPublishedFragment"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v4 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "condition": "skipPublishedFragment",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "emojiTitlePublished",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "emoji-title-published"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v5 /*: any*/ ,
                                    "storageKey": "properties(key:\"emoji-title-published\")"
                                }
                            ]
                        },
                        {
                            "alias": "emojiTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "emoji-title-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v5 /*: any*/ ,
                            "storageKey": "properties(key:\"emoji-title-draft\")"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PublishedContentProperties",
                                    "kind": "LinkedField",
                                    "name": "latest",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "defaultTitleEmoji"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EmojiTitleQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EmojiTitleQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "736318216100158fedfd1efdb0277723",
            "id": "ee7b55ba4a12d84512c880cfd1a46392ff785081052c438befeefd868cef06a6",
            "metadata": {},
            "name": "EmojiTitleQuery",
            "operationKind": "query",
            "text": "query EmojiTitleQuery($contentId:ID,$status:[String],$draftShareId:String,$skipPublishedFragment:Boolean!){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,emojiTitlePublished:properties(key:\"emoji-title-published\")@skip(if:$skipPublishedFragment){nodes{id,key,value,version{number}}},emojiTitleDraft:properties(key:\"emoji-title-draft\"){nodes{id,key,value,version{number}}},contentProperties{latest{defaultTitleEmoji}}}}}"
        }
    };
}();
$4dc353069380bea7$var$node.hash = "c3af19fccb4a5096e4bb34c9aa198098";
var $4dc353069380bea7$export$2e2bcd8739ae039 = $4dc353069380bea7$var$node;
module.exports["default"] = $4dc353069380bea7$export$2e2bcd8739ae039;

});

parcelRegister("huWyw", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");

const $61f50eb1c9d5c417$export$35f6369946b1d8c9 = ({ url: url, spaceKey: spaceKey, contentType: contentType, editorVersion: editorVersion, contentId: contentId, fabricEditorSupported: fabricEditorSupported, noContextPath: noContextPath })=>{
    const isPage = contentType === 'page';
    const isBlog = contentType === 'blogpost';
    const isPageOrBlog = isPage || isBlog;
    const isUsingFabricEditor = fabricEditorSupported || editorVersion === 'v2'; // as opposed to the v1 TinyMCE editor
    const providedURLHitsResumeDraftAction = url.includes('resumedraft.action');
    if (isPageOrBlog && isUsingFabricEditor && providedURLHitsResumeDraftAction) {
        const contentTypeForURL = isPage ? 'pages' : 'blog';
        const contentIdForURL = contentId;
        // Extract the query string from the relative URL.
        const queryString = url.includes('?') ? url.slice(url.indexOf('?') + 1) : '';
        // Extract the `draftShareId` from the query string.
        const urlSearchParams = new URLSearchParams(queryString);
        const draftShareId = urlSearchParams.get('draftShareId');
        const draftShareIdParamString = draftShareId ? `draftShareId=${draftShareId}` : '';
        const optionalContextPath = noContextPath ? '' : (0, $jlIaF.CONTEXT_PATH);
        const bypassURL = `${optionalContextPath}/spaces/${spaceKey}/${contentTypeForURL}/edit-v2/${contentIdForURL}?${draftShareIdParamString}`;
        return bypassURL;
    } else return url;
};
module.exports["getURLBypassingResumeDraftAction"] = $61f50eb1c9d5c417$export$35f6369946b1d8c9;

});

parcelRegister("c7GB4", function(module, exports) {

var $5BvyC = parcelRequire("5BvyC");

var $lT7Mv = parcelRequire("lT7Mv");

var $k0a0F = parcelRequire("k0a0F");

var $bAV6O = parcelRequire("bAV6O");

var $8jDil = parcelRequire("8jDil");

var $dLbqW = parcelRequire("dLbqW");

var $7GbwS = parcelRequire("7GbwS");


var $1ggpj = parcelRequire("1ggpj");

const $c96e0d62cf176fc6$export$84dfa7fadd8a006b = ({ ari: ari, resourceType: resourceType })=>{
    if (!ari) return null;
    switch(resourceType){
        case (0, $1ggpj.ContentType).PAGE:
            return (0, $8jDil.ConfluencePageAri).parse(ari).pageId;
        case (0, $1ggpj.ContentType).BLOGPOST:
            return (0, $5BvyC.ConfluenceBlogpostAri).parse(ari).blogpostId;
        case (0, $1ggpj.ContentType).WHITEBOARD:
            return (0, $7GbwS.ConfluenceWhiteboardAri).parse(ari).whiteboardId;
        case (0, $1ggpj.ContentType).DATABASE:
            return (0, $lT7Mv.ConfluenceDatabaseAri).parse(ari).databaseId;
        case (0, $1ggpj.ContentType).EMBED:
            return (0, $k0a0F.ConfluenceEmbedAri).parse(ari).embedId;
        case (0, $1ggpj.ContentType).FOLDER:
            return (0, $bAV6O.ConfluenceFolderAri).parse(ari).folderId;
        case (0, $1ggpj.ContentType).SLIDE:
            return (0, $dLbqW.ConfluenceSlideAri).parse(ari).slideId;
    }
};
module.exports["getIdFromConfluenceContentAri"] = $c96e0d62cf176fc6$export$84dfa7fadd8a006b;

});

parcelRegister("5BvyC", function(module, exports) {

var $eQkRH = parcelRequire("eQkRH");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/blogpost/manifest.ts
var $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $eQkRH.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $eQkRH.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $4148e3160e6a23b4$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $4148e3160e6a23b4$export$8602a2c2f6ac09bc;

});

parcelRegister("eQkRH", function(module, exports) {
// src/confluence/blogpost/types.ts
var $ace61b64202bfb2d$export$9389f06bd1d0765c = "confluence", $ace61b64202bfb2d$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $ace61b64202bfb2d$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $ace61b64202bfb2d$export$fb777a2d645a4129;

});

parcelRegister("lT7Mv", function(module, exports) {

var $jp6rV = parcelRequire("jp6rV");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/database/manifest.ts
var $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jp6rV.ConfluenceDatabaseAriResourceOwner),
    resourceType: (0, $jp6rV.ConfluenceDatabaseAriResourceType),
    resourceIdSlug: "activation/{activationId}/{databaseId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        databaseId: /[0-9]+/
    }
};
// src/confluence/database/index.ts
var $fef4c53c0d169c78$export$317cd32472deea7e = class _ConfluenceDatabaseAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get databaseId() {
        return this._databaseId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts.qualifier,
            platformQualifier: $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts.resourceOwner,
            resourceType: $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.databaseId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                databaseId: opts.databaseId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            databaseId: this.databaseId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._databaseId = opts.resourceIdSegmentValues.databaseId;
    }
};
module.exports["ConfluenceDatabaseAri"] = $fef4c53c0d169c78$export$317cd32472deea7e;

});

parcelRegister("jp6rV", function(module, exports) {
// src/confluence/database/types.ts
var $e2055ad385da7e5a$export$e83bc7b627335f1d = "confluence", $e2055ad385da7e5a$export$d26db9a1a0b750aa = "database";
module.exports["ConfluenceDatabaseAriResourceOwner"] = $e2055ad385da7e5a$export$e83bc7b627335f1d;
module.exports["ConfluenceDatabaseAriResourceType"] = $e2055ad385da7e5a$export$d26db9a1a0b750aa;

});

parcelRegister("k0a0F", function(module, exports) {

var $1pgGd = parcelRequire("1pgGd");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/embed/manifest.ts
var $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1pgGd.ConfluenceEmbedAriResourceOwner),
    resourceType: (0, $1pgGd.ConfluenceEmbedAriResourceType),
    resourceIdSlug: "activation/{activationId}/{embedId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        embedId: /[0-9]+/
    }
};
// src/confluence/embed/index.ts
var $e8fb927b13f87211$export$47d4b4205d0ac61a = class _ConfluenceEmbedAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get embedId() {
        return this._embedId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts.qualifier,
            platformQualifier: $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts.resourceOwner,
            resourceType: $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.embedId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                embedId: opts.embedId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            embedId: this.embedId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._embedId = opts.resourceIdSegmentValues.embedId;
    }
};
module.exports["ConfluenceEmbedAri"] = $e8fb927b13f87211$export$47d4b4205d0ac61a;

});

parcelRegister("1pgGd", function(module, exports) {
// src/confluence/embed/types.ts
var $10651083a44828c2$export$7a02af293cacddd2 = "confluence", $10651083a44828c2$export$f817d48842ea0d4a = "embed";
module.exports["ConfluenceEmbedAriResourceOwner"] = $10651083a44828c2$export$7a02af293cacddd2;
module.exports["ConfluenceEmbedAriResourceType"] = $10651083a44828c2$export$f817d48842ea0d4a;

});

parcelRegister("bAV6O", function(module, exports) {

var $7SOnZ = parcelRequire("7SOnZ");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/folder/manifest.ts
var $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $7SOnZ.ConfluenceFolderAriResourceOwner),
    resourceType: (0, $7SOnZ.ConfluenceFolderAriResourceType),
    resourceIdSlug: "activation/{activationId}/{folderId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        folderId: /[0-9]+/
    }
};
// src/confluence/folder/index.ts
var $870f5b1ead2b6083$export$501a782385a3f485 = class _ConfluenceFolderAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get folderId() {
        return this._folderId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts.qualifier,
            platformQualifier: $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts.resourceOwner,
            resourceType: $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.folderId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                folderId: opts.folderId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            folderId: this.folderId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._folderId = opts.resourceIdSegmentValues.folderId;
    }
};
module.exports["ConfluenceFolderAri"] = $870f5b1ead2b6083$export$501a782385a3f485;

});

parcelRegister("7SOnZ", function(module, exports) {
// src/confluence/folder/types.ts
var $5bd4a92be6836a9b$export$77cf4e1b17902bfa = "confluence", $5bd4a92be6836a9b$export$6256ff329bc25a9c = "folder";
module.exports["ConfluenceFolderAriResourceOwner"] = $5bd4a92be6836a9b$export$77cf4e1b17902bfa;
module.exports["ConfluenceFolderAriResourceType"] = $5bd4a92be6836a9b$export$6256ff329bc25a9c;

});

parcelRegister("8jDil", function(module, exports) {

var $jyUkr = parcelRequire("jyUkr");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/page/manifest.ts
var $60de943ef043ed79$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jyUkr.ConfluencePageAriResourceOwner),
    resourceType: (0, $jyUkr.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $60de943ef043ed79$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $60de943ef043ed79$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $60de943ef043ed79$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $60de943ef043ed79$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $60de943ef043ed79$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $60de943ef043ed79$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $60de943ef043ed79$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $60de943ef043ed79$export$3f931dd15d96caff;

});

parcelRegister("jyUkr", function(module, exports) {
// src/confluence/page/types.ts
var $e3dce2fc5add42f7$export$da53e4f7db4c6a71 = "confluence", $e3dce2fc5add42f7$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $e3dce2fc5add42f7$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $e3dce2fc5add42f7$export$636fc622562a2c5b;

});

parcelRegister("dLbqW", function(module, exports) {

var $1AG0i = parcelRequire("1AG0i");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/slide/manifest.ts
var $a04888a2b5576260$var$confluenceSlideAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1AG0i.ConfluenceSlideAriResourceOwner),
    resourceType: (0, $1AG0i.ConfluenceSlideAriResourceType),
    resourceIdSlug: "activation/{activationId}/{slideId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        slideId: /[0-9]+/
    }
};
// src/confluence/slide/index.ts
var $a04888a2b5576260$export$86048ac46024146a = class _ConfluenceSlideAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get slideId() {
        return this._slideId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $a04888a2b5576260$var$confluenceSlideAriStaticOpts.qualifier,
            platformQualifier: $a04888a2b5576260$var$confluenceSlideAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $a04888a2b5576260$var$confluenceSlideAriStaticOpts.resourceOwner,
            resourceType: $a04888a2b5576260$var$confluenceSlideAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.slideId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                slideId: opts.slideId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $a04888a2b5576260$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $a04888a2b5576260$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            slideId: this.slideId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._slideId = opts.resourceIdSegmentValues.slideId;
    }
};
module.exports["ConfluenceSlideAri"] = $a04888a2b5576260$export$86048ac46024146a;

});

parcelRegister("1AG0i", function(module, exports) {
// src/confluence/slide/types.ts
var $1289bc4ba87a8942$export$204fa7edd529d4b3 = "confluence", $1289bc4ba87a8942$export$3de52c55a164daa4 = "slide";
module.exports["ConfluenceSlideAriResourceOwner"] = $1289bc4ba87a8942$export$204fa7edd529d4b3;
module.exports["ConfluenceSlideAriResourceType"] = $1289bc4ba87a8942$export$3de52c55a164daa4;

});

parcelRegister("7GbwS", function(module, exports) {

var $9z7xR = parcelRequire("9z7xR");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/whiteboard/manifest.ts
var $597566211494b449$var$confluenceWhiteboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $9z7xR.ConfluenceWhiteboardAriResourceOwner),
    resourceType: (0, $9z7xR.ConfluenceWhiteboardAriResourceType),
    resourceIdSlug: "{whiteboardId}",
    resourceIdSegmentFormats: {
        whiteboardId: /[0-9]+/
    }
};
// src/confluence/whiteboard/index.ts
var $597566211494b449$export$ba3d25b6768ddb10 = class _ConfluenceWhiteboardAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get whiteboardId() {
        return this._whiteboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $597566211494b449$var$confluenceWhiteboardAriStaticOpts.qualifier,
            platformQualifier: $597566211494b449$var$confluenceWhiteboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $597566211494b449$var$confluenceWhiteboardAriStaticOpts.resourceOwner,
            resourceType: $597566211494b449$var$confluenceWhiteboardAriStaticOpts.resourceType,
            resourceId: `${opts.whiteboardId}`,
            resourceIdSegmentValues: {
                whiteboardId: opts.whiteboardId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $597566211494b449$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $597566211494b449$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            whiteboardId: this.whiteboardId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._whiteboardId = opts.resourceIdSegmentValues.whiteboardId;
    }
};
module.exports["ConfluenceWhiteboardAri"] = $597566211494b449$export$ba3d25b6768ddb10;

});

parcelRegister("9z7xR", function(module, exports) {
// src/confluence/whiteboard/types.ts
var $6f6d3c41ba97755c$export$6130ea1abbb885ef = "confluence", $6f6d3c41ba97755c$export$d3070d1568a10e2d = "whiteboard";
module.exports["ConfluenceWhiteboardAriResourceOwner"] = $6f6d3c41ba97755c$export$6130ea1abbb885ef;
module.exports["ConfluenceWhiteboardAriResourceType"] = $6f6d3c41ba97755c$export$d3070d1568a10e2d;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["SLIDE"] = "slide";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name,
    (0, $1NBp8.EDIT_PAGE).name,
    (0, $1NBp8.EDIT_PAGE_V2).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "slide",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE,
    ["slide"]: (0, $lx6jn.FeedbackSource).SLIDE
};
const $2aa2bdb281c6889a$export$4aba9c2e2995f563 = [
    "whiteboard",
    "slide"
];
const $2aa2bdb281c6889a$export$ea7ca1acbbc07168 = (contentType)=>!!contentType && $2aa2bdb281c6889a$export$4aba9c2e2995f563.includes(contentType);
const $2aa2bdb281c6889a$var$VERSION_HISTORY_CONTENT_TYPE_SET = {
    whiteboard: true,
    database: true,
    slide: true
};
const $2aa2bdb281c6889a$export$4c89eeb173e3fb0e = (contentType)=>!!contentType && Object.prototype.hasOwnProperty.call($2aa2bdb281c6889a$var$VERSION_HISTORY_CONTENT_TYPE_SET, contentType);
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'slide',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["isCanvasContentType"] = $2aa2bdb281c6889a$export$ea7ca1acbbc07168;
module.exports["isVersionHistoryContentType"] = $2aa2bdb281c6889a$export$4c89eeb173e3fb0e;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    FeedbackSource["SLIDE"] = "Slide";
    FeedbackSource["TABS"] = "Tabs";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("i1t43", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $7vK9E = parcelRequire("7vK9E");


var $iMnC5 = parcelRequire("iMnC5");

const $7e44050607850249$var$styles = {
    base: "_0bjKvDcjp5 _0WKd3G4z3T",
    visitedLink: "_2nTuUYWfPD _3ADzdEWfPD _1warJ9WfPD _4scvAwWyeI",
    defaultAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMM7Tp _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbkAwSC",
    subtleAppearance: "_00uqCYjOvk _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzZpcK _32C2rkjOvk _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbky7kJ",
    inverseAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMe5R3 _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbke5R3",
    iconWrapper: "_3iDTPbS8kF _1ANEUSLRg7 _1RrJLiQame _1mT5xdRAKS _2I62gzVQEB"
};
const $7e44050607850249$var$iconStyles = null;
const $7e44050607850249$var$LinkWithoutRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(24);
    let children;
    let htmlAttributes;
    let newWindowLabel;
    let t1;
    let target;
    let testId;
    if ($[0] !== t0) {
        const { children: t2, testId: t3, appearance: t4, newWindowLabel: t5, target: t6, className: _preventedClassName, style: _preventedStyle, ...t7 } = t0;
        children = t2;
        testId = t3;
        t1 = t4;
        newWindowLabel = t5;
        target = t6;
        htmlAttributes = t7;
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = newWindowLabel;
        $[4] = t1;
        $[5] = target;
        $[6] = testId;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        newWindowLabel = $[3];
        t1 = $[4];
        target = $[5];
        testId = $[6];
    }
    const appearance = t1 === undefined ? "default" : t1;
    const t2 = appearance === "default" && $7e44050607850249$var$styles.defaultAppearance;
    const t3 = appearance === "subtle" && $7e44050607850249$var$styles.subtleAppearance;
    const t4 = appearance === "inverse" && $7e44050607850249$var$styles.inverseAppearance;
    const t5 = appearance !== "inverse" && $7e44050607850249$var$styles.visitedLink;
    let t6;
    if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
        t6 = (0, $w6R6I.cx)($7e44050607850249$var$styles.base, t2, t3, t4, t5);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== target || $[13] !== testId) {
        t7 = target === "_blank" && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            as: "span",
            xcss: $7e44050607850249$var$styles.iconWrapper,
            testId: testId && `${testId}__icon`,
            children: [
                "\uFEFF",
                /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    className: (0, $hekY6.default)([
                        "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                        fill: "currentColor"
                    })
                })
            ]
        });
        $[12] = target;
        $[13] = testId;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== children || $[16] !== htmlAttributes || $[17] !== newWindowLabel || $[18] !== ref || $[19] !== t6 || $[20] !== t7 || $[21] !== target || $[22] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor), {
            ...htmlAttributes,
            target: target,
            ref: ref,
            xcss: t6,
            testId: testId,
            componentName: "Link",
            newWindowLabel: newWindowLabel,
            children: [
                children,
                t7
            ]
        });
        $[15] = children;
        $[16] = htmlAttributes;
        $[17] = newWindowLabel;
        $[18] = ref;
        $[19] = t6;
        $[20] = t7;
        $[21] = target;
        $[22] = testId;
        $[23] = t8;
    } else t8 = $[23];
    return t8;
} : ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $w6R6I.cx)($7e44050607850249$var$styles.base, appearance === 'default' && $7e44050607850249$var$styles.defaultAppearance, appearance === 'subtle' && $7e44050607850249$var$styles.subtleAppearance, appearance === 'inverse' && $7e44050607850249$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $7e44050607850249$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                as: "span",
                xcss: $7e44050607850249$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $hekY6.default)([
                            "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                        ]),
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    }); // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $7e44050607850249$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)($7e44050607850249$var$LinkWithoutRef);
var $7e44050607850249$export$2e2bcd8739ae039 = $7e44050607850249$var$Link;
module.exports["default"] = $7e44050607850249$export$2e2bcd8739ae039;

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

const $abc73c6f5c74c436$export$6d558eab13290f59 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
module.exports["useRouterLink"] = $abc73c6f5c74c436$export$6d558eab13290f59;

});

parcelRegister("ac2J9", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1,
            children: children
        });
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("lyWac", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");


var $3mugH = parcelRequire("3mugH");

// Mirrors GraphqlErrorProcessor's mark. Read through the global symbol registry rather than
// importing `isErrorMarkedAsHandled`, because ~20 test files mock
// `@confluence/graphql-error-processor` partially and a new import here would break all of them.
// The registry is the same mechanism GraphqlErrorProcessor relies on to share the mark across the
// preloader and main-app bundles, and `ignores errors already marked as handled` in this module's
// tests exercises the real `markErrorAsHandled`, so the key cannot drift unnoticed.
const $6e8f7926b945fe5e$var$HANDLED_ERROR_MARK_SYMBOL = Symbol.for('error marked as handled');
function $6e8f7926b945fe5e$var$isErrorMarkedAsHandled(error) {
    return typeof error === 'object' && error !== null && Boolean(error[$6e8f7926b945fe5e$var$HANDLED_ERROR_MARK_SYMBOL]);
}
const $6e8f7926b945fe5e$var$isLegacyUnauthorizedGraphQLError = (error)=>error?.extensions?.data?.authorized === false;
/**
 * A page the viewer is not allowed to see is a normal SSR outcome, not a defect — the render falls
 * back to the restricted-content screen. `query()` marks these as handled when a preloader resolves
 * with its query result, but a task that *rejects* with a permission error (or resolves with the
 * error itself) never passes through that path, so the handled mark alone does not keep restricted
 * pages out of the SSR prepare errors.
 *
 * Covers both status codes of the permission contract — 401 (unauthenticated) and 403 (not
 * permitted) — plus the legacy `extensions.data.authorized === false` shape, matching
 * `@confluence/unauthorized-error-boundary`. `isStatusCodeError` walks `graphQLErrors`,
 * `networkError` and `originalError`, so a rejected ApolloError wrapping a 403 is recognised too.
 * `@confluence/error-types` is used rather than the boundary's copy of this predicate to keep React
 * out of the preloader bundle.
 *
 * https://pug.jira-dev.com/wiki/spaces/CCB/pages/4709260932/GraphQL+Errors+Contract+for+Status+Code+401+and+403
 */ function $6e8f7926b945fe5e$var$isPermissionError(error) {
    const candidate = error;
    return (0, $aMcHK.isStatusCodeError)(candidate, '403', $6e8f7926b945fe5e$var$isLegacyUnauthorizedGraphQLError) || (0, $aMcHK.isStatusCodeError)(candidate, '401');
}
/**
 * Errors that are an expected outcome of preloading and must not be reported as SSR prepare errors.
 */ function $6e8f7926b945fe5e$var$isExpectedPreloadError(error) {
    return $6e8f7926b945fe5e$var$isErrorMarkedAsHandled(error) || $6e8f7926b945fe5e$var$isPermissionError(error);
}
function $6e8f7926b945fe5e$var$expandErrorToErrors(error) {
    // Error from createDataFetcherForSuspense might have nested errors
    const errors = [
        error
    ];
    if (Array.isArray(error.otherErrors)) errors.push(...error.otherErrors);
    delete error.otherErrors;
    return errors;
}
/**
 * `query()` and `queryAgg()` resolve to `{ data, errors, hasErrors }` rather than rejecting or
 * resolving to an `Error`, so a preloader that returns its result object straight into the task
 * list would otherwise slip past the `instanceof Error` checks below.
 */ function $6e8f7926b945fe5e$var$isPreloaderQueryResultWithErrors(value) {
    return typeof value === 'object' && value !== null && value.hasErrors === true && Array.isArray(value.errors);
}
/**
 * Only surfaces errors nobody has claimed. `query()` marks the expected ones (unauthorized,
 * not-found, and other known shapes) as handled before resolving, and those still come back with
 * `hasErrors: true` — reporting them here would turn every restricted or missing page into a bogus
 * SSR prepare error, since preloaders like `preloadPageStatusQuery` return their result object
 * straight into the task list.
 *
 * Filtering happens here, before the conversion below, because `new Error(message)` drops
 * `extensions` — the only place the permission status code lives on a plain GraphQL error object.
 */ function $6e8f7926b945fe5e$var$collectUnhandledQueryErrors(result) {
    const unhandledErrors = [];
    for (const error of result.errors ?? []){
        if ($6e8f7926b945fe5e$var$isExpectedPreloadError(error)) continue;
        unhandledErrors.push(error instanceof Error ? error : new Error(String(error?.message ?? error)));
    }
    return unhandledErrors;
}
function $6e8f7926b945fe5e$var$collectErrorsFromFulfilledValue(fulfilledValue) {
    if (fulfilledValue instanceof Error) return $6e8f7926b945fe5e$var$expandErrorToErrors(fulfilledValue);
    if (Array.isArray(fulfilledValue)) return fulfilledValue.flatMap((value)=>value instanceof Error || $6e8f7926b945fe5e$var$isPreloaderQueryResultWithErrors(value) ? $6e8f7926b945fe5e$var$collectErrorsFromFulfilledValue(value) : []);
    if ($6e8f7926b945fe5e$var$isPreloaderQueryResultWithErrors(fulfilledValue)) return $6e8f7926b945fe5e$var$collectUnhandledQueryErrors(fulfilledValue);
    return [];
}
async function $6e8f7926b945fe5e$export$ba9c3910d56be969(values) {
    if (!Array.isArray(values)) values = [
        values
    ];
    return Promise.allSettled(values).then((results)=>{
        const errors = [];
        for (const result of results){
            if (result.status === 'rejected') errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(result.reason));
            else if (result.status === 'fulfilled') errors.push(...$6e8f7926b945fe5e$var$collectErrorsFromFulfilledValue(result.value));
        }
        // Drop the expected outcomes — already-handled and permission errors — so a restricted page
        // does not report a prepare error. Rejections and error values are filtered here rather than
        // at each collection site so that every path is held to the same rule; query results are
        // filtered earlier, while their `extensions` are still intact.
        const reportableErrors = errors.filter((error)=>!$6e8f7926b945fe5e$var$isExpectedPreloadError(error));
        if (reportableErrors.length > 0) {
            // Errors on preloader functions are not meant to break anything.
            // But we still want to know them...
            for (const error of reportableErrors)(0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Error caught by waitForAllReturnWhenError: ${error.message}`));
            return reportableErrors;
        }
    });
}
module.exports["waitForAllReturnWhenError"] = $6e8f7926b945fe5e$export$ba9c3910d56be969;

});

parcelRegister("3mugH", function(module, exports) {

var $lrjR8 = parcelRequire("lrjR8");

const $d967841d02dde0d1$export$17bc715070d0e7ef = new (0, $lrjR8.SSRPrepareErrorsClient)();
module.exports["ssrPrepareErrorsClient"] = $d967841d02dde0d1$export$17bc715070d0e7ef;

});

parcelRegister("lrjR8", function(module, exports) {
class $7cc20c0ac0ad5b24$export$622a2782a1f9c63 {
    submitError(e, errorData = {}) {
        let additional = {};
        // Not actually importing the error class to avoid circular dependency
        const response = // RateLimitedError or BadStatusError
        e?.response || // Apollo Error
        e?.networkError?.response;
        if (response) additional = {
            response: {
                url: response.url,
                status: response.status,
                statusText: response.statusText
            }
        };
        this.errors.push({
            error: {
                message: e.message,
                stack: e.stack
            },
            meta: errorData,
            ...additional
        });
    }
    getErrors() {
        return this.errors;
    }
    constructor(){
        this.errors = void 0;
        this.errors = [];
    }
}
module.exports["SSRPrepareErrorsClient"] = $7cc20c0ac0ad5b24$export$622a2782a1f9c63;

});

parcelRegister("gTPfK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");

const $6057e25d3e7f93e3$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
            const $ = (0, $bDgLe.c)(11);
            let analyticsContext;
            let rest;
            if ($[0] !== t0) {
                ({ analyticsContext: analyticsContext, ...rest } = t0);
                $[0] = t0;
                $[1] = analyticsContext;
                $[2] = rest;
            } else {
                analyticsContext = $[1];
                rest = $[2];
            }
            let t1;
            if ($[3] !== analyticsContext) {
                t1 = {
                    ...defaultData,
                    ...analyticsContext
                };
                $[3] = analyticsContext;
                $[4] = t1;
            } else t1 = $[4];
            const analyticsData = t1;
            const t2 = rest;
            let t3;
            if ($[5] !== ref || $[6] !== t2) {
                t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                    ...t2,
                    ref: ref
                });
                $[5] = ref;
                $[6] = t2;
                $[7] = t3;
            } else t3 = $[7];
            let t4;
            if ($[8] !== analyticsData || $[9] !== t3) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                    data: analyticsData
                }, t3);
                $[8] = analyticsData;
                $[9] = t3;
                $[10] = t4;
            } else t4 = $[10];
            return t4;
        } : ({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $cozmU.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                ...rest,
                ref: ref
            }));
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $6057e25d3e7f93e3$export$2e2bcd8739ae039 = $6057e25d3e7f93e3$var$withAnalyticsContext;
module.exports["default"] = $6057e25d3e7f93e3$export$2e2bcd8739ae039;

});

parcelRegister("lrDw7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6a66563ef19581ba$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $cozmU.useRef)(null);
    const setRef = (0, $cozmU.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $6a66563ef19581ba$export$ff879f35a69d56b7;

});

parcelRegister("g3XYx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f8fe10123ae9dc81$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $f8fe10123ae9dc81$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $cozmU.useRef)([]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f8fe10123ae9dc81$var$getHookDeps(opts));
    return (0, $cozmU.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $f8fe10123ae9dc81$export$1775f27e7c8051ca;

});

parcelRegister("2khPJ", function(module, exports) {

var $aQ0yV = parcelRequire("aQ0yV");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/identity/user/manifest.ts
var $1b1b4861ffbabf45$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $aQ0yV.IdentityUserAriResourceOwner),
    resourceType: (0, $aQ0yV.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $1b1b4861ffbabf45$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $9j37t.RegisteredAri) {
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $1b1b4861ffbabf45$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $1b1b4861ffbabf45$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
    constructor(opts){
        super(opts), this._userId = opts.resourceIdSegmentValues.userId;
    }
};
module.exports["IdentityUserAri"] = $1b1b4861ffbabf45$export$1e9d09c2be53e55e;

});

parcelRegister("aQ0yV", function(module, exports) {
// src/identity/user/types.ts
var $7e3f325f95b56bab$export$b4c14c54282a779d = "identity", $7e3f325f95b56bab$export$e9b50e20f4fbfb71 = "user";
module.exports["IdentityUserAriResourceOwner"] = $7e3f325f95b56bab$export$b4c14c54282a779d;
module.exports["IdentityUserAriResourceType"] = $7e3f325f95b56bab$export$e9b50e20f4fbfb71;

});

parcelRegister("d9tcB", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $adbc8f20ade62008$export$9d38595f26d62a61 = /*#__PURE__*/ function(AccessStatus) {
    AccessStatus["ANONYMOUS_ACCESS"] = "ANONYMOUS_ACCESS";
    AccessStatus["EXTERNAL_COLLABORATOR_ACCESS"] = "EXTERNAL_COLLABORATOR_ACCESS";
    AccessStatus["EXTERNAL_SHARE_ACCESS"] = "EXTERNAL_SHARE_ACCESS";
    AccessStatus["LICENSED_ADMIN_ACCESS"] = "LICENSED_ADMIN_ACCESS";
    AccessStatus["LICENSED_USE_ACCESS"] = "LICENSED_USE_ACCESS";
    AccessStatus["NOT_PERMITTED"] = "NOT_PERMITTED";
    AccessStatus["UNLICENSED_AUTHENTICATED_ACCESS"] = "UNLICENSED_AUTHENTICATED_ACCESS";
    return AccessStatus;
}({});
var $adbc8f20ade62008$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $adbc8f20ade62008$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["DEVELOPMENT"] = "DEVELOPMENT";
    Environment["PRODUCTION"] = "PRODUCTION";
    Environment["STAGING"] = "STAGING";
    return Environment;
}({});
module.exports["AccessStatus"] = $adbc8f20ade62008$export$9d38595f26d62a61;
module.exports["ConfluenceEdition"] = $adbc8f20ade62008$export$68577d543b14ae02;

});

parcelRegister("kquO1", function(module, exports) {

var $05daj = parcelRequire("05daj");


var $7Sm4c = parcelRequire("7Sm4c");


var $dYU3e = parcelRequire("dYU3e");


var $8tmcF = parcelRequire("8tmcF");


var $3mugH = parcelRequire("3mugH");

const $16ec8c3b2306adb8$var$PRELOAD_TIMEOUT_MS = 500;
const $16ec8c3b2306adb8$var$TIMED_OUT = Symbol('outgoing-links-preload-timed-out');
const $16ec8c3b2306adb8$export$a0681264c37c98d4 = (0, $05daj.default);
const $16ec8c3b2306adb8$var$runQuery = (contentId)=>(0, $dYU3e.query)({
        query: $16ec8c3b2306adb8$export$a0681264c37c98d4,
        variables: {
            contentId: contentId
        },
        __callerPackage__: "connectors"
    });
const $16ec8c3b2306adb8$var$reportUnavailable = (reason, cause)=>{
    (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Outgoing links preload unavailable: ${reason}`, {
        cause: cause
    }), {
        operation: 'preload-outgoing-links',
        reason: reason
    });
    if (cause instanceof Error) (0, $7Sm4c.markErrorAsHandled)(cause);
};
const $16ec8c3b2306adb8$export$57bfcc710803f40e = async (contentId)=>{
    try {
        const promise = $16ec8c3b2306adb8$var$runQuery(contentId);
        const result = await (0, $8tmcF.timeGuard)(()=>promise, $16ec8c3b2306adb8$var$TIMED_OUT, $16ec8c3b2306adb8$var$PRELOAD_TIMEOUT_MS);
        if (result === $16ec8c3b2306adb8$var$TIMED_OUT) {
            $16ec8c3b2306adb8$var$reportUnavailable('timeout');
            return;
        }
        if (result.hasErrors || result.errors?.length) $16ec8c3b2306adb8$var$reportUnavailable('query-error', result.errors?.[0]);
    } catch (cause) {
        $16ec8c3b2306adb8$var$reportUnavailable('query-error', cause);
    }
};
module.exports["OutgoingLinksQuery"] = $16ec8c3b2306adb8$export$a0681264c37c98d4;
module.exports["preloadOutgoingLinks"] = $16ec8c3b2306adb8$export$57bfcc710803f40e;

});

parcelRegister("05daj", function(module, exports) {
/**
 * @generated SignedSource<<9b82e025502749d65398a1224a13d8b3>>
 * @relayHash fec3092eee5be8002a509e6d3be00bc6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ab71c9a12a0be2c8e5d9d99b7deecbd0116bb7ce35f6af9111a2fe2f1177c3c
const $be4a7160c946b27a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "OutgoingLinks",
                            "kind": "LinkedField",
                            "name": "outgoingLinks",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 50
                                        }
                                    ],
                                    "concreteType": "ConfluenceExternalLinkConnection",
                                    "kind": "LinkedField",
                                    "name": "externalOutgoingLinks",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceExternalLink",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "url"
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "externalOutgoingLinks(first:50)"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadOutgoingLinksQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadOutgoingLinksQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fec3092eee5be8002a509e6d3be00bc6",
            "id": "1ab71c9a12a0be2c8e5d9d99b7deecbd0116bb7ce35f6af9111a2fe2f1177c3c",
            "metadata": {},
            "name": "preloadOutgoingLinksQuery",
            "operationKind": "query",
            "text": "query preloadOutgoingLinksQuery($contentId:ID!){content(id:$contentId){nodes{id,outgoingLinks{externalOutgoingLinks(first:50){nodes{url}}}}}}"
        }
    };
}();
$be4a7160c946b27a$var$node.hash = "62d400bfa3bd0d225066bef6f6f82860";
var $be4a7160c946b27a$export$2e2bcd8739ae039 = $be4a7160c946b27a$var$node;
module.exports["default"] = $be4a7160c946b27a$export$2e2bcd8739ae039;

});

parcelRegister("8tmcF", function(module, exports) {
function $5c639d7819ef31f1$export$baa85236a0d673f4(task, returnValueOnTimeout, timeout) {
    return Promise.race([
        task(),
        new Promise((resolve)=>setTimeout(()=>{
                resolve(typeof returnValueOnTimeout === 'function' ? returnValueOnTimeout() : returnValueOnTimeout);
            }, timeout))
    ]);
}
module.exports["timeGuard"] = $5c639d7819ef31f1$export$baa85236a0d673f4;

});

parcelRegister("fh15z", function(module, exports) {

var $3Ww6H = parcelRequire("3Ww6H");


var $cNAch = parcelRequire("cNAch");

class $235e9e63ec7037ae$export$ac1cddfee07ba6ac {
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $cNAch.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $3Ww6H.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
    constructor(experienceId, config){
        this.experienceId = void 0;
        this.config = void 0;
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
}
module.exports["ConcurrentExperience"] = $235e9e63ec7037ae$export$ac1cddfee07ba6ac;

});

parcelRegister("3Ww6H", function(module, exports) {

var $jmjuG = parcelRequire("jmjuG");

const $50aee1cd0289a711$export$b4958caff08a0960 = (...args)=>{
    (0, $jmjuG.ufologger).log(...args);
};
module.exports["ufolog"] = $50aee1cd0289a711$export$b4958caff08a0960;

});

parcelRegister("jmjuG", function(module, exports) {
class $fdaa18971c6567c6$var$UFOLogger {
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($fdaa18971c6567c6$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($fdaa18971c6567c6$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
$fdaa18971c6567c6$var$UFOLogger.UFOprefix = "[ufo\uD83D\uDEF8]";
const $fdaa18971c6567c6$export$4ab84f6f04f6566d = new $fdaa18971c6567c6$var$UFOLogger();
module.exports["ufologger"] = $fdaa18971c6567c6$export$4ab84f6f04f6566d;

});

parcelRegister("cNAch", function(module, exports) {

var $YHNTN = parcelRequire("YHNTN");

class $c65b2e96b7a8c980$export$c00d22927c60484a extends (0, $YHNTN.UFOAbstractExperience) {
}
module.exports["UFOExperience"] = $c65b2e96b7a8c980$export$c00d22927c60484a;

});

parcelRegister("YHNTN", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $03RpJ = parcelRequire("03RpJ");


var $dd3JJ = parcelRequire("dd3JJ");


var $gDr1n = parcelRequire("gDr1n");


var $11QNa = parcelRequire("11QNa");


var $i3Cqs = parcelRequire("i3Cqs");


var $8D8OR = parcelRequire("8D8OR");


var $3Ww6H = parcelRequire("3Ww6H");


var $bdTYA = parcelRequire("bdTYA");


var $aNeq3 = parcelRequire("aNeq3");


var $f07wD = parcelRequire("f07wD");


var $e22Cc = parcelRequire("e22Cc");


var $j7Sza = parcelRequire("j7Sza");


var $g8bWJ = parcelRequire("g8bWJ");


var $4MiWC = parcelRequire("4MiWC");


var $DJFHw = parcelRequire("DJFHw");

const $35f46dabe2d905ec$var$getPageVisibleState = ()=>{
    return !(0, $e22Cc.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $f07wD.PageVisibleState).VISIBLE : (0, $f07wD.PageVisibleState).HIDDEN;
};
class $35f46dabe2d905ec$export$d31c89db257648c {
    async transition(newState, timestamp) {
        (0, $3Ww6H.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $g8bWJ.canTransition)(this.state, newState)) {
            (0, $3Ww6H.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $j7Sza.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = (0, $DJFHw.perfNowOrTimestamp)(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $03RpJ.default)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = (0, $DJFHw.perfNowOrTimestamp)(timestamp);
                if (!this._isManualStateEnabled()) (0, $11QNa.getGlobalEventStream)().push((0, $8D8OR.unsubscribeEvent)((0, $f07wD.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $3Ww6H.ufolog)('this.parent', this.parent);
                (0, $11QNa.getGlobalEventStream)().push((0, $gDr1n.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $3Ww6H.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $bdTYA.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $j7Sza.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $35f46dabe2d905ec$var$getPageVisibleState();
            (0, $aNeq3.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $3Ww6H.ufolog)('subscribed', this.id);
                (0, $11QNa.getGlobalEventStream)().push((0, $i3Cqs.subscribeEvent)((0, $f07wD.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $f07wD.FMP_MARK) && name !== (0, $f07wD.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $bdTYA.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: (0, $DJFHw.perfNowOrTimestamp)(timestamp)
        });
        this.transition((0, $j7Sza.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $f07wD.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $f07wD.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $bdTYA.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $aNeq3.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $j7Sza.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $j7Sza.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $j7Sza.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $3Ww6H.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $dd3JJ.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
    constructor(id, config, instanceId = null){
        this.state = (0, $j7Sza.UFOExperienceState).NOT_STARTED;
        this.id = void 0;
        this.instanceId = null;
        // for concurrent
        this.parent = null;
        this.category = null;
        this.type = void 0;
        this.performanceType = void 0;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.featureFlags = void 0;
        this.timings = void 0;
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.handleDoneBind = void 0;
        this.uuid = null;
        this.until = void 0;
        this._until = null;
        this.pageVisibleState = void 0;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.config = void 0;
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $f07wD.PageVisibleState).MIXED;
            (0, $aNeq3.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $35f46dabe2d905ec$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $4MiWC.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
}
module.exports["UFOAbstractExperience"] = $35f46dabe2d905ec$export$d31c89db257648c;

});

parcelRegister("dd3JJ", function(module, exports) {
// temp solution until we can get it automated
const $79d018f255564301$export$2295b861f318254a = '0.1.5';
module.exports["UFO_EXPERIMENTAL_BUILD_VERSION"] = $79d018f255564301$export$2295b861f318254a;

});

parcelRegister("gDr1n", function(module, exports) {

var $f07wD = parcelRequire("f07wD");

const $7cdf9804f4fb0f15$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $f07wD.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};
module.exports["experiencePayloadEvent"] = $7cdf9804f4fb0f15$export$7c957416596ca127;

});

parcelRegister("f07wD", function(module, exports) {
var $ff3bb8d57004c3c7$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $ff3bb8d57004c3c7$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $ff3bb8d57004c3c7$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $ff3bb8d57004c3c7$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $ff3bb8d57004c3c7$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $ff3bb8d57004c3c7$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $ff3bb8d57004c3c7$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $ff3bb8d57004c3c7$export$9f2bf58999404c75 = 'fmp';
const $ff3bb8d57004c3c7$export$837e0f79a8056912 = 'inline-response';
module.exports["UFOGlobalEventStreamEventType"] = $ff3bb8d57004c3c7$export$96253c35c37cf96b;
module.exports["PageVisibleState"] = $ff3bb8d57004c3c7$export$a12c67b37a306b13;
module.exports["SUBSCRIBE_ALL"] = $ff3bb8d57004c3c7$export$79bf131685ad41d7;
module.exports["FMP_MARK"] = $ff3bb8d57004c3c7$export$9f2bf58999404c75;
module.exports["INLINE_RESPONSE_MARK"] = $ff3bb8d57004c3c7$export$837e0f79a8056912;

});

parcelRegister("11QNa", function(module, exports) {

var $7Ce5m = parcelRequire("7Ce5m");

const $c1569a93aa4391e4$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < (0, $7Ce5m.MAX_EARLY_QUEUE_LENGTH)) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
module.exports["getGlobalEventStream"] = $c1569a93aa4391e4$export$6123a44dc2384540;

});

parcelRegister("7Ce5m", function(module, exports) {
const $0cc5590ab6f8b46e$export$d8b468db8a225bc9 = 250;
module.exports["MAX_EARLY_QUEUE_LENGTH"] = $0cc5590ab6f8b46e$export$d8b468db8a225bc9;

});

parcelRegister("i3Cqs", function(module, exports) {

var $f07wD = parcelRequire("f07wD");

const $a239602ece96b732$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $f07wD.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
module.exports["subscribeEvent"] = $a239602ece96b732$export$37863216db4b714d;

});

parcelRegister("8D8OR", function(module, exports) {

var $f07wD = parcelRequire("f07wD");

const $0a3f0389a9961f72$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $f07wD.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
module.exports["unsubscribeEvent"] = $0a3f0389a9961f72$export$ee1a7bd1fc9ea85e;

});

parcelRegister("bdTYA", function(module, exports) {

var $jmjuG = parcelRequire("jmjuG");

const $5c1c0b03503ca679$export$d53d07b6034c4560 = (...args)=>{
    (0, $jmjuG.ufologger).warn(...args);
};
module.exports["ufowarn"] = $5c1c0b03503ca679$export$d53d07b6034c4560;

});

parcelRegister("aNeq3", function(module, exports) {

var $e22Cc = parcelRequire("e22Cc");

class $1043fc05a880bbb3$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ if ((0, $e22Cc.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $1043fc05a880bbb3$export$13e680397ec8f3eb = new $1043fc05a880bbb3$var$VisibilityChangeObserver();
module.exports["visibilityChangeObserver"] = $1043fc05a880bbb3$export$13e680397ec8f3eb;

});

parcelRegister("e22Cc", function(module, exports) {
const $0f617bf44fb531ac$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};
module.exports["isWindowObjectAvailable"] = $0f617bf44fb531ac$export$15e172712955e18f;

});

parcelRegister("j7Sza", function(module, exports) {
const $f267d4a3139d0594$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};
module.exports["UFOExperienceState"] = $f267d4a3139d0594$export$81b70111112841a0;

});

parcelRegister("g8bWJ", function(module, exports) {

var $j7Sza = parcelRequire("j7Sza");

const $59fdb64e04330d55$var$UFOStateAvailableTransitions = {
    [(0, $j7Sza.UFOExperienceState).NOT_STARTED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).STARTED.id]: [
        (0, $j7Sza.UFOExperienceState).IN_PROGRESS.id,
        (0, $j7Sza.UFOExperienceState).BLOCKED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $j7Sza.UFOExperienceState).BLOCKED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).BLOCKED.id]: [
        (0, $j7Sza.UFOExperienceState).RECOVERED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).RECOVERED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).SUCCEEDED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).FAILED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).ABORTED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ]
};
const $59fdb64e04330d55$export$178881f329fdb81f = (state1, state2)=>{
    return $59fdb64e04330d55$var$UFOStateAvailableTransitions[state1.id] && $59fdb64e04330d55$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};
module.exports["canTransition"] = $59fdb64e04330d55$export$178881f329fdb81f;

});

parcelRegister("4MiWC", function(module, exports) {
var $d8444ff033f3362a$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $d8444ff033f3362a$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});
module.exports["ExperienceTypes"] = $d8444ff033f3362a$export$994164cf3ae1cc9a;
module.exports["ExperiencePerformanceTypes"] = $d8444ff033f3362a$export$cc26007c03242fff;

});

parcelRegister("DJFHw", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $2xhEb = parcelRequire("2xhEb");

const $56570a8acedc1b5f$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $2xhEb.roundPerfNow)();
};
module.exports["perfNowOrTimestamp"] = $56570a8acedc1b5f$export$c753e8669d30c8ad;

});

parcelRegister("2xhEb", function(module, exports) {
const $a279419ecc31ce6a$export$5f490af6b2b115cf = ()=>~~performance.now();
module.exports["roundPerfNow"] = $a279419ecc31ce6a$export$5f490af6b2b115cf;

});

parcelRegister("4o0zT", function(module, exports) {

var $cha5E = parcelRequire("cha5E");

function $36a5a3af492bc91f$export$336b018592dc9972(experimentName) {
    return (0, $cha5E.expVal)(experimentName, 'isEnabled', false) === true;
}
module.exports["isExperimentEnabled"] = $36a5a3af492bc91f$export$336b018592dc9972;

});

parcelRegister("cha5E", function(module, exports) {

var $a4RZV = parcelRequire("a4RZV");

function $62f475419a76226b$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    return (0, $a4RZV.expValInternal)(experimentName, param, defaultValue, true);
}
module.exports["expVal"] = $62f475419a76226b$export$9db1624a8af791a4;

});

parcelRegister("a4RZV", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $7OZjB = parcelRequire("7OZjB");


var $gvJlB = parcelRequire("gvJlB");

function $9b4163a3d03875dc$export$48708229abf6ab93(experimentName, param, defaultValue, fireExperimentExposure) {
    // Dev-mode override (platform website dev panel, Gemini VR test harness).
    if ((0, $gvJlB.devOverrides).has(experimentName)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const overrideParams = (0, $gvJlB.devOverrides).get(experimentName);
        const overrideValue = overrideParams[param];
        if (overrideValue !== undefined) {
            (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, overrideValue);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return overrideValue;
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return defaultValue;
    }
    // If Statsig is not initialized, return the default.
    if (!(0, $cXtTj.default).initializeCompleted()) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return defaultValue;
    // Live Statsig value.
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const value = (0, $cXtTj.default).getExperimentValue(experimentName, param, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
module.exports["expValInternal"] = $9b4163a3d03875dc$export$48708229abf6ab93;

});

parcelRegister("gvJlB", function(module, exports) {
const $bd07fe7ea4e784d1$export$89f9222be8849d61 = new Map();
let $bd07fe7ea4e784d1$export$1443858d5f82511f = false;
function $bd07fe7ea4e784d1$export$6bce865e33a255c3(value) {
    $bd07fe7ea4e784d1$export$1443858d5f82511f = value;
}
module.exports["devOverrides"] = $bd07fe7ea4e784d1$export$89f9222be8849d61;

});

parcelRegister("2pQiO", function(module, exports) {

var $a4RZV = parcelRequire("a4RZV");

function $1295d9cf79f622cc$export$da472ee01c19d92e(experimentName, param, defaultValue) {
    return (0, $a4RZV.expValInternal)(experimentName, param, defaultValue, false);
}
module.exports["UNSAFE_expValNoExposure"] = $1295d9cf79f622cc$export$da472ee01c19d92e;

});

parcelRegister("i3jcY", function(module, exports) {

const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return (window.location.search ?? '').includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("9NPFC", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


const $60cc37ad75899268$var$tileSizePx = {
    xxsmall: 16,
    xsmall: 20,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
const $60cc37ad75899268$var$styles = {
    root: "_0bjKvD0O7w _4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _3iDTPbccYA _24h04i2Njc _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _2O5VijdnbC _4ouGXIdnbC _4kiQYAdnbC _1RrJLit2nV",
    border: "_2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67",
    inset: "_3B3jB1IZbP _0LETLXIZbP _4ACwSfIZbP _2Qxi4nIZbP",
    nonInset: "_49oNbqN91d _1tJeXfN91d _0VARMJN91d _27VeLCN91d _3B3jB1N91d _0LETLXN91d _4ACwSfN91d _2Qxi4nN91d _3G0Ib8iObl"
};
const $60cc37ad75899268$var$sizeMap = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F _4ya3eEuFDC",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1 _4ya3eExpxF",
    small: "_39xV02oWWg _0jFU0VoWWg _4ya3eEEbN9",
    medium: "_39xV02Uofl _0jFU0VUofl _4ya3eEey7F",
    large: "_39xV02UF4f _0jFU0VUF4f _4ya3eESPN1",
    xlarge: "_39xV02pJKa _0jFU0VpJKa _4ya3eEoWWg"
};
const $60cc37ad75899268$var$insetSizeMap = {
    xxsmall: "_49oNbquFDC _1tJeXfuFDC _0VARMJuFDC _27VeLCuFDC _0mzAWiNKBH _3woHNtNKBH _430i96NKBH _1GBPVvNKBH",
    xsmall: "_49oNbqxpxF _1tJeXfxpxF _0VARMJxpxF _27VeLCxpxF _0mzAWiqBG1 _3woHNtqBG1 _430i96qBG1 _1GBPVvqBG1",
    small: "_49oNbqEbN9 _1tJeXfEbN9 _0VARMJEbN9 _27VeLCEbN9 _0mzAWif9wp _3woHNtf9wp _430i96f9wp _1GBPVvf9wp",
    medium: "_49oNbqey7F _1tJeXfey7F _0VARMJey7F _27VeLCey7F _0mzAWiIRC9 _3woHNtIRC9 _430i96IRC9 _1GBPVvIRC9",
    large: "_49oNbqSPN1 _1tJeXfSPN1 _0VARMJSPN1 _27VeLCSPN1 _0mzAWiPcut _3woHNtPcut _430i96Pcut _1GBPVvPcut",
    xlarge: "_49oNbqoWWg _1tJeXfoWWg _0VARMJoWWg _27VeLCoWWg _0mzAWiY6u9 _3woHNtY6u9 _430i96Y6u9 _1GBPVvY6u9"
};
const $60cc37ad75899268$var$backgroundColorMap = {
    white: "_0KLXrut28M",
    black: "_0KLXru52mJ",
    transparent: "_0KLXrujOvk",
    'color.background.accent.lime.subtlest': "_0KLXruXL80",
    'color.background.accent.lime.subtler': "_0KLXruuKDS",
    'color.background.accent.lime.subtle': "_0KLXruZcd0",
    'color.background.accent.lime.bolder': "_0KLXrubYhN",
    'color.background.accent.red.subtlest': "_0KLXrusDFP",
    'color.background.accent.red.subtler': "_0KLXrubV9i",
    'color.background.accent.red.subtle': "_0KLXru0cUQ",
    'color.background.accent.red.bolder': "_0KLXruQrW1",
    'color.background.accent.orange.subtlest': "_0KLXru2QQR",
    'color.background.accent.orange.subtler': "_0KLXruwJ86",
    'color.background.accent.orange.subtle': "_0KLXruuwVU",
    'color.background.accent.orange.bolder': "_0KLXrux4f7",
    'color.background.accent.yellow.subtlest': "_0KLXru56u3",
    'color.background.accent.yellow.subtler': "_0KLXruLv9B",
    'color.background.accent.yellow.subtle': "_0KLXruC29w",
    'color.background.accent.yellow.bolder': "_0KLXruYB6L",
    'color.background.accent.green.subtlest': "_0KLXruV6wL",
    'color.background.accent.green.subtler': "_0KLXruNUep",
    'color.background.accent.green.subtle': "_0KLXru50ZN",
    'color.background.accent.green.bolder': "_0KLXrude1t",
    'color.background.accent.teal.subtlest': "_0KLXruuBpz",
    'color.background.accent.teal.subtler': "_0KLXrunfgW",
    'color.background.accent.teal.subtle': "_0KLXrufjGw",
    'color.background.accent.teal.bolder': "_0KLXruzHaB",
    'color.background.accent.blue.subtlest': "_0KLXruVva3",
    'color.background.accent.blue.subtler': "_0KLXrup9dS",
    'color.background.accent.blue.subtle': "_0KLXru28sy",
    'color.background.accent.blue.bolder': "_0KLXrutfbE",
    'color.background.accent.purple.subtlest': "_0KLXruB8KG",
    'color.background.accent.purple.subtler': "_0KLXruWOdT",
    'color.background.accent.purple.subtle': "_0KLXruf89Q",
    'color.background.accent.purple.bolder': "_0KLXruhdss",
    'color.background.accent.magenta.subtlest': "_0KLXru8frT",
    'color.background.accent.magenta.subtler': "_0KLXruXM4x",
    'color.background.accent.magenta.subtle': "_0KLXrupmfs",
    'color.background.accent.magenta.bolder': "_0KLXruxE6Y",
    'color.background.accent.gray.subtlest': "_0KLXrumhAQ",
    'color.background.accent.gray.subtler': "_0KLXruG6qS",
    'color.background.accent.gray.subtle': "_0KLXrueZ10",
    'color.background.accent.gray.bolder': "_0KLXrurxgm",
    'color.background.inverse.subtle': "_0KLXruB4sa",
    'color.background.neutral': "_0KLXruDMqu",
    'color.background.neutral.bold': "_0KLXrugozt",
    'color.background.brand.subtlest': "_0KLXrunl7T",
    'color.background.brand.bold': "_0KLXruDM2k",
    'color.background.brand.boldest': "_0KLXru2o0p",
    'color.background.danger': "_0KLXruhH7k",
    'color.background.danger.bold': "_0KLXruqsXs",
    'color.background.warning': "_0KLXruhxIM",
    'color.background.warning.bold': "_0KLXruKLKE",
    'color.background.success': "_0KLXruzaZe",
    'color.background.success.bold': "_0KLXruhbjP",
    'color.background.discovery': "_0KLXru94rk",
    'color.background.discovery.bold': "_0KLXruqjHC",
    'color.background.information': "_0KLXrugNg3",
    'color.background.information.bold': "_0KLXruASYT"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
const $60cc37ad75899268$var$Tile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Tile(props) {
    const $ = (0, $bDgLe.c)(17);
    const { children: children, label: label, size: t0, backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: t1, testId: testId } = props;
    const size = t0 === undefined ? "medium" : t0;
    const isInset = t1 === undefined ? true : t1;
    const containerRef = (0, $cozmU.useRef)(null);
    let t2;
    if ($[0] !== size) {
        t2 = ()=>{
            return;
        };
        $[0] = size;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== size) {
        t3 = [
            children,
            size
        ];
        $[2] = children;
        $[3] = size;
        $[4] = t3;
    } else t3 = $[4];
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = label !== "" ? label : undefined;
    const t5 = label !== "" ? "img" : undefined;
    const t6 = $60cc37ad75899268$var$sizeMap[size];
    const t7 = isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset;
    const t8 = isInset && $60cc37ad75899268$var$insetSizeMap[size];
    const t9 = $60cc37ad75899268$var$backgroundColorMap[backgroundColor || "color.background.neutral"];
    const t10 = hasBorder && $60cc37ad75899268$var$styles.border;
    let t11;
    if ($[5] !== t10 || $[6] !== t6 || $[7] !== t7 || $[8] !== t8 || $[9] !== t9) {
        t11 = (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            t6,
            t7,
            t8,
            t9,
            t10
        ]);
        $[5] = t10;
        $[6] = t6;
        $[7] = t7;
        $[8] = t8;
        $[9] = t9;
        $[10] = t11;
    } else t11 = $[10];
    let t12;
    if ($[11] !== children || $[12] !== t11 || $[13] !== t4 || $[14] !== t5 || $[15] !== testId) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            ref: containerRef,
            "data-testid": testId,
            "aria-label": t4,
            role: t5,
            className: t11,
            children: children
        });
        $[11] = children;
        $[12] = t11;
        $[13] = t4;
        $[14] = t5;
        $[15] = testId;
        $[16] = t12;
    } else t12 = $[16];
    return t12;
} : function Tile(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    const containerRef = (0, $cozmU.useRef)(null); // Dev-mode only: validate that raster images passed into the tile
    // are square and retina-compatible (at least 2x the rendered tile size).
    (0, $cozmU.useEffect)(()=>{
        return;
    }, [
        children,
        size
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ref: containerRef,
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            $60cc37ad75899268$var$sizeMap[size],
            isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset,
            isInset && $60cc37ad75899268$var$insetSizeMap[size],
            $60cc37ad75899268$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $60cc37ad75899268$var$styles.border
        ]),
        children: children
    });
};
var $60cc37ad75899268$export$2e2bcd8739ae039 = $60cc37ad75899268$var$Tile;
function $60cc37ad75899268$var$_temp(fn) {
    return fn();
}
module.exports["default"] = $60cc37ad75899268$export$2e2bcd8739ae039;

});

parcelRegister("ai0Ge", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $d4GYd = parcelRequire("d4GYd");


var $gEyoZ = parcelRequire("gEyoZ");

const $36820b590bf4d8fd$var$BlogObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BlogObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Blog" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BlogObjectTile({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $36820b590bf4d8fd$export$2e2bcd8739ae039 = $36820b590bf4d8fd$var$BlogObjectTile;
module.exports["default"] = $36820b590bf4d8fd$export$2e2bcd8739ae039;

});

parcelRegister("gEyoZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $9NPFC = parcelRequire("9NPFC");

/**
 * __Object tile base__
 *
 * An object tile represents an Atlassian-specific content type.
 *
 */ const $e64fa8a7fc69b505$var$ObjectTileBase = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ObjectTileBase(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { label: t1, size: t2, testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const validSizes = [
        "xsmall",
        "small",
        "medium",
        "large",
        "xlarge"
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(", ")}`);
    let t3;
    if ($[0] !== Icon || $[1] !== color || $[2] !== label || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            shouldScale: true
        });
        $[0] = Icon;
        $[1] = color;
        $[2] = label;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== backgroundColor || $[6] !== size || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default), {
            label: "",
            backgroundColor: backgroundColor,
            size: size,
            children: t3
        });
        $[5] = backgroundColor;
        $[6] = size;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function ObjectTileBase({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            // @ts-expect-error - Internal, undocumented prop
            shouldScale: true
        })
    });
};
var $e64fa8a7fc69b505$export$2e2bcd8739ae039 = $e64fa8a7fc69b505$var$ObjectTileBase;
module.exports["default"] = $e64fa8a7fc69b505$export$2e2bcd8739ae039;

});

parcelRegister("7pJjg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $4hmAW = parcelRequire("4hmAW");

const $5d24b7fd99811061$var$PageLiveDocObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageLiveDocObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            color: "var(--ds-icon-accent-magenta, #CD519D)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageLiveDocObject({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
};
var $5d24b7fd99811061$export$2e2bcd8739ae039 = $5d24b7fd99811061$var$PageLiveDocObject;
module.exports["default"] = $5d24b7fd99811061$export$2e2bcd8739ae039;

});

parcelRegister("kLlYX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::80e1615540ac9d82a9937150e7cfa4ab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1d93fa86ac2ebd2$var$_react = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f1d93fa86ac2ebd2$var$_iconNew = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f1d93fa86ac2ebd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/page-live-doc
 * Usage guidance:
 * Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1d93fa86ac2ebd2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $f1d93fa86ac2ebd2$var$_react.default.createElement($f1d93fa86ac2ebd2$var$_iconNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$f1d93fa86ac2ebd2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $f1d93fa86ac2ebd2$var$_default = module.exports.default = $f1d93fa86ac2ebd2$var$PageLiveDocIcon;

});

parcelRegister("dipyx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $gEyoZ = parcelRequire("gEyoZ");

const $5d01faeb97b0ed22$var$PageLiveDocObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageLiveDocObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)";
    const t3 = isBold ? "color.background.accent.magenta.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PageLiveDocObjectTile({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
};
var $5d01faeb97b0ed22$export$2e2bcd8739ae039 = $5d01faeb97b0ed22$var$PageLiveDocObjectTile;
module.exports["default"] = $5d01faeb97b0ed22$export$2e2bcd8739ae039;

});

parcelRegister("i9pyX", function(module, exports) {

var $fExfj = parcelRequire("fExfj");


var $bZF61 = parcelRequire("bZF61");


var $fyjce = parcelRequire("fyjce");


var $9C63M = parcelRequire("9C63M");


var $bfpjP = parcelRequire("bfpjP");


var $d9nAp = parcelRequire("d9nAp");

const $c1ab7bf16286d454$var$RELATIVE_URL = '/gateway/api/xpsearch-aggregator/configuration/v1';
const $c1ab7bf16286d454$var$RELATIVE_URL_V2 = '/gateway/api/xpsearch-aggregator/api/v2/configuration';
const $c1ab7bf16286d454$var$RELATIVE_3P_URL = '/gateway/api/third-party-configuration/connected-data-sources';
const $c1ab7bf16286d454$var$RELATIVE_LOOM_AUTH_URL = '/gateway/api/loom-auth/api/internal/identity/user-status';
const $c1ab7bf16286d454$export$19524a749d98a458 = 'search-config';
const $c1ab7bf16286d454$export$cf95148f36a28b96 = 'search-3p-config';
const $c1ab7bf16286d454$export$44d1e7c4ef26c467 = 'loom-user-auth';
const { refreshOnAccessDecorator: $c1ab7bf16286d454$var$refreshOnAccessDecoratorSearch } = (0, $fyjce.promiseCache)({
    name: $c1ab7bf16286d454$export$19524a749d98a458
});
const { refreshOnAccessDecorator: $c1ab7bf16286d454$var$refreshOnAccessDecorator3pSearch, update: $c1ab7bf16286d454$var$update3pCache } = (0, $fyjce.promiseCache)({
    name: $c1ab7bf16286d454$export$cf95148f36a28b96,
    expiration: 300000
});
const { refreshOnAccessDecorator: $c1ab7bf16286d454$var$refreshOnAccessDecoratorUserLoomAuth } = (0, $fyjce.promiseCache)({
    name: $c1ab7bf16286d454$export$44d1e7c4ef26c467
});
const $c1ab7bf16286d454$var$SITELESS_PRODUCTS = [
    'trello',
    'bitbucket'
];
/**
 * Creates a traceInfoExtractor that reads from a mutable headers reference.
 * Used by REST config endpoints to extract requestId/traceId from HTTP response headers
 * without storing them in the cache.
 */ const $c1ab7bf16286d454$var$createTraceInfoExtractor = (headersRef)=>{
    return ()=>{
        const headers = headersRef();
        const requestId = headers['atl-request-id'];
        const traceId = headers['x-trace-id'];
        if (requestId || traceId) return {
            requestId: requestId,
            traceId: traceId
        };
        return undefined;
    };
};
const $c1ab7bf16286d454$export$2e9655e8b4177582 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration })=>{
    const url = absoluteUrl || `${hostName || ''}${$c1ab7bf16286d454$var$RELATIVE_URL}`;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $bZF61.generateHash)(`1p|${userId}|${cloudId}`);
    const supplier = ()=>(0, $fExfj.utils).requestService({
            url: url
        }, options).then((data)=>{
            const resources = data.resources.filter((resource)=>cloudId ? resource.id.includes(cloudId) || $c1ab7bf16286d454$var$SITELESS_PRODUCTS.find((product)=>resource.id.includes(product)) // Allow access to products that are not associated with a site
                 : true);
            return {
                resources: resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
    return $c1ab7bf16286d454$var$refreshOnAccessDecoratorSearch({
        key: key.toString(),
        supplier: supplier,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        serveResolvedDuringRefresh: true
    });
};
const $c1ab7bf16286d454$export$c6f4290269f11bd5 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, cacheAnalyticsCallback: cacheAnalyticsCallback, degradationCallback: degradationCallback = ()=>{}, returnExpired: returnExpired, networkCallbacks: networkCallbacks })=>{
    const url = absoluteUrl || `${hostName || ''}${$c1ab7bf16286d454$var$RELATIVE_URL_V2}/${cloudId}`;
    const queryParams = {
        operationName: 'searchPageFirstPartyConfig'
    };
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        },
        queryParams: queryParams
    };
    const key = (0, $bZF61.generateHash)(`1p|${userId}|${cloudId}|v2`);
    // Mutable reference for capturing tracing headers from the REST response.
    // Set by the supplier's reportTracingHeaders callback, read by traceInfoExtractor.
    // This avoids storing tracing headers in the cache — they're only used transiently for VitalStats events.
    let capturedTracingHeaders = {};
    const supplier = ()=>{
        capturedTracingHeaders = {};
        const searchConfigPromise = (0, $fExfj.utils).requestService({
            url: url
        }, {
            ...options,
            reportTracingHeaders: (headers)=>{
                capturedTracingHeaders = headers;
            }
        }).then((data)=>{
            return {
                resources: data.resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
        // Two cases here, due to the promiseCache from refreshOnAccessDecoratorSearch below
        // 1. Cache-miss: we of course want to handle degradation!
        // 2. Cache-hit: we actually still want to handle degradation, because if we can't refresh the cache due to a slow dependency, that is a signal we need in healthchecks
        // The alternate approach here would be to wrap the promiseCache in the DegradablePromise, but then we'd only get degradation pings on cache-miss.
        const degrader = new (0, $9C63M.DegradablePromise)(searchConfigPromise, degradationCallback);
        return degrader.promise();
    };
    const traceInfoExtractor = $c1ab7bf16286d454$var$createTraceInfoExtractor(()=>capturedTracingHeaders);
    return $c1ab7bf16286d454$var$refreshOnAccessDecoratorSearch({
        key: key.toString(),
        supplier: supplier,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        returnExpired: returnExpired,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true,
        traceInfoExtractor: traceInfoExtractor
    });
};
const $c1ab7bf16286d454$export$6916ea7f169882e0 = async ({ absoluteUrl: absoluteUrl = '', cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, cacheAnalyticsCallback: cacheAnalyticsCallback, degradationCallback: degradationCallback = ()=>{}, returnExpired: returnExpired, networkCallbacks: networkCallbacks })=>{
    const baseUrl = absoluteUrl || $c1ab7bf16286d454$var$RELATIVE_3P_URL;
    const url = `${baseUrl}/${cloudId}`;
    const queryParams = {
        operationName: 'searchPageThirdPartyConfig'
    };
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        },
        queryParams: queryParams
    };
    const key = (0, $d9nAp.generate3pHash)(userId || '', cloudId || '');
    // Mutable reference for capturing tracing headers from the REST response.
    // Set by the supplier's reportTracingHeaders callback, read by traceInfoExtractor.
    // This avoids storing tracing headers in the cache — they're only used transiently for VitalStats events.
    let capturedTracingHeaders = {};
    const supplier = ()=>{
        capturedTracingHeaders = {};
        const searchConfig3PPromise = (0, $fExfj.utils).requestService({
            url: url
        }, {
            ...options,
            reportTracingHeaders: (headers)=>{
                capturedTracingHeaders = headers;
            }
        });
        // Two cases here, due to the promiseCache from refreshOnAccessDecorator3pSearch below
        // 1. Cache-miss: we of course want to handle degradation!
        // 2. Cache-hit: we actually still want to handle degradation, because if we can't refresh the cache due to a slow dependency, that is a signal we need in healthchecks
        // The alternate approach here would be to wrap the promiseCache in the DegradablePromise, but then we'd only get degradation pings on cache-miss.
        const degrader = new (0, $9C63M.DegradablePromise)(searchConfig3PPromise, degradationCallback);
        return degrader.promise();
    };
    const traceInfoExtractor = $c1ab7bf16286d454$var$createTraceInfoExtractor(()=>capturedTracingHeaders);
    return $c1ab7bf16286d454$var$refreshOnAccessDecorator3pSearch({
        key: key.toString(),
        supplier: supplier,
        returnExpired: returnExpired,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true,
        traceInfoExtractor: traceInfoExtractor
    });
};
const $c1ab7bf16286d454$export$b75556aa5958ec1f = (userId, cloudId, updater)=>{
    const key = (0, $d9nAp.generate3pHash)(userId, cloudId);
    return $c1ab7bf16286d454$var$update3pCache(key.toString(), updater);
};
const $c1ab7bf16286d454$export$46e3d34ee7b8c58a = async ({ cloudId: cloudId, userId: userId })=>{
    const url = $c1ab7bf16286d454$var$RELATIVE_LOOM_AUTH_URL;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $bfpjP.generateLoomAuthHash)(userId || '', cloudId || '');
    const supplier = ()=>(0, $fExfj.utils).requestService({
            url: url
        }, options);
    return $c1ab7bf16286d454$var$refreshOnAccessDecoratorUserLoomAuth({
        key: key.toString(),
        supplier: supplier,
        returnExpired: false
    });
};
module.exports["getSearchConfigV2"] = $c1ab7bf16286d454$export$c6f4290269f11bd5;
module.exports["get3pSearchConfig"] = $c1ab7bf16286d454$export$6916ea7f169882e0;
module.exports["update3pConfigCacheEntry"] = $c1ab7bf16286d454$export$b75556aa5958ec1f;
module.exports["getUserLoomAuthStatus"] = $c1ab7bf16286d454$export$46e3d34ee7b8c58a;

});

parcelRegister("bZF61", function(module, exports) {
/**
 * Simple implementation of djb2 hashing.
 * The reason we have it internally is because at the moment we can't add new
 * dependencies into search-client package as it triggers a deprecated VR test in Editor
 * and it is locked down. So it fails to resolve the new dependency
 */ const $a6b1de276595dc61$export$daf4c137c5f56404 = (query)=>{
    let hash = 5381;
    for(let i = 0; i < query.length; i++){
        const char = query.charCodeAt(i);
        hash = (hash << 5) + hash + char; /* hash * 33 + char */ 
    }
    return hash;
};
const $a6b1de276595dc61$export$5c07a4287a46fa1f = (variables)=>{
    try {
        return $a6b1de276595dc61$export$daf4c137c5f56404(JSON.stringify(variables)).toString();
    } catch (e) {
        return '';
    }
};
module.exports["generateHash"] = $a6b1de276595dc61$export$daf4c137c5f56404;
module.exports["generateHashFromVariables"] = $a6b1de276595dc61$export$5c07a4287a46fa1f;

});

parcelRegister("fyjce", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $6dPGs = parcelRequire("6dPGs");


var $6s56R = parcelRequire("6s56R");


var $8N8EQ = parcelRequire("8N8EQ");


var $7jITD = parcelRequire("7jITD");


var $5oT59 = parcelRequire("5oT59");


var $esAoV = parcelRequire("esAoV");

const $86ca83201018b107$export$e89e805418f4d2c = (args)=>{
    const { name: name, shouldUseStorageAdapter: shouldUseStorageAdapter } = args;
    let cacheInstance = null;
    let resolvedStorage = null;
    // During refresh, the main cache will hold pending promises so we need a way to access the last resolved value
    // This cache can return these values while the refresh is in progress
    const resolvedValueCache = new Map();
    /**
   * NOTE: Scope control (QS-9209)
   *
   * The storage adapter system is introduced specifically so the combined search config cache
   * can participate in host-provided persistence (e.g., Confluence SSR local storage).
   */ const COMBINED_CONFIG_PERSISTED_CACHE_KEY = (0, $5oT59.SEARCH_COMBINED_CONFIG_CACHE_KEY);
    const defaultLocalStorageAdapter = {
        getItem: (key)=>(0, $6dPGs.getLocalStorageItemAsString)(key),
        setItem: (key, value)=>(0, $6dPGs.setLocalStorageItem)(key, value)
    };
    function shouldUseAdapterSystemForThisCache() {
        // Explicit opt-in/out takes precedence (lets two caches share a `name` but
        // target different storage — bare key vs host-adapter/account-namespaced key).
        // When unspecified, preserve the historical behaviour: the combined-config
        // cache routes through the host adapter so the legacy path is untouched.
        if (shouldUseStorageAdapter !== undefined && ((0, $iDrrr.fg)('rovo_fps_use_rovo_config') || (0, $6s56R.isUsingRovoConfigStoreExperiment)())) return shouldUseStorageAdapter;
        return name === COMBINED_CONFIG_PERSISTED_CACHE_KEY;
    }
    const getCacheInstance = ()=>{
        /**
     * We lazily create the cache instance to avoid the issue in SSR
     * where the localStorage isn't available.
     */ if (!cacheInstance) {
            cacheInstance = (0, $7jITD.getInstance)(args);
            // Resolve persisted state lazily (SSR-safe)
            let persistedState = null;
            try {
                if (shouldUseAdapterSystemForThisCache()) {
                    const factory = (0, $esAoV.getSearchClientStorageAdapterFactory)();
                    if (factory) {
                        resolvedStorage = factory();
                        persistedState = resolvedStorage?.getItem(name) ?? null;
                    }
                    // If the adapter cache is cold or the factory isn't registered yet, fall back
                    // to the raw localStorage key. This ensures stale-but-present data is served
                    // immediately rather than blocking on the network and potentially timing out
                    // the DegradablePromise.
                    // SSR-safe: getLocalStorageItemAsString throws in SSR -> caught by outer try/catch.
                    if (!persistedState) persistedState = (0, $6dPGs.getLocalStorageItemAsString)(name);
                } else persistedState = (0, $6dPGs.getLocalStorageItemAsString)(name);
            } catch  {
            // Error retrieving persisted state - continue without it
            }
            if (persistedState) {
                // Populate the resolved value cache with the contents of local storage
                const object = cacheInstance.deserialize(persistedState);
                if (object) Object.entries(object).forEach(([key, entry])=>{
                    if (entry && 'result' in entry) resolvedValueCache.set(key, entry.result);
                });
            }
        }
        return cacheInstance;
    };
    const get = (key, returnExpired)=>{
        const storedValue = getCacheInstance().get(key, returnExpired ?? true); // fetch expired result by default
        const isExpired = getCacheInstance().isExpired(key);
        return {
            storedValue: storedValue,
            isExpired: isExpired
        };
    };
    const set = async (key, result, expiration)=>{
        getCacheInstance().set(key, result, expiration);
        try {
            const resolvedValue = await result;
            resolvedValueCache.set(key, resolvedValue);
            const serialized = await getCacheInstance().serialize();
            if (serialized) {
                if (shouldUseAdapterSystemForThisCache()) {
                    const adapter = resolvedStorage ?? (0, $esAoV.getSearchClientStorageAdapterFactory)()?.() ?? defaultLocalStorageAdapter;
                    adapter.setItem(name, serialized);
                } else (0, $6dPGs.setLocalStorageItem)(name, serialized);
            }
        } catch  {
        // noop - an exception in the result promise or serialisation should be ignored so we dont throw unhandled exceptions
        }
    };
    const update = async (key, updater, expiration)=>{
        // Read remaining TTL before get(), which removes expired entries from the map
        const remainingTtl = expiration ?? getCacheInstance().getRemainingTtl(key);
        const { storedValue: storedValue } = get(key, true);
        if (!storedValue) return false;
        try {
            const currentValue = await storedValue;
            const updatedValue = updater(currentValue);
            await set(key, Promise.resolve(updatedValue), remainingTtl || undefined);
            return true;
        } catch  {
            return false;
        }
    };
    const clear = (key)=>{
        if (key) resolvedValueCache.delete(key);
        else resolvedValueCache.clear();
        getCacheInstance().clear(key);
    };
    const refreshOnAccessDecorator = ({ key: key, supplier: supplier, returnExpired: returnExpired, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, analyticsCallback: analyticsCallback, networkCallbacks: networkCallbacks, serveResolvedDuringRefresh: serveResolvedDuringRefresh, traceInfoExtractor: traceInfoExtractor })=>{
        const { storedValue: storedValue, isExpired: isExpired } = get(key, returnExpired);
        const shouldRefresh = onlyRefreshIfExpired ? isExpired : true;
        // When enabled, returns already-resolved values from an in-memory cache during background
        // refresh instead of returning pending promises. Callers can opt out by passing false.
        const serveResolvedDuringRefreshEnabled = serveResolvedDuringRefresh ?? false;
        if (!storedValue || shouldRefresh) {
            // Wrap the supplier to track network calls
            const trackedSupplier = async ()=>{
                networkCallbacks?.onStart();
                try {
                    const result = await supplier();
                    const traceInfo = traceInfoExtractor ? traceInfoExtractor() : (0, $8N8EQ.extractTraceInfoFromResponse)(result);
                    networkCallbacks?.onSuccess(traceInfo);
                    return result;
                } catch (error) {
                    const errorName = error?.name || 'UnknownError';
                    const errorMessage = error?.message || 'An unknown error occurred';
                    networkCallbacks?.onError(errorName, errorMessage, undefined);
                    throw error;
                }
            };
            const apiPromise = trackedSupplier();
            set(key, apiPromise, expiration);
            // If there was already a stored value prior to refreshing, return it
            if (storedValue) {
                if (analyticsCallback) analyticsCallback({
                    refreshTriggered: true,
                    hit: true
                });
                // Return resolved value if serveResolvedDuringRefresh is enabled and we have it cached
                if (serveResolvedDuringRefreshEnabled) {
                    const resolvedValue = resolvedValueCache.get(key);
                    if (resolvedValue !== undefined) return resolvedValue;
                }
                return storedValue;
            } else {
                if (analyticsCallback) analyticsCallback({
                    refreshTriggered: true,
                    hit: false
                });
                return apiPromise;
            }
        } else {
            if (analyticsCallback) analyticsCallback({
                refreshTriggered: false,
                hit: true
            });
            // Return resolved value if serveResolvedDuringRefresh is enabled and we have it cached
            if (serveResolvedDuringRefreshEnabled) {
                const resolvedValue = resolvedValueCache.get(key);
                if (resolvedValue !== undefined) return resolvedValue;
            }
            return storedValue;
        }
    };
    const seed = (key, value, expiration)=>set(key, Promise.resolve(value), expiration);
    return {
        get: get,
        refreshOnAccessDecorator: refreshOnAccessDecorator,
        clear: clear,
        update: update,
        seed: seed
    };
};
module.exports["promiseCache"] = $86ca83201018b107$export$e89e805418f4d2c;

});

parcelRegister("6dPGs", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7dBf8 = parcelRequire("7dBf8");

// `localStorage` is a browser-only Web API and does not exist during server-side
// rendering (SSR). Accessing the bare `localStorage` identifier on the server
// throws a `ReferenceError`, which crashes the render.
const $96c9493b1d7fc1a3$var$isLocalStorageAvailable = ()=>{
    return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
};
const $96c9493b1d7fc1a3$export$5aa524d86254b4f = (key, value)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return;
    if ((0, $iDrrr.fg)('search_page_use_browser_storage_controls')) (0, $7dBf8.AtlBrowserStorageLocal).setItem(key, value);
    else // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(key, value);
};
const $96c9493b1d7fc1a3$export$93d719890ad66653 = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return null;
    const item = (0, $iDrrr.fg)('search_page_use_browser_storage_controls') ? (0, $7dBf8.AtlBrowserStorageLocal).getItem(key) : // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
};
const $96c9493b1d7fc1a3$export$5df15f289f441790 = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return null;
    const item = (0, $iDrrr.fg)('search_page_use_browser_storage_controls') ? (0, $7dBf8.AtlBrowserStorageLocal).getItem(key) : // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(key);
    return item ? item : null;
};
const $96c9493b1d7fc1a3$export$baf306891f1b93bd = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return;
    if ((0, $iDrrr.fg)('search_page_use_browser_storage_controls')) (0, $7dBf8.AtlBrowserStorageLocal).removeItem(key);
    else // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(key);
};
module.exports["setLocalStorageItem"] = $96c9493b1d7fc1a3$export$5aa524d86254b4f;
module.exports["getLocalStorageItem"] = $96c9493b1d7fc1a3$export$93d719890ad66653;
module.exports["getLocalStorageItemAsString"] = $96c9493b1d7fc1a3$export$5df15f289f441790;
module.exports["removeLocalStorageItem"] = $96c9493b1d7fc1a3$export$baf306891f1b93bd;

});

parcelRegister("6s56R", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $0f4933595e34bba8$export$aa9f97d4dfccb6ff = ()=>{
    if ((0, $iDrrr.fg)('rovo_cas_use_rovo_config')) return true;
    return (0, $cXtTj.default).getExperimentValue('rovo_cas_use_rovo_config_exp', 'cohort', 'control') === 'test';
};
module.exports["isUsingRovoConfigStoreExperiment"] = $0f4933595e34bba8$export$aa9f97d4dfccb6ff;

});

parcelRegister("8N8EQ", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $20c1508e7bfb5af0$var$NOT_AVAILABLE = 'not_available';
/**
 * HTTP response headers the gateway returns its trace / request IDs on. `fetchAgg` copies these
 * onto the parsed result as `gatewayTracingHeaders`.
 */ const $20c1508e7bfb5af0$var$TRACE_ID_HEADER = 'x-trace-id';
const $20c1508e7bfb5af0$var$REQUEST_ID_HEADER = 'atl-request-id';
const $20c1508e7bfb5af0$export$fca3401e33379daf = (result)=>{
    if (!result || typeof result !== 'object') return undefined;
    const preferTracingHeaders = (0, $iDrrr.fg)('rovo-search-vitalstats-trace-from-headers');
    if (preferTracingHeaders) {
        const tracingHeaders = result.gatewayTracingHeaders;
        const traceId = tracingHeaders?.[$20c1508e7bfb5af0$var$TRACE_ID_HEADER];
        const requestId = tracingHeaders?.[$20c1508e7bfb5af0$var$REQUEST_ID_HEADER];
        if (traceId || requestId) return {
            requestId: requestId,
            traceId: traceId
        };
    }
    if ('extensions' in result) {
        const extensions = result.extensions;
        const gateway = extensions?.gateway;
        if (gateway) return {
            requestId: gateway.request_id ?? undefined,
            // `tId` is the current gateway field name, `trace_id` the older one.
            traceId: preferTracingHeaders ? gateway.tId ?? gateway.trace_id ?? undefined : gateway.trace_id ?? undefined
        };
    }
    return undefined;
};
const $20c1508e7bfb5af0$export$4acb28c262cd52bd = (traceInfo)=>({
        requestId: traceInfo?.requestId ?? $20c1508e7bfb5af0$var$NOT_AVAILABLE,
        traceId: traceInfo?.traceId ?? $20c1508e7bfb5af0$var$NOT_AVAILABLE
    });
module.exports["extractTraceInfoFromResponse"] = $20c1508e7bfb5af0$export$fca3401e33379daf;
module.exports["normaliseTraceInfo"] = $20c1508e7bfb5af0$export$4acb28c262cd52bd;

});

parcelRegister("7jITD", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $df3ea53f68f38eaa$var$DEFAULT_EXPIRATION = 900000; // 15 mins in milliseconds
const $df3ea53f68f38eaa$var$PERSISTED_EXPIRATION_GRACE_PERIOD = 86400000;
class $df3ea53f68f38eaa$var$Cache {
    get(key, returnExpired = false) {
        const entry = this.map[key];
        if (entry) {
            if (entry.isExpired()) {
                delete this.map[key];
                return returnExpired ? entry.getResult() : undefined;
            } else return entry.getResult();
        }
        return;
    }
    set(key, result, expiration) {
        const entry = new $df3ea53f68f38eaa$var$Entry({
            result: result,
            expirationTime: Date.now() + (expiration || this.expiration),
            accessCount: 0
        });
        this.map[key] = entry;
    }
    has(key) {
        return key in this.map;
    }
    clear(key) {
        if (key) delete this.map[key];
        else this.map = {};
    }
    async serialize() {
        const serialized = {};
        const cleanupEnabled = (0, $iDrrr.fg)('search_cache_cleanup_on_write');
        const cutoff = Date.now() - $df3ea53f68f38eaa$var$PERSISTED_EXPIRATION_GRACE_PERIOD;
        const resolvers = Object.entries(this.map).map(([key, entry])=>(async ()=>{
                // Filter persistence only: stale responses remain available in memory.
                // Skip before awaiting so obsolete promises cannot block this write.
                if (cleanupEnabled && entry.getExpirationTime() < cutoff) return;
                serialized[key] = {
                    result: await entry.getResult(),
                    expirationTime: entry.getExpirationTime(),
                    accessCount: entry.getAccessCount()
                };
            })());
        await Promise.all(resolvers);
        return JSON.stringify(serialized);
    }
    deserialize(persisted) {
        try {
            const object = JSON.parse(persisted);
            for(const key in object){
                const { result: result, expirationTime: expirationTime, accessCount: accessCount } = object[key];
                this.map[key] = new $df3ea53f68f38eaa$var$Entry({
                    result: Promise.resolve(result),
                    expirationTime: expirationTime,
                    accessCount: accessCount
                });
            }
            return object;
        } catch  {
        // TODO: Log error via sentry
        }
        return undefined;
    }
    isExpired(key) {
        const entry = this.map[key];
        return entry ? entry.isExpired() : true;
    }
    getRemainingTtl(key) {
        const entry = this.map[key];
        if (!entry) return undefined;
        return Math.max(0, entry.getExpirationTime() - Date.now());
    }
    constructor(args = {}){
        this.map = void 0;
        this.expiration = void 0;
        const { expiration: expiration = $df3ea53f68f38eaa$var$DEFAULT_EXPIRATION } = args;
        this.map = {};
        this.expiration = expiration;
    }
}
class $df3ea53f68f38eaa$var$Entry {
    getResult() {
        this.accessCount++;
        return this.result;
    }
    isExpired() {
        return this.expirationTime < Date.now();
    }
    getExpirationTime() {
        return this.expirationTime;
    }
    getAccessCount() {
        return this.accessCount;
    }
    constructor({ result: result, expirationTime: expirationTime, accessCount: accessCount }){
        this.result = void 0;
        this.expirationTime = void 0;
        this.accessCount = void 0;
        this.result = result;
        this.expirationTime = expirationTime;
        this.accessCount = accessCount;
    }
}
const $df3ea53f68f38eaa$export$8bedcca5bbd73999 = (args)=>{
    return new $df3ea53f68f38eaa$var$Cache(args);
};
module.exports["getInstance"] = $df3ea53f68f38eaa$export$8bedcca5bbd73999;

});

parcelRegister("9C63M", function(module, exports) {
$parcel$export(module.exports, "DegradeError", () => (parcelRequire("aHhuQ")).DegradeError);

var $aHhuQ = parcelRequire("aHhuQ");

const $40115e6ed8d3612b$export$ff01cc10d3c607be = 6000; // default timeout
const $40115e6ed8d3612b$var$DEGRADE_ERROR = new (0, $aHhuQ.DegradeError)('Promise is degraded');
class $40115e6ed8d3612b$export$ea6d6e4c9647fa9 {
    static from(wrapped, degradationCallback = ()=>{}, timeoutMs) {
        return new $40115e6ed8d3612b$export$ea6d6e4c9647fa9(wrapped, degradationCallback, timeoutMs ?? $40115e6ed8d3612b$export$ff01cc10d3c607be);
    }
    constructor(wrapped, degradationCallback, timeoutMs = $40115e6ed8d3612b$export$ff01cc10d3c607be){
        this.degradablePromiseInternal = void 0;
        this.degradeTimeout = void 0;
        this.timeoutMs = void 0;
        this.degradeInternal = ()=>{
            // Default throws an error as this should never happen
            throw new Error('Programming error, cancelling promise is not properly rejected');
        };
        this.timeout = ()=>{
            this.degradeInternal();
        };
        this.promise = ()=>this.degradablePromiseInternal;
        const degrader = new Promise((_, reject)=>{
            this.degradeInternal = ()=>{
                reject($40115e6ed8d3612b$var$DEGRADE_ERROR);
                degradationCallback('timeout');
            };
        });
        // Call the degradation callback with 'failed' if the wrapped promise fails, easy way to track metrics at fetch level
        wrapped.catch(()=>{
            degradationCallback('failure');
        });
        // Build a finally chain into the wrapped promise so if it resolves early, we cancel the degradation
        const wrappedFinally = wrapped.finally(()=>{
            if (this.degradeTimeout) clearTimeout(this.degradeTimeout);
        });
        const wrapper = Promise.race([
            wrappedFinally,
            degrader
        ]);
        this.degradablePromiseInternal = wrapper;
        this.timeoutMs = timeoutMs ?? $40115e6ed8d3612b$export$ff01cc10d3c607be;
        this.degradeTimeout = setTimeout(this.timeout, this.timeoutMs);
    }
}
module.exports["DegradablePromise"] = $40115e6ed8d3612b$export$ea6d6e4c9647fa9;

});

parcelRegister("aHhuQ", function(module, exports) {
class $b0ed35fbaacb89be$export$85bf8e4fb143676a extends Error {
    constructor(...args){
        super(...args);
        this.isDegraded = true;
    }
}
module.exports["DegradeError"] = $b0ed35fbaacb89be$export$85bf8e4fb143676a;

});

parcelRegister("bfpjP", function(module, exports) {

var $bZF61 = parcelRequire("bZF61");

const $413fa6e1c2c21add$export$42b67d93e908c9dc = (userId, cloudId)=>(0, $bZF61.generateHash)(`loom|${userId}|${cloudId}`);
module.exports["generateLoomAuthHash"] = $413fa6e1c2c21add$export$42b67d93e908c9dc;

});

parcelRegister("d9nAp", function(module, exports) {

var $bZF61 = parcelRequire("bZF61");

const $de62146c16c69af1$export$f80795c7fd0ce9fc = (userId, cloudId)=>(0, $bZF61.generateHash)(`3p|${userId}|${cloudId}`);
module.exports["generate3pHash"] = $de62146c16c69af1$export$f80795c7fd0ce9fc;

});

parcelRegister("fR63l", function(module, exports) {
/**
 * Product keys for third-party connectors.
 * Each key maps to a unique identifier used throughout the search system.
 */ // oxlint-disable-next-line eslint/no-redeclare
const $dce31c4071a2ecfb$export$93aa518ca2694c2d = {
    AtlassianWebCrawler: 'atlassian-web-crawler',
    Figma: 'figma',
    Github: 'github',
    GoogleDrive: 'drive',
    Loom: 'loom',
    OneDrive: 'onedrive',
    Dropbox: 'dropbox',
    Slack: 'slack',
    Sharepoint: 'sharepoint',
    Teams: 'teams',
    GoogleCalendar: 'google-calendar',
    OutlookCalendar: 'outlook-calendar',
    OutlookMail: 'outlook-mail',
    Gmail: 'gmail',
    AdobeSign: 'adobe-sign',
    Asana: 'asana',
    Zendesk: 'zendesk',
    Airtable: 'airtable',
    Smartsheet: 'smartsheet',
    Notion: 'notion',
    Miro: 'miro',
    Docusign: 'docusign',
    Lucid: 'lucid',
    Monday: 'monday',
    AzureDevops: 'azure-devops',
    Gitlab: 'gitlab',
    ConfluenceDC: 'confluence-dc',
    Canva: 'canva',
    Box: 'box',
    Zeplin: 'zeplin',
    ServiceNow: 'servicenow',
    Freshservice: 'freshservice',
    PowerBI: 'power-bi',
    ClickUp: 'clickup',
    Amplitude: 'amplitude',
    Stripe: 'stripe',
    AdobeXD: 'adobexd',
    Aha: 'aha',
    Mural: 'mural',
    Webex: 'webex',
    Todoist: 'todoist',
    PagerDuty: 'pagerduty',
    Pipedrive: 'pipedrive',
    Hubspot: 'hubspot',
    Dovetail: 'dovetail',
    LaunchDarkly: 'launchdarkly',
    Salesforce: 'salesforce',
    Sentry: 'sentry',
    JiraDC: 'jira-dc',
    Gitbook: 'gitbook',
    AWSS3: 'aws-s3',
    Databricks: 'databricks',
    JsmDC: 'jsm-dc',
    ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp',
    Gong: 'gong',
    Zoom: 'zoom'
};
const $dce31c4071a2ecfb$export$5378b945bea99ba3 = {
    AtlassianWebCrawler: 'webcrawler-connector',
    Figma: 'figma-connector',
    Github: 'github-connector',
    GoogleDrive: 'google-drive-connector',
    OneDrive: 'onedrive-connector',
    Dropbox: 'dropbox-connector',
    Slack: 'slack-connector',
    Sharepoint: 'sharepoint-connector',
    Teams: 'microsoft-teams-connector',
    GoogleCalendar: 'google-calendar-connector',
    OutlookCalendar: 'outlook-calendar-connector',
    OutlookMail: 'outlook-mail-connector',
    Gmail: 'gmail-connector',
    AdobeSign: 'adobe-sign-connector',
    Asana: 'asana-connector',
    Zendesk: 'zendesk-connector',
    Airtable: 'airtable-connector',
    Smartsheet: 'smartsheet-connector',
    Notion: 'notion-connector',
    Miro: 'miro-connector',
    Docusign: 'docusign-connector',
    Lucid: 'lucid-connector',
    Monday: 'monday-connector',
    AzureDevops: 'azure-devops-connector',
    Gitlab: 'gitlab-connector',
    ConfluenceDC: 'confluence-dc-connector',
    JiraDC: 'jira-dc-connector',
    JsmDC: 'jsm-dc-connector',
    Canva: 'canva-connector',
    Box: 'box-connector',
    Zeplin: 'smartlinks-connector-zeplin',
    ServiceNow: 'servicenow-connector',
    Freshservice: 'freshservice-connector',
    PowerBI: 'smartlinks-connector-power-bi',
    ClickUp: 'smartlinks-connector-clickup',
    Amplitude: 'smartlinks-connector-amplitude',
    Stripe: 'smartlinks-connector-stripe',
    AdobeXD: 'smartlinks-connector-adobexd',
    Aha: 'aha-connector',
    Mural: 'smartlinks-connector-mural',
    Webex: 'smartlinks-connector-webex',
    Todoist: 'smartlinks-connector-todoist',
    PagerDuty: 'smartlinks-connector-pagerduty',
    Pipedrive: 'smartlinks-connector-pipedrive',
    Hubspot: 'hubspot-connector',
    Dovetail: 'smartlinks-connector-dovetail',
    LaunchDarkly: 'smartlinks-connector-launchdarkly',
    Salesforce: 'salesforce-connector',
    Sentry: 'smartlinks-connector-sentry',
    Gitbook: 'gitbook-connector',
    AWSS3: 'aws-s3-connector',
    Databricks: 'databricks-connector',
    ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp',
    Gong: 'gong-connector',
    Zoom: 'zoom-connector'
};
module.exports["ProductKeys3P"] = $dce31c4071a2ecfb$export$93aa518ca2694c2d;
module.exports["ProductResourceTypes3P"] = $dce31c4071a2ecfb$export$5378b945bea99ba3;

});

parcelRegister("jAKKt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $krxYo = parcelRequire("krxYo");


var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $2a08l = parcelRequire("2a08l");


var $frXak = parcelRequire("frXak");

const $349db1466702a732$export$fbd198cf40195606 = {
    displayName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $frXak.messages)['atlassian-web-crawler']),
    id: 'atlassian-web-crawler',
    resourceType: (0, $fR63l.ProductResourceTypes3P).AtlassianWebCrawler,
    icon: (0, $i52Hf.RovoLogoFromLogo)((0, (/*@__PURE__*/$parcel$interopDefault($krxYo))), 'Atlassian Web Crawler'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $2a08l.WebDomainSearchResultIcon), 'Atlassian Web Crawler', 'large'),
    integrationAri: 'ari:cloud:platform::integration/atlassian-web-crawler',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WebPage,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: false,
    isEnabled: ()=>true,
    fanOutConnectorSources: true,
    displayWorkspaceNameAsProductName: true,
    getFiltersForSelectedDatasources: (datasource, existingFilters)=>({
            ...existingFilters,
            additionalTexts: [
                ...existingFilters?.additionalTexts || [],
                ...datasource?.workspaceUrl ? [
                    datasource.workspaceUrl
                ] : []
            ]
        })
};
module.exports["atlassianWebCrawlerConfig"] = $349db1466702a732$export$fbd198cf40195606;

});

parcelRegister("dAioJ", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $ac1d391d64bfedde$export$d520529b4595d46c = [
    'ati:cloud:graph:document'
];
module.exports["DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI"] = $ac1d391d64bfedde$export$d520529b4595d46c;

});

parcelRegister("5PPrc", function(module, exports) {
const $b36df32f21d2d1ae$export$49f6cbb853d30562 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    Repository: 'repository',
    PullRequest: 'pull-request',
    Branch: 'branch',
    Commit: 'commit',
    DevopsWorkItem: 'devops-work-item',
    WebPage: 'web-page',
    Conversation: 'conversation',
    Message: 'message',
    Video: 'video',
    Design: 'design',
    Page: 'page',
    Blogpost: 'blogpost',
    Attachment: 'attachment',
    Space: 'space',
    Whiteboard: 'whiteboard',
    Slide: 'slide',
    Comment: 'comment',
    Database: 'database',
    Embed: 'embed',
    Folder: 'folder',
    Calendar: 'calendar',
    SpaceCalendar: 'space-calendar',
    Question: 'question',
    Answer: 'answer',
    Issue: 'issue',
    Epic: 'epic',
    Bug: 'bug',
    Story: 'story',
    Task: 'task',
    Subtask: 'subtask',
    Project: 'project',
    Incident: 'incident',
    Filter: 'filter',
    Plan: 'plan',
    Board: 'board',
    Component: 'component',
    Card: 'card',
    Goal: 'goal',
    Tag: 'tag',
    WorkItem: 'work-item',
    FocusArea: 'focus-area',
    Organization: 'organization',
    Ask: 'ask',
    Risk: 'risk',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Deal: 'deal',
    Gliffy: 'gliffy',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Type: 'type',
    Schema: 'schema',
    Position: 'position',
    Image: 'image',
    Audio: 'audio',
    Pdf: 'pdf',
    Shortcut: 'shortcut',
    Code: 'code',
    Archive: 'archive',
    Other: 'other',
    Notebook: 'notebook',
    Form: 'form',
    Article: 'article',
    Post: 'post',
    Ticket: 'ticket',
    Campaign: 'campaign',
    Case: 'case',
    CatalogItem: 'catalog-item',
    RequestedItem: 'requested-item',
    Demand: 'demand',
    KnowledgeArticle: 'knowledge-article',
    NewsArticle: 'news-article',
    Lead: 'lead'
};
const $b36df32f21d2d1ae$export$e01073b80ff953d5 = Object.values($b36df32f21d2d1ae$export$49f6cbb853d30562);
const $b36df32f21d2d1ae$export$1f2db89e0caa00c9 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    File: 'file',
    Database: 'database',
    WebPage: 'web-page',
    Page: 'page',
    Blogpost: 'blogpost',
    Article: 'article',
    Post: 'post',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Design: 'design',
    Deal: 'deal',
    Video: 'video',
    Task: 'task',
    Issue: 'issue',
    Space: 'space',
    Project: 'project',
    Repository: 'repository',
    PullRequest: 'pull-request',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    Image: 'image',
    Archive: 'archive',
    Audio: 'audio',
    Code: 'code',
    Pdf: 'pdf',
    Other: 'other',
    Software: 'software',
    ServiceDesk: 'service_desk',
    Business: 'business',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Schema: 'schema',
    Type: 'type',
    Folder: 'folder',
    Notebook: 'notebook',
    Form: 'form',
    Shortcut: 'shortcut',
    Site: 'site',
    Subsite: 'subsite',
    Drive: 'drive',
    Comment: 'comment',
    Incident: 'incident',
    CatalogItem: 'catalog_item',
    RequestedItem: 'requested_item',
    KnowledgeArticle: 'knowledge_article',
    Demand: 'demand',
    NewsArticle: 'news_article',
    Epic: 'epic'
};
/**
 * Maps CloudGraph ATI to TypeFilterValueKey
 */ const $b36df32f21d2d1ae$var$ATI_TO_TYPE_FILTER_KEY_MAP = {
    'ati:cloud:graph:document': $b36df32f21d2d1ae$export$49f6cbb853d30562.Document,
    'ati:cloud:graph:message': $b36df32f21d2d1ae$export$49f6cbb853d30562.Message,
    'ati:cloud:graph:conversation': $b36df32f21d2d1ae$export$49f6cbb853d30562.Conversation,
    'ati:cloud:graph:design': $b36df32f21d2d1ae$export$49f6cbb853d30562.Design,
    'ati:cloud:graph:video': $b36df32f21d2d1ae$export$49f6cbb853d30562.Video,
    'ati:cloud:graph:space': $b36df32f21d2d1ae$export$49f6cbb853d30562.Space,
    'ati:cloud:graph:comment': $b36df32f21d2d1ae$export$49f6cbb853d30562.Comment,
    'ati:cloud:graph:repository': $b36df32f21d2d1ae$export$49f6cbb853d30562.Repository,
    'ati:cloud:graph:pull-request': $b36df32f21d2d1ae$export$49f6cbb853d30562.PullRequest,
    'ati:cloud:graph:commit': $b36df32f21d2d1ae$export$49f6cbb853d30562.Commit,
    'ati:cloud:graph:branch': $b36df32f21d2d1ae$export$49f6cbb853d30562.Branch,
    'ati:cloud:graph:calendar-event': $b36df32f21d2d1ae$export$49f6cbb853d30562.Calendar,
    'ati:cloud:graph:work-item': $b36df32f21d2d1ae$export$49f6cbb853d30562.WorkItem,
    'ati:cloud:graph:project': $b36df32f21d2d1ae$export$49f6cbb853d30562.Project,
    'ati:cloud:graph:deal': $b36df32f21d2d1ae$export$49f6cbb853d30562.Deal,
    'ati:cloud:graph:customer-org': $b36df32f21d2d1ae$export$49f6cbb853d30562.CustomerOrg,
    'ati:cloud:graph:customer-contact': $b36df32f21d2d1ae$export$49f6cbb853d30562.CustomerContact,
    'ati:cloud:graph:dashboard': $b36df32f21d2d1ae$export$49f6cbb853d30562.Dashboard,
    'ati:cloud:graph:data-table': $b36df32f21d2d1ae$export$49f6cbb853d30562.DataTable,
    'ati:cloud:graph:campaign': $b36df32f21d2d1ae$export$49f6cbb853d30562.Campaign,
    'ati:cloud:graph:case': $b36df32f21d2d1ae$export$49f6cbb853d30562.Case,
    'ati:cloud:graph:lead': $b36df32f21d2d1ae$export$49f6cbb853d30562.Lead
};
/**
 * Checks if an ATI string is a CloudGraph ATI
 */ const $b36df32f21d2d1ae$var$isCloudGraphAti = (ati)=>{
    return ati.startsWith('ati:cloud:graph:');
};
function $b36df32f21d2d1ae$export$770175465f396551(atis) {
    const typeFilterConfig = new Map();
    // Group ATIs by their corresponding TypeFilterValueKey
    const atisByTypeKey = new Map();
    for (const ati of atis)if ($b36df32f21d2d1ae$var$isCloudGraphAti(ati)) {
        const typeKey = $b36df32f21d2d1ae$var$ATI_TO_TYPE_FILTER_KEY_MAP[ati];
        if (typeKey) {
            if (!atisByTypeKey.has(typeKey)) atisByTypeKey.set(typeKey, []);
            atisByTypeKey.get(typeKey).push(ati);
        }
    }
    // Convert to TypeFilterConfig3P format
    for (const [typeKey, entityAtis] of atisByTypeKey)typeFilterConfig.set(typeKey, {
        entities3P: entityAtis,
        subTypes3P: [] // Most configs use empty subTypes3P, can be extended if needed
    });
    return typeFilterConfig;
}
module.exports["TypeFilterValueKey"] = $b36df32f21d2d1ae$export$49f6cbb853d30562;
module.exports["allTypeFilterValueKeys"] = $b36df32f21d2d1ae$export$e01073b80ff953d5;
module.exports["NounSubtypeKey"] = $b36df32f21d2d1ae$export$1f2db89e0caa00c9;
module.exports["mapAtisToTypeFilterConfig"] = $b36df32f21d2d1ae$export$770175465f396551;

});

parcelRegister("i52Hf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");




var $6suVE = parcelRequire("6suVE");


var $ehKBQ = parcelRequire("ehKBQ");


var $iS3Tu = parcelRequire("iS3Tu");


var $dULnI = parcelRequire("dULnI");


var $2sFbd = parcelRequire("2sFbd");



var $9Jc29 = parcelRequire("9Jc29");





var $Douji = parcelRequire("Douji");


var $iPmoS = parcelRequire("iPmoS");

// Legacy custom @atlaskit/icon glyphs render one size smaller than requested, so this container
// is bumped up a step to compensate (see `correctedSize` below).
const $8a7a1ec4b7d3b7f4$var$legacySvgIconContainerStyles = {
    small: "_39xV02ey7F _0jFU0Vey7F _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    medium: "_39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    large: "_39xV02Uofl _0jFU0VUofl _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    xlarge: "_39xV02Uofl _0jFU0VUofl _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
// The official brand icon library (behind rovo-search-team-eu-26-brand-icon-library) renders
// through ADS Tile, whose size scale already matches the Logo scale 1:1 — no compensation needed.
const $8a7a1ec4b7d3b7f4$var$accurateSvgIconContainerStyles = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    small: "_39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    medium: "_39xV02Uofl _0jFU0VUofl _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    large: "_39xV02UF4f _0jFU0VUF4f _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
const $8a7a1ec4b7d3b7f4$var$SVGIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { glyph: SVG, label: label, legacySize: legacySize, accurateSize: accurateSize } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("rovo-search-team-eu-26-brand-icon-library");
        $[0] = t1;
    } else t1 = $[0];
    const isAccurateSizeEnabled = t1;
    const t2 = isAccurateSizeEnabled ? $8a7a1ec4b7d3b7f4$var$accurateSvgIconContainerStyles[accurateSize] : $8a7a1ec4b7d3b7f4$var$legacySvgIconContainerStyles[legacySize];
    const t3 = label || undefined;
    const t4 = label ? "img" : "presentation";
    let t5;
    if ($[1] !== SVG || $[2] !== accurateSize) {
        t5 = isAccurateSizeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, {
            size: accurateSize
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, null);
        $[1] = SVG;
        $[2] = accurateSize;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4 || $[7] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t2,
            "aria-label": t3,
            role: t4
        }, t5);
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    return t6;
} : ({ glyph: SVG, label: label, legacySize: legacySize, accurateSize: accurateSize })=>{
    const isAccurateSizeEnabled = (0, $iDrrr.fg)('rovo-search-team-eu-26-brand-icon-library');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: isAccurateSizeEnabled ? $8a7a1ec4b7d3b7f4$var$accurateSvgIconContainerStyles[accurateSize] : $8a7a1ec4b7d3b7f4$var$legacySvgIconContainerStyles[legacySize],
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, isAccurateSizeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, {
        size: accurateSize
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, null));
};
const $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize = (size)=>{
    return [
        'xxsmall',
        'xsmall',
        'small',
        'medium',
        'large'
    ].includes(size);
};
const $8a7a1ec4b7d3b7f4$var$correctedSize = {
    xxsmall: 'small',
    xsmall: 'small',
    small: 'medium',
    medium: 'large',
    large: 'xlarge'
};
const $8a7a1ec4b7d3b7f4$var$sizeStyles = {
    small: "_39xV02ey7F _0jFU0Vey7F",
    medium: "_39xV02oWWg _0jFU0VoWWg",
    large: "_39xV02Uofl _0jFU0VUofl",
    xlarge: "_39xV02pJKa _0jFU0VpJKa"
}; // The official brand icon library (behind rovo-search-team-eu-26-brand-icon-library) renders
// through ADS Tile, whose size scale already matches the Logo scale 1:1 — unlike the legacy
// custom @atlaskit/icon glyphs above, it needs no "one size bigger" compensation.
const $8a7a1ec4b7d3b7f4$var$accurateSizeStyles = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f"
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with custom Rovo Icons
    *
    * Internally uses <Icon glyph={glyph} ... />
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$7b66a86355afbb91 = (Glyph, defaultLabel = '', defaultSize = 'medium')=>{
    return ({ size: size = defaultSize, label: label = defaultLabel, testId: testId })=>{
        const resolvedSize = size && $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize(size) ? size : defaultSize;
        const isAccurateSizeEnabled = (0, $iDrrr.fg)('rovo-search-team-eu-26-brand-icon-library');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-label": label || undefined,
            "data-testid": testId,
            role: label ? 'img' : 'presentation',
            className: (0, $hekY6.default)([
                isAccurateSizeEnabled ? $8a7a1ec4b7d3b7f4$var$accurateSizeStyles[resolvedSize] : $8a7a1ec4b7d3b7f4$var$sizeStyles[$8a7a1ec4b7d3b7f4$var$correctedSize[resolvedSize]]
            ])
        }, isAccurateSizeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Glyph, {
            size: resolvedSize
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Glyph, null));
    };
}; /**
    * A wrapper for rendering 3P svg illustrations in a similar way for atlaskit icon components
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d = (glyph, defaultLabel = '', defaultSize)=>{
    return ({ label: label = defaultLabel, size: size = defaultSize })=>{
        const resolvedSize = size && $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize(size) ? size : defaultSize ?? 'medium';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8a7a1ec4b7d3b7f4$var$SVGIcon, {
            label: label,
            glyph: glyph,
            legacySize: $8a7a1ec4b7d3b7f4$var$correctedSize[resolvedSize],
            accurateSize: resolvedSize
        });
    };
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with \@atlaskit/logo
    *
    * Internally uses <LogoComponent ... />
    *
    * @param {} LogoComponent an import from \@atlaskit/logo
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$32db889b380fa03c = (LogoComponent, defaultLabel = '')=>{
    return ({ size: size, label: label, testId: testId })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LogoComponent, {
            label: label || defaultLabel,
            testId: testId,
            size: size || 'medium',
            appearance: "brand"
        });
    };
}; /**
    * Takes a logo component and returns a new logo component that uses the new logo design.
    */ 
function $8a7a1ec4b7d3b7f4$export$a34cd1871c6541c9(Icon) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, props);
}
function $8a7a1ec4b7d3b7f4$export$fab9faef3411dc6c(iconGlyph, iconLabel, size) {
    return $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d(iconGlyph, iconLabel, size);
}
const $8a7a1ec4b7d3b7f4$var$imageStyles = null; /**
                           * Helper function to convert an image URL into a glyph function
                           *
                           * @param imageUrl URL string pointing to the image
                           * @returns A glyph function that returns an img element
                           */ 
const $8a7a1ec4b7d3b7f4$export$f9f7178f66750cba = (imageUrl)=>{
    return ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: imageUrl,
            alt: "",
            className: (0, $hekY6.default)([
                "_39xV02N91d _0jFU0VN91d _00EA0egIor"
            ])
        });
    };
}; /**
    * Creates a RovoLogo from a URL. Useful for Forge connectors that provide icon URLs.
    * Uses the existing RovoLogoFromSVG infrastructure for consistent handling.
    */ 
function $8a7a1ec4b7d3b7f4$export$97ac28be52c9e29f(iconUrl, iconLabel, size) {
    return $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d($8a7a1ec4b7d3b7f4$export$f9f7178f66750cba(iconUrl), iconLabel, size);
} // Jira-specific icons
module.exports["RovoLogoFromGlyph"] = $8a7a1ec4b7d3b7f4$export$7b66a86355afbb91;
module.exports["RovoLogoFromSVG"] = $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d;
module.exports["RovoLogoFromLogo"] = $8a7a1ec4b7d3b7f4$export$32db889b380fa03c;
module.exports["get3PLogo"] = $8a7a1ec4b7d3b7f4$export$fab9faef3411dc6c;
module.exports["get3PLogoFromURL"] = $8a7a1ec4b7d3b7f4$export$97ac28be52c9e29f;

});

parcelRegister("6suVE", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $db93e344a28daeff$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4hzFj")).then((m)=>m.GitHubIcon), {
    moduleId: '@atlassian/logo-third-party/github'
});

const $db93e344a28daeff$var$LazyGithubIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("3w7xz")).then((m)=>m.GithubIcon), {
    moduleId: '@atlassian/rovo-connectors-config/github/icon'
});

const $db93e344a28daeff$var$LazyGithubSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("3w7xz")).then((m)=>m.GithubSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/github/search-result-icon'
});
const $db93e344a28daeff$export$e8e65f186ccd8749 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db93e344a28daeff$var$LazyGithubIconComponent, null)), $db93e344a28daeff$var$OfficialIcon, 'small');
const $db93e344a28daeff$export$fa0f141eb732d2d7 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db93e344a28daeff$var$LazyGithubSearchResultIconComponent, null)), $db93e344a28daeff$var$OfficialIcon, 'medium');
module.exports["GithubIcon"] = $db93e344a28daeff$export$e8e65f186ccd8749;
module.exports["GithubSearchResultIcon"] = $db93e344a28daeff$export$fa0f141eb732d2d7;

});

parcelRegister("5mh7K", function(module, exports) {

var $6zMm4 = parcelRequire("6zMm4");


var $3zIme = parcelRequire("3zIme");


var $jrpaf = parcelRequire("jrpaf");


var $iqYgx = parcelRequire("iqYgx");


var $3Zhtx = parcelRequire("3Zhtx");

var $dZb8A = parcelRequire("dZb8A");


var $9W961 = parcelRequire("9W961");


var $f1SiZ = parcelRequire("f1SiZ");


var $6DjRB = parcelRequire("6DjRB");


var $ah4XH = parcelRequire("ah4XH");


var $cU4Ow = parcelRequire("cU4Ow");


var $31PDK = parcelRequire("31PDK");


function $bfc96ad9243c26fc$var$noop() {}
function $bfc96ad9243c26fc$var$deferToPhase(phase) {
    switch(phase){
        case (0, $iqYgx.PHASE).PAINT:
            return (0, $6zMm4.postTask)($bfc96ad9243c26fc$var$noop, {
                priority: 'user-blocking'
            });
        case (0, $iqYgx.PHASE).AFTER_PAINT:
            return (0, $6zMm4.postTask)($bfc96ad9243c26fc$var$noop, {
                priority: 'user-visible'
            });
        case (0, $iqYgx.PHASE).LAZY:
            return (0, $6zMm4.postTask)($bfc96ad9243c26fc$var$noop, {
                priority: 'background'
            });
        default:
            return Promise.resolve();
    }
}
function $bfc96ad9243c26fc$var$lazyProxy(loader, { defer: defer = (0, $iqYgx.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $3Zhtx.isNodeEnvironment)();
    const dataLazyId = (0, $dZb8A.default)(moduleId);
    // eslint-disable-next-line @typescript-eslint/no-restricted-types
    const LazyInternal = isServer ? (0, $f1SiZ.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $9W961.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $ah4XH.createDeferred)(dataLazyId, {
            loader: ()=>{
                const { retry: maxAttempts, usePostTaskPhases: usePostTaskPhases } = (0, $jrpaf.getConfig)();
                const deferredLoader = usePostTaskPhases ? ()=>$bfc96ad9243c26fc$var$deferToPhase(defer).then(()=>loader()) : loader;
                return (0, $31PDK.retry)(deferredLoader, {
                    delay: (0, $6DjRB.RETRY_DELAY),
                    factor: (0, $6DjRB.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $3Zhtx.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $jrpaf.getConfig)();
        return (0, $3zIme.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority ?? (defer === (0, $iqYgx.PHASE).PAINT ? (0, $6DjRB.PRIORITY).HIGH : (0, $6DjRB.PRIORITY).LOW);
        return (0, $cU4Ow.preloadAsset)({
            loader: loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        moduleId: moduleId,
        preload: preload
    });
}
const $bfc96ad9243c26fc$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $iqYgx.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $iqYgx.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $iqYgx.PHASE).LAZY
    }
};
function $bfc96ad9243c26fc$export$c952e5f94576010e(loader, opts) {
    return $bfc96ad9243c26fc$var$lazyProxy(loader, {
        ...$bfc96ad9243c26fc$export$93ca5d3f8675ae4c.lazyForPaint,
        ...opts || {}
    });
}
function $bfc96ad9243c26fc$export$291dd592399bdafa(loader, opts) {
    return $bfc96ad9243c26fc$var$lazyProxy(loader, {
        ...$bfc96ad9243c26fc$export$93ca5d3f8675ae4c.lazyAfterPaint,
        ...opts || {}
    });
}
function $bfc96ad9243c26fc$export$488013bae63b21da(loader, opts) {
    return $bfc96ad9243c26fc$var$lazyProxy(loader, {
        ...$bfc96ad9243c26fc$export$93ca5d3f8675ae4c.lazy,
        ...opts || {}
    });
}
module.exports["lazyForPaint"] = $bfc96ad9243c26fc$export$c952e5f94576010e;
module.exports["lazy"] = $bfc96ad9243c26fc$export$488013bae63b21da;

});

parcelRegister("3zIme", function(module, exports) {
const $26c544e248d4f3ef$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets || !manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $26c544e248d4f3ef$export$303f43e55cf1ef2f;

});

parcelRegister("jrpaf", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("hwBK6")).MODE);

var $hwBK6 = parcelRequire("hwBK6");

const $8f2b5a3b1d08430b$var$DEFAULT_CROSS_ORIGIN = undefined;
const $8f2b5a3b1d08430b$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $8f2b5a3b1d08430b$var$DEFAULT_MODE = (0, $hwBK6.MODE).HYDRATE;
const $8f2b5a3b1d08430b$var$DEFAULT_RETRY = 2;
const $8f2b5a3b1d08430b$var$nullFunction = ()=>{};
const $8f2b5a3b1d08430b$var$config = {
    crossOrigin: $8f2b5a3b1d08430b$var$DEFAULT_CROSS_ORIGIN,
    manifest: $8f2b5a3b1d08430b$var$DEFAULT_MANIFEST,
    mode: $8f2b5a3b1d08430b$var$DEFAULT_MODE,
    retry: $8f2b5a3b1d08430b$var$DEFAULT_RETRY,
    react18: false,
    onChunkRender: $8f2b5a3b1d08430b$var$nullFunction,
    usePostTaskPhases: false,
    modernErrorFallback: false,
    markedForPreload: [],
    environment: undefined
};
const $8f2b5a3b1d08430b$export$44487a86467333c3 = ()=>$8f2b5a3b1d08430b$var$config;
const $8f2b5a3b1d08430b$export$940a7873bb071df8 = (nextConfig)=>{
    $8f2b5a3b1d08430b$var$config.crossOrigin = nextConfig.crossOrigin ?? $8f2b5a3b1d08430b$var$DEFAULT_CROSS_ORIGIN;
    $8f2b5a3b1d08430b$var$config.manifest = nextConfig.manifest ?? $8f2b5a3b1d08430b$var$DEFAULT_MANIFEST;
    $8f2b5a3b1d08430b$var$config.mode = nextConfig.mode ?? $8f2b5a3b1d08430b$var$DEFAULT_MODE;
    $8f2b5a3b1d08430b$var$config.retry = nextConfig.retry ?? $8f2b5a3b1d08430b$var$DEFAULT_RETRY;
    $8f2b5a3b1d08430b$var$config.react18 = nextConfig.react18 ?? false;
    $8f2b5a3b1d08430b$var$config.onChunkRender = nextConfig.onChunkRender ?? $8f2b5a3b1d08430b$var$nullFunction;
    $8f2b5a3b1d08430b$var$config.usePostTaskPhases = nextConfig.usePostTaskPhases ?? false;
    $8f2b5a3b1d08430b$var$config.modernErrorFallback = nextConfig.modernErrorFallback ?? false;
    $8f2b5a3b1d08430b$var$config.markedForPreload = nextConfig.markedForPreload ?? undefined;
    $8f2b5a3b1d08430b$var$config.environment = nextConfig.environment ?? undefined;
};
module.exports["getConfig"] = $8f2b5a3b1d08430b$export$44487a86467333c3;

});

parcelRegister("hwBK6", function(module, exports) {
const $b5e78af7707a7c4f$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $b5e78af7707a7c4f$export$e48589d9e4824227;

});

parcelRegister("iqYgx", function(module, exports) {
const $affaceaac00ccc54$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $affaceaac00ccc54$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $affaceaac00ccc54$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $affaceaac00ccc54$export$4831ef3968ea94ef;

});

parcelRegister("3Zhtx", function(module, exports) {

var $dZb8A = parcelRequire("dZb8A");

const $a3803c67f4544810$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $a3803c67f4544810$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $a3803c67f4544810$export$283635c04a02cc36 = ()=>{
    if (typeof window === 'undefined') return true;
    if (window.name === 'nodejs') return true;
    return false;
};
function $a3803c67f4544810$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $a3803c67f4544810$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $a3803c67f4544810$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $a3803c67f4544810$export$283635c04a02cc36;
module.exports["attrToProp"] = $a3803c67f4544810$export$62bf630d0de3d781;

});

parcelRegister("dZb8A", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a2d13c19047c2e6$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $2a2d13c19047c2e6$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        // @ts-ignore TS7029 fallthrough
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        // @ts-ignore TS7029 fallthrough
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("9W961", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $jrpaf = parcelRequire("jrpaf");
var $hwBK6 = parcelRequire("hwBK6");


var $iqYgx = parcelRequire("iqYgx");


var $6pwcu = parcelRequire("6pwcu");


var $hGTvt = parcelRequire("hGTvt");


var $bSocS = parcelRequire("bSocS");


var $3UFgg = parcelRequire("3UFgg");


var $27xqQ = parcelRequire("27xqQ");


var $bYDpj = parcelRequire("bYDpj");


var $iQUPl = parcelRequire("iQUPl");


var $6mYYR = parcelRequire("6mYYR");

function $9e10a968465c2ceb$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const ResolvedLazy = /*#__PURE__*/ (0, $cozmU.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $cozmU.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $iqYgx.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $iqYgx.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const { usePostTaskPhases: usePostTaskPhases } = (0, $jrpaf.getConfig)();
        const { setFallback: setFallback, getIsBoundaryInitialized: getIsBoundaryInitialized } = (0, $cozmU.useContext)((0, $3UFgg.LazySuspenseContext));
        const profiler = (0, $cozmU.useContext)((0, $bSocS.ProfilerContext)).current;
        const load = ()=>{
            if (usePostTaskPhases) {
                if (status.started) return;
            } else {
                if (status.started || !status.phase || !status.noWait) return;
            }
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $27xqQ.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        if (usePostTaskPhases) // Start loading immediately, as the loader itself will be delayed until the appropriate phase
        (0, $cozmU.useMemo)(()=>{
            load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        else {
            // Subscribe to LazyWait context, triggering load when until is true
            (0, $6mYYR.useSubscription)({
                context: (0, $6pwcu.WaitContext),
                load: load,
                onValue: (v)=>status.noWait = v === 1
            });
            if (defer === (0, $iqYgx.PHASE).AFTER_PAINT) // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $6mYYR.useSubscription)({
                context: (0, $hGTvt.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
        }
        (0, $cozmU.useMemo)(()=>{
            // Skip collecting fallbacks if the boundary is already initialized
            if (usePostTaskPhases && getIsBoundaryInitialized()) return;
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $iqYgx.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $jrpaf.getConfig)().mode === (0, $hwBK6.MODE).RENDER ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iQUPl.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bYDpj.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback,
            getIsBoundaryInitialized,
            usePostTaskPhases
        ]);
        (0, $cozmU.useMemo)(()=>{
            const { mode: mode, react18: react18 } = (0, $jrpaf.getConfig)();
            // we dont remove fallback in RENDER mode as it happens too early
            // however it's not a problem for HYDRATION as Suspense will handle all nuances
            if (mode === (0, $hwBK6.MODE).HYDRATE && react18) // Allow hydration to support partials without server components
            // suspense will discard ssr during hydration if re-renders so we
            // set a dummy fallback to block updates from the provider until we resolve
            setFallback(/*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {}));
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, $8aG6j.jsx)(ResolvedLazy, {
            ...props
        });
    };
}
module.exports["createComponentClient"] = $9e10a968465c2ceb$export$6898b5504b58699a;

});

parcelRegister("6pwcu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aJQSl = parcelRequire("aJQSl");

const $548763ff32fd4fa9$export$9ba3fe09d15de47b = (0, $cozmU.createContext)({
    subscribe: ()=>(0, $aJQSl.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $548763ff32fd4fa9$export$9ba3fe09d15de47b;

});

parcelRegister("aJQSl", function(module, exports) {
const $05617924a76d0a6c$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $05617924a76d0a6c$export$276c7dbda7675aec;

});

parcelRegister("hGTvt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iqYgx = parcelRequire("iqYgx");


var $lJvTv = parcelRequire("lJvTv");


var $dcIK9 = parcelRequire("dcIK9");

let $672f0e6595584070$var$CURRENT_PHASE = (0, $iqYgx.PHASE).PAINT;
const $672f0e6595584070$export$5f80f094fd31fffd = (phase)=>{
    $672f0e6595584070$var$CURRENT_PHASE = phase;
    (0, $lJvTv.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $672f0e6595584070$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribe: (0, $dcIK9.createSubscribe)((0, $lJvTv.LISTENERS)),
    currentValue: ()=>$672f0e6595584070$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $672f0e6595584070$export$5f80f094fd31fffd((0, $iqYgx.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$672f0e6595584070$export$5f80f094fd31fffd((0, $iqYgx.PHASE).PAINT)
    }
});
const $672f0e6595584070$export$1dc361b277327f88 = ()=>{
    const v = (0, $cozmU.useContext)($672f0e6595584070$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["LazyPhaseContext"] = $672f0e6595584070$export$5a25eca35e5debcb;

});

parcelRegister("lJvTv", function(module, exports) {
const $17f151a063744015$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $17f151a063744015$export$81b9c458a026d68f;

});

parcelRegister("dcIK9", function(module, exports) {
const $66c4eef17986e77d$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $66c4eef17986e77d$export$364097d812234b3f;

});

parcelRegister("bSocS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0b79a9622223785f$export$e2d53c0cbedd2710 = {
    current: null
};
const $0b79a9622223785f$export$8146ab57a3f7a7cb = (0, $cozmU.createContext)($0b79a9622223785f$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $0b79a9622223785f$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $0b79a9622223785f$export$8146ab57a3f7a7cb;

});

parcelRegister("3UFgg", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $jrpaf = parcelRequire("jrpaf");
var $hwBK6 = parcelRequire("hwBK6");

const $307cdf761723c83f$export$c33990e84065970c = /*#__PURE__*/ (0, $cozmU.createContext)({
    getIsBoundaryInitialized: ()=>false,
    fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Fragment), {}),
    setFallback: ()=>{
        if ((0, $jrpaf.getConfig)().mode === (0, $hwBK6.MODE).RENDER) // render mode MUST have a properly configured boundary
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $307cdf761723c83f$export$c33990e84065970c;

});

parcelRegister("27xqQ", function(module, exports) {
const $8d723af0e292a27d$export$6aa69c1258005366 = Symbol.for('@atlassian/react-loosely-lazy/loader-error');
const $8d723af0e292a27d$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$8d723af0e292a27d$export$6aa69c1258005366]: true
    });
    return error;
};
const $8d723af0e292a27d$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($8d723af0e292a27d$export$6aa69c1258005366);
module.exports["createLoaderError"] = $8d723af0e292a27d$export$c73a6a6f0bf7d425;

});

parcelRegister("bYDpj", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3Zhtx = parcelRequire("3Zhtx");

const $308221388927349f$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                type: "hidden",
                "data-lazy-begin": id
            }),
            content.map((el, i)=>{
                const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
                const props = Array.from(attributes).reduce((0, $3Zhtx.attrToProp), {
                    key: String(i)
                });
                // text node
                if (!tagName) return /*#__PURE__*/ (0, $cozmU.createElement)((0, $cozmU.Fragment), props, el.textContent);
                // childless tag
                if (!childNodes.length) return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), props);
                // tag with content
                return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), {
                    ...props,
                    dangerouslySetInnerHTML: {
                        __html: ''
                    },
                    suppressHydrationWarning: true
                });
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                type: "hidden",
                "data-lazy-end": id
            })
        ]
    });
};
module.exports["PlaceholderFallbackHydrate"] = $308221388927349f$export$ca5b8fbc835d95e4;

});

parcelRegister("iQUPl", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $6pwcu = parcelRequire("6pwcu");


var $bSocS = parcelRequire("bSocS");


var $3UFgg = parcelRequire("3UFgg");

function $fac82888d07c9621$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $fac82888d07c9621$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $cozmU.useRef)(null);
    const { current: ssrDomNodes } = (0, $cozmU.useRef)(content || []);
    const profilerContext = (0, $cozmU.useContext)((0, $bSocS.ProfilerContext)).current;
    const waitContext = (0, $cozmU.useContext)((0, $6pwcu.WaitContext));
    const suspenseContext = (0, $cozmU.useContext)((0, $3UFgg.LazySuspenseContext));
    (0, $cozmU.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        profilerContext?.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($fac82888d07c9621$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            profilerContext?.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            ssrDomNodes.forEach((node)=>node.parentNode?.removeChild(node));
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $fac82888d07c9621$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $fac82888d07c9621$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $fac82888d07c9621$export$d55db778a3e1446b;

});

parcelRegister("6mYYR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $fb43d3d8deaa2f13$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $cozmU.useContext)(context);
    (0, $cozmU.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $fb43d3d8deaa2f13$export$368b4214baeb914c;

});

parcelRegister("f1SiZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3zIme = parcelRequire("3zIme");


var $jrpaf = parcelRequire("jrpaf");
var $hwBK6 = parcelRequire("hwBK6");


var $iqYgx = parcelRequire("iqYgx");


var $3UFgg = parcelRequire("3UFgg");


var $3Zhtx = parcelRequire("3Zhtx");


var $27xqQ = parcelRequire("27xqQ");

function $e4910f9bc5a8efc5$var$load(moduleId, loader) {
    try {
        return (0, $3Zhtx.getExport)(loader());
    } catch (err) {
        throw (0, $27xqQ.createLoaderError)(err);
    }
}
function $e4910f9bc5a8efc5$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        const { fallback: fallback } = (0, $cozmU.useContext)((0, $3UFgg.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest, onChunkRender: onChunkRender, mode: mode, react18: react18, modernErrorFallback: modernErrorFallback, environment: environment } = (0, $jrpaf.getConfig)();
        const shouldLoad = ssr || environment === 'client';
        const Resolved = shouldLoad ? $e4910f9bc5a8efc5$var$load(moduleId, loader) : null;
        onChunkRender(dataLazyId, moduleId, defer);
        if (mode === (0, $hwBK6.MODE).HYDRATE && react18) {
            if (!Resolved) throw new $e4910f9bc5a8efc5$var$ReactLooselyLazyNoSsrError(moduleId);
            return /*#__PURE__*/ (0, $8aG6j.jsx)(Resolved, {
                ...props
            });
        }
        if (modernErrorFallback) {
            if (!Resolved) // lets just return the fallback without extra fuzz
            // and "error" fallback is usually totally empty, so why bother?
            return fallback;
        }
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                    type: "hidden",
                    "data-lazy-begin": dataLazyId
                }),
                defer !== (0, $iqYgx.PHASE).LAZY && (0, $3zIme.getAssetUrlsFromId)(manifest, moduleId)?.map((url)=>/*#__PURE__*/ (0, $8aG6j.jsx)("link", {
                        rel: defer === (0, $iqYgx.PHASE).PAINT ? 'preload' : 'prefetch',
                        href: url,
                        crossOrigin: crossOrigin,
                        as: "script"
                    }, url)),
                Resolved ? /*#__PURE__*/ (0, $8aG6j.jsx)(Resolved, {
                    ...props
                }) : fallback,
                /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                    type: "hidden",
                    "data-lazy-end": dataLazyId
                })
            ]
        });
    };
}
class $e4910f9bc5a8efc5$var$ReactLooselyLazyNoSsrError extends Error {
    constructor(moduleId){
        super(`[no-error] React-Loosely-Lazy SSR opt out - ${moduleId}`);
        // This error is used to indicate to React that this component should not
        // render in SSR (it will instead trigger the nearest Suspense boundary)
        // so we mark it as ignored in SSR reporting.
        this.skipSsr = void 0;
        this.skipSsr = true;
    }
}
module.exports["createComponentServer"] = $e4910f9bc5a8efc5$export$eb2e4b04351cdd9e;

});

parcelRegister("6DjRB", function(module, exports) {
const $ee7f0d866347d691$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $ee7f0d866347d691$export$a339266ad71b2447 = 300;
const $ee7f0d866347d691$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $ee7f0d866347d691$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $ee7f0d866347d691$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $ee7f0d866347d691$export$ba64c908e55507fe;

});

parcelRegister("ah4XH", function(module, exports) {
/**
 * a map of all created deferred to
 * - ensure there is single deferred created for every lazy (NOT YET ENFORCED/USED)
 * - track list of known LazyComponents so we can, for example, preload them by id
 */ const $841e841717fb4840$var$lazyIds = new Map();
/**
 * ids "marked" for preload on spot
 */ let $841e841717fb4840$var$preloadIds;
const $841e841717fb4840$export$ac21d099cbc8d569 = (preload)=>{
    $841e841717fb4840$var$preloadIds = preload;
    try {
        $841e841717fb4840$var$preloadIds.forEach((lazyId)=>{
            const deffered = $841e841717fb4840$var$lazyIds.get(lazyId);
            if (deffered) // preload dont have any "phases" and visa versa. Just load it ASAP
            deffered.preload();
        });
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('RLL preload', e);
    }
};
const $841e841717fb4840$export$e673efccd97e4223 = (lazyId, { loader: loader, preload: preload })=>{
    // we dont cache deferred FOR NOW as the goal is to handle networking first
    // the next step would in better pre-resolving deferred, so Suspense might be never triggered
    // if (lazyIds.has(lazyId)) {
    // 	return lazyIds.get(lazyId)!;
    // }
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: ()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        },
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    $841e841717fb4840$var$lazyIds.set(lazyId, deferred);
    // in case of "just created" deferred is already marked for preload
    // do instant preload
    if ($841e841717fb4840$var$preloadIds?.includes(lazyId)) deferred.preload();
    return deferred;
};
module.exports["createDeferred"] = $841e841717fb4840$export$e673efccd97e4223;

});

parcelRegister("cU4Ow", function(module, exports) {

var $3zIme = parcelRequire("3zIme");


var $aJQSl = parcelRequire("aJQSl");


var $jrpaf = parcelRequire("jrpaf");


var $bSocS = parcelRequire("bSocS");


var $3Zhtx = parcelRequire("3Zhtx");


var $6DjRB = parcelRequire("6DjRB");


var $1Y0Bp = parcelRequire("1Y0Bp");

function $72b45db42b4960fa$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $jrpaf.getConfig)();
    const assets = (0, $3zIme.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $1Y0Bp.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $72b45db42b4960fa$var$fakePromise = {
    then: ()=>$72b45db42b4960fa$var$fakePromise,
    catch: ()=>$72b45db42b4960fa$var$fakePromise,
    finally: ()=>$72b45db42b4960fa$var$fakePromise
};
function $72b45db42b4960fa$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $1Y0Bp.insertLinkTag)(href, rel));
        return $72b45db42b4960fa$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $72b45db42b4960fa$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $aJQSl.noopCleanup;
}
function $72b45db42b4960fa$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    if ((0, $3Zhtx.isNodeEnvironment)()) return 0, $aJQSl.noopCleanup;
    (0, $bSocS.GlobalReactLooselyLazyProfiler).current?.onPreload(moduleId, priority);
    const rel = priority === (0, $6DjRB.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $72b45db42b4960fa$export$3af04dbcb01bad4d,
        $72b45db42b4960fa$export$1046fd6a49d5e7a,
        $72b45db42b4960fa$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $aJQSl.noopCleanup;
}
module.exports["preloadAsset"] = $72b45db42b4960fa$export$25bad4aa00c45355;

});

parcelRegister("1Y0Bp", function(module, exports) {

var $aJQSl = parcelRequire("aJQSl");


var $jrpaf = parcelRequire("jrpaf");


var $bSocS = parcelRequire("bSocS");

function $e5a7bcb8f7812549$export$6610512821c8a4ce(href, rel) {
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $aJQSl.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $jrpaf.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $bSocS.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    document.head?.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) document.head?.removeChild(link);
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $e5a7bcb8f7812549$export$6610512821c8a4ce;

});

parcelRegister("31PDK", function(module, exports) {
const $e0741a36efbb4dfa$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $e0741a36efbb4dfa$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $e0741a36efbb4dfa$var$getPolicy = (configuration)=>({
        delay: Math.max(0, configuration.delay ?? 0),
        factor: Math.max(0, configuration.factor ?? 0),
        maxAttempts: Math.max(0, configuration.maxAttempts ?? 0)
    });
function $e0741a36efbb4dfa$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $e0741a36efbb4dfa$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $e0741a36efbb4dfa$var$calculateDelay(context, policy);
        if (delay) await $e0741a36efbb4dfa$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $e0741a36efbb4dfa$export$9369b12211e1fce4;

});

parcelRegister("3LxIp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");

function $1efef99f0e02a868$export$7c51f1b21238e429(LegacyIcon, OfficialIcon, defaultSize) {
    return function BrandIcon({ size: size = defaultSize } = {}) {
        if ((0, $iDrrr.fg)('rovo-search-team-eu-26-brand-icon-library')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(OfficialIcon, {
            label: "",
            size: size
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LegacyIcon, null);
    };
}
module.exports["withBrandIcon"] = $1efef99f0e02a868$export$7c51f1b21238e429;

});

parcelRegister("4hzFj", function(module, exports) {

let $31e46a58d87c0f49$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $31e46a58d87c0f49$var$load("jxGqt").then(()=>parcelRequire('fyTd1'));

});

parcelRegister("3w7xz", function(module, exports) {

let $28fa35a07f4c32d8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $28fa35a07f4c32d8$var$load("ECQ6q").then(()=>parcelRequire('kGNh6'));

});

parcelRegister("ehKBQ", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $6ce68911b0df4e15$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9dtYX")).then((m)=>m.GitlabIcon), {
    moduleId: '@atlassian/logo-third-party/gitlab'
});

const $6ce68911b0df4e15$var$LazyGitlabIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/icon'
});

const $6ce68911b0df4e15$var$LazyGitlabSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/search-result-icon'
});

const $6ce68911b0df4e15$var$LazyGitlabIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/icon-borderless'
});
const $6ce68911b0df4e15$export$8b4e5326778cce0f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabIconComponent, null)), $6ce68911b0df4e15$var$OfficialIcon, 'small');
const $6ce68911b0df4e15$export$b828123bc19648f9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabSearchResultIconComponent, null)), $6ce68911b0df4e15$var$OfficialIcon, 'medium');
const $6ce68911b0df4e15$export$7e0d364467f49036 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabIconBorderlessComponent, null)), $6ce68911b0df4e15$var$OfficialIcon, 'xxsmall');
module.exports["GitlabIcon"] = $6ce68911b0df4e15$export$8b4e5326778cce0f;
module.exports["GitlabSearchResultIcon"] = $6ce68911b0df4e15$export$b828123bc19648f9;
module.exports["GitlabIconBorderless"] = $6ce68911b0df4e15$export$7e0d364467f49036;

});

parcelRegister("9dtYX", function(module, exports) {

let $6b5c95c494a16587$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b5c95c494a16587$var$load("4LY4N").then(()=>parcelRequire('kmcLM'));

});

parcelRegister("ilgI1", function(module, exports) {

let $d5a726386ad88d53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5a726386ad88d53$var$load("1p9Ip").then(()=>parcelRequire('hYL6T'));

});

parcelRegister("iS3Tu", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $83bbbb3fda08bb6a$var$LazyGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lbDA4")).then((m)=>m.GitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitbook/icon'
});

const $83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lbDA4")).then((m)=>m.GitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitbook/search-result-icon'
});
const $83bbbb3fda08bb6a$export$6da1c7984975c183 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookIconComponent, null));
const $83bbbb3fda08bb6a$export$65b356f251826206 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent, null));
module.exports["GitbookIcon"] = $83bbbb3fda08bb6a$export$6da1c7984975c183;
module.exports["GitbookSearchResultIcon"] = $83bbbb3fda08bb6a$export$65b356f251826206;

});

parcelRegister("lbDA4", function(module, exports) {

let $f6c953f826ed6884$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f6c953f826ed6884$var$load("k1ije").then(()=>parcelRequire('lG6hv'));

});

parcelRegister("dULnI", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2cad9d35507cac43$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("enDSk")).then((m)=>m.MicrosoftAzureDevOpsIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-azure-devops'
});

const $2cad9d35507cac43$var$LazyAzureDevopsIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8WMbv")).then((m)=>m.AzureDevopsIcon), {
    moduleId: '@atlassian/rovo-connectors-config/azure-devops/icon'
});

const $2cad9d35507cac43$var$LazyAzureDevopsSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8WMbv")).then((m)=>m.AzureDevopsSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/azure-devops/search-result-icon'
});
const $2cad9d35507cac43$export$2dcf704e717ca168 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2cad9d35507cac43$var$LazyAzureDevopsIconComponent, null)), $2cad9d35507cac43$var$OfficialIcon, 'small');
const $2cad9d35507cac43$export$a64bb17da4dc2efb = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2cad9d35507cac43$var$LazyAzureDevopsSearchResultIconComponent, null)), $2cad9d35507cac43$var$OfficialIcon, 'medium');
module.exports["AzureDevopsIcon"] = $2cad9d35507cac43$export$2dcf704e717ca168;
module.exports["AzureDevopsSearchResultIcon"] = $2cad9d35507cac43$export$a64bb17da4dc2efb;

});

parcelRegister("enDSk", function(module, exports) {

let $a782250e15e8574e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a782250e15e8574e$var$load("jLsGY").then(()=>parcelRequire('b9s7D'));

});

parcelRegister("8WMbv", function(module, exports) {

let $68391df23b860e75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $68391df23b860e75$var$load("axvMK").then(()=>parcelRequire('fTk3N'));

});

parcelRegister("2sFbd", function(module, exports) {
/**
 * Lazy-loaded Slack icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $809b94d6e1c8821b$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ln0Jc")).then((m)=>m.SlackIcon), {
    moduleId: '@atlassian/logo-third-party/slack'
});

// Lazy load the actual icon components from utils
const $809b94d6e1c8821b$var$LazySlackIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/icon'
});

const $809b94d6e1c8821b$var$LazySlackIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/slack/icon-borderless'
});

const $809b94d6e1c8821b$var$LazySlackSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/search-result-icon'
});

const $809b94d6e1c8821b$var$LazySlackAppSelectorIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackAppSelectorIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/app-selector-icon'
});
const $809b94d6e1c8821b$export$b33fb54b08bb6422 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackIconComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'small');
const $809b94d6e1c8821b$export$359ca796b415372 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackIconBorderlessComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'xxsmall');
const $809b94d6e1c8821b$export$9e3ecebaf98513b9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackSearchResultIconComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'medium');
const $809b94d6e1c8821b$export$f11b42d1aefdd173 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackAppSelectorIconComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'xxsmall');
module.exports["SlackIcon"] = $809b94d6e1c8821b$export$b33fb54b08bb6422;
module.exports["SlackIconBorderless"] = $809b94d6e1c8821b$export$359ca796b415372;
module.exports["SlackSearchResultIcon"] = $809b94d6e1c8821b$export$9e3ecebaf98513b9;

});

parcelRegister("ln0Jc", function(module, exports) {

let $f8ec4f8a6e6abecf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f8ec4f8a6e6abecf$var$load("7S2Sh").then(()=>parcelRequire('eaD9b'));

});

parcelRegister("iCjpP", function(module, exports) {

let $d8dad6234f740135$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d8dad6234f740135$var$load("hUTu6").then(()=>parcelRequire('gaQ0m'));

});

parcelRegister("9Jc29", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $f96caf77f5e0e90e$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hcdgm")).then((m)=>m.GoogleDriveIcon), {
    moduleId: '@atlassian/logo-third-party/google-drive'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/icon'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/search-result-icon'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/google/icon-borderless'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveAppSelectorIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveAppSelectorIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/app-selector-icon'
});
const $f96caf77f5e0e90e$export$e16bd899bb4eebf9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveIconComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'small');
const $f96caf77f5e0e90e$export$99050685a064f8e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveSearchResultIconComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'medium');
const $f96caf77f5e0e90e$export$1f3b452b60b13122 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveIconBorderlessComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'xxsmall');
const $f96caf77f5e0e90e$export$e087ba40596ff085 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveAppSelectorIconComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'xxsmall');
module.exports["GoogleDriveIcon"] = $f96caf77f5e0e90e$export$e16bd899bb4eebf9;
module.exports["GoogleDriveSearchResultIcon"] = $f96caf77f5e0e90e$export$99050685a064f8e;
module.exports["GoogleDriveIconBorderless"] = $f96caf77f5e0e90e$export$1f3b452b60b13122;
module.exports["GoogleDriveAppSelectorIcon"] = $f96caf77f5e0e90e$export$e087ba40596ff085;

});

parcelRegister("hcdgm", function(module, exports) {

let $c84dd866b614e7fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c84dd866b614e7fc$var$load("iDrFi").then(()=>parcelRequire('4zc1o'));

});

parcelRegister("eauWV", function(module, exports) {

let $a50a01c0fe4d8419$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a50a01c0fe4d8419$var$load("fz4Mg").then(()=>parcelRequire('aqriX'));

});

parcelRegister("jyScu", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $63cad5270e3124a2$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jQMxS")).then((m)=>m.FigmaIcon), {
    moduleId: '@atlassian/logo-third-party/figma'
});

const $63cad5270e3124a2$var$LazyFigmaIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lv0ob")).then((m)=>m.FigmaIcon), {
    moduleId: '@atlassian/rovo-connectors-config/figma/icon'
});

const $63cad5270e3124a2$var$LazyFigmaSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lv0ob")).then((m)=>m.FigmaSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/figma/search-result-icon'
});
const $63cad5270e3124a2$export$54e0f4982aa79afe = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($63cad5270e3124a2$var$LazyFigmaIconComponent, null)), $63cad5270e3124a2$var$OfficialIcon, 'small');
const $63cad5270e3124a2$export$b31792ff95c3d83f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($63cad5270e3124a2$var$LazyFigmaSearchResultIconComponent, null)), $63cad5270e3124a2$var$OfficialIcon, 'medium');
module.exports["FigmaIcon"] = $63cad5270e3124a2$export$54e0f4982aa79afe;
module.exports["FigmaSearchResultIcon"] = $63cad5270e3124a2$export$b31792ff95c3d83f;

});

parcelRegister("jQMxS", function(module, exports) {

let $e73887c3b4774afa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e73887c3b4774afa$var$load("lrpUd").then(()=>parcelRequire('d5OuW'));

});

parcelRegister("lv0ob", function(module, exports) {

let $fa6ccb7c265dd600$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fa6ccb7c265dd600$var$load("lXqxA").then(()=>parcelRequire('3jkLL'));

});

parcelRegister("1q7zk", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $795cd329f1dc6efb$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7L3HM")).then((m)=>m.MiroIcon), {
    moduleId: '@atlassian/logo-third-party/miro'
});

const $795cd329f1dc6efb$var$LazyMiroIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8rXyj")).then((m)=>m.MiroIcon), {
    moduleId: '@atlassian/rovo-connectors-config/miro/icon'
});

const $795cd329f1dc6efb$var$LazyMiroSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8rXyj")).then((m)=>m.MiroSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/miro/search-result-icon'
});
const $795cd329f1dc6efb$export$38410c1d5582587e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($795cd329f1dc6efb$var$LazyMiroIconComponent, null)), $795cd329f1dc6efb$var$OfficialIcon, 'small');
const $795cd329f1dc6efb$export$c22696a011659024 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($795cd329f1dc6efb$var$LazyMiroSearchResultIconComponent, null)), $795cd329f1dc6efb$var$OfficialIcon, 'medium');
module.exports["MiroIcon"] = $795cd329f1dc6efb$export$38410c1d5582587e;
module.exports["MiroSearchResultIcon"] = $795cd329f1dc6efb$export$c22696a011659024;

});

parcelRegister("7L3HM", function(module, exports) {

let $5a5fcbf4df6462e4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a5fcbf4df6462e4$var$load("fDXJE").then(()=>parcelRequire('dPB9D'));

});

parcelRegister("8rXyj", function(module, exports) {

let $626f0a394095201f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $626f0a394095201f$var$load("6cQfl").then(()=>parcelRequire('UNjzi'));

});

parcelRegister("dpFv1", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $eadc98172343aaf6$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("duDsS")).then((m)=>m.NotionIcon), {
    moduleId: '@atlassian/logo-third-party/notion'
});

const $eadc98172343aaf6$var$LazyNotionIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("dqLLz")).then((m)=>m.NotionIcon), {
    moduleId: '@atlassian/rovo-connectors-config/notion/icon'
});

const $eadc98172343aaf6$var$LazyNotionSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("dqLLz")).then((m)=>m.NotionSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/notion/search-result-icon'
});

const $eadc98172343aaf6$var$LazyNotionIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("dqLLz")).then((m)=>m.NotionIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/notion/icon-borderless'
});
const $eadc98172343aaf6$export$694ff710b1e20299 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eadc98172343aaf6$var$LazyNotionIconComponent, null)), $eadc98172343aaf6$var$OfficialIcon, 'small');
const $eadc98172343aaf6$export$7dd377a68ecb1d9f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eadc98172343aaf6$var$LazyNotionSearchResultIconComponent, null)), $eadc98172343aaf6$var$OfficialIcon, 'medium');
const $eadc98172343aaf6$export$5b5388c6f4e608dd = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($eadc98172343aaf6$var$LazyNotionIconBorderlessComponent, null)), $eadc98172343aaf6$var$OfficialIcon, 'xxsmall');
module.exports["NotionIcon"] = $eadc98172343aaf6$export$694ff710b1e20299;
module.exports["NotionSearchResultIcon"] = $eadc98172343aaf6$export$7dd377a68ecb1d9f;
module.exports["NotionIconBorderless"] = $eadc98172343aaf6$export$5b5388c6f4e608dd;

});

parcelRegister("duDsS", function(module, exports) {

let $9d2cb0973885463a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9d2cb0973885463a$var$load("gSN2U").then(()=>parcelRequire('3zDBO'));

});

parcelRegister("dqLLz", function(module, exports) {

let $9c72c17820ac74dc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9c72c17820ac74dc$var$load("iCnHc").then(()=>parcelRequire('lRem0'));

});

parcelRegister("Douji", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $216cd14c42636556$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("60nw9")).then((m)=>m.MicrosoftSharePointIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-sharepoint'
});

const $216cd14c42636556$var$LazySharePointIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharePointIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/icon'
});

const $216cd14c42636556$var$LazySharePointSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharePointSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/search-result-icon'
});

const $216cd14c42636556$var$LazySharepointIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharepointIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/icon-borderless'
});
const $216cd14c42636556$export$53d8bcde0f28cd56 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharePointIconComponent, null)), $216cd14c42636556$var$OfficialIcon, 'small');
const $216cd14c42636556$export$65b9e0ddb04a51a1 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharePointSearchResultIconComponent, null)), $216cd14c42636556$var$OfficialIcon, 'medium');
const $216cd14c42636556$export$a0d18fc9cea4f40e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharepointIconBorderlessComponent, null)), $216cd14c42636556$var$OfficialIcon, 'xxsmall');
module.exports["SharePointIcon"] = $216cd14c42636556$export$53d8bcde0f28cd56;
module.exports["SharePointSearchResultIcon"] = $216cd14c42636556$export$65b9e0ddb04a51a1;
module.exports["SharepointIconBorderless"] = $216cd14c42636556$export$a0d18fc9cea4f40e;

});

parcelRegister("60nw9", function(module, exports) {

let $45f4fc3fccb59bad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $45f4fc3fccb59bad$var$load("i8lZ0").then(()=>parcelRequire('8RTwe'));

});

parcelRegister("kabYe", function(module, exports) {

let $eade06eb3e209cb5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eade06eb3e209cb5$var$load("c2llp").then(()=>parcelRequire('58jvK'));

});

parcelRegister("iPmoS", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $b77f1e6828d0ac82$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4hzFj")).then((m)=>m.GitHubIcon), {
    moduleId: '@atlassian/logo-third-party/github'
});

const $b77f1e6828d0ac82$var$LazyForgePioGithubIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9RFVr")).then((m)=>m.ForgePioGithubIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-prod/icon'
});

const $b77f1e6828d0ac82$var$LazyForgePioGithubSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9RFVr")).then((m)=>m.ForgePioGithubSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-prod/search-result-icon'
});
const $b77f1e6828d0ac82$export$f1d7e8d930f0538e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b77f1e6828d0ac82$var$LazyForgePioGithubIconComponent, null)), $b77f1e6828d0ac82$var$OfficialIcon, 'small');
const $b77f1e6828d0ac82$export$f318f463f9328f3f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b77f1e6828d0ac82$var$LazyForgePioGithubSearchResultIconComponent, null)), $b77f1e6828d0ac82$var$OfficialIcon, 'medium');
module.exports["ForgePioGithubIcon"] = $b77f1e6828d0ac82$export$f1d7e8d930f0538e;
module.exports["ForgePioGithubSearchResultIcon"] = $b77f1e6828d0ac82$export$f318f463f9328f3f;

});

parcelRegister("9RFVr", function(module, exports) {

let $72e995d3df53c84c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $72e995d3df53c84c$var$load("cNleL").then(()=>parcelRequire('gcarM'));

});

parcelRegister("2a08l", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $f2ed16baff72ba2b$var$LazyWebDomainSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l1BmH")).then((m)=>m.WebDomainSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/atlassian-web-crawler/search-result-icon'
});
const $f2ed16baff72ba2b$export$b16288f56aa4a879 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f2ed16baff72ba2b$var$LazyWebDomainSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f2ed16baff72ba2b$var$LazyWebDomainSearchResultIconComponent, null));
module.exports["WebDomainSearchResultIcon"] = $f2ed16baff72ba2b$export$b16288f56aa4a879;

});

parcelRegister("l1BmH", function(module, exports) {

let $f4e6ace1a3666370$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f4e6ace1a3666370$var$load("5ZoVX").then(()=>parcelRequire('5TYsy'));

});

parcelRegister("frXak", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $67596226ed2b5a5b$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    ['atlassian-web-crawler']: {
        id: "search-page.products.custom-website",
        defaultMessage: "Web page"
    }
});
module.exports["messages"] = $67596226ed2b5a5b$export$defe85febe8b728c;

});

parcelRegister("7dzhu", function(module, exports) {

var $hareu = parcelRequire("hareu");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $jyScu = parcelRequire("jyScu");

const $5121b1584cf21fa5$export$e821d8af66e3adab = {
    displayName: 'Figma',
    id: 'figma',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Figma,
    icon: (0, $i52Hf.get3PLogo)((0, $jyScu.FigmaIcon), 'Figma', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $jyScu.FigmaSearchResultIcon), 'Figma', 'large'),
    integrationAri: 'ari:cloud:platform::integration/figma',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: [
                    ...(0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["figmaConfig"] = $5121b1584cf21fa5$export$e821d8af66e3adab;

});

parcelRegister("hareu", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $572397f4f72859d8$export$9d37c36d8b43baee = [
    'ati:cloud:graph:design'
];
module.exports["DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI"] = $572397f4f72859d8$export$9d37c36d8b43baee;

});

parcelRegister("kFLxH", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $cd2849e7738ca37b$export$1dc2d469fb044d48 = [
    'ati:cloud:graph:remote-link'
];
module.exports["DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI"] = $cd2849e7738ca37b$export$1dc2d469fb044d48;

});

parcelRegister("6Ymez", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $0aab066f73937fd8$export$7bf025ec33e76761 = [
    'ati:cloud:graph:branch'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI"] = $0aab066f73937fd8$export$7bf025ec33e76761;

});

parcelRegister("bCUcs", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $ea564ddf0cc8c2fd$export$3e5409bef2addb56 = [
    'ati:cloud:graph:commit'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI"] = $ea564ddf0cc8c2fd$export$3e5409bef2addb56;

});

parcelRegister("fmJYG", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $51acdb1b50e4834b$export$3268f1527392e5ac = [
    'ati:cloud:graph:pull-request'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI"] = $51acdb1b50e4834b$export$3268f1527392e5ac;

});

parcelRegister("iM9d2", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $fe7cd180c5f0ee38$export$c28231fcae6448eb = [
    'ati:cloud:graph:repository'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI"] = $fe7cd180c5f0ee38$export$c28231fcae6448eb;

});

parcelRegister("2Rsot", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $a989069c3574d0d8$export$d810eae89914369b = [
    'ati:cloud:graph:work-item'
];
module.exports["DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI"] = $a989069c3574d0d8$export$d810eae89914369b;

});

parcelRegister("sRb5o", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $cedd31adddcd6a4e$export$a3d7cddace4fe237 = [
    'ati:cloud:graph:video'
];
module.exports["DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI"] = $cedd31adddcd6a4e$export$a3d7cddace4fe237;

});

parcelRegister("2qza4", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $jkp8o = parcelRequire("jkp8o");

const $f930aa7851f48d68$export$4a63cdb15a145936 = {
    displayName: 'Dropbox',
    id: 'dropbox',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Dropbox,
    icon: (0, $i52Hf.get3PLogo)((0, $jkp8o.DropboxIcon), 'Dropbox', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $jkp8o.DropboxSearchResultIcon), 'Dropbox', 'large'),
    integrationAri: 'ari:cloud:platform::integration/dropbox',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document,
                    (0, $5PPrc.NounSubtypeKey).Pdf
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Spreadsheet,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Spreadsheet
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Presentation,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Presentation
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["dropboxConfig"] = $f930aa7851f48d68$export$4a63cdb15a145936;

});

parcelRegister("jkp8o", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $f91f519b5bcd4961$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8ndru")).then((m)=>m.DropboxIcon), {
    moduleId: '@atlassian/logo-third-party/dropbox'
});

const $f91f519b5bcd4961$var$LazyDropboxIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jawnG")).then((m)=>m.DropboxIcon), {
    moduleId: '@atlassian/rovo-connectors-config/dropbox/icon'
});

const $f91f519b5bcd4961$var$LazyDropboxSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jawnG")).then((m)=>m.DropboxSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/dropbox/search-result-icon'
});
const $f91f519b5bcd4961$export$5e2362bb78414664 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f91f519b5bcd4961$var$LazyDropboxIconComponent, null)), $f91f519b5bcd4961$var$OfficialIcon, 'small');
const $f91f519b5bcd4961$export$197780c70679b508 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f91f519b5bcd4961$var$LazyDropboxSearchResultIconComponent, null)), $f91f519b5bcd4961$var$OfficialIcon, 'medium');
module.exports["DropboxIcon"] = $f91f519b5bcd4961$export$5e2362bb78414664;
module.exports["DropboxSearchResultIcon"] = $f91f519b5bcd4961$export$197780c70679b508;

});

parcelRegister("8ndru", function(module, exports) {

let $618ae617941e5dc0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $618ae617941e5dc0$var$load("1FkAI").then(()=>parcelRequire('7qsey'));

});

parcelRegister("jawnG", function(module, exports) {

let $df4811b549e8b26a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $df4811b549e8b26a$var$load("4zHyf").then(()=>parcelRequire('lOu1t'));

});

parcelRegister("kDG5l", function(module, exports) {

var $6GYKu = parcelRequire("6GYKu");


var $72Zuk = parcelRequire("72Zuk");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $2sFbd = parcelRequire("2sFbd");

const $35e09b6a61d5b2b9$var$getSlackTypeFilterConfig = ()=>{
    const typeFilter = new Map();
    // Always include Message
    typeFilter.set((0, $5PPrc.TypeFilterValueKey).Message, {
        entities3P: (0, $72Zuk.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
        subTypes3P: []
    });
    typeFilter.set((0, $5PPrc.TypeFilterValueKey).Conversation, {
        entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
        subTypes3P: []
    });
    return typeFilter;
};
const $35e09b6a61d5b2b9$export$c33894e475506863 = {
    displayName: 'Slack',
    id: 'slack',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Slack,
    icon: (0, $i52Hf.get3PLogo)((0, $2sFbd.SlackIcon), 'Slack', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $2sFbd.SlackIconBorderless), 'Slack', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $2sFbd.SlackSearchResultIcon), 'Slack', 'large'),
    integrationAri: 'ari:cloud:platform::integration/slack',
    get typeFilterConfig () {
        return $35e09b6a61d5b2b9$var$getSlackTypeFilterConfig();
    },
    filters: [
        'lastUpdated',
        'slackChannel'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["slackConfig"] = $35e09b6a61d5b2b9$export$c33894e475506863;

});

parcelRegister("6GYKu", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $76ad9eb563127536$export$a752b216a5b9069f = [
    'ati:cloud:graph:conversation'
];
module.exports["DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI"] = $76ad9eb563127536$export$a752b216a5b9069f;

});

parcelRegister("72Zuk", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $229f506edf3bbbcc$export$8bd7fa13a82672fe = [
    'ati:cloud:graph:message'
];
module.exports["DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI"] = $229f506edf3bbbcc$export$8bd7fa13a82672fe;

});

parcelRegister("6eg6r", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $bshDC = parcelRequire("bshDC");

const $5a3e20cfdf519b55$export$be326f2f9a08a3a4 = {
    displayName: 'Google Calendar',
    id: 'google-calendar',
    resourceType: (0, $fR63l.ProductResourceTypes3P).GoogleCalendar,
    icon: (0, $i52Hf.get3PLogo)((0, $bshDC.GoogleCalendarIcon), 'Google Calendar', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $bshDC.GoogleCalendarIconBorderless), 'Google Calendar', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $bshDC.GoogleCalendarSearchResultIcon), 'Google Calendar', 'large'),
    integrationAri: 'ari:cloud:platform::integration/google',
    requiresOauth: true,
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    isEnabled: ()=>true
};
module.exports["googleCalendarConfig"] = $5a3e20cfdf519b55$export$be326f2f9a08a3a4;

});

parcelRegister("f3t7x", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $353cafebfceb5684$export$733c2acb2513a07a = [
    'ati:cloud:graph:calendar-event'
];
module.exports["DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI"] = $353cafebfceb5684$export$733c2acb2513a07a;

});

parcelRegister("bshDC", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $5e54e69c86724cae$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("anZGr")).then((m)=>m.GoogleCalendarIcon), {
    moduleId: '@atlassian/logo-third-party/google-calendar'
});

const $5e54e69c86724cae$var$LazyGoogleCalendarIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4w4Kc")).then((m)=>m.GoogleCalendarIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google-calendar/icon'
});

const $5e54e69c86724cae$var$LazyGoogleCalendarSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4w4Kc")).then((m)=>m.GoogleCalendarSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google-calendar/search-result-icon'
});

const $5e54e69c86724cae$var$LazyGoogleCalendarIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4w4Kc")).then((m)=>m.GoogleCalendarIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/google-calendar/icon-borderless'
});
const $5e54e69c86724cae$export$5d128e0a6ffc0558 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5e54e69c86724cae$var$LazyGoogleCalendarIconComponent, null)), $5e54e69c86724cae$var$OfficialIcon, 'small');
const $5e54e69c86724cae$export$aed283b8fb73a449 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5e54e69c86724cae$var$LazyGoogleCalendarSearchResultIconComponent, null)), $5e54e69c86724cae$var$OfficialIcon, 'medium');
const $5e54e69c86724cae$export$dc8e328f8eb98139 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5e54e69c86724cae$var$LazyGoogleCalendarIconBorderlessComponent, null)), $5e54e69c86724cae$var$OfficialIcon, 'xxsmall');
module.exports["GoogleCalendarIcon"] = $5e54e69c86724cae$export$5d128e0a6ffc0558;
module.exports["GoogleCalendarSearchResultIcon"] = $5e54e69c86724cae$export$aed283b8fb73a449;
module.exports["GoogleCalendarIconBorderless"] = $5e54e69c86724cae$export$dc8e328f8eb98139;

});

parcelRegister("anZGr", function(module, exports) {

let $78fbe6699ea6267d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $78fbe6699ea6267d$var$load("eN8m9").then(()=>parcelRequire('dO5IM'));

});

parcelRegister("4w4Kc", function(module, exports) {

let $349dd4aca5d2aad7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $349dd4aca5d2aad7$var$load("41vki").then(()=>parcelRequire('bzpJH'));

});

parcelRegister("ijAga", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9dIsl = parcelRequire("9dIsl");

const $28f910cc1563149a$export$3e5044818f2e9ef3 = {
    displayName: 'Outlook Calendar',
    id: 'outlook-calendar',
    resourceType: (0, $fR63l.ProductResourceTypes3P).OutlookCalendar,
    icon: (0, $i52Hf.get3PLogo)((0, $9dIsl.OutlookCalendarIcon), 'Outlook Calendar', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $9dIsl.OutlookCalendarIconBorderless), 'Outlook Calendar', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9dIsl.OutlookCalendarSearchResultIcon), 'Outlook Calendar', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["outlookCalendarConfig"] = $28f910cc1563149a$export$3e5044818f2e9ef3;

});

parcelRegister("9dIsl", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $b7be050c70ad0dbd$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lwMgp")).then((m)=>m.MicrosoftOutlookIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-outlook'
});

const $b7be050c70ad0dbd$var$LazyOutlookCalendarIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1cK5e")).then((m)=>m.OutlookCalendarIcon), {
    moduleId: '@atlassian/rovo-connectors-config/outlook-calendar/icon'
});

const $b7be050c70ad0dbd$var$LazyOutlookCalendarSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1cK5e")).then((m)=>m.OutlookCalendarSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/outlook-calendar/search-result-icon'
});

const $b7be050c70ad0dbd$var$LazyOutlookCalendarIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1cK5e")).then((m)=>m.OutlookCalendarIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/outlook-calendar/icon-borderless'
});
const $b7be050c70ad0dbd$export$62b570fbaf793397 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7be050c70ad0dbd$var$LazyOutlookCalendarIconComponent, null)), $b7be050c70ad0dbd$var$OfficialIcon, 'small');
const $b7be050c70ad0dbd$export$c93fd0887f18cc87 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7be050c70ad0dbd$var$LazyOutlookCalendarSearchResultIconComponent, null)), $b7be050c70ad0dbd$var$OfficialIcon, 'medium');
const $b7be050c70ad0dbd$export$dd150ae24aa9e16a = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7be050c70ad0dbd$var$LazyOutlookCalendarIconBorderlessComponent, null)), $b7be050c70ad0dbd$var$OfficialIcon, 'xxsmall');
module.exports["OutlookCalendarIcon"] = $b7be050c70ad0dbd$export$62b570fbaf793397;
module.exports["OutlookCalendarSearchResultIcon"] = $b7be050c70ad0dbd$export$c93fd0887f18cc87;
module.exports["OutlookCalendarIconBorderless"] = $b7be050c70ad0dbd$export$dd150ae24aa9e16a;

});

parcelRegister("lwMgp", function(module, exports) {

let $fac20645ff50f52d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fac20645ff50f52d$var$load("eLIPc").then(()=>parcelRequire('6Adh3'));

});

parcelRegister("1cK5e", function(module, exports) {

let $0e0aa8a5bee42239$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0e0aa8a5bee42239$var$load("kD3mK").then(()=>parcelRequire('izieu'));

});

parcelRegister("4Be7r", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $5SyKL = parcelRequire("5SyKL");

const $e64348b365719323$export$72c8845a87b8934e = {
    displayName: 'Asana',
    id: 'asana',
    icon: (0, $i52Hf.get3PLogo)((0, $5SyKL.AsanaIcon), 'Asana', 'medium'),
    resourceType: (0, $fR63l.ProductResourceTypes3P).Asana,
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $5SyKL.AsanaSearchResultIcon), 'Asana', 'large'),
    integrationAri: 'ari:cloud:platform::integration/asana',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: [
                    ...(0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Task
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["asanaConfig"] = $e64348b365719323$export$72c8845a87b8934e;

});

parcelRegister("5SyKL", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $6e40eba859cc102e$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kMuq9")).then((m)=>m.AsanaIcon), {
    moduleId: '@atlassian/logo-third-party/asana'
});

const $6e40eba859cc102e$var$LazyAsanaIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("63WVt")).then((m)=>m.AsanaIcon), {
    moduleId: '@atlassian/rovo-connectors-config/asana/icon'
});

const $6e40eba859cc102e$var$LazyAsanaSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("63WVt")).then((m)=>m.AsanaSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/asana/search-result-icon'
});
const $6e40eba859cc102e$export$671541d0c7918cd9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e40eba859cc102e$var$LazyAsanaIconComponent, null)), $6e40eba859cc102e$var$OfficialIcon, 'small');
const $6e40eba859cc102e$export$c3fa6bf9156b56f9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e40eba859cc102e$var$LazyAsanaSearchResultIconComponent, null)), $6e40eba859cc102e$var$OfficialIcon, 'medium');
module.exports["AsanaIcon"] = $6e40eba859cc102e$export$671541d0c7918cd9;
module.exports["AsanaSearchResultIcon"] = $6e40eba859cc102e$export$c3fa6bf9156b56f9;

});

parcelRegister("kMuq9", function(module, exports) {

let $f20fe34add90d72b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f20fe34add90d72b$var$load("d4v6U").then(()=>parcelRequire('2FcOq'));

});

parcelRegister("63WVt", function(module, exports) {

let $46a0bb5c742ef139$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $46a0bb5c742ef139$var$load("cQSOF").then(()=>parcelRequire('9fYuQ'));

});

parcelRegister("kmEEk", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $dAioJ = parcelRequire("dAioJ");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $ajO8r = parcelRequire("ajO8r");

const $c81e254992debedb$export$74a2db0a5eb2da3f = {
    displayName: 'Zendesk',
    id: 'zendesk',
    icon: (0, $i52Hf.get3PLogo)((0, $ajO8r.ZendeskIcon), 'Zendesk', 'medium'),
    resourceType: (0, $fR63l.ProductResourceTypes3P).Zendesk,
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $ajO8r.ZendeskSearchResultIcon), 'Zendesk', 'large'),
    integrationAri: 'ari:cloud:platform::integration/zendesk',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Ticket,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Post,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Post
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Article,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Article
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["zendeskConfig"] = $c81e254992debedb$export$74a2db0a5eb2da3f;

});

parcelRegister("4moZS", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $4dabbc53c19f0eb6$export$4e0eae9edc1a8907 = [
    'ati:cloud:graph:comment'
];
module.exports["DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI"] = $4dabbc53c19f0eb6$export$4e0eae9edc1a8907;

});

parcelRegister("ajO8r", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $8cf8b8beac6f4758$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eU7gC")).then((m)=>m.ZendeskIcon), {
    moduleId: '@atlassian/logo-third-party/zendesk'
});

const $8cf8b8beac6f4758$var$LazyZendeskIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fmsuC")).then((m)=>m.ZendeskIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zendesk/icon'
});

const $8cf8b8beac6f4758$var$LazyZendeskSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fmsuC")).then((m)=>m.ZendeskSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zendesk/search-result-icon'
});
const $8cf8b8beac6f4758$export$9969d63eaadfddf7 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8cf8b8beac6f4758$var$LazyZendeskIconComponent, null)), $8cf8b8beac6f4758$var$OfficialIcon, 'small');
const $8cf8b8beac6f4758$export$439dd6b525db0f9a = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8cf8b8beac6f4758$var$LazyZendeskSearchResultIconComponent, null)), $8cf8b8beac6f4758$var$OfficialIcon, 'medium');
module.exports["ZendeskIcon"] = $8cf8b8beac6f4758$export$9969d63eaadfddf7;
module.exports["ZendeskSearchResultIcon"] = $8cf8b8beac6f4758$export$439dd6b525db0f9a;

});

parcelRegister("eU7gC", function(module, exports) {

let $ad9beeb805548024$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ad9beeb805548024$var$load("T8raP").then(()=>parcelRequire('6foYz'));

});

parcelRegister("fmsuC", function(module, exports) {

let $b2ef03301938ca3f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b2ef03301938ca3f$var$load("2TtSv").then(()=>parcelRequire('iMWOo'));

});

parcelRegister("52Drw", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $inzhp = parcelRequire("inzhp");

const $03fbf292f7174bda$export$962b0679c5bd2c33 = {
    displayName: 'Airtable',
    id: 'airtable',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Airtable,
    icon: (0, $i52Hf.get3PLogo)((0, $inzhp.AirtableIcon), 'Airtable', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $inzhp.AirtableSearchResultIcon), 'Airtable', 'large'),
    integrationAri: 'ari:cloud:platform::integration/airtable',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["airtableConfig"] = $03fbf292f7174bda$export$962b0679c5bd2c33;

});

parcelRegister("inzhp", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $92a7691f4600f71d$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("d0y3M")).then((m)=>m.AirtableIcon), {
    moduleId: '@atlassian/logo-third-party/airtable'
});

const $92a7691f4600f71d$var$LazyAirtableIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kzDsq")).then((m)=>m.AirtableIcon), {
    moduleId: '@atlassian/rovo-connectors-config/airtable/icon'
});

const $92a7691f4600f71d$var$LazyAirtableSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kzDsq")).then((m)=>m.AirtableSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/airtable/search-result-icon'
});
const $92a7691f4600f71d$export$88b64eee273831fd = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($92a7691f4600f71d$var$LazyAirtableIconComponent, null)), $92a7691f4600f71d$var$OfficialIcon, 'small');
const $92a7691f4600f71d$export$826c628c1cea041a = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($92a7691f4600f71d$var$LazyAirtableSearchResultIconComponent, null)), $92a7691f4600f71d$var$OfficialIcon, 'medium');
module.exports["AirtableIcon"] = $92a7691f4600f71d$export$88b64eee273831fd;
module.exports["AirtableSearchResultIcon"] = $92a7691f4600f71d$export$826c628c1cea041a;

});

parcelRegister("d0y3M", function(module, exports) {

let $9785b20e7cd3fd83$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9785b20e7cd3fd83$var$load("1p5Hv").then(()=>parcelRequire('3WMFE'));

});

parcelRegister("kzDsq", function(module, exports) {

let $efa5aef30890ae60$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $efa5aef30890ae60$var$load("ks6Jw").then(()=>parcelRequire('dIIkr'));

});

parcelRegister("aaz0Y", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $g0bLV = parcelRequire("g0bLV");

const $81da3ded26649f38$export$aad10bcf647ef696 = {
    displayName: 'Smartsheet',
    id: 'smartsheet',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Smartsheet,
    icon: (0, $i52Hf.get3PLogo)((0, $g0bLV.SmartsheetIcon), 'Smartsheet', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $g0bLV.SmartsheetSearchResultIcon), 'Smartsheet', 'large'),
    integrationAri: 'ari:cloud:platform::integration/smartsheet',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["smartsheetConfig"] = $81da3ded26649f38$export$aad10bcf647ef696;

});

parcelRegister("g0bLV", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $8f9328e012078649$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iR5v6")).then((m)=>m.SmartsheetIcon), {
    moduleId: '@atlassian/logo-third-party/smartsheet'
});

const $8f9328e012078649$var$LazySmartsheetIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hsPg7")).then((m)=>m.SmartsheetIcon), {
    moduleId: '@atlassian/rovo-connectors-config/smartsheet/icon'
});

const $8f9328e012078649$var$LazySmartsheetSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hsPg7")).then((m)=>m.SmartsheetSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/smartsheet/search-result-icon'
});
const $8f9328e012078649$export$dd0ad7bd8a5794f4 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8f9328e012078649$var$LazySmartsheetIconComponent, null)), $8f9328e012078649$var$OfficialIcon, 'small');
const $8f9328e012078649$export$3b8c4380ae1ed96d = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8f9328e012078649$var$LazySmartsheetSearchResultIconComponent, null)), $8f9328e012078649$var$OfficialIcon, 'medium');
module.exports["SmartsheetIcon"] = $8f9328e012078649$export$dd0ad7bd8a5794f4;
module.exports["SmartsheetSearchResultIcon"] = $8f9328e012078649$export$3b8c4380ae1ed96d;

});

parcelRegister("iR5v6", function(module, exports) {

let $dba171869ac506f9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dba171869ac506f9$var$load("5ErXe").then(()=>parcelRequire('hRzDR'));

});

parcelRegister("hsPg7", function(module, exports) {

let $cb6cd027ab9362e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cb6cd027ab9362e1$var$load("hwAbd").then(()=>parcelRequire('7j9rQ'));

});

parcelRegister("kcCFv", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $dpFv1 = parcelRequire("dpFv1");

const $2afe1256651e861b$export$ddf7404f556e473a = {
    displayName: 'Notion',
    id: 'notion',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Notion,
    icon: (0, $i52Hf.get3PLogo)((0, $dpFv1.NotionIcon), 'Notion', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $dpFv1.NotionIconBorderless), 'Notion', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $dpFv1.NotionSearchResultIcon), 'Notion', 'large'),
    integrationAri: 'ari:cloud:platform::integration/notion',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["notionConfig"] = $2afe1256651e861b$export$ddf7404f556e473a;

});

parcelRegister("6lsSn", function(module, exports) {

var $hareu = parcelRequire("hareu");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $1q7zk = parcelRequire("1q7zk");

const $b9040784bae93d2b$export$b11bada05d439596 = {
    displayName: 'Miro',
    id: 'miro',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Miro,
    icon: (0, $i52Hf.get3PLogo)((0, $1q7zk.MiroIcon), 'Miro', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $1q7zk.MiroSearchResultIcon), 'Miro', 'large'),
    integrationAri: 'ari:cloud:platform::integration/miro',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: [
                    ...(0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["miroConfig"] = $b9040784bae93d2b$export$b11bada05d439596;

});

parcelRegister("k521G", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $3XMnx = parcelRequire("3XMnx");

const $3c5ca7e0efe3fba9$export$cee55280cabc1aa1 = {
    displayName: 'Docusign',
    id: 'docusign',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Docusign,
    icon: (0, $i52Hf.get3PLogo)((0, $3XMnx.DocusignIcon), 'Docusign', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $3XMnx.DocusignIconBorderless), 'Docusign', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $3XMnx.DocusignSearchResultIcon), 'Docusign', 'large'),
    integrationAri: 'ari:cloud:platform::integration/docusign',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["docusignConfig"] = $3c5ca7e0efe3fba9$export$cee55280cabc1aa1;

});

parcelRegister("3XMnx", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $094cc084c2c96e5c$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2xHBu")).then((m)=>m.DocuSignIcon), {
    moduleId: '@atlassian/logo-third-party/docusign'
});

const $094cc084c2c96e5c$var$LazyDocusignIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l2dtx")).then((m)=>m.DocusignIcon), {
    moduleId: '@atlassian/rovo-connectors-config/docusign/icon'
});

const $094cc084c2c96e5c$var$LazyDocusignSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l2dtx")).then((m)=>m.DocusignSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/docusign/search-result-icon'
});

const $094cc084c2c96e5c$var$LazyDocusignIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l2dtx")).then((m)=>m.DocusignIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/docusign/icon-borderless'
});
const $094cc084c2c96e5c$export$393452da0e179bab = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($094cc084c2c96e5c$var$LazyDocusignIconComponent, null)), $094cc084c2c96e5c$var$OfficialIcon, 'small');
const $094cc084c2c96e5c$export$4cdd065eb81c5a09 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($094cc084c2c96e5c$var$LazyDocusignSearchResultIconComponent, null)), $094cc084c2c96e5c$var$OfficialIcon, 'medium');
const $094cc084c2c96e5c$export$db2f9bd1f316d475 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($094cc084c2c96e5c$var$LazyDocusignIconBorderlessComponent, null)), $094cc084c2c96e5c$var$OfficialIcon, 'xxsmall');
module.exports["DocusignIcon"] = $094cc084c2c96e5c$export$393452da0e179bab;
module.exports["DocusignSearchResultIcon"] = $094cc084c2c96e5c$export$4cdd065eb81c5a09;
module.exports["DocusignIconBorderless"] = $094cc084c2c96e5c$export$db2f9bd1f316d475;

});

parcelRegister("2xHBu", function(module, exports) {

let $1da07ca46271c18f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1da07ca46271c18f$var$load("7YktL").then(()=>parcelRequire('eF6SD'));

});

parcelRegister("l2dtx", function(module, exports) {

let $f5043cd00e87a001$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f5043cd00e87a001$var$load("hY6q1").then(()=>parcelRequire('l3sY5'));

});

parcelRegister("43W2t", function(module, exports) {

var $hareu = parcelRequire("hareu");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $kSVSf = parcelRequire("kSVSf");

const $20e2732837474949$export$3cac442956139a7e = {
    displayName: 'Lucid',
    id: 'lucid',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Lucid,
    icon: (0, $i52Hf.get3PLogo)((0, $kSVSf.LucidIcon), 'Lucid', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $kSVSf.LucidSearchResultIcon), 'Lucid', 'large'),
    integrationAri: 'ari:cloud:platform::integration/lucid',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: [
                    ...(0, $hareu.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true
};
module.exports["lucidConfig"] = $20e2732837474949$export$3cac442956139a7e;

});

parcelRegister("kSVSf", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $28a610a168ffc34d$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("aujOL")).then((m)=>m.LucidIcon), {
    moduleId: '@atlassian/logo-third-party/lucid'
});

const $28a610a168ffc34d$var$LazyLucidIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("627KK")).then((m)=>m.LucidIcon), {
    moduleId: '@atlassian/rovo-connectors-config/lucid/icon'
});

const $28a610a168ffc34d$var$LazyLucidSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("627KK")).then((m)=>m.LucidSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/lucid/search-result-icon'
});
const $28a610a168ffc34d$export$8664694e1d7db2a0 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28a610a168ffc34d$var$LazyLucidIconComponent, null)), $28a610a168ffc34d$var$OfficialIcon, 'small');
const $28a610a168ffc34d$export$6daa097ac5ffeb2c = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28a610a168ffc34d$var$LazyLucidSearchResultIconComponent, null)), $28a610a168ffc34d$var$OfficialIcon, 'medium');
module.exports["LucidIcon"] = $28a610a168ffc34d$export$8664694e1d7db2a0;
module.exports["LucidSearchResultIcon"] = $28a610a168ffc34d$export$6daa097ac5ffeb2c;

});

parcelRegister("aujOL", function(module, exports) {

let $7a2c1421be11368f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a2c1421be11368f$var$load("c2c9w").then(()=>parcelRequire('h4FW2'));

});

parcelRegister("627KK", function(module, exports) {

let $4648f18ba45c9e97$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4648f18ba45c9e97$var$load("hU3Xi").then(()=>parcelRequire('c6ZRh'));

});

parcelRegister("6ThsT", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cJP8d = parcelRequire("cJP8d");

const $03d641d2f237614a$export$49283b8341865631 = {
    displayName: 'Monday',
    id: 'monday',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Monday,
    icon: (0, $i52Hf.get3PLogo)((0, $cJP8d.MondayIcon), 'Monday', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $cJP8d.MondayIconBorderless), 'Monday', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cJP8d.MondaySearchResultIcon), 'Monday', 'large'),
    integrationAri: 'ari:cloud:platform::integration/monday',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["mondayConfig"] = $03d641d2f237614a$export$49283b8341865631;

});

parcelRegister("cJP8d", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $142215abe5670892$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("f2rQp")).then((m)=>m.MondayIcon), {
    moduleId: '@atlassian/logo-third-party/monday'
});

const $142215abe5670892$var$LazyMondayIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9b74Z")).then((m)=>m.MondayIcon), {
    moduleId: '@atlassian/rovo-connectors-config/monday/icon'
});

const $142215abe5670892$var$LazyMondaySearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9b74Z")).then((m)=>m.MondaySearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/monday/search-result-icon'
});

const $142215abe5670892$var$LazyMondayIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9b74Z")).then((m)=>m.MondayIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/monday/icon-borderless'
});
const $142215abe5670892$export$37b4104f63b2f4bd = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($142215abe5670892$var$LazyMondayIconComponent, null)), $142215abe5670892$var$OfficialIcon, 'small');
const $142215abe5670892$export$bf10d2e61430fb53 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($142215abe5670892$var$LazyMondaySearchResultIconComponent, null)), $142215abe5670892$var$OfficialIcon, 'medium');
const $142215abe5670892$export$43da0494a61d1337 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($142215abe5670892$var$LazyMondayIconBorderlessComponent, null)), $142215abe5670892$var$OfficialIcon, 'xxsmall');
module.exports["MondayIcon"] = $142215abe5670892$export$37b4104f63b2f4bd;
module.exports["MondaySearchResultIcon"] = $142215abe5670892$export$bf10d2e61430fb53;
module.exports["MondayIconBorderless"] = $142215abe5670892$export$43da0494a61d1337;

});

parcelRegister("f2rQp", function(module, exports) {

let $af2ca43c73de70db$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $af2ca43c73de70db$var$load("8UmJb").then(()=>parcelRequire('863CU'));

});

parcelRegister("9b74Z", function(module, exports) {

let $6aeaa1f9faf92676$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6aeaa1f9faf92676$var$load("1EOaf").then(()=>parcelRequire('iBWwo'));

});

parcelRegister("4x6XK", function(module, exports) {

var $iM9d2 = parcelRequire("iM9d2");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $dULnI = parcelRequire("dULnI");

const $aaf7a143bc096e5d$export$f324080d91cfb196 = {
    displayName: 'Azure DevOps',
    id: 'azure-devops',
    resourceType: (0, $fR63l.ProductResourceTypes3P).AzureDevops,
    icon: (0, $i52Hf.get3PLogo)((0, $dULnI.AzureDevopsIcon), 'AzureDevOps', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $dULnI.AzureDevopsSearchResultIcon), 'AzureDevOps', 'large'),
    integrationAri: 'ari:cloud:platform::integration/azure-devops',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Repository,
            {
                entities3P: [
                    ...(0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Repository
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["azureDevopsConfig"] = $aaf7a143bc096e5d$export$f324080d91cfb196;

});

parcelRegister("382mb", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $iM9d2 = parcelRequire("iM9d2");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $ehKBQ = parcelRequire("ehKBQ");

const $e23e1846e340baa7$var$getGitlabTypeFilterConfig = ()=>{
    const config = new Map();
    config.set((0, $5PPrc.TypeFilterValueKey).Repository, {
        entities3P: [
            ...(0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).Repository,
            (0, $5PPrc.NounSubtypeKey).Project
        ]
    });
    if ((0, $iDrrr.fg)('rovo-fps-3p-ux-gitlab-pull-request-noun')) config.set((0, $5PPrc.TypeFilterValueKey).PullRequest, {
        entities3P: [
            ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
        ],
        subTypes3P: [
            (0, $5PPrc.NounSubtypeKey).PullRequest
        ]
    });
    return config;
};
const $e23e1846e340baa7$export$72758f81cc2e21e1 = {
    displayName: 'Gitlab',
    id: 'gitlab',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Gitlab,
    icon: (0, $i52Hf.get3PLogo)((0, $ehKBQ.GitlabIcon), 'Gitlab', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $ehKBQ.GitlabIconBorderless), 'Gitlab', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $ehKBQ.GitlabSearchResultIcon), 'Gitlab', 'large'),
    integrationAri: 'ari:cloud:platform::integration/gitlab',
    get typeFilterConfig () {
        return $e23e1846e340baa7$var$getGitlabTypeFilterConfig();
    },
    filters: [
        'pullRequestStatus'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["gitlabConfig"] = $e23e1846e340baa7$export$72758f81cc2e21e1;

});

parcelRegister("2vDkv", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $b3506739b3db16a9$export$1e3b02869b42f77a = [
    'ati:cloud:graph:space'
];
module.exports["DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI"] = $b3506739b3db16a9$export$1e3b02869b42f77a;

});

parcelRegister("fg2gb", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $fDs5L = parcelRequire("fDs5L");

const $ded2e0e354596c76$export$75e56657ffc0207b = {
    displayName: 'Canva',
    id: 'canva',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Canva,
    icon: (0, $i52Hf.get3PLogo)((0, $fDs5L.CanvaIcon), 'Canva', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $fDs5L.CanvaSearchResultIcon), 'Canva', 'large'),
    integrationAri: 'ari:cloud:platform::integration/canva',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["canvaConfig"] = $ded2e0e354596c76$export$75e56657ffc0207b;

});

parcelRegister("fDs5L", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $4d4fb88adf934208$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gefM5")).then((m)=>m.CanvaIcon), {
    moduleId: '@atlassian/logo-third-party/canva'
});

const $4d4fb88adf934208$var$LazyCanvaIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6LmRM")).then((m)=>m.CanvaIcon), {
    moduleId: '@atlassian/rovo-connectors-config/canva/icon'
});

const $4d4fb88adf934208$var$LazyCanvaSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6LmRM")).then((m)=>m.CanvaSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/canva/search-result-icon'
});
const $4d4fb88adf934208$export$3ad1ba1bf426d64a = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d4fb88adf934208$var$LazyCanvaIconComponent, null)), $4d4fb88adf934208$var$OfficialIcon, 'small');
const $4d4fb88adf934208$export$ac6bbd7ba99716e3 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d4fb88adf934208$var$LazyCanvaSearchResultIconComponent, null)), $4d4fb88adf934208$var$OfficialIcon, 'medium');
module.exports["CanvaIcon"] = $4d4fb88adf934208$export$3ad1ba1bf426d64a;
module.exports["CanvaSearchResultIcon"] = $4d4fb88adf934208$export$ac6bbd7ba99716e3;

});

parcelRegister("gefM5", function(module, exports) {

let $bd0a30ad629dad14$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bd0a30ad629dad14$var$load("h6ocG").then(()=>parcelRequire('luZrp'));

});

parcelRegister("6LmRM", function(module, exports) {

let $4ec8dea8ab0a1852$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ec8dea8ab0a1852$var$load("bX5IH").then(()=>parcelRequire('agGaQ'));

});

parcelRegister("fauGM", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $6MJWz = parcelRequire("6MJWz");

const $9286766965944e9d$export$3e7603f097ea326e = {
    displayName: 'Box',
    id: 'box',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Box,
    icon: (0, $i52Hf.get3PLogo)((0, $6MJWz.BoxIcon), 'Box', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $6MJWz.BoxSearchResultIcon), 'Box', 'large'),
    integrationAri: 'ari:cloud:platform::integration/box',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document,
                    (0, $5PPrc.NounSubtypeKey).Pdf
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Spreadsheet,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Spreadsheet
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Presentation,
            {
                entities3P: [
                    ...(0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Presentation
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["boxConfig"] = $9286766965944e9d$export$3e7603f097ea326e;

});

parcelRegister("6MJWz", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $b99c2662195c467e$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9cFmD")).then((m)=>m.BoxIcon), {
    moduleId: '@atlassian/logo-third-party/box'
});

const $b99c2662195c467e$var$LazyBoxIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1x79L")).then((m)=>m.BoxIcon), {
    moduleId: '@atlassian/rovo-connectors-config/box/icon'
});

const $b99c2662195c467e$var$LazyBoxSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1x79L")).then((m)=>m.BoxSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/box/search-result-icon'
});
const $b99c2662195c467e$export$adedf1569d7107de = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b99c2662195c467e$var$LazyBoxIconComponent, null)), $b99c2662195c467e$var$OfficialIcon, 'small');
const $b99c2662195c467e$export$f9ea3a56c013af54 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b99c2662195c467e$var$LazyBoxSearchResultIconComponent, null)), $b99c2662195c467e$var$OfficialIcon, 'medium');
module.exports["BoxIcon"] = $b99c2662195c467e$export$adedf1569d7107de;
module.exports["BoxSearchResultIcon"] = $b99c2662195c467e$export$f9ea3a56c013af54;

});

parcelRegister("9cFmD", function(module, exports) {

let $6b35521bfc8d519c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b35521bfc8d519c$var$load("gzrsz").then(()=>parcelRequire('kmQeH'));

});

parcelRegister("1x79L", function(module, exports) {

let $11de6ca258b12afa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $11de6ca258b12afa$var$load("1KhjS").then(()=>parcelRequire('h43rp'));

});

parcelRegister("bj13p", function(module, exports) {

var $f3t7x = parcelRequire("f3t7x");


var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $8uEzt = parcelRequire("8uEzt");

const $55934d84816643a8$export$ce290ee9e9d9bcd7 = {
    displayName: 'Zoom',
    id: 'zoom',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Zoom,
    icon: (0, $i52Hf.get3PLogo)((0, $8uEzt.ZoomIcon), 'Zoom', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $8uEzt.ZoomSearchResultIcon), 'Zoom', 'large'),
    integrationAri: 'ari:cloud:platform::integration/zoom',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Calendar,
            {
                entities3P: (0, $f3t7x.DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["zoomConfig"] = $55934d84816643a8$export$ce290ee9e9d9bcd7;

});

parcelRegister("8uEzt", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $f1c2fec685aced05$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gByso")).then((m)=>m.ZoomIcon), {
    moduleId: '@atlassian/logo-third-party/zoom'
});

const $f1c2fec685aced05$var$LazyZoomIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("brtqH")).then((m)=>m.ZoomIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zoom/icon'
});

const $f1c2fec685aced05$var$LazyZoomSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("brtqH")).then((m)=>m.ZoomSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zoom/search-result-icon'
});
const $f1c2fec685aced05$export$db7393a57b3e6d84 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1c2fec685aced05$var$LazyZoomIconComponent, null)), $f1c2fec685aced05$var$OfficialIcon, 'small');
const $f1c2fec685aced05$export$5c9fb0638b666051 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1c2fec685aced05$var$LazyZoomSearchResultIconComponent, null)), $f1c2fec685aced05$var$OfficialIcon, 'medium');
module.exports["ZoomIcon"] = $f1c2fec685aced05$export$db7393a57b3e6d84;
module.exports["ZoomSearchResultIcon"] = $f1c2fec685aced05$export$5c9fb0638b666051;

});

parcelRegister("gByso", function(module, exports) {

let $c16ad47bb10c0bc2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c16ad47bb10c0bc2$var$load("b2JtK").then(()=>parcelRequire('30kpZ'));

});

parcelRegister("brtqH", function(module, exports) {

let $85490b746b3dbf90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $85490b746b3dbf90$var$load("kxE93").then(()=>parcelRequire('9e80B'));

});

parcelRegister("3VdqU", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cdPZA = parcelRequire("cdPZA");

const $6e80d7674da45b22$export$d198c255b2b88327 = {
    displayName: 'Zeplin',
    id: 'zeplin',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Zeplin,
    icon: (0, $i52Hf.get3PLogo)((0, $cdPZA.ZeplinIcon), 'Zeplin', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $cdPZA.ZeplinIconBorderless), 'Zeplin', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cdPZA.ZeplinSearchResultIcon), 'Zeplin', 'large'),
    integrationAri: 'ari:cloud:platform::integration/zeplin',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["zeplinConfig"] = $6e80d7674da45b22$export$d198c255b2b88327;

});

parcelRegister("cdPZA", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $fbd169a88d312a73$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hafBA")).then((m)=>m.ZeplinIcon), {
    moduleId: '@atlassian/logo-third-party/zeplin'
});

const $fbd169a88d312a73$var$LazyZeplinIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gAgWa")).then((m)=>m.ZeplinIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zeplin/icon'
});

const $fbd169a88d312a73$var$LazyZeplinSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gAgWa")).then((m)=>m.ZeplinSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/zeplin/search-result-icon'
});

const $fbd169a88d312a73$var$LazyZeplinIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gAgWa")).then((m)=>m.ZeplinIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/zeplin/icon-borderless'
});
const $fbd169a88d312a73$export$81c909fcf490b72b = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbd169a88d312a73$var$LazyZeplinIconComponent, null)), $fbd169a88d312a73$var$OfficialIcon, 'small');
const $fbd169a88d312a73$export$e3736b5ffc9fcc9e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbd169a88d312a73$var$LazyZeplinSearchResultIconComponent, null)), $fbd169a88d312a73$var$OfficialIcon, 'medium');
const $fbd169a88d312a73$export$d013f8d99ccc63fb = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fbd169a88d312a73$var$LazyZeplinIconBorderlessComponent, null)), $fbd169a88d312a73$var$OfficialIcon, 'xxsmall');
module.exports["ZeplinIcon"] = $fbd169a88d312a73$export$81c909fcf490b72b;
module.exports["ZeplinSearchResultIcon"] = $fbd169a88d312a73$export$e3736b5ffc9fcc9e;
module.exports["ZeplinIconBorderless"] = $fbd169a88d312a73$export$d013f8d99ccc63fb;

});

parcelRegister("hafBA", function(module, exports) {

let $c7ef79bb151dcf06$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c7ef79bb151dcf06$var$load("czpIO").then(()=>parcelRequire('ktsV4'));

});

parcelRegister("gAgWa", function(module, exports) {

let $c12d257c331759c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c12d257c331759c7$var$load("dBdPR").then(()=>parcelRequire('cNG5i'));

});

parcelRegister("fA9zj", function(module, exports) {

var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $ldmHj = parcelRequire("ldmHj");

const $95e57b030e0f8dca$export$8120804698f632ae = {
    displayName: 'Freshservice',
    id: 'freshservice',
    icon: (0, $i52Hf.get3PLogo)((0, $ldmHj.FreshserviceIcon), 'Freshservice', 'medium'),
    resourceType: (0, $fR63l.ProductResourceTypes3P).Freshservice,
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $ldmHj.FreshserviceSearchResultIcon), 'Freshservice', 'large'),
    integrationAri: 'ari:cloud:platform::integration/freshservice',
    // this hasn't been implemented in the codebase yet, so will need to confirm that it is correct in the future,
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["freshserviceConfig"] = $95e57b030e0f8dca$export$8120804698f632ae;

});

parcelRegister("ldmHj", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $45beef96d43b57ec$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("d3rS9")).then((m)=>m.FreshserviceIcon), {
    moduleId: '@atlassian/logo-third-party/freshservice'
});

const $45beef96d43b57ec$var$LazyFreshserviceIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jwajS")).then((m)=>m.FreshserviceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/freshservice/icon'
});

const $45beef96d43b57ec$var$LazyFreshserviceSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jwajS")).then((m)=>m.FreshserviceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/freshservice/search-result-icon'
});
const $45beef96d43b57ec$export$327de5bc0476c8b8 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45beef96d43b57ec$var$LazyFreshserviceIconComponent, null)), $45beef96d43b57ec$var$OfficialIcon, 'small');
const $45beef96d43b57ec$export$afb7a1d2b1e9186c = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45beef96d43b57ec$var$LazyFreshserviceSearchResultIconComponent, null)), $45beef96d43b57ec$var$OfficialIcon, 'medium');
module.exports["FreshserviceIcon"] = $45beef96d43b57ec$export$327de5bc0476c8b8;
module.exports["FreshserviceSearchResultIcon"] = $45beef96d43b57ec$export$afb7a1d2b1e9186c;

});

parcelRegister("d3rS9", function(module, exports) {

let $98112d0f9100e3e9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98112d0f9100e3e9$var$load("1TO8o").then(()=>parcelRequire('eVhsQ'));

});

parcelRegister("jwajS", function(module, exports) {

let $e35902b647be50d9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e35902b647be50d9$var$load("cgVYM").then(()=>parcelRequire('byKTU'));

});

parcelRegister("iTxTm", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $jHpbI = parcelRequire("jHpbI");

const $fe7cdbf0eb82d212$export$b883b80d867cc715 = {
    displayName: 'PowerBI',
    id: 'power-bi',
    resourceType: (0, $fR63l.ProductResourceTypes3P).PowerBI,
    icon: (0, $i52Hf.get3PLogo)((0, $jHpbI.PowerBIIcon), 'PowerBI', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $jHpbI.PowerBIIconBorderless), 'PowerBI', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $jHpbI.PowerBISearchResultIcon), 'PowerBI', 'large'),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Dashboard
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["powerBIConfig"] = $fe7cdbf0eb82d212$export$b883b80d867cc715;

});

parcelRegister("jHpbI", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $b89a7a27b28a6f7f$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cZjn1")).then((m)=>m.MicrosoftPowerBIIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-power-bi'
});

const $b89a7a27b28a6f7f$var$LazyPowerBIIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gLSjb")).then((m)=>m.PowerBIIcon), {
    moduleId: '@atlassian/rovo-connectors-config/powerBI/icon'
});

const $b89a7a27b28a6f7f$var$LazyPowerBISearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gLSjb")).then((m)=>m.PowerBISearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/powerBI/search-result-icon'
});

const $b89a7a27b28a6f7f$var$LazyPowerBIIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gLSjb")).then((m)=>m.PowerBIIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/powerBI/icon-borderless'
});
const $b89a7a27b28a6f7f$export$8a27e4cfebfdcb7 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b89a7a27b28a6f7f$var$LazyPowerBIIconComponent, null)), $b89a7a27b28a6f7f$var$OfficialIcon, 'small');
const $b89a7a27b28a6f7f$export$66bbf4ebbd8bb09 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b89a7a27b28a6f7f$var$LazyPowerBISearchResultIconComponent, null)), $b89a7a27b28a6f7f$var$OfficialIcon, 'medium');
const $b89a7a27b28a6f7f$export$77c3c6e8d16b3669 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b89a7a27b28a6f7f$var$LazyPowerBIIconBorderlessComponent, null)), $b89a7a27b28a6f7f$var$OfficialIcon, 'xxsmall');
module.exports["PowerBIIcon"] = $b89a7a27b28a6f7f$export$8a27e4cfebfdcb7;
module.exports["PowerBISearchResultIcon"] = $b89a7a27b28a6f7f$export$66bbf4ebbd8bb09;
module.exports["PowerBIIconBorderless"] = $b89a7a27b28a6f7f$export$77c3c6e8d16b3669;

});

parcelRegister("cZjn1", function(module, exports) {

let $974a3518074827aa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $974a3518074827aa$var$load("eLocl").then(()=>parcelRequire('a71rl'));

});

parcelRegister("gLSjb", function(module, exports) {

let $c35b29a88fc41c42$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c35b29a88fc41c42$var$load("7yeiN").then(()=>parcelRequire('7NK6P'));

});

parcelRegister("5pWqV", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $iq3xJ = parcelRequire("iq3xJ");

const $cec4d02f64d13f8c$export$7ef79ba9bf00ce19 = {
    displayName: 'ClickUp',
    id: 'clickup',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ClickUp,
    icon: (0, $i52Hf.get3PLogo)((0, $iq3xJ.ClickUpIcon), 'ClickUp', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $iq3xJ.ClickUpIconBorderless), 'ClickUp', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $iq3xJ.ClickUpSearchResultIcon), 'ClickUp', 'large'),
    integrationAri: 'ari:cloud:platform::integration/clickup',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["clickUpConfig"] = $cec4d02f64d13f8c$export$7ef79ba9bf00ce19;

});

parcelRegister("iq3xJ", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $530f12575ecdabb5$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7sd0z")).then((m)=>m.ClickupIcon), {
    moduleId: '@atlassian/logo-third-party/clickup'
});

const $530f12575ecdabb5$var$LazyClickUpIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eZzOO")).then((m)=>m.ClickUpIcon), {
    moduleId: '@atlassian/rovo-connectors-config/clickup/icon'
});

const $530f12575ecdabb5$var$LazyClickUpSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eZzOO")).then((m)=>m.ClickUpSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/clickup/search-result-icon'
});

const $530f12575ecdabb5$var$LazyClickUpIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eZzOO")).then((m)=>m.ClickUpIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/clickup/icon-borderless'
});
const $530f12575ecdabb5$export$592b235c95c5fb2b = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($530f12575ecdabb5$var$LazyClickUpIconComponent, null)), $530f12575ecdabb5$var$OfficialIcon, 'small');
const $530f12575ecdabb5$export$7ca2508a62493599 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($530f12575ecdabb5$var$LazyClickUpSearchResultIconComponent, null)), $530f12575ecdabb5$var$OfficialIcon, 'medium');
const $530f12575ecdabb5$export$d29fdfa1300ec8ae = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($530f12575ecdabb5$var$LazyClickUpIconBorderlessComponent, null)), $530f12575ecdabb5$var$OfficialIcon, 'xxsmall');
module.exports["ClickUpIcon"] = $530f12575ecdabb5$export$592b235c95c5fb2b;
module.exports["ClickUpSearchResultIcon"] = $530f12575ecdabb5$export$7ca2508a62493599;
module.exports["ClickUpIconBorderless"] = $530f12575ecdabb5$export$d29fdfa1300ec8ae;

});

parcelRegister("7sd0z", function(module, exports) {

let $56d53d15de41d2d2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56d53d15de41d2d2$var$load("lXXxc").then(()=>parcelRequire('el36N'));

});

parcelRegister("eZzOO", function(module, exports) {

let $aea28c0308a21713$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aea28c0308a21713$var$load("Wo3LI").then(()=>parcelRequire('aFqIo'));

});

parcelRegister("juuLe", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $8DGA8 = parcelRequire("8DGA8");

const $bf887cabcde61381$export$a0702b571a9392d4 = {
    displayName: 'Amplitude',
    id: 'amplitude',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Amplitude,
    icon: (0, $i52Hf.get3PLogo)((0, $8DGA8.AmplitudeIcon), 'Amplitude', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $8DGA8.AmplitudeSearchResultIcon), 'Amplitude', 'large'),
    integrationAri: 'ari:cloud:platform::integration/amplitude',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Dashboard
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["amplitudeConfig"] = $bf887cabcde61381$export$a0702b571a9392d4;

});

parcelRegister("8DGA8", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $1c1e864948fda48c$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fLb3r")).then((m)=>m.AmplitudeIcon), {
    moduleId: '@atlassian/logo-third-party/amplitude'
});

const $1c1e864948fda48c$var$LazyAmplitudeIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1Lj2x")).then((m)=>m.AmplitudeIcon), {
    moduleId: '@atlassian/rovo-connectors-config/amplitude/icon'
});

const $1c1e864948fda48c$var$LazyAmplitudeSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1Lj2x")).then((m)=>m.AmplitudeSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/amplitude/search-result-icon'
});
const $1c1e864948fda48c$export$5e013c7991ef7bd0 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1c1e864948fda48c$var$LazyAmplitudeIconComponent, null)), $1c1e864948fda48c$var$OfficialIcon, 'small');
const $1c1e864948fda48c$export$49b3130ea0e9d6dd = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1c1e864948fda48c$var$LazyAmplitudeSearchResultIconComponent, null)), $1c1e864948fda48c$var$OfficialIcon, 'medium');
module.exports["AmplitudeIcon"] = $1c1e864948fda48c$export$5e013c7991ef7bd0;
module.exports["AmplitudeSearchResultIcon"] = $1c1e864948fda48c$export$49b3130ea0e9d6dd;

});

parcelRegister("fLb3r", function(module, exports) {

let $b793d1fa98c7296a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b793d1fa98c7296a$var$load("7ZEab").then(()=>parcelRequire('aIs8c'));

});

parcelRegister("1Lj2x", function(module, exports) {

let $1488f32e8fa7fe12$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1488f32e8fa7fe12$var$load("aHKXM").then(()=>parcelRequire('7uWoZ'));

});

parcelRegister("3juV6", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9PLia = parcelRequire("9PLia");

const $92674268e4049146$export$3be693d67bbce82 = {
    displayName: 'Stripe',
    id: 'stripe',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Stripe,
    icon: (0, $i52Hf.get3PLogo)((0, $9PLia.StripeIcon), 'Stripe', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9PLia.StripeSearchResultIcon), 'Stripe', 'large'),
    integrationAri: 'ari:cloud:platform::integration/stripe',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Invoice,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Invoice
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["stripeConfig"] = $92674268e4049146$export$3be693d67bbce82;

});

parcelRegister("9PLia", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $33b6aea29cf3117b$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4qEUM")).then((m)=>m.StripeIcon), {
    moduleId: '@atlassian/logo-third-party/stripe'
});

const $33b6aea29cf3117b$var$LazyStripeIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cp8O6")).then((m)=>m.StripeIcon), {
    moduleId: '@atlassian/rovo-connectors-config/stripe/icon'
});

const $33b6aea29cf3117b$var$LazyStripeSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cp8O6")).then((m)=>m.StripeSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/stripe/search-result-icon'
});
const $33b6aea29cf3117b$export$86ab8f6f2448222e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($33b6aea29cf3117b$var$LazyStripeIconComponent, null)), $33b6aea29cf3117b$var$OfficialIcon, 'small');
const $33b6aea29cf3117b$export$efbbc3acb0731d93 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($33b6aea29cf3117b$var$LazyStripeSearchResultIconComponent, null)), $33b6aea29cf3117b$var$OfficialIcon, 'medium');
module.exports["StripeIcon"] = $33b6aea29cf3117b$export$86ab8f6f2448222e;
module.exports["StripeSearchResultIcon"] = $33b6aea29cf3117b$export$efbbc3acb0731d93;

});

parcelRegister("4qEUM", function(module, exports) {

let $339953fb1179e69d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $339953fb1179e69d$var$load("iZ7w3").then(()=>parcelRequire('fc8zu'));

});

parcelRegister("cp8O6", function(module, exports) {

let $907ea6b91679f987$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $907ea6b91679f987$var$load("12xPP").then(()=>parcelRequire('5eELb'));

});

parcelRegister("hIDj1", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $01lrE = parcelRequire("01lrE");

const $9077aa6f5e17fbbd$export$e69f90b2aa757835 = {
    displayName: 'AdobeXD',
    id: 'adobexd',
    resourceType: (0, $fR63l.ProductResourceTypes3P).AdobeXD,
    icon: (0, $i52Hf.get3PLogo)((0, $01lrE.AdobeXDIcon), 'AdobeXD', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $01lrE.AdobeXDSearchResultIcon), 'AdobeXD', 'large'),
    integrationAri: 'ari:cloud:platform::integration/adobe',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["adobeXDConfig"] = $9077aa6f5e17fbbd$export$e69f90b2aa757835;

});

parcelRegister("01lrE", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $9542dedcb7e547d5$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cD7ku")).then((m)=>m.AdobeXDIcon), {
    moduleId: '@atlassian/logo-third-party/adobexd'
});

const $9542dedcb7e547d5$var$LazyAdobeXDIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6qisw")).then((m)=>m.AdobeXDIcon), {
    moduleId: '@atlassian/rovo-connectors-config/adobe-xd/icon'
});

const $9542dedcb7e547d5$var$LazyAdobeXDSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6qisw")).then((m)=>m.AdobeXDSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/adobe-xd/search-result-icon'
});
const $9542dedcb7e547d5$export$be8cba599441db6e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9542dedcb7e547d5$var$LazyAdobeXDIconComponent, null)), $9542dedcb7e547d5$var$OfficialIcon, 'small');
const $9542dedcb7e547d5$export$145a936ff16d9011 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9542dedcb7e547d5$var$LazyAdobeXDSearchResultIconComponent, null)), $9542dedcb7e547d5$var$OfficialIcon, 'medium');
module.exports["AdobeXDIcon"] = $9542dedcb7e547d5$export$be8cba599441db6e;
module.exports["AdobeXDSearchResultIcon"] = $9542dedcb7e547d5$export$145a936ff16d9011;

});

parcelRegister("cD7ku", function(module, exports) {

let $931ed00f35da9582$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $931ed00f35da9582$var$load("bPHKE").then(()=>parcelRequire('8E3YW'));

});

parcelRegister("6qisw", function(module, exports) {

let $4ad37d5fd1b448bd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ad37d5fd1b448bd$var$load("jIck0").then(()=>parcelRequire('1M0ll'));

});

parcelRegister("7WW80", function(module, exports) {

var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9DXSY = parcelRequire("9DXSY");

const $c8bb031355bf837b$export$ad976bfe08240460 = {
    displayName: 'Aha',
    id: 'aha',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Aha,
    icon: (0, $i52Hf.get3PLogo)((0, $9DXSY.AhaIcon), 'Aha', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9DXSY.AhaSearchResultIcon), 'Aha', 'large'),
    integrationAri: 'ari:cloud:platform::integration/aha',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["ahaConfig"] = $c8bb031355bf837b$export$ad976bfe08240460;

});

parcelRegister("9DXSY", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2d91c1380dbfeb61$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ajWin")).then((m)=>m.AhaIcon), {
    moduleId: '@atlassian/logo-third-party/aha'
});

const $2d91c1380dbfeb61$var$LazyAhaIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eC0Ay")).then((m)=>m.AhaIcon), {
    moduleId: '@atlassian/rovo-connectors-config/aha/icon'
});

const $2d91c1380dbfeb61$var$LazyAhaSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eC0Ay")).then((m)=>m.AhaSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/aha/search-result-icon'
});
const $2d91c1380dbfeb61$export$f28fe6c5ebff8c30 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2d91c1380dbfeb61$var$LazyAhaIconComponent, null)), $2d91c1380dbfeb61$var$OfficialIcon, 'small');
const $2d91c1380dbfeb61$export$7dd76757b7d2d978 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2d91c1380dbfeb61$var$LazyAhaSearchResultIconComponent, null)), $2d91c1380dbfeb61$var$OfficialIcon, 'medium');
module.exports["AhaIcon"] = $2d91c1380dbfeb61$export$f28fe6c5ebff8c30;
module.exports["AhaSearchResultIcon"] = $2d91c1380dbfeb61$export$7dd76757b7d2d978;

});

parcelRegister("ajWin", function(module, exports) {

let $7838e6019e3525a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7838e6019e3525a7$var$load("jX4pB").then(()=>parcelRequire('4fs5C'));

});

parcelRegister("eC0Ay", function(module, exports) {

let $aa35122a7f0ad582$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aa35122a7f0ad582$var$load("crPYr").then(()=>parcelRequire('52Csx'));

});

parcelRegister("au9jr", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $exlh6 = parcelRequire("exlh6");

const $5a9c1a558ebaa3a8$export$8130889f372e8ca5 = {
    displayName: 'Adobe Sign',
    id: 'adobe-sign',
    resourceType: (0, $fR63l.ProductResourceTypes3P).AdobeSign,
    icon: (0, $i52Hf.get3PLogo)((0, $exlh6.AdobeSignIcon), 'Adobe Sign', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $exlh6.AdobeSignSearchResultIcon), 'Adobe Sign', 'large'),
    integrationAri: 'ari:cloud:platform::integration/adobe',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["adobeSignConfig"] = $5a9c1a558ebaa3a8$export$8130889f372e8ca5;

});

parcelRegister("exlh6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $0790bbd11d84640d$var$LazyAdobeSignIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("71Q5J")).then((m)=>m.AdobeSignIcon), {
    moduleId: '@atlassian/rovo-connectors-config/adobe-sign/icon'
});

const $0790bbd11d84640d$var$LazyAdobeSignSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("71Q5J")).then((m)=>m.AdobeSignSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/adobe-sign/search-result-icon'
});
const $0790bbd11d84640d$export$600af2172b0f5fb = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0790bbd11d84640d$var$LazyAdobeSignIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0790bbd11d84640d$var$LazyAdobeSignIconComponent, null));
const $0790bbd11d84640d$export$9efd1df023dc9339 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0790bbd11d84640d$var$LazyAdobeSignSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0790bbd11d84640d$var$LazyAdobeSignSearchResultIconComponent, null));
module.exports["AdobeSignIcon"] = $0790bbd11d84640d$export$600af2172b0f5fb;
module.exports["AdobeSignSearchResultIcon"] = $0790bbd11d84640d$export$9efd1df023dc9339;

});

parcelRegister("71Q5J", function(module, exports) {

let $51e108abf4f92495$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $51e108abf4f92495$var$load("6hjEN").then(()=>parcelRequire('8lSkY'));

});

parcelRegister("diJOH", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $fgzey = parcelRequire("fgzey");

const $4cab0849efa124dd$export$8855f5ba0dd32fb9 = {
    displayName: 'Mural',
    id: 'mural',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Mural,
    icon: (0, $i52Hf.get3PLogo)((0, $fgzey.MuralIcon), 'Mural', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $fgzey.MuralIconBorderless), 'Mural', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $fgzey.MuralSearchResultIcon), 'Mural', 'large'),
    integrationAri: 'ari:cloud:platform::integration/mural',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Design,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Design
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["muralConfig"] = $4cab0849efa124dd$export$8855f5ba0dd32fb9;

});

parcelRegister("fgzey", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $a97a3de67fb67ec6$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("e7Ot5")).then((m)=>m.MuralIcon), {
    moduleId: '@atlassian/logo-third-party/mural'
});

const $a97a3de67fb67ec6$var$LazyMuralIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fR633")).then((m)=>m.MuralIcon), {
    moduleId: '@atlassian/rovo-connectors-config/mural/icon'
});

const $a97a3de67fb67ec6$var$LazyMuralSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fR633")).then((m)=>m.MuralSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/mural/search-result-icon'
});

const $a97a3de67fb67ec6$var$LazyMuralIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fR633")).then((m)=>m.MuralIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/mural/icon-borderless'
});
const $a97a3de67fb67ec6$export$807a21e0dcf114c4 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a97a3de67fb67ec6$var$LazyMuralIconComponent, null)), $a97a3de67fb67ec6$var$OfficialIcon, 'small');
const $a97a3de67fb67ec6$export$930cc976c0fd31d6 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a97a3de67fb67ec6$var$LazyMuralSearchResultIconComponent, null)), $a97a3de67fb67ec6$var$OfficialIcon, 'medium');
const $a97a3de67fb67ec6$export$f2b3c9d5e4a9191a = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a97a3de67fb67ec6$var$LazyMuralIconBorderlessComponent, null)), $a97a3de67fb67ec6$var$OfficialIcon, 'xxsmall');
module.exports["MuralIcon"] = $a97a3de67fb67ec6$export$807a21e0dcf114c4;
module.exports["MuralSearchResultIcon"] = $a97a3de67fb67ec6$export$930cc976c0fd31d6;
module.exports["MuralIconBorderless"] = $a97a3de67fb67ec6$export$f2b3c9d5e4a9191a;

});

parcelRegister("e7Ot5", function(module, exports) {

let $a488de0f6b76266c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a488de0f6b76266c$var$load("bHGdS").then(()=>parcelRequire('1YPcS'));

});

parcelRegister("fR633", function(module, exports) {

let $b8b07f4942fa03b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b8b07f4942fa03b7$var$load("hZppl").then(()=>parcelRequire('9pV7D'));

});

parcelRegister("5bQLl", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9tcvD = parcelRequire("9tcvD");

const $1ec69a9c30a99d71$export$57d2eef9725d4993 = {
    displayName: 'Webex',
    id: 'webex',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Webex,
    icon: (0, $i52Hf.get3PLogo)((0, $9tcvD.WebexIcon), 'Webex', 'medium'),
    iconBorderless: (0, $i52Hf.get3PLogo)((0, $9tcvD.WebexIconBorderless), 'Webex', 'small'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9tcvD.WebexSearchResultIcon), 'Webex', 'large'),
    integrationAri: 'ari:cloud:platform::integration/cisco',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Video
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["webexConfig"] = $1ec69a9c30a99d71$export$57d2eef9725d4993;

});

parcelRegister("9tcvD", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $df7a27f90b6b2c5e$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("150aL")).then((m)=>m.WebexIcon), {
    moduleId: '@atlassian/logo-third-party/webex'
});

const $df7a27f90b6b2c5e$var$LazyWebexIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lSDFq")).then((m)=>m.WebexIcon), {
    moduleId: '@atlassian/rovo-connectors-config/webex/icon'
});

const $df7a27f90b6b2c5e$var$LazyWebexSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lSDFq")).then((m)=>m.WebexSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/webex/search-result-icon'
});

const $df7a27f90b6b2c5e$var$LazyWebexIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lSDFq")).then((m)=>m.WebexIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/webex/icon-borderless'
});
const $df7a27f90b6b2c5e$export$4079343fb47e7f0d = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df7a27f90b6b2c5e$var$LazyWebexIconComponent, null)), $df7a27f90b6b2c5e$var$OfficialIcon, 'small');
const $df7a27f90b6b2c5e$export$37506c98e5c4eabb = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df7a27f90b6b2c5e$var$LazyWebexSearchResultIconComponent, null)), $df7a27f90b6b2c5e$var$OfficialIcon, 'medium');
const $df7a27f90b6b2c5e$export$92866e6fe777cbf9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df7a27f90b6b2c5e$var$LazyWebexIconBorderlessComponent, null)), $df7a27f90b6b2c5e$var$OfficialIcon, 'xxsmall');
module.exports["WebexIcon"] = $df7a27f90b6b2c5e$export$4079343fb47e7f0d;
module.exports["WebexSearchResultIcon"] = $df7a27f90b6b2c5e$export$37506c98e5c4eabb;
module.exports["WebexIconBorderless"] = $df7a27f90b6b2c5e$export$92866e6fe777cbf9;

});

parcelRegister("150aL", function(module, exports) {

let $0c96645c4f95dd26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0c96645c4f95dd26$var$load("hpN8h").then(()=>parcelRequire('l8EZo'));

});

parcelRegister("lSDFq", function(module, exports) {

let $fedd6930306be96d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fedd6930306be96d$var$load("cbO8L").then(()=>parcelRequire('4o0Z8'));

});

parcelRegister("dVIA3", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $566qE = parcelRequire("566qE");

const $f809cfee2fd3adf4$export$2ece5664272d405b = {
    displayName: 'Todoist',
    id: 'todoist',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Todoist,
    icon: (0, $i52Hf.get3PLogo)((0, $566qE.TodoistIcon), 'Todoist', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $566qE.TodoistSearchResultIcon), 'Todoist', 'large'),
    integrationAri: 'ari:cloud:platform::integration/todoist',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["todoistConfig"] = $f809cfee2fd3adf4$export$2ece5664272d405b;

});

parcelRegister("566qE", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $7f696030f35b1bfe$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("87oFm")).then((m)=>m.TodoistIcon), {
    moduleId: '@atlassian/logo-third-party/todoist'
});

const $7f696030f35b1bfe$var$LazyTodoistIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7r1J2")).then((m)=>m.TodoistIcon), {
    moduleId: '@atlassian/rovo-connectors-config/todoist/icon'
});

const $7f696030f35b1bfe$var$LazyTodoistSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7r1J2")).then((m)=>m.TodoistSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/todoist/search-result-icon'
});
const $7f696030f35b1bfe$export$e5f255e151507cba = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f696030f35b1bfe$var$LazyTodoistIconComponent, null)), $7f696030f35b1bfe$var$OfficialIcon, 'small');
const $7f696030f35b1bfe$export$c7baa9df7dbe4b13 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f696030f35b1bfe$var$LazyTodoistSearchResultIconComponent, null)), $7f696030f35b1bfe$var$OfficialIcon, 'medium');
module.exports["TodoistIcon"] = $7f696030f35b1bfe$export$e5f255e151507cba;
module.exports["TodoistSearchResultIcon"] = $7f696030f35b1bfe$export$c7baa9df7dbe4b13;

});

parcelRegister("87oFm", function(module, exports) {

let $5e921c539822847e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5e921c539822847e$var$load("el4Li").then(()=>parcelRequire('irDM6'));

});

parcelRegister("7r1J2", function(module, exports) {

let $569c64a902747f35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $569c64a902747f35$var$load("kriZK").then(()=>parcelRequire('bkDWX'));

});

parcelRegister("emznk", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cgpdn = parcelRequire("cgpdn");

const $aedb00e010a8a347$export$cc8a555111f14137 = {
    displayName: 'PagerDuty',
    id: 'pagerduty',
    resourceType: (0, $fR63l.ProductResourceTypes3P).PagerDuty,
    icon: (0, $i52Hf.get3PLogo)((0, $cgpdn.PagerDutyIcon), 'PagerDuty', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cgpdn.PagerDutySearchResultIcon), 'PagerDuty', 'large'),
    integrationAri: 'ari:cloud:platform::integration/pagerduty',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["pagerDutyConfig"] = $aedb00e010a8a347$export$cc8a555111f14137;

});

parcelRegister("cgpdn", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $82cf772d0622b4e8$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("3oqfa")).then((m)=>m.PagerDutyIcon), {
    moduleId: '@atlassian/logo-third-party/pager-duty'
});

const $82cf772d0622b4e8$var$LazyPagerDutyIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("bUXcS")).then((m)=>m.PagerDutyIcon), {
    moduleId: '@atlassian/rovo-connectors-config/pagerduty/icon'
});

const $82cf772d0622b4e8$var$LazyPagerDutySearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("bUXcS")).then((m)=>m.PagerDutySearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/pagerduty/search-result-icon'
});
const $82cf772d0622b4e8$export$e9a3fd43f9d4bddc = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($82cf772d0622b4e8$var$LazyPagerDutyIconComponent, null)), $82cf772d0622b4e8$var$OfficialIcon, 'small');
const $82cf772d0622b4e8$export$494d5ec19d75a736 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($82cf772d0622b4e8$var$LazyPagerDutySearchResultIconComponent, null)), $82cf772d0622b4e8$var$OfficialIcon, 'medium');
module.exports["PagerDutyIcon"] = $82cf772d0622b4e8$export$e9a3fd43f9d4bddc;
module.exports["PagerDutySearchResultIcon"] = $82cf772d0622b4e8$export$494d5ec19d75a736;

});

parcelRegister("3oqfa", function(module, exports) {

let $2787f86fb8a1796c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2787f86fb8a1796c$var$load("3BBsj").then(()=>parcelRequire('hhFQM'));

});

parcelRegister("bUXcS", function(module, exports) {

let $8ad2d9e55360e7ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8ad2d9e55360e7ef$var$load("i66KR").then(()=>parcelRequire('BKXay'));

});

parcelRegister("fMCQp", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $4dY8b = parcelRequire("4dY8b");

const $3e19c412c5468840$export$9441b0ee1f92e710 = {
    displayName: 'Pipedrive',
    id: 'pipedrive',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Pipedrive,
    icon: (0, $i52Hf.get3PLogo)((0, $4dY8b.PipedriveIcon), 'Pipedrive', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $4dY8b.PipedriveSearchResultIcon), 'Pipedrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/pipedrive',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["pipedriveConfig"] = $3e19c412c5468840$export$9441b0ee1f92e710;

});

parcelRegister("4dY8b", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $37fe8e692e6a8fbb$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("a0UGh")).then((m)=>m.PipedriveIcon), {
    moduleId: '@atlassian/logo-third-party/pipedrive'
});

const $37fe8e692e6a8fbb$var$LazyPipedriveIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1NJ45")).then((m)=>m.PipedriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/pipedrive/icon'
});

const $37fe8e692e6a8fbb$var$LazyPipedriveSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1NJ45")).then((m)=>m.PipedriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/pipedrive/search-result-icon'
});
const $37fe8e692e6a8fbb$export$e66a8d6ac96d6ba1 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($37fe8e692e6a8fbb$var$LazyPipedriveIconComponent, null)), $37fe8e692e6a8fbb$var$OfficialIcon, 'small');
const $37fe8e692e6a8fbb$export$18970dea61783916 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($37fe8e692e6a8fbb$var$LazyPipedriveSearchResultIconComponent, null)), $37fe8e692e6a8fbb$var$OfficialIcon, 'medium');
module.exports["PipedriveIcon"] = $37fe8e692e6a8fbb$export$e66a8d6ac96d6ba1;
module.exports["PipedriveSearchResultIcon"] = $37fe8e692e6a8fbb$export$18970dea61783916;

});

parcelRegister("a0UGh", function(module, exports) {

let $01e1a4a1772b5e57$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $01e1a4a1772b5e57$var$load("27hzN").then(()=>parcelRequire('7RZ3z'));

});

parcelRegister("1NJ45", function(module, exports) {

let $14fd53058867bdc5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $14fd53058867bdc5$var$load("1Vgyr").then(()=>parcelRequire('7n163'));

});

parcelRegister("cdiu6", function(module, exports) {

var $5L3UP = parcelRequire("5L3UP");


var $2eAN0 = parcelRequire("2eAN0");


var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $i3YNQ = parcelRequire("i3YNQ");

const $cc73151629925938$export$ba5f4c654d743419 = {
    displayName: 'HubSpot',
    id: 'hubspot',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Hubspot,
    icon: (0, $i52Hf.get3PLogo)((0, $i3YNQ.HubSpotFilterIcon), 'HubSpot', 'medium'),
    searchResultIcon: (0, $i52Hf.RovoLogoFromGlyph)((0, $i3YNQ.HubSpotIcon), 'HubSpot'),
    integrationAri: 'ari:cloud:platform::integration/hubspot',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: [
                    ...(0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                    ...(0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI)
                ],
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch',
        'lastUpdatedBy',
        'createdBy'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["hubSpotConfig"] = $cc73151629925938$export$ba5f4c654d743419;

});

parcelRegister("5L3UP", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $c71c6856c01ed4e1$export$8dd471de1c2be682 = [
    'ati:cloud:graph:customer-org'
];
module.exports["DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI"] = $c71c6856c01ed4e1$export$8dd471de1c2be682;

});

parcelRegister("2eAN0", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $985674bff788ed13$export$13c55dcee8605c46 = [
    'ati:cloud:graph:deal'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI"] = $985674bff788ed13$export$13c55dcee8605c46;

});

parcelRegister("i3YNQ", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2057a2845d392fbb$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kQYlp")).then((m)=>m.HubSpotIcon), {
    moduleId: '@atlassian/logo-third-party/hubspot'
});

const $2057a2845d392fbb$var$LazyHubSpotFilterIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iQk0M")).then((m)=>m.HubSpotFilterIcon), {
    moduleId: '@atlassian/rovo-connectors-config/hubspot/icon'
});

const $2057a2845d392fbb$var$LazyHubSpotIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iQk0M")).then((m)=>m.HubSpotIcon), {
    moduleId: '@atlassian/rovo-connectors-config/hubspot/search-result-icon'
});
const $2057a2845d392fbb$export$bee6964e6c60da93 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2057a2845d392fbb$var$LazyHubSpotFilterIconComponent, null)), $2057a2845d392fbb$var$OfficialIcon, 'small');
const $2057a2845d392fbb$export$c9a6a66ee7acc43a = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2057a2845d392fbb$var$LazyHubSpotIconComponent, null)), $2057a2845d392fbb$var$OfficialIcon, 'medium');
module.exports["HubSpotFilterIcon"] = $2057a2845d392fbb$export$bee6964e6c60da93;
module.exports["HubSpotIcon"] = $2057a2845d392fbb$export$c9a6a66ee7acc43a;

});

parcelRegister("kQYlp", function(module, exports) {

let $f2e7791a0e64cf65$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f2e7791a0e64cf65$var$load("5tNoP").then(()=>parcelRequire('7v0Y0'));

});

parcelRegister("iQk0M", function(module, exports) {

let $db7c9b3ae5d37f01$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $db7c9b3ae5d37f01$var$load("jjiWX").then(()=>parcelRequire('7iwl3'));

});

parcelRegister("8djpu", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $1IKTt = parcelRequire("1IKTt");

const $a36ea8dac5de07a0$export$74bb7abed969b4a3 = {
    displayName: 'Dovetail',
    id: 'dovetail',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Dovetail,
    icon: (0, $i52Hf.get3PLogo)((0, $1IKTt.DovetailIcon), 'Dovetail', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $1IKTt.DovetailSearchResultIcon), 'Dovetail', 'large'),
    integrationAri: 'ari:cloud:platform::integration/dovetail',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["dovetailConfig"] = $a36ea8dac5de07a0$export$74bb7abed969b4a3;

});

parcelRegister("1IKTt", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2f56e48e9ad9c3ed$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("jZqjP")).then((m)=>m.DovetailIcon), {
    moduleId: '@atlassian/logo-third-party/dovetail'
});

const $2f56e48e9ad9c3ed$var$LazyDovetailIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1agKU")).then((m)=>m.DovetailIcon), {
    moduleId: '@atlassian/rovo-connectors-config/dovetail/icon'
});

const $2f56e48e9ad9c3ed$var$LazyDovetailSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1agKU")).then((m)=>m.DovetailSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/dovetail/search-result-icon'
});
const $2f56e48e9ad9c3ed$export$e67ec9178da81ba8 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2f56e48e9ad9c3ed$var$LazyDovetailIconComponent, null)), $2f56e48e9ad9c3ed$var$OfficialIcon, 'small');
const $2f56e48e9ad9c3ed$export$ba101884e6c20332 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2f56e48e9ad9c3ed$var$LazyDovetailSearchResultIconComponent, null)), $2f56e48e9ad9c3ed$var$OfficialIcon, 'medium');
module.exports["DovetailIcon"] = $2f56e48e9ad9c3ed$export$e67ec9178da81ba8;
module.exports["DovetailSearchResultIcon"] = $2f56e48e9ad9c3ed$export$ba101884e6c20332;

});

parcelRegister("jZqjP", function(module, exports) {

let $e8d8212c9bf885b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e8d8212c9bf885b2$var$load("j30YZ").then(()=>parcelRequire('63pax'));

});

parcelRegister("1agKU", function(module, exports) {

let $0d93b8f44ef4ee77$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0d93b8f44ef4ee77$var$load("lX1Po").then(()=>parcelRequire('2C7nj'));

});

parcelRegister("3P9fk", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cGNUU = parcelRequire("cGNUU");

const $c668170e147f45a4$export$e45ddd51efe4cb0c = {
    displayName: 'LaunchDarkly',
    id: 'launchdarkly',
    resourceType: (0, $fR63l.ProductResourceTypes3P).LaunchDarkly,
    icon: (0, $i52Hf.get3PLogo)((0, $cGNUU.LaunchDarklyIcon), 'LaunchDarkly', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cGNUU.LaunchDarklySearchResultIcon), 'LaunchDarkly', 'large'),
    integrationAri: 'ari:cloud:platform::integration/launchdarkly',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["launchDarklyConfig"] = $c668170e147f45a4$export$e45ddd51efe4cb0c;

});

parcelRegister("cGNUU", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $ef4ce76b17680270$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7M0yS")).then((m)=>m.LaunchdarklyIcon), {
    moduleId: '@atlassian/logo-third-party/launchdarkly'
});

const $ef4ce76b17680270$var$LazyLaunchDarklyIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ezxxX")).then((m)=>m.LaunchDarklyIcon), {
    moduleId: '@atlassian/rovo-connectors-config/launchdarkly/icon'
});

const $ef4ce76b17680270$var$LazyLaunchDarklySearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ezxxX")).then((m)=>m.LaunchDarklySearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/launchdarkly/search-result-icon'
});
const $ef4ce76b17680270$export$68470e68dec0bc46 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ef4ce76b17680270$var$LazyLaunchDarklyIconComponent, null)), $ef4ce76b17680270$var$OfficialIcon, 'small');
const $ef4ce76b17680270$export$66f000bb4bcf5fcd = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ef4ce76b17680270$var$LazyLaunchDarklySearchResultIconComponent, null)), $ef4ce76b17680270$var$OfficialIcon, 'medium');
module.exports["LaunchDarklyIcon"] = $ef4ce76b17680270$export$68470e68dec0bc46;
module.exports["LaunchDarklySearchResultIcon"] = $ef4ce76b17680270$export$66f000bb4bcf5fcd;

});

parcelRegister("7M0yS", function(module, exports) {

let $5a8d739df515d449$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a8d739df515d449$var$load("jdLOX").then(()=>parcelRequire('d9BBd'));

});

parcelRegister("ezxxX", function(module, exports) {

let $a9be5b4384d2d964$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a9be5b4384d2d964$var$load("fK6ul").then(()=>parcelRequire('26kgz'));

});

parcelRegister("2zNcl", function(module, exports) {

var $kFLxH = parcelRequire("kFLxH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $gZuUC = parcelRequire("gZuUC");

const $b44f335e0add65f2$export$6c52693ff10aea16 = {
    displayName: 'Sentry',
    id: 'sentry',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Sentry,
    icon: (0, $i52Hf.get3PLogo)((0, $gZuUC.SentryIcon), 'Sentry', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $gZuUC.SentrySearchResultIcon), 'Sentry', 'large'),
    integrationAri: 'ari:cloud:platform::integration/sentry',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $kFLxH.DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["sentryConfig"] = $b44f335e0add65f2$export$6c52693ff10aea16;

});

parcelRegister("gZuUC", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2e1e358b3dafc32e$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6PzNO")).then((m)=>m.SentryIcon), {
    moduleId: '@atlassian/logo-third-party/sentry'
});

const $2e1e358b3dafc32e$var$LazySentryIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("5Kyst")).then((m)=>m.SentryIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sentry/icon'
});

const $2e1e358b3dafc32e$var$LazySentrySearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("5Kyst")).then((m)=>m.SentrySearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sentry/search-result-icon'
});
const $2e1e358b3dafc32e$export$ddeafef64c08610e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e1e358b3dafc32e$var$LazySentryIconComponent, null)), $2e1e358b3dafc32e$var$OfficialIcon, 'small');
const $2e1e358b3dafc32e$export$18b7ca5aa35613ec = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e1e358b3dafc32e$var$LazySentrySearchResultIconComponent, null)), $2e1e358b3dafc32e$var$OfficialIcon, 'medium');
module.exports["SentryIcon"] = $2e1e358b3dafc32e$export$ddeafef64c08610e;
module.exports["SentrySearchResultIcon"] = $2e1e358b3dafc32e$export$18b7ca5aa35613ec;

});

parcelRegister("6PzNO", function(module, exports) {

let $4f9347196859d88a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4f9347196859d88a$var$load("kxaOw").then(()=>parcelRequire('fscxt'));

});

parcelRegister("5Kyst", function(module, exports) {

let $42fbfa53463ffb37$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $42fbfa53463ffb37$var$load("2wWLi").then(()=>parcelRequire('8cuRQ'));

});

parcelRegister("h8Js2", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $iS3Tu = parcelRequire("iS3Tu");

const $1575c63b0570ab84$export$49c4b548f63d5a90 = {
    displayName: 'GitBook',
    id: 'gitbook',
    icon: (0, $i52Hf.RovoLogoFromLogo)((0, $iS3Tu.GitbookIcon), 'GitBook'),
    resourceType: (0, $fR63l.ProductResourceTypes3P).Gitbook,
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $iS3Tu.GitbookSearchResultIcon), 'GitBook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/graph-test-app',
    // as provided here: https://atlassian.slack.com/archives/C0882LN4A56/p1741316020130509
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: false,
    userNeedsOAuth: false,
    // This will only be enabled on the demo instance
    isEnabled: ()=>true
};
module.exports["gitbookConfig"] = $1575c63b0570ab84$export$49c4b548f63d5a90;

});

parcelRegister("9Om9G", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $8dCVx = parcelRequire("8dCVx");

const $e51655ee0504dbb7$export$7a257877f5f8c5de = {
    displayName: 'Amazon Web Services S3',
    id: 'aws-s3',
    icon: (0, $i52Hf.RovoLogoFromLogo)((0, $8dCVx.AWSS3Icon), 'Amazon Web Services S3'),
    resourceType: (0, $fR63l.ProductResourceTypes3P).AWSS3,
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $8dCVx.AWSS3SearchResultIcon), 'Amazon Web Services S3', 'large'),
    integrationAri: 'ari:cloud:platform::integration/graph-test-app',
    // as provided here: https://atlassian.slack.com/archives/C0882LN4A56/p1741316020130509
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    requiresOauth: true,
    // Keeping this disabled for team demo. We only need GitBook enabled for demo.
    isEnabled: ()=>false
};
module.exports["awss3Config"] = $e51655ee0504dbb7$export$7a257877f5f8c5de;

});

parcelRegister("8dCVx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $8d6fe8b599ff2fd4$var$LazyAWSS3IconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lyZyY")).then((m)=>m.AWSS3Icon), {
    moduleId: '@atlassian/rovo-connectors-config/aws-s3/icon'
});

const $8d6fe8b599ff2fd4$var$LazyAWSS3SearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lyZyY")).then((m)=>m.AWSS3SearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/aws-s3/search-result-icon'
});
const $8d6fe8b599ff2fd4$export$abf71a44e930800c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d6fe8b599ff2fd4$var$LazyAWSS3IconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d6fe8b599ff2fd4$var$LazyAWSS3IconComponent, null));
const $8d6fe8b599ff2fd4$export$30c777236008d219 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d6fe8b599ff2fd4$var$LazyAWSS3SearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d6fe8b599ff2fd4$var$LazyAWSS3SearchResultIconComponent, null));
module.exports["AWSS3Icon"] = $8d6fe8b599ff2fd4$export$abf71a44e930800c;
module.exports["AWSS3SearchResultIcon"] = $8d6fe8b599ff2fd4$export$30c777236008d219;

});

parcelRegister("lyZyY", function(module, exports) {

let $fb2c871e4dc34770$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fb2c871e4dc34770$var$load("dy0Fn").then(()=>parcelRequire('2tcCJ'));

});

parcelRegister("kiNtZ", function(module, exports) {

var $lSV0R = parcelRequire("lSV0R");


var $5zhyH = parcelRequire("5zhyH");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $4mBqr = parcelRequire("4mBqr");

const $436740c22c009a9f$export$a9b5a82aefd10fde = {
    displayName: 'Databricks',
    id: 'databricks',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Databricks,
    icon: (0, $i52Hf.get3PLogo)((0, $4mBqr.DatabricksIcon), 'Databricks', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $4mBqr.DatabricksSearchResultIcon), 'Databricks', 'large'),
    integrationAri: 'ari:cloud:platform::integration/databricks',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Dashboard,
            {
                entities3P: (0, $lSV0R.DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).DataTable,
            {
                entities3P: (0, $5zhyH.DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["databricksConfig"] = $436740c22c009a9f$export$a9b5a82aefd10fde;

});

parcelRegister("lSV0R", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $73e7c9ae902307cd$export$5794851cbc8ee193 = [
    'ati:cloud:graph:dashboard'
];
module.exports["DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI"] = $73e7c9ae902307cd$export$5794851cbc8ee193;

});

parcelRegister("5zhyH", function(module, exports) {
/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */ const $c56574206e5d9432$export$f752f74515f17189 = [
    'ati:cloud:graph:data-table'
];
module.exports["DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI"] = $c56574206e5d9432$export$f752f74515f17189;

});

parcelRegister("4mBqr", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $4005a63328b92542$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("5aTt1")).then((m)=>m.DatabricksIcon), {
    moduleId: '@atlassian/logo-third-party/databricks'
});

const $4005a63328b92542$var$LazyDatabricksIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("aug3w")).then((m)=>m.DatabricksIcon), {
    moduleId: '@atlassian/rovo-connectors-config/databricks/icon'
});

const $4005a63328b92542$var$LazyDatabricksSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("aug3w")).then((m)=>m.DatabricksSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/databricks/search-result-icon'
});
const $4005a63328b92542$export$d86876f5e6aac5e0 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4005a63328b92542$var$LazyDatabricksIconComponent, null)), $4005a63328b92542$var$OfficialIcon, 'small');
const $4005a63328b92542$export$efd3770b613bb37b = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4005a63328b92542$var$LazyDatabricksSearchResultIconComponent, null)), $4005a63328b92542$var$OfficialIcon, 'medium');
module.exports["DatabricksIcon"] = $4005a63328b92542$export$d86876f5e6aac5e0;
module.exports["DatabricksSearchResultIcon"] = $4005a63328b92542$export$efd3770b613bb37b;

});

parcelRegister("5aTt1", function(module, exports) {

let $3c48e987dbae287f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3c48e987dbae287f$var$load("ltjdT").then(()=>parcelRequire('6t9s3'));

});

parcelRegister("aug3w", function(module, exports) {

let $7a292913e24060be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a292913e24060be$var$load("cSRnY").then(()=>parcelRequire('8CpxA'));

});

parcelRegister("1RpaO", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $bcqy7 = parcelRequire("bcqy7");

const $2080cd553843d21e$export$208b563484d68ba9 = {
    displayName: 'VitaReq by Adam',
    id: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeAdamVitareqDev,
    icon: (0, $i52Hf.get3PLogo)((0, $bcqy7.ForgeAdamVitareqIcon), 'ForgeAdamVitareq', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $bcqy7.ForgeAdamVitareqSearchResultIcon), 'ForgeAdamVitareq', 'large'),
    integrationAri: 'ari:cloud:platform::integration/dAkghOClvWGokDftTTaIgNoD6pnNt74z',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeAdamVitareqConfig"] = $2080cd553843d21e$export$208b563484d68ba9;

});

parcelRegister("bcqy7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $93f1018b38c58e9f$var$LazyForgeAdamVitareqIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("bVu7g")).then((m)=>m.ForgeAdamVitareqIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-adam-vitareq-dev/icon'
});

const $93f1018b38c58e9f$var$LazyForgeAdamVitareqSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("bVu7g")).then((m)=>m.ForgeAdamVitareqSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-adam-vitareq-dev/search-result-icon'
});
const $93f1018b38c58e9f$export$31bc4bf573db3488 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93f1018b38c58e9f$var$LazyForgeAdamVitareqIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93f1018b38c58e9f$var$LazyForgeAdamVitareqIconComponent, null));
const $93f1018b38c58e9f$export$bd28886795da63ae = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93f1018b38c58e9f$var$LazyForgeAdamVitareqSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93f1018b38c58e9f$var$LazyForgeAdamVitareqSearchResultIconComponent, null));
module.exports["ForgeAdamVitareqIcon"] = $93f1018b38c58e9f$export$31bc4bf573db3488;
module.exports["ForgeAdamVitareqSearchResultIcon"] = $93f1018b38c58e9f$export$bd28886795da63ae;

});

parcelRegister("bVu7g", function(module, exports) {

let $8aec6105bf7a443e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8aec6105bf7a443e$var$load("ePl2b").then(()=>parcelRequire('kel29'));

});

parcelRegister("jENKA", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $eRwR0 = parcelRequire("eRwR0");

const $939217ca713606ec$export$208b563484d68ba9 = {
    displayName: 'VitaReq by Adam',
    id: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeAdamVitareqProd,
    icon: (0, $i52Hf.get3PLogo)((0, $eRwR0.ForgeAdamVitareqIcon), 'ForgeAdamVitareq', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $eRwR0.ForgeAdamVitareqSearchResultIcon), 'ForgeAdamVitareq', 'large'),
    integrationAri: 'ari:cloud:platform::integration/EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeAdamVitareqConfig"] = $939217ca713606ec$export$208b563484d68ba9;

});

parcelRegister("eRwR0", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $ecc3a7c114d137a3$var$LazyForgeAdamVitareqIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4m2wQ")).then((m)=>m.ForgeAdamVitareqIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-adam-vitareq-prod/icon'
});

const $ecc3a7c114d137a3$var$LazyForgeAdamVitareqSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4m2wQ")).then((m)=>m.ForgeAdamVitareqSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-adam-vitareq-prod/search-result-icon'
});
const $ecc3a7c114d137a3$export$31bc4bf573db3488 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ecc3a7c114d137a3$var$LazyForgeAdamVitareqIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ecc3a7c114d137a3$var$LazyForgeAdamVitareqIconComponent, null));
const $ecc3a7c114d137a3$export$bd28886795da63ae = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ecc3a7c114d137a3$var$LazyForgeAdamVitareqSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ecc3a7c114d137a3$var$LazyForgeAdamVitareqSearchResultIconComponent, null));
module.exports["ForgeAdamVitareqIcon"] = $ecc3a7c114d137a3$export$31bc4bf573db3488;
module.exports["ForgeAdamVitareqSearchResultIcon"] = $ecc3a7c114d137a3$export$bd28886795da63ae;

});

parcelRegister("4m2wQ", function(module, exports) {

let $32bb2da49487064c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $32bb2da49487064c$var$load("5bnED").then(()=>parcelRequire('gKTnp'));

});

parcelRegister("aiL8h", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $2vDkv = parcelRequire("2vDkv");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $8xRaD = parcelRequire("8xRaD");

const $3bed2460a9ac74a9$export$1e9db6975f6a70ae = {
    displayName: 'Clickup by Pio',
    id: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioClickupDev,
    icon: (0, $i52Hf.get3PLogo)((0, $8xRaD.ForgePioClickupIcon), 'ForgePioClickup', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $8xRaD.ForgePioClickupSearchResultIcon), 'ForgePioClickup', 'large'),
    integrationAri: 'ari:cloud:platform::integration/ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioClickupConfig"] = $3bed2460a9ac74a9$export$1e9db6975f6a70ae;

});

parcelRegister("8xRaD", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $90c5d9d93ae12793$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7sd0z")).then((m)=>m.ClickupIcon), {
    moduleId: '@atlassian/logo-third-party/clickup'
});

const $90c5d9d93ae12793$var$LazyForgePioClickupIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cIrR2")).then((m)=>m.ForgePioClickupIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-clickup-dev/icon'
});

const $90c5d9d93ae12793$var$LazyForgePioClickupSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cIrR2")).then((m)=>m.ForgePioClickupSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-clickup-dev/search-result-icon'
});
const $90c5d9d93ae12793$export$836fbefaf37221f1 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($90c5d9d93ae12793$var$LazyForgePioClickupIconComponent, null)), $90c5d9d93ae12793$var$OfficialIcon, 'small');
const $90c5d9d93ae12793$export$83043b67e00ef5ec = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($90c5d9d93ae12793$var$LazyForgePioClickupSearchResultIconComponent, null)), $90c5d9d93ae12793$var$OfficialIcon, 'medium');
module.exports["ForgePioClickupIcon"] = $90c5d9d93ae12793$export$836fbefaf37221f1;
module.exports["ForgePioClickupSearchResultIcon"] = $90c5d9d93ae12793$export$83043b67e00ef5ec;

});

parcelRegister("cIrR2", function(module, exports) {

let $941f336918174642$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $941f336918174642$var$load("8s0tV").then(()=>parcelRequire('8nxWD'));

});

parcelRegister("cY0ZT", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $2vDkv = parcelRequire("2vDkv");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $8IQya = parcelRequire("8IQya");

const $5d6955193314318a$export$1e9db6975f6a70ae = {
    displayName: 'Clickup by Pio',
    id: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioClickupProd,
    icon: (0, $i52Hf.get3PLogo)((0, $8IQya.ForgePioClickupIcon), 'ForgePioClickup', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $8IQya.ForgePioClickupSearchResultIcon), 'ForgePioClickup', 'large'),
    integrationAri: 'ari:cloud:platform::integration/uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioClickupConfig"] = $5d6955193314318a$export$1e9db6975f6a70ae;

});

parcelRegister("8IQya", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $87a1e5b2c35074ff$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("7sd0z")).then((m)=>m.ClickupIcon), {
    moduleId: '@atlassian/logo-third-party/clickup'
});

const $87a1e5b2c35074ff$var$LazyForgePioClickupIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("181bf")).then((m)=>m.ForgePioClickupIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-clickup-prod/icon'
});

const $87a1e5b2c35074ff$var$LazyForgePioClickupSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("181bf")).then((m)=>m.ForgePioClickupSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-clickup-prod/search-result-icon'
});
const $87a1e5b2c35074ff$export$836fbefaf37221f1 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87a1e5b2c35074ff$var$LazyForgePioClickupIconComponent, null)), $87a1e5b2c35074ff$var$OfficialIcon, 'small');
const $87a1e5b2c35074ff$export$83043b67e00ef5ec = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87a1e5b2c35074ff$var$LazyForgePioClickupSearchResultIconComponent, null)), $87a1e5b2c35074ff$var$OfficialIcon, 'medium');
module.exports["ForgePioClickupIcon"] = $87a1e5b2c35074ff$export$836fbefaf37221f1;
module.exports["ForgePioClickupSearchResultIcon"] = $87a1e5b2c35074ff$export$83043b67e00ef5ec;

});

parcelRegister("181bf", function(module, exports) {

let $0d2774388cdc3227$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0d2774388cdc3227$var$load("fHbPr").then(()=>parcelRequire('lbEqU'));

});

parcelRegister("9SYma", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2vDkv = parcelRequire("2vDkv");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $luC3K = parcelRequire("luC3K");

const $30c6c0a5f88da5cd$export$a10b5ae888bd2541 = {
    displayName: 'Gitbook by Pio',
    id: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGitbookDev,
    icon: (0, $i52Hf.get3PLogo)((0, $luC3K.ForgePioGitbookIcon), 'ForgePioGitbook', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $luC3K.ForgePioGitbookSearchResultIcon), 'ForgePioGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGitbookConfig"] = $30c6c0a5f88da5cd$export$a10b5ae888bd2541;

});

parcelRegister("luC3K", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $ff3e09ebc7d38a88$var$LazyForgePioGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eaLXQ")).then((m)=>m.ForgePioGitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitbook-dev/icon'
});

const $ff3e09ebc7d38a88$var$LazyForgePioGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eaLXQ")).then((m)=>m.ForgePioGitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitbook-dev/search-result-icon'
});
const $ff3e09ebc7d38a88$export$39f7ff8bf3e8ca0a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff3e09ebc7d38a88$var$LazyForgePioGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff3e09ebc7d38a88$var$LazyForgePioGitbookIconComponent, null));
const $ff3e09ebc7d38a88$export$6de477beffd11496 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff3e09ebc7d38a88$var$LazyForgePioGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff3e09ebc7d38a88$var$LazyForgePioGitbookSearchResultIconComponent, null));
module.exports["ForgePioGitbookIcon"] = $ff3e09ebc7d38a88$export$39f7ff8bf3e8ca0a;
module.exports["ForgePioGitbookSearchResultIcon"] = $ff3e09ebc7d38a88$export$6de477beffd11496;

});

parcelRegister("eaLXQ", function(module, exports) {

let $a517348cc13b5415$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a517348cc13b5415$var$load("doxhZ").then(()=>parcelRequire('5yzek'));

});

parcelRegister("ie06K", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2vDkv = parcelRequire("2vDkv");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $hqQhc = parcelRequire("hqQhc");

const $7e16e25b4d6e9ae6$export$a10b5ae888bd2541 = {
    displayName: 'Gitbook by Pio',
    id: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGitbookProd,
    icon: (0, $i52Hf.get3PLogo)((0, $hqQhc.ForgePioGitbookIcon), 'ForgePioGitbook', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $hqQhc.ForgePioGitbookSearchResultIcon), 'ForgePioGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Space,
            {
                entities3P: (0, $2vDkv.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGitbookConfig"] = $7e16e25b4d6e9ae6$export$a10b5ae888bd2541;

});

parcelRegister("hqQhc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $f7c3187305b5af82$var$LazyForgePioGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cxRlS")).then((m)=>m.ForgePioGitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitbook-prod/icon'
});

const $f7c3187305b5af82$var$LazyForgePioGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("cxRlS")).then((m)=>m.ForgePioGitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-gitbook-prod/search-result-icon'
});
const $f7c3187305b5af82$export$39f7ff8bf3e8ca0a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7c3187305b5af82$var$LazyForgePioGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7c3187305b5af82$var$LazyForgePioGitbookIconComponent, null));
const $f7c3187305b5af82$export$6de477beffd11496 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7c3187305b5af82$var$LazyForgePioGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7c3187305b5af82$var$LazyForgePioGitbookSearchResultIconComponent, null));
module.exports["ForgePioGitbookIcon"] = $f7c3187305b5af82$export$39f7ff8bf3e8ca0a;
module.exports["ForgePioGitbookSearchResultIcon"] = $f7c3187305b5af82$export$6de477beffd11496;

});

parcelRegister("cxRlS", function(module, exports) {

let $9221f3aa58abeaa8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9221f3aa58abeaa8$var$load("f79rV").then(()=>parcelRequire('jAHFR'));

});

parcelRegister("dChew", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $5QuHV = parcelRequire("5QuHV");

const $e57423fd67cdd8c6$export$7b3aebc675da1806 = {
    displayName: 'Google Drive by Pio',
    id: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGoogleDriveDev,
    icon: (0, $i52Hf.get3PLogo)((0, $5QuHV.ForgePioGoogleDriveIcon), 'ForgePioGoogleDrive', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $5QuHV.ForgePioGoogleDriveSearchResultIcon), 'ForgePioGoogleDrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Video
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGoogleDriveConfig"] = $e57423fd67cdd8c6$export$7b3aebc675da1806;

});

parcelRegister("5QuHV", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $9b14ef24b242b0f5$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hcdgm")).then((m)=>m.GoogleDriveIcon), {
    moduleId: '@atlassian/logo-third-party/google-drive'
});

const $9b14ef24b242b0f5$var$LazyForgePioGoogleDriveIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2dyBk")).then((m)=>m.ForgePioGoogleDriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-dev/icon'
});

const $9b14ef24b242b0f5$var$LazyForgePioGoogleDriveSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2dyBk")).then((m)=>m.ForgePioGoogleDriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-dev/search-result-icon'
});
const $9b14ef24b242b0f5$export$a1f95679f652d1ae = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b14ef24b242b0f5$var$LazyForgePioGoogleDriveIconComponent, null)), $9b14ef24b242b0f5$var$OfficialIcon, 'small');
const $9b14ef24b242b0f5$export$4bae7f77a341daa0 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b14ef24b242b0f5$var$LazyForgePioGoogleDriveSearchResultIconComponent, null)), $9b14ef24b242b0f5$var$OfficialIcon, 'medium');
module.exports["ForgePioGoogleDriveIcon"] = $9b14ef24b242b0f5$export$a1f95679f652d1ae;
module.exports["ForgePioGoogleDriveSearchResultIcon"] = $9b14ef24b242b0f5$export$4bae7f77a341daa0;

});

parcelRegister("2dyBk", function(module, exports) {

let $19d7a2b45b018186$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $19d7a2b45b018186$var$load("eQyR8").then(()=>parcelRequire('65WlL'));

});

parcelRegister("TCovD", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $f0NBB = parcelRequire("f0NBB");

const $edc55c611b3bef54$export$7b3aebc675da1806 = {
    displayName: 'Google Drive by Pio',
    id: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGoogleDriveProd,
    icon: (0, $i52Hf.get3PLogo)((0, $f0NBB.ForgePioGoogleDriveIcon), 'ForgePioGoogleDrive', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $f0NBB.ForgePioGoogleDriveSearchResultIcon), 'ForgePioGoogleDrive', 'large'),
    integrationAri: 'ari:cloud:platform::integration/pcIwW04B398CSnilRIyzPJ5v5GevlCCo',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Video
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGoogleDriveConfig"] = $edc55c611b3bef54$export$7b3aebc675da1806;

});

parcelRegister("f0NBB", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2a4f11fd35f1561d$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hcdgm")).then((m)=>m.GoogleDriveIcon), {
    moduleId: '@atlassian/logo-third-party/google-drive'
});

const $2a4f11fd35f1561d$var$LazyForgePioGoogleDriveIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("a07eA")).then((m)=>m.ForgePioGoogleDriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-prod/icon'
});

const $2a4f11fd35f1561d$var$LazyForgePioGoogleDriveSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("a07eA")).then((m)=>m.ForgePioGoogleDriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-google-drive-prod/search-result-icon'
});
const $2a4f11fd35f1561d$export$a1f95679f652d1ae = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a4f11fd35f1561d$var$LazyForgePioGoogleDriveIconComponent, null)), $2a4f11fd35f1561d$var$OfficialIcon, 'small');
const $2a4f11fd35f1561d$export$4bae7f77a341daa0 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a4f11fd35f1561d$var$LazyForgePioGoogleDriveSearchResultIconComponent, null)), $2a4f11fd35f1561d$var$OfficialIcon, 'medium');
module.exports["ForgePioGoogleDriveIcon"] = $2a4f11fd35f1561d$export$a1f95679f652d1ae;
module.exports["ForgePioGoogleDriveSearchResultIcon"] = $2a4f11fd35f1561d$export$4bae7f77a341daa0;

});

parcelRegister("a07eA", function(module, exports) {

let $747f8411ae156579$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $747f8411ae156579$var$load("fPrZJ").then(()=>parcelRequire('foLez'));

});

parcelRegister("feDPe", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cDJLe = parcelRequire("cDJLe");

const $6d6cb4a42f1a5c65$export$528a99587bc9b40e = {
    displayName: 'Guru by Pio',
    id: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGuruDev,
    icon: (0, $i52Hf.get3PLogo)((0, $cDJLe.ForgePioGuruIcon), 'ForgePioGuru', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cDJLe.ForgePioGuruSearchResultIcon), 'ForgePioGuru', 'large'),
    integrationAri: 'ari:cloud:platform::integration/NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGuruConfig"] = $6d6cb4a42f1a5c65$export$528a99587bc9b40e;

});

parcelRegister("cDJLe", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $2920441e11b70cd2$var$LazyForgePioGuruIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hIbHQ")).then((m)=>m.ForgePioGuruIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-guru-dev/icon'
});

const $2920441e11b70cd2$var$LazyForgePioGuruSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hIbHQ")).then((m)=>m.ForgePioGuruSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-guru-dev/search-result-icon'
});
const $2920441e11b70cd2$export$f1cafab080b3bd5c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2920441e11b70cd2$var$LazyForgePioGuruIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2920441e11b70cd2$var$LazyForgePioGuruIconComponent, null));
const $2920441e11b70cd2$export$b49ff31395265951 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2920441e11b70cd2$var$LazyForgePioGuruSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2920441e11b70cd2$var$LazyForgePioGuruSearchResultIconComponent, null));
module.exports["ForgePioGuruIcon"] = $2920441e11b70cd2$export$f1cafab080b3bd5c;
module.exports["ForgePioGuruSearchResultIcon"] = $2920441e11b70cd2$export$b49ff31395265951;

});

parcelRegister("hIbHQ", function(module, exports) {

let $ce4fa05b13629a64$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce4fa05b13629a64$var$load("lxdqb").then(()=>parcelRequire('27bjo'));

});

parcelRegister("klS4t", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $4tpeK = parcelRequire("4tpeK");

const $77afbf3b994cdec8$export$528a99587bc9b40e = {
    displayName: 'Guru by Pio',
    id: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioGuruProd,
    icon: (0, $i52Hf.get3PLogo)((0, $4tpeK.ForgePioGuruIcon), 'ForgePioGuru', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $4tpeK.ForgePioGuruSearchResultIcon), 'ForgePioGuru', 'large'),
    integrationAri: 'ari:cloud:platform::integration/mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioGuruConfig"] = $77afbf3b994cdec8$export$528a99587bc9b40e;

});

parcelRegister("4tpeK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $b236eb93e0f85320$var$LazyForgePioGuruIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hReiL")).then((m)=>m.ForgePioGuruIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-guru-prod/icon'
});

const $b236eb93e0f85320$var$LazyForgePioGuruSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hReiL")).then((m)=>m.ForgePioGuruSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-guru-prod/search-result-icon'
});
const $b236eb93e0f85320$export$f1cafab080b3bd5c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b236eb93e0f85320$var$LazyForgePioGuruIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b236eb93e0f85320$var$LazyForgePioGuruIconComponent, null));
const $b236eb93e0f85320$export$b49ff31395265951 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b236eb93e0f85320$var$LazyForgePioGuruSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b236eb93e0f85320$var$LazyForgePioGuruSearchResultIconComponent, null));
module.exports["ForgePioGuruIcon"] = $b236eb93e0f85320$export$f1cafab080b3bd5c;
module.exports["ForgePioGuruSearchResultIcon"] = $b236eb93e0f85320$export$b49ff31395265951;

});

parcelRegister("hReiL", function(module, exports) {

let $d0027aea808a4c93$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d0027aea808a4c93$var$load("l3yCu").then(()=>parcelRequire('5IaNj'));

});

parcelRegister("hFdyH", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $9o5zM = parcelRequire("9o5zM");

const $d06de435425db1cd$export$a612366ee7742bc4 = {
    displayName: 'Helpjuice by Pio',
    id: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioHelpjuiceDev,
    icon: (0, $i52Hf.get3PLogo)((0, $9o5zM.ForgePioHelpjuiceIcon), 'ForgePioHelpjuice', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $9o5zM.ForgePioHelpjuiceSearchResultIcon), 'ForgePioHelpjuice', 'large'),
    integrationAri: 'ari:cloud:platform::integration/f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioHelpjuiceConfig"] = $d06de435425db1cd$export$a612366ee7742bc4;

});

parcelRegister("9o5zM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $1a59bb9fa163a26b$var$LazyForgePioHelpjuiceIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l85tV")).then((m)=>m.ForgePioHelpjuiceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-helpjuice-dev/icon'
});

const $1a59bb9fa163a26b$var$LazyForgePioHelpjuiceSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("l85tV")).then((m)=>m.ForgePioHelpjuiceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-helpjuice-dev/search-result-icon'
});
const $1a59bb9fa163a26b$export$7640ce31f2af22a2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a59bb9fa163a26b$var$LazyForgePioHelpjuiceIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a59bb9fa163a26b$var$LazyForgePioHelpjuiceIconComponent, null));
const $1a59bb9fa163a26b$export$2782a2dcd42b923c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a59bb9fa163a26b$var$LazyForgePioHelpjuiceSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a59bb9fa163a26b$var$LazyForgePioHelpjuiceSearchResultIconComponent, null));
module.exports["ForgePioHelpjuiceIcon"] = $1a59bb9fa163a26b$export$7640ce31f2af22a2;
module.exports["ForgePioHelpjuiceSearchResultIcon"] = $1a59bb9fa163a26b$export$2782a2dcd42b923c;

});

parcelRegister("l85tV", function(module, exports) {

let $f61e98dabceec19b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f61e98dabceec19b$var$load("BZA59").then(()=>parcelRequire('lcok7'));

});

parcelRegister("e6TPF", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $3XLGG = parcelRequire("3XLGG");

const $ebd7c08029c46f92$export$a612366ee7742bc4 = {
    displayName: 'Helpjuice by Pio',
    id: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioHelpjuiceProd,
    icon: (0, $i52Hf.get3PLogo)((0, $3XLGG.ForgePioHelpjuiceIcon), 'ForgePioHelpjuice', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $3XLGG.ForgePioHelpjuiceSearchResultIcon), 'ForgePioHelpjuice', 'large'),
    integrationAri: 'ari:cloud:platform::integration/8durapLyclxZeEexKkwxw6ZpCRpBz4dP',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioHelpjuiceConfig"] = $ebd7c08029c46f92$export$a612366ee7742bc4;

});

parcelRegister("3XLGG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8ZtAm")).then((m)=>m.ForgePioHelpjuiceIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-helpjuice-prod/icon'
});

const $c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8ZtAm")).then((m)=>m.ForgePioHelpjuiceSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-helpjuice-prod/search-result-icon'
});
const $c3f8a80c4bf2155c$export$7640ce31f2af22a2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceIconComponent, null));
const $c3f8a80c4bf2155c$export$2782a2dcd42b923c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3f8a80c4bf2155c$var$LazyForgePioHelpjuiceSearchResultIconComponent, null));
module.exports["ForgePioHelpjuiceIcon"] = $c3f8a80c4bf2155c$export$7640ce31f2af22a2;
module.exports["ForgePioHelpjuiceSearchResultIcon"] = $c3f8a80c4bf2155c$export$2782a2dcd42b923c;

});

parcelRegister("8ZtAm", function(module, exports) {

let $68baf8514ec615e9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $68baf8514ec615e9$var$load("89OPU").then(()=>parcelRequire('exmtD'));

});

parcelRegister("7piBv", function(module, exports) {

var $5L3UP = parcelRequire("5L3UP");


var $2eAN0 = parcelRequire("2eAN0");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $lHmnw = parcelRequire("lHmnw");

const $ff6b770550126248$export$2bb44bd2479444f9 = {
    displayName: 'HubSpot by Pio',
    id: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioHubspotDev,
    icon: (0, $i52Hf.get3PLogo)((0, $lHmnw.ForgePioHubspotIcon), 'ForgePioHubspot', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $lHmnw.ForgePioHubspotSearchResultIcon), 'ForgePioHubspot', 'large'),
    integrationAri: 'ari:cloud:platform::integration/RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioHubspotConfig"] = $ff6b770550126248$export$2bb44bd2479444f9;

});

parcelRegister("lHmnw", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $ae4c750f6148d7b8$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kQYlp")).then((m)=>m.HubSpotIcon), {
    moduleId: '@atlassian/logo-third-party/hubspot'
});

const $ae4c750f6148d7b8$var$LazyForgePioHubspotIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gDgqn")).then((m)=>m.ForgePioHubspotIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-hubspot-dev/icon'
});

const $ae4c750f6148d7b8$var$LazyForgePioHubspotSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("gDgqn")).then((m)=>m.ForgePioHubspotSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-hubspot-dev/search-result-icon'
});
const $ae4c750f6148d7b8$export$e87bb425fde16105 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae4c750f6148d7b8$var$LazyForgePioHubspotIconComponent, null)), $ae4c750f6148d7b8$var$OfficialIcon, 'small');
const $ae4c750f6148d7b8$export$cc1026e3c5b549e1 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae4c750f6148d7b8$var$LazyForgePioHubspotSearchResultIconComponent, null)), $ae4c750f6148d7b8$var$OfficialIcon, 'medium');
module.exports["ForgePioHubspotIcon"] = $ae4c750f6148d7b8$export$e87bb425fde16105;
module.exports["ForgePioHubspotSearchResultIcon"] = $ae4c750f6148d7b8$export$cc1026e3c5b549e1;

});

parcelRegister("gDgqn", function(module, exports) {

let $c1bd0762a9485a15$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c1bd0762a9485a15$var$load("12zSS").then(()=>parcelRequire('577rm'));

});

parcelRegister("3yXQ1", function(module, exports) {

var $5L3UP = parcelRequire("5L3UP");


var $2eAN0 = parcelRequire("2eAN0");


var $2Rsot = parcelRequire("2Rsot");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $dB1o2 = parcelRequire("dB1o2");

const $9438ce5263366d16$export$2bb44bd2479444f9 = {
    displayName: 'HubSpot by Pio',
    id: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioHubspotProd,
    icon: (0, $i52Hf.get3PLogo)((0, $dB1o2.ForgePioHubspotIcon), 'ForgePioHubspot', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $dB1o2.ForgePioHubspotSearchResultIcon), 'ForgePioHubspot', 'large'),
    integrationAri: 'ari:cloud:platform::integration/O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).WorkItem,
            {
                entities3P: (0, $2Rsot.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).CustomerOrg,
            {
                entities3P: (0, $5L3UP.DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).CustomerOrg
                ]
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Deal,
            {
                entities3P: (0, $2eAN0.DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Deal
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioHubspotConfig"] = $9438ce5263366d16$export$2bb44bd2479444f9;

});

parcelRegister("dB1o2", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $138972da21ac7328$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kQYlp")).then((m)=>m.HubSpotIcon), {
    moduleId: '@atlassian/logo-third-party/hubspot'
});

const $138972da21ac7328$var$LazyForgePioHubspotIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("23P54")).then((m)=>m.ForgePioHubspotIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-hubspot-prod/icon'
});

const $138972da21ac7328$var$LazyForgePioHubspotSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("23P54")).then((m)=>m.ForgePioHubspotSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-hubspot-prod/search-result-icon'
});
const $138972da21ac7328$export$e87bb425fde16105 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($138972da21ac7328$var$LazyForgePioHubspotIconComponent, null)), $138972da21ac7328$var$OfficialIcon, 'small');
const $138972da21ac7328$export$cc1026e3c5b549e1 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($138972da21ac7328$var$LazyForgePioHubspotSearchResultIconComponent, null)), $138972da21ac7328$var$OfficialIcon, 'medium');
module.exports["ForgePioHubspotIcon"] = $138972da21ac7328$export$e87bb425fde16105;
module.exports["ForgePioHubspotSearchResultIcon"] = $138972da21ac7328$export$cc1026e3c5b549e1;

});

parcelRegister("23P54", function(module, exports) {

let $18037c2587a44799$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $18037c2587a44799$var$load("6nOSk").then(()=>parcelRequire('5aOBD'));

});

parcelRegister("dwyZc", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $7hXqS = parcelRequire("7hXqS");

const $d0c1882acaf8175d$export$a62192356b6384ff = {
    displayName: 'SharePoint by Pio',
    id: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioSharepointDev,
    icon: (0, $i52Hf.get3PLogo)((0, $7hXqS.ForgePioSharepointIcon), 'ForgePioSharepoint', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $7hXqS.ForgePioSharepointSearchResultIcon), 'ForgePioSharepoint', 'large'),
    integrationAri: 'ari:cloud:platform::integration/cl5i3J8L463hTuQiDt7f1mK4vZllsAo0',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: [
                    (0, $5PPrc.NounSubtypeKey).Document,
                    (0, $5PPrc.NounSubtypeKey).Pdf
                ]
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioSharepointConfig"] = $d0c1882acaf8175d$export$a62192356b6384ff;

});

parcelRegister("7hXqS", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $9b6113d0f81ce6d8$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("60nw9")).then((m)=>m.MicrosoftSharePointIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-sharepoint'
});

const $9b6113d0f81ce6d8$var$LazyForgePioSharepointIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4NZXw")).then((m)=>m.ForgePioSharepointIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-dev/icon'
});

const $9b6113d0f81ce6d8$var$LazyForgePioSharepointSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4NZXw")).then((m)=>m.ForgePioSharepointSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-dev/search-result-icon'
});
const $9b6113d0f81ce6d8$export$ecc35ba2a32c7e3f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b6113d0f81ce6d8$var$LazyForgePioSharepointIconComponent, null)), $9b6113d0f81ce6d8$var$OfficialIcon, 'small');
const $9b6113d0f81ce6d8$export$ff73eba88c3a5de7 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9b6113d0f81ce6d8$var$LazyForgePioSharepointSearchResultIconComponent, null)), $9b6113d0f81ce6d8$var$OfficialIcon, 'medium');
module.exports["ForgePioSharepointIcon"] = $9b6113d0f81ce6d8$export$ecc35ba2a32c7e3f;
module.exports["ForgePioSharepointSearchResultIcon"] = $9b6113d0f81ce6d8$export$ff73eba88c3a5de7;

});

parcelRegister("4NZXw", function(module, exports) {

let $37fbccc6b891f09a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $37fbccc6b891f09a$var$load("jSUxV").then(()=>parcelRequire('l1iDy'));

});

parcelRegister("9sIt4", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $bE1lG = parcelRequire("bE1lG");

const $683bf0dbe93cd230$export$a62192356b6384ff = {
    displayName: 'SharePoint by Pio',
    id: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioSharepointProd,
    icon: (0, $i52Hf.get3PLogo)((0, $bE1lG.ForgePioSharepointIcon), 'ForgePioSharepoint', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $bE1lG.ForgePioSharepointSearchResultIcon), 'ForgePioSharepoint', 'large'),
    integrationAri: 'ari:cloud:platform::integration/7yrzYPlAOcZAif2tIymeDXBUNUAxI95G',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioSharepointConfig"] = $683bf0dbe93cd230$export$a62192356b6384ff;

});

parcelRegister("bE1lG", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $b90524babf24a663$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("60nw9")).then((m)=>m.MicrosoftSharePointIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-sharepoint'
});

const $b90524babf24a663$var$LazyForgePioSharepointIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4OSjU")).then((m)=>m.ForgePioSharepointIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-prod/icon'
});

const $b90524babf24a663$var$LazyForgePioSharepointSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4OSjU")).then((m)=>m.ForgePioSharepointSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-sharepoint-prod/search-result-icon'
});
const $b90524babf24a663$export$ecc35ba2a32c7e3f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b90524babf24a663$var$LazyForgePioSharepointIconComponent, null)), $b90524babf24a663$var$OfficialIcon, 'small');
const $b90524babf24a663$export$ff73eba88c3a5de7 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b90524babf24a663$var$LazyForgePioSharepointSearchResultIconComponent, null)), $b90524babf24a663$var$OfficialIcon, 'medium');
module.exports["ForgePioSharepointIcon"] = $b90524babf24a663$export$ecc35ba2a32c7e3f;
module.exports["ForgePioSharepointSearchResultIcon"] = $b90524babf24a663$export$ff73eba88c3a5de7;

});

parcelRegister("4OSjU", function(module, exports) {

let $3825f7c2c9b6438f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3825f7c2c9b6438f$var$load("dGvaI").then(()=>parcelRequire('53U7P'));

});

parcelRegister("7UyZr", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $eLukX = parcelRequire("eLukX");

const $7b363fb97ca8421c$export$cc9a98fbdf14b1ba = {
    displayName: 'Stack Overflow by Pio',
    id: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioStackOverflowDev,
    icon: (0, $i52Hf.get3PLogo)((0, $eLukX.ForgePioStackOverflowIcon), 'ForgePioStackOverflow', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $eLukX.ForgePioStackOverflowSearchResultIcon), 'ForgePioStackOverflow', 'large'),
    integrationAri: 'ari:cloud:platform::integration/ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioStackOverflowConfig"] = $7b363fb97ca8421c$export$cc9a98fbdf14b1ba;

});

parcelRegister("eLukX", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $d275976379838dc2$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fBB29")).then((m)=>m.StackOverflowIcon), {
    moduleId: '@atlassian/logo-third-party/stack-overflow'
});

const $d275976379838dc2$var$LazyForgePioStackOverflowIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kmocd")).then((m)=>m.ForgePioStackOverflowIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-stack-overflow-dev/icon'
});

const $d275976379838dc2$var$LazyForgePioStackOverflowSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kmocd")).then((m)=>m.ForgePioStackOverflowSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-stack-overflow-dev/search-result-icon'
});
const $d275976379838dc2$export$99bc27b78a6e71df = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d275976379838dc2$var$LazyForgePioStackOverflowIconComponent, null)), $d275976379838dc2$var$OfficialIcon, 'small');
const $d275976379838dc2$export$9a30339a9bdbd3d6 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d275976379838dc2$var$LazyForgePioStackOverflowSearchResultIconComponent, null)), $d275976379838dc2$var$OfficialIcon, 'medium');
module.exports["ForgePioStackOverflowIcon"] = $d275976379838dc2$export$99bc27b78a6e71df;
module.exports["ForgePioStackOverflowSearchResultIcon"] = $d275976379838dc2$export$9a30339a9bdbd3d6;

});

parcelRegister("fBB29", function(module, exports) {

let $b5c709d86027bc48$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b5c709d86027bc48$var$load("aQKKn").then(()=>parcelRequire('l2bfr'));

});

parcelRegister("kmocd", function(module, exports) {

let $ed28a18858f32988$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ed28a18858f32988$var$load("fhGCt").then(()=>parcelRequire('cH70d'));

});

parcelRegister("2KPYZ", function(module, exports) {

var $4moZS = parcelRequire("4moZS");


var $6GYKu = parcelRequire("6GYKu");


var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $dNyzf = parcelRequire("dNyzf");

const $406347052a44a9c5$export$cc9a98fbdf14b1ba = {
    displayName: 'Stack Overflow by Pio',
    id: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgePioStackOverflowProd,
    icon: (0, $i52Hf.get3PLogo)((0, $dNyzf.ForgePioStackOverflowIcon), 'ForgePioStackOverflow', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $dNyzf.ForgePioStackOverflowSearchResultIcon), 'ForgePioStackOverflow', 'large'),
    integrationAri: 'ari:cloud:platform::integration/vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Conversation,
            {
                entities3P: (0, $6GYKu.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
                subTypes3P: []
            }
        ],
        [
            (0, $5PPrc.TypeFilterValueKey).Comment,
            {
                entities3P: (0, $4moZS.DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgePioStackOverflowConfig"] = $406347052a44a9c5$export$cc9a98fbdf14b1ba;

});

parcelRegister("dNyzf", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $d7c3a178bcc55be2$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("fBB29")).then((m)=>m.StackOverflowIcon), {
    moduleId: '@atlassian/logo-third-party/stack-overflow'
});

const $d7c3a178bcc55be2$var$LazyForgePioStackOverflowIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2QdDM")).then((m)=>m.ForgePioStackOverflowIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-stack-overflow-prod/icon'
});

const $d7c3a178bcc55be2$var$LazyForgePioStackOverflowSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("2QdDM")).then((m)=>m.ForgePioStackOverflowSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-stack-overflow-prod/search-result-icon'
});
const $d7c3a178bcc55be2$export$99bc27b78a6e71df = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d7c3a178bcc55be2$var$LazyForgePioStackOverflowIconComponent, null)), $d7c3a178bcc55be2$var$OfficialIcon, 'small');
const $d7c3a178bcc55be2$export$9a30339a9bdbd3d6 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d7c3a178bcc55be2$var$LazyForgePioStackOverflowSearchResultIconComponent, null)), $d7c3a178bcc55be2$var$OfficialIcon, 'medium');
module.exports["ForgePioStackOverflowIcon"] = $d7c3a178bcc55be2$export$99bc27b78a6e71df;
module.exports["ForgePioStackOverflowSearchResultIcon"] = $d7c3a178bcc55be2$export$9a30339a9bdbd3d6;

});

parcelRegister("2QdDM", function(module, exports) {

let $211b04dc028d7bac$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $211b04dc028d7bac$var$load("i47NY").then(()=>parcelRequire('7DqjS'));

});

parcelRegister("9lVxQ", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $5vkE3 = parcelRequire("5vkE3");

const $3e70faad8a12b1e6$export$1c8bdcf28097f33d = {
    displayName: 'Gitbook - by Utoolity',
    id: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeUtoolityGitbookDev,
    icon: (0, $i52Hf.get3PLogo)((0, $5vkE3.ForgeUtoolityGitbookIcon), 'ForgeUtoolityGitbook', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $5vkE3.ForgeUtoolityGitbookSearchResultIcon), 'ForgeUtoolityGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeUtoolityGitbookConfig"] = $3e70faad8a12b1e6$export$1c8bdcf28097f33d;

});

parcelRegister("5vkE3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $d8f18c592b583242$var$LazyForgeUtoolityGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("31MoW")).then((m)=>m.ForgeUtoolityGitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-utoolity-gitbook-dev/icon'
});

const $d8f18c592b583242$var$LazyForgeUtoolityGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("31MoW")).then((m)=>m.ForgeUtoolityGitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-utoolity-gitbook-dev/search-result-icon'
});
const $d8f18c592b583242$export$fc1920df99f3d560 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8f18c592b583242$var$LazyForgeUtoolityGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8f18c592b583242$var$LazyForgeUtoolityGitbookIconComponent, null));
const $d8f18c592b583242$export$41e46c9b83e3cfe1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8f18c592b583242$var$LazyForgeUtoolityGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d8f18c592b583242$var$LazyForgeUtoolityGitbookSearchResultIconComponent, null));
module.exports["ForgeUtoolityGitbookIcon"] = $d8f18c592b583242$export$fc1920df99f3d560;
module.exports["ForgeUtoolityGitbookSearchResultIcon"] = $d8f18c592b583242$export$41e46c9b83e3cfe1;

});

parcelRegister("31MoW", function(module, exports) {

let $2347029a7fa3b936$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2347029a7fa3b936$var$load("5b0ls").then(()=>parcelRequire('krol2'));

});

parcelRegister("1HfnT", function(module, exports) {

var $dAioJ = parcelRequire("dAioJ");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $cRk65 = parcelRequire("cRk65");

const $86431f8286f0d68f$export$1c8bdcf28097f33d = {
    displayName: 'Gitbook - by Utoolity',
    id: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    resourceType: (0, $fR63l.ProductResourceTypes3P).ForgeUtoolityGitbookProd,
    icon: (0, $i52Hf.get3PLogo)((0, $cRk65.ForgeUtoolityGitbookIcon), 'ForgeUtoolityGitbook', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $cRk65.ForgeUtoolityGitbookSearchResultIcon), 'ForgeUtoolityGitbook', 'large'),
    integrationAri: 'ari:cloud:platform::integration/byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Document,
            {
                entities3P: (0, $dAioJ.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true,
    displayWorkspaceNameAsProductName: true
};
module.exports["forgeUtoolityGitbookConfig"] = $86431f8286f0d68f$export$1c8bdcf28097f33d;

});

parcelRegister("cRk65", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $6130c3bf337d5909$var$LazyForgeUtoolityGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("84tMx")).then((m)=>m.ForgeUtoolityGitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-utoolity-gitbook-prod/icon'
});

const $6130c3bf337d5909$var$LazyForgeUtoolityGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("84tMx")).then((m)=>m.ForgeUtoolityGitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-utoolity-gitbook-prod/search-result-icon'
});
const $6130c3bf337d5909$export$fc1920df99f3d560 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6130c3bf337d5909$var$LazyForgeUtoolityGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6130c3bf337d5909$var$LazyForgeUtoolityGitbookIconComponent, null));
const $6130c3bf337d5909$export$41e46c9b83e3cfe1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6130c3bf337d5909$var$LazyForgeUtoolityGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6130c3bf337d5909$var$LazyForgeUtoolityGitbookSearchResultIconComponent, null));
module.exports["ForgeUtoolityGitbookIcon"] = $6130c3bf337d5909$export$fc1920df99f3d560;
module.exports["ForgeUtoolityGitbookSearchResultIcon"] = $6130c3bf337d5909$export$41e46c9b83e3cfe1;

});

parcelRegister("84tMx", function(module, exports) {

let $5e05cc7d0478333e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5e05cc7d0478333e$var$load("etezH").then(()=>parcelRequire('k1qzV'));

});

parcelRegister("bzVC8", function(module, exports) {

var $sRb5o = parcelRequire("sRb5o");


var $5PPrc = parcelRequire("5PPrc");


var $i52Hf = parcelRequire("i52Hf");


var $fR63l = parcelRequire("fR63l");


var $gkMkb = parcelRequire("gkMkb");

const $cd6088651b1d3011$export$da489f084fc70d3a = {
    displayName: 'Gong',
    id: 'gong',
    resourceType: (0, $fR63l.ProductResourceTypes3P).Gong,
    icon: (0, $i52Hf.get3PLogo)((0, $gkMkb.GongIcon), 'Gong', 'medium'),
    searchResultIcon: (0, $i52Hf.get3PLogo)((0, $gkMkb.GongSearchResultIcon), 'Gong', 'large'),
    integrationAri: 'ari:cloud:platform::integration/gong',
    typeFilterConfig: new Map([
        [
            (0, $5PPrc.TypeFilterValueKey).Video,
            {
                entities3P: (0, $sRb5o.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
                subTypes3P: []
            }
        ]
    ]),
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["gongConfig"] = $cd6088651b1d3011$export$da489f084fc70d3a;

});

parcelRegister("gkMkb", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $46f3e375cd9453c4$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("6pBWK")).then((m)=>m.GongIcon), {
    moduleId: '@atlassian/logo-third-party/gong'
});

const $46f3e375cd9453c4$var$LazyGongIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1AiKZ")).then((m)=>m.GongIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gong/icon'
});

const $46f3e375cd9453c4$var$LazyGongSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("1W2a0")).then((m)=>m.GongSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gong/search-result-icon'
});
const $46f3e375cd9453c4$export$81a901141c7fd09d = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($46f3e375cd9453c4$var$LazyGongIconComponent, null)), $46f3e375cd9453c4$var$OfficialIcon, 'small');
const $46f3e375cd9453c4$export$f1670de5ba3e94b4 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($46f3e375cd9453c4$var$LazyGongSearchResultIconComponent, null)), $46f3e375cd9453c4$var$OfficialIcon, 'medium');
module.exports["GongIcon"] = $46f3e375cd9453c4$export$81a901141c7fd09d;
module.exports["GongSearchResultIcon"] = $46f3e375cd9453c4$export$f1670de5ba3e94b4;

});

parcelRegister("6pBWK", function(module, exports) {

let $4ab28342f43aa805$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ab28342f43aa805$var$load("4daxi").then(()=>parcelRequire('8DzYI'));

});

parcelRegister("1AiKZ", function(module, exports) {

let $1277b3fb732798dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1277b3fb732798dd$var$load("1GQMk").then(()=>parcelRequire('bkQed'));

});

parcelRegister("1W2a0", function(module, exports) {

let $168ce23c4db71f08$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $168ce23c4db71f08$var$load("5lziI").then(()=>parcelRequire('leql4'));

});

parcelRegister("kcIQr", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $9DHhW = parcelRequire("9DHhW");

const $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70 = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (payload)=>createAnalyticsEvent(payload);
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const createEvent = t0;
    let t1;
    if ($[2] !== createEvent) {
        t1 = {
            createEvent: createEvent
        };
        $[2] = createEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["useConfluenceAnalyticsEvents"] = $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70;

});

parcelRegister("etoPX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $63a5cd591bbe1860$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>
</svg>
`;
const $63a5cd591bbe1860$export$e23ae35269442b4f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Rovo" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $63a5cd591bbe1860$var$svg,
            label: label,
            type: "rovo",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function RovoIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $63a5cd591bbe1860$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["RovoIcon"] = $63a5cd591bbe1860$export$e23ae35269442b4f;

});

parcelRegister("a9aSv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $5EzLH = parcelRequire("5EzLH");


var $iDrrr = parcelRequire("iDrrr");

const $19ad0c297e7cfe22$var$shimmerKeyframes = null;
const $19ad0c297e7cfe22$var$skeletonStyles = null;
const $19ad0c297e7cfe22$var$activeShimmerStyles = null; /**
                                   * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
                                   * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
                                   * which makes things simpler than doing an `isServer` check or a `null` check.
                                   *
                                   * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
                                   */ 
const $19ad0c297e7cfe22$var$useLayoutEffect = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect); /**
                                                                                          * __Skeleton__
                                                                                          *
                                                                                          * A skeleton acts as a placeholder for content, usually while the content loads.
                                                                                          *
                                                                                          * - [Examples](https://atlassian.design/components/skeleton/examples)
                                                                                          * - [Code](https://atlassian.design/components/skeleton/code)
                                                                                          */ 
const $19ad0c297e7cfe22$var$Skeleton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { width: width, height: height, borderRadius: t1, color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: t2, groupName: groupName, interactionName: interactionName, testId: testId } = t0;
    const borderRadius = t1 === undefined ? "var(--ds-radius-small, 4px)" : t1;
    const isShimmering = t2 === undefined ? false : t2;
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    let t3;
    let t4;
    if ($[0] !== context || $[1] !== interactionName) {
        t3 = ()=>{
            if (context != null && (0, $iDrrr.fg)("platform-dst-skeleton-ufo-hold")) return context.hold(interactionName);
        };
        t4 = [
            context,
            interactionName
        ];
        $[0] = context;
        $[1] = interactionName;
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    $19ad0c297e7cfe22$var$useLayoutEffect(t3, t4);
    const t5 = color && ShimmeringEndColor ? color : undefined;
    const t6 = color && ShimmeringEndColor ? ShimmeringEndColor : undefined;
    let t7;
    if ($[4] !== borderRadius || $[5] !== color || $[6] !== height || $[7] !== t5 || $[8] !== t6 || $[9] !== width) {
        t7 = {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            "--ds-skeleton-from-color": t5,
            "--ds-skeleton-to-color": t6
        };
        $[4] = borderRadius;
        $[5] = color;
        $[6] = height;
        $[7] = t5;
        $[8] = t6;
        $[9] = width;
        $[10] = t7;
    } else t7 = $[10];
    const t8 = t7;
    let t9;
    if ($[11] !== groupDataAttribute) {
        t9 = groupDataAttribute && {
            [groupDataAttribute]: "true"
        };
        $[11] = groupDataAttribute;
        $[12] = t9;
    } else t9 = $[12];
    const t10 = isShimmering && "";
    const t11 = isShimmering && "_1gBibyKB6V";
    let t12;
    if ($[13] !== t10 || $[14] !== t11) {
        t12 = (0, $hekY6.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            t10,
            t11
        ]);
        $[13] = t10;
        $[14] = t11;
        $[15] = t12;
    } else t12 = $[15];
    let t13;
    if ($[16] !== t12 || $[17] !== t8 || $[18] !== t9 || $[19] !== testId) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": testId,
            style: t8,
            ...t9,
            className: t12
        });
        $[16] = t12;
        $[17] = t8;
        $[18] = t9;
        $[19] = testId;
        $[20] = t13;
    } else t13 = $[20];
    return t13;
} : ({ width: width, height: height, borderRadius: borderRadius = "var(--ds-radius-small, 4px)", color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, interactionName: interactionName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    $19ad0c297e7cfe22$var$useLayoutEffect(()=>{
        if (context != null && (0, $iDrrr.fg)('platform-dst-skeleton-ufo-hold')) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $hekY6.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            isShimmering && "",
            isShimmering && "_1gBibyKB6V"
        ])
    });
};
var $19ad0c297e7cfe22$export$2e2bcd8739ae039 = $19ad0c297e7cfe22$var$Skeleton;
module.exports["default"] = $19ad0c297e7cfe22$export$2e2bcd8739ae039;

});

parcelRegister("4Uejl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jlWUB = parcelRequire("jlWUB");


var $lrDw7 = parcelRequire("lrDw7");


var $7BVQi = parcelRequire("7BVQi");


var $g3XYx = parcelRequire("g3XYx");


var $1U6E9 = parcelRequire("1U6E9");


var $jhrdR = parcelRequire("jhrdR");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $8b8583a0a90649e3$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $8b8583a0a90649e3$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $8b8583a0a90649e3$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $8b8583a0a90649e3$export$a300664a1a230956 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion, onStartMotion: onStartMotion } = t0;
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            cleanup: "next-effect"
        };
        $[0] = t1;
    } else t1 = $[0];
    const setTimeout = (0, $1U6E9.useSetTimeout)(t1);
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    let t2;
    if ($[1] !== element) {
        t2 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element) return;
            const rect = element.getBoundingClientRect();
            prevDimensions.current = {
                width: rect.width,
                height: rect.height
            };
        };
        $[1] = element;
        $[2] = t2;
    } else t2 = $[2];
    (0, $jhrdR.useSnapshotBeforeUpdate)(t2);
    let t3;
    if ($[3] !== dimension || $[4] !== duration || $[5] !== easing || $[6] !== element || $[7] !== onFinishMotion || $[8] !== onStartMotion || $[9] !== requestAnimationFrame || $[10] !== setTimeout) {
        t3 = ()=>{
            if (!element) return;
            if ((0, $jlWUB.isReducedMotion)()) {
                onFinishMotion?.();
                return;
            }
            if (!prevDimensions.current) return;
            element.setAttribute("style", "");
            const rect_0 = element.getBoundingClientRect();
            const nextDimensions = {
                width: rect_0.width,
                height: rect_0.height
            };
            if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
                onFinishMotion?.();
                return;
            }
            onStartMotion?.();
            const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
            const newStyles = {
                willChange: propertyList,
                transitionProperty: propertyList,
                transitionDuration: duration,
                boxSizing: "border-box",
                transitionTimingFunction: easing
            };
            if (dimension === "width" || dimension === "both") newStyles.width = `${prevDimensions.current.width}px`;
            if (dimension === "height" || dimension === "both") newStyles.height = `${prevDimensions.current.height}px`;
            Object.assign(element.style, newStyles);
            const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!element) return;
                    if (dimension === "width" || dimension === "both") element.style.width = `${nextDimensions.width}px`;
                    if (dimension === "height" || dimension === "both") element.style.height = `${nextDimensions.height}px`;
                    setTimeout(()=>{
                        if (!element) return;
                        element.setAttribute("style", "");
                        onFinishMotion?.();
                    }, resolvedDuration);
                });
            });
        };
        $[3] = dimension;
        $[4] = duration;
        $[5] = easing;
        $[6] = element;
        $[7] = onFinishMotion;
        $[8] = onStartMotion;
        $[9] = requestAnimationFrame;
        $[10] = setTimeout;
        $[11] = t3;
    } else t3 = $[11];
    (0, $7BVQi.useLayoutEffect)(t3);
    let t4;
    if ($[12] !== setElementRef) {
        t4 = {
            ref: setElementRef
        };
        $[12] = setElementRef;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion, onStartMotion: onStartMotion })=>{
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    const setTimeout = (0, $1U6E9.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    (0, $jhrdR.useSnapshotBeforeUpdate)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $7BVQi.useLayoutEffect)(()=>{
        if (!element) return;
        if ((0, $jlWUB.isReducedMotion)()) {
            // No motion will ever run, so the element is already at its final dimensions.
            onFinishMotion?.();
            return;
        }
        if (!prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect_0 = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect_0.width,
            height: rect_0.height
        };
        if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        // Any in-flight transition styles have been cleared and the next ones haven't been applied
        // yet, so the element is at the natural layout it will settle at.
        onStartMotion?.();
        const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $8b8583a0a90649e3$export$a300664a1a230956;

});

parcelRegister("jhrdR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7BVQi = parcelRequire("7BVQi");

const $8584e1bffd64d1d0$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $cozmU.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $7BVQi.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $8584e1bffd64d1d0$export$9e95200239cd148b;

});

parcelRegister("lkYE1", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");

//      
var $f88a81f3886ec3a5$var$charCodeOfDot = ".".charCodeAt(0);
var $f88a81f3886ec3a5$var$reEscapeChar = /\\(\\)?/g;
var $f88a81f3886ec3a5$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f88a81f3886ec3a5$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f88a81f3886ec3a5$var$charCodeOfDot) result.push("");
    string.replace($f88a81f3886ec3a5$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f88a81f3886ec3a5$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f88a81f3886ec3a5$var$keysCache = {};
var $f88a81f3886ec3a5$var$keysRegex = /[.[\]]+/;
var $f88a81f3886ec3a5$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f88a81f3886ec3a5$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f88a81f3886ec3a5$var$keysCache[key] = key.split($f88a81f3886ec3a5$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f88a81f3886ec3a5$var$keysCache[key] = $f88a81f3886ec3a5$var$stringToPath(key);
    }
    return $f88a81f3886ec3a5$var$keysCache[key];
};
//      
var $f88a81f3886ec3a5$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f88a81f3886ec3a5$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f88a81f3886ec3a5$var$_toPropertyKey(arg) {
    var key = $f88a81f3886ec3a5$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f88a81f3886ec3a5$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f88a81f3886ec3a5$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $1eVGO.default)(current, [
                key
            ].map($f88a81f3886ec3a5$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $eb3ax.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f88a81f3886ec3a5$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f88a81f3886ec3a5$var$setInRecursor(state, 0, $f88a81f3886ec3a5$var$toPath(key), value1, destroyArrays);
};
var $f88a81f3886ec3a5$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f88a81f3886ec3a5$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f88a81f3886ec3a5$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f88a81f3886ec3a5$export$c52e5867d5879e24(values, name);
    var error = $f88a81f3886ec3a5$export$c52e5867d5879e24(errors, name);
    if (error && error[$f88a81f3886ec3a5$export$735bebc8ffabf28a]) error = error[$f88a81f3886ec3a5$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f88a81f3886ec3a5$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f88a81f3886ec3a5$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f88a81f3886ec3a5$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f88a81f3886ec3a5$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f88a81f3886ec3a5$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f88a81f3886ec3a5$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f88a81f3886ec3a5$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f88a81f3886ec3a5$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f88a81f3886ec3a5$var$subscriptionFilter(result, state, previousState, subscription, $f88a81f3886ec3a5$export$41e855cb628c1b55, $f88a81f3886ec3a5$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f88a81f3886ec3a5$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f88a81f3886ec3a5$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f88a81f3886ec3a5$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f88a81f3886ec3a5$var$subscriptionFilter(result, state, previousState, subscription, $f88a81f3886ec3a5$export$f1ff97b9d1c7a3c3, $f88a81f3886ec3a5$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f88a81f3886ec3a5$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f88a81f3886ec3a5$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f88a81f3886ec3a5$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f88a81f3886ec3a5$export$83d89fbfd8236492 = "4.20.10";
var $f88a81f3886ec3a5$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f88a81f3886ec3a5$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f88a81f3886ec3a5$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f88a81f3886ec3a5$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f88a81f3886ec3a5$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f88a81f3886ec3a5$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f88a81f3886ec3a5$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f88a81f3886ec3a5$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f88a81f3886ec3a5$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f88a81f3886ec3a5$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $eb3ax.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $eb3ax.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $eb3ax.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $eb3ax.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $eb3ax.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f88a81f3886ec3a5$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f88a81f3886ec3a5$export$e6bdf135a54e021b,
                    shallowEqual: $f88a81f3886ec3a5$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $eb3ax.default)({}, state.formState.values)); // clone to avoid writing
            if ($f88a81f3886ec3a5$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f88a81f3886ec3a5$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f88a81f3886ec3a5$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $eb3ax.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $eb3ax.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f88a81f3886ec3a5$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f88a81f3886ec3a5$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f88a81f3886ec3a5$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f88a81f3886ec3a5$export$735bebc8ffabf28a]) {
                    var existing = $f88a81f3886ec3a5$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f88a81f3886ec3a5$export$735bebc8ffabf28a] = error[$f88a81f3886ec3a5$export$735bebc8ffabf28a];
                    merged = $f88a81f3886ec3a5$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f88a81f3886ec3a5$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f88a81f3886ec3a5$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $eb3ax.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f88a81f3886ec3a5$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f88a81f3886ec3a5$var$notify(fieldSubscriber, fieldState, lastFieldState, $f88a81f3886ec3a5$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f88a81f3886ec3a5$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $eb3ax.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key), $f88a81f3886ec3a5$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key), $f88a81f3886ec3a5$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f88a81f3886ec3a5$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f88a81f3886ec3a5$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f88a81f3886ec3a5$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f88a81f3886ec3a5$var$notify(state.subscribers, nextFormState, lastFormState, $f88a81f3886ec3a5$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $eb3ax.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $eb3ax.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $eb3ax.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key), $f88a81f3886ec3a5$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f88a81f3886ec3a5$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f88a81f3886ec3a5$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, name) === $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $eb3ax.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $eb3ax.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $eb3ax.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f88a81f3886ec3a5$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f88a81f3886ec3a5$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $eb3ax.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f88a81f3886ec3a5$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f88a81f3886ec3a5$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f88a81f3886ec3a5$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f88a81f3886ec3a5$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}
module.exports["getIn"] = $f88a81f3886ec3a5$export$c52e5867d5879e24;
module.exports["FORM_ERROR"] = $f88a81f3886ec3a5$export$97cd7fc25dd32915;
module.exports["fieldSubscriptionItems"] = $f88a81f3886ec3a5$export$41e855cb628c1b55;
module.exports["formSubscriptionItems"] = $f88a81f3886ec3a5$export$f1ff97b9d1c7a3c3;
module.exports["version"] = $f88a81f3886ec3a5$export$83d89fbfd8236492;
module.exports["createForm"] = $f88a81f3886ec3a5$export$f681a8129d2e9d28;

});

parcelRegister("19ZlF", function(module, exports) {

var $lkYE1 = parcelRequire("lkYE1");

//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $0d863840e9077425$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $0d863840e9077425$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($0d863840e9077425$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $0d863840e9077425$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $lkYE1.getIn)(errors, input.name);
    });
};
//      
var $0d863840e9077425$var$noop = function noop() {};
var $0d863840e9077425$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $0d863840e9077425$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $0d863840e9077425$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $0d863840e9077425$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $0d863840e9077425$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($0d863840e9077425$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$0d863840e9077425$export$2e2bcd8739ae039 = $0d863840e9077425$var$createDecorator;
module.exports["default"] = $0d863840e9077425$export$2e2bcd8739ae039;

});

parcelRegister("lSFbL", function(module, exports) {

var $2itBe = parcelRequire("2itBe");

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $fede975c1f302c4c$var$set(object, path, value) {
    return object == null ? object : $2itBe(object, path, value);
}
module.exports = $fede975c1f302c4c$var$set;

});

parcelRegister("4Qc44", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5936b606760a760$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $e5936b606760a760$export$2e2bcd8739ae039 = (0, $cozmU.forwardRef);

});

parcelRegister("2uDbg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7r5Hr = parcelRequire("7r5Hr");


var $lmzCg = parcelRequire("lmzCg");


var $8c6io = parcelRequire("8c6io");


var $2hGAN = parcelRequire("2hGAN");


var $cAK2R = parcelRequire("cAK2R");


var $kbRVk = parcelRequire("kbRVk");

const $5e9458ef4430c05f$var$checkboxStyles = {
    root: "_30huDKYbGa _1xC2CJsLaB _2xIroY98eZ _497WNwYbGa _2zndICT6kp _39xV02N91d _0jFU0VN91d _034jHtYbGa _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _1YKVNsdnbC"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $5e9458ef4430c05f$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Checkbox(t0, ref) {
    const $ = (0, $bDgLe.c)(59);
    let analyticsContext;
    let className;
    let isCheckedProp;
    let isRequired;
    let label;
    let name;
    let onChangeProps;
    let rest;
    let t1;
    let t2;
    let t3;
    let t4;
    let testId;
    let value;
    let xcss;
    if ($[0] !== t0) {
        ({ isChecked: isCheckedProp, isDisabled: t1, isInvalid: t2, defaultChecked: t3, isIndeterminate: t4, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = className;
        $[3] = isCheckedProp;
        $[4] = isRequired;
        $[5] = label;
        $[6] = name;
        $[7] = onChangeProps;
        $[8] = rest;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = testId;
        $[14] = value;
        $[15] = xcss;
    } else {
        analyticsContext = $[1];
        className = $[2];
        isCheckedProp = $[3];
        isRequired = $[4];
        label = $[5];
        name = $[6];
        onChangeProps = $[7];
        rest = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        t4 = $[12];
        testId = $[13];
        value = $[14];
        xcss = $[15];
    }
    const isDisabled = t1 === undefined ? false : t1;
    const isInvalid = t2 === undefined ? false : t2;
    const defaultChecked = t3 === undefined ? false : t3;
    const isIndeterminate = t4 === undefined ? false : t4;
    const [isCheckedState, setIsCheckedState] = (0, $cozmU.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    let t5;
    if ($[16] !== onChangeProps) {
        t5 = (e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        };
        $[16] = onChangeProps;
        $[17] = t5;
    } else t5 = $[17];
    const onChange = t5;
    let t6;
    if ($[18] !== analyticsContext || $[19] !== onChange) {
        t6 = {
            fn: onChange,
            action: "changed",
            analyticsData: analyticsContext,
            componentName: "checkbox",
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        };
        $[18] = analyticsContext;
        $[19] = onChange;
        $[20] = t6;
    } else t6 = $[20];
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t6);
    const internalRef = (0, $cozmU.useRef)(null);
    const mergedRefs = (0, $lmzCg.default)([
        internalRef,
        ref
    ]);
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    let t7;
    if ($[21] !== internalRef || $[22] !== isIndeterminate) {
        t7 = ()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        };
        $[21] = internalRef;
        $[22] = isIndeterminate;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== isIndeterminate) {
        t8 = [
            isIndeterminate
        ];
        $[24] = isIndeterminate;
        $[25] = t8;
    } else t8 = $[25];
    (0, $cozmU.useEffect)(t7, t8);
    const t9 = label;
    const t10 = rest.id ? `${rest.id}-label` : undefined;
    const t11 = testId && `${testId}--checkbox-label`;
    let t12;
    if ($[26] !== className) {
        t12 = (0, $hekY6.default)([
            $5e9458ef4430c05f$var$checkboxStyles.root,
            className
        ]);
        $[26] = className;
        $[27] = t12;
    } else t12 = $[27];
    const t13 = isInvalid ? "true" : undefined;
    const t14 = testId && `${testId}--hidden-checkbox`;
    const t15 = isInvalid ? "true" : undefined;
    let t16;
    if ($[28] !== isChecked || $[29] !== isDisabled || $[30] !== isRequired || $[31] !== mergedRefs || $[32] !== name || $[33] !== onChangeAnalytics || $[34] !== rest || $[35] !== t12 || $[36] !== t13 || $[37] !== t14 || $[38] !== t15 || $[39] !== value) {
        t16 = /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            className: t12,
            onChange: onChangeAnalytics,
            "aria-invalid": t13,
            "data-testid": t14,
            "data-invalid": t15
        });
        $[28] = isChecked;
        $[29] = isDisabled;
        $[30] = isRequired;
        $[31] = mergedRefs;
        $[32] = name;
        $[33] = onChangeAnalytics;
        $[34] = rest;
        $[35] = t12;
        $[36] = t13;
        $[37] = t14;
        $[38] = t15;
        $[39] = value;
        $[40] = t16;
    } else t16 = $[40];
    let t17;
    if ($[41] !== isChecked || $[42] !== isIndeterminate) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8c6io.default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        });
        $[41] = isChecked;
        $[42] = isIndeterminate;
        $[43] = t17;
    } else t17 = $[43];
    let t18;
    if ($[44] !== isRequired || $[45] !== label) {
        t18 = label && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cAK2R.default), {
            children: [
                label,
                isRequired && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kbRVk.default), {})
            ]
        });
        $[44] = isRequired;
        $[45] = label;
        $[46] = t18;
    } else t18 = $[46];
    let t19;
    if ($[47] !== isChecked || $[48] !== isDisabled || $[49] !== isIndeterminate || $[50] !== isInvalid || $[51] !== t10 || $[52] !== t11 || $[53] !== t16 || $[54] !== t17 || $[55] !== t18 || $[56] !== t9 || $[57] !== xcss) {
        t19 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $2hGAN.default), {
            isDisabled: isDisabled,
            isChecked: isChecked,
            isIndeterminate: isIndeterminate,
            isInvalid: isInvalid,
            label: t9,
            id: t10,
            testId: t11,
            xcss: xcss,
            children: [
                t16,
                t17,
                t18
            ]
        });
        $[47] = isChecked;
        $[48] = isDisabled;
        $[49] = isIndeterminate;
        $[50] = isInvalid;
        $[51] = t10;
        $[52] = t11;
        $[53] = t16;
        $[54] = t17;
        $[55] = t18;
        $[56] = t9;
        $[57] = xcss;
        $[58] = t19;
    } else t19 = $[58];
    return t19;
} : function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $cozmU.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $cozmU.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $cozmU.useRef)(null);
    const mergedRefs = (0, $lmzCg.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $cozmU.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $2hGAN.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $hekY6.default)([
                    $5e9458ef4430c05f$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8c6io.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cAK2R.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kbRVk.default), {})
                ]
            })
        ]
    });
}));
$5e9458ef4430c05f$export$48513f6b9f8ce62d.displayName = 'Checkbox'; // keep the default export for backwards compatibility
var $5e9458ef4430c05f$export$2e2bcd8739ae039 = $5e9458ef4430c05f$export$48513f6b9f8ce62d;
module.exports["Checkbox"] = $5e9458ef4430c05f$export$48513f6b9f8ce62d;
module.exports["default"] = $5e9458ef4430c05f$export$2e2bcd8739ae039;

});

parcelRegister("8c6io", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");

const $ef6550583d45a5c6$var$svgStyles = {
    root: "_1xC2CJsLaB _4bt5LAnQyn _2WAcuGnQyn _23rrnHXVX0 _0bjKvDKxmn _32BiAhDfsT _1pp6NdYbGa _1UtDYzQPq5 _1rdFvh1XeA _3e6OgrLl21",
    rect: "_23rrnHFqy6 _4gxJYwNvrM _4e1TYvUkr1"
}; // Cross-fade colors and glyphs without moving the input or focus outline.
// Semantic tokens keep SVG colors, borders and indicators aligned with input motion.
// Preserve non-spatial transitions for reduced motion, per the LDR:
// https://hello.atlassian.net/wiki/spaces/DST/pages/7402790985
const $ef6550583d45a5c6$var$motionStyles = {
    root: "_23rrnHnc7r",
    selected: "_1YKVNs7dHp",
    glyph: "_23rrnHnc7r _1YKVNsdnbC _3wrwGmYbGa",
    border: "_23rrnHnc7r"
};
function $ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked, motionState) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit",
        className: (0, $hekY6.default)([
            motionState && $ef6550583d45a5c6$var$motionStyles.glyph,
            motionState === 'visible' && $ef6550583d45a5c6$var$motionStyles.selected
        ])
    });
    if (isChecked) return /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit",
        className: (0, $hekY6.default)([
            motionState && $ef6550583d45a5c6$var$motionStyles.glyph,
            motionState === 'visible' && $ef6550583d45a5c6$var$motionStyles.selected
        ])
    });
     // No icon
    return null;
}
const $ef6550583d45a5c6$var$CheckboxIcon = /*#__PURE__*/ (0, $cozmU.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const hasMotion = (0, $iDrrr.fg)('platform_design_system_selection_radial_fade');
    const icon = (0, $cozmU.useMemo)(()=>$ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $hekY6.default)([
            $ef6550583d45a5c6$var$svgStyles.root,
            hasMotion && $ef6550583d45a5c6$var$motionStyles.root
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    className: (0, $hekY6.default)([
                        $ef6550583d45a5c6$var$svgStyles.rect,
                        hasMotion && $ef6550583d45a5c6$var$motionStyles.border
                    ])
                }),
                hasMotion ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
                    children: [
                        $ef6550583d45a5c6$var$getIcon(false, true, isChecked && !isIndeterminate ? 'visible' : 'hidden'),
                        $ef6550583d45a5c6$var$getIcon(true, false, isIndeterminate ? 'visible' : 'hidden')
                    ]
                }) : icon
            ]
        })
    });
});
var $ef6550583d45a5c6$export$2e2bcd8739ae039 = $ef6550583d45a5c6$var$CheckboxIcon;
module.exports["default"] = $ef6550583d45a5c6$export$2e2bcd8739ae039;

});

parcelRegister("2hGAN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $1634ca3e0554fde5$var$baseStyles = null;
const $1634ca3e0554fde5$var$textLabelLayoutStyles = null; // Checked/Indeterminate state
const $1634ca3e0554fde5$var$checkedStyles = null; // Invalid state - must override hover/active to maintain red border
const $1634ca3e0554fde5$var$invalidStyles = null; // Disabled state - must override hover/active to maintain disabled appearance
const $1634ca3e0554fde5$var$disabledStyles = null; // Disabled + Checked/Indeterminate
const $1634ca3e0554fde5$var$disabledCheckedStyles = null;
const $1634ca3e0554fde5$var$Label = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Label(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss } = t0;
    const t1 = label && "_2mHwu8RsfN _2iEGP2a3NQ";
    const t2 = (isChecked || isIndeterminate) && "_49q2vakLmD _0ZqVxakLmD _3jFxiY6BYM _4slB72XLOx _1IEstyXLOx _01wY7FutHW _0R5xzg9r67 _2m1JOU6BYM _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4";
    const t3 = isInvalid && "_0ZqVxanod9 _1IEstynod9 _0R5xzgnod9 _4dUVtQBvTi";
    const t4 = isDisabled && "_49q2vaVrZW _0ZqVxaVrZW _1UtDYzot27 _0wOv4Qsyl5 _4slB72VrZW _1IEstyVrZW _01wY7FVrZW _0R5xzgVrZW _1ixXUak5Cz _4dUVtQ5l5r _2o2XD95l5r";
    const t5 = isDisabled && (isChecked || isIndeterminate) && "_3jFxiYoM2E _0D4MlqoM2E _2m1JOUoM2E";
    let t6;
    if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== xcss) {
        t6 = (0, $hekY6.default)([
            "_2sNsIgmnOE _3iDTPbgBM8 _3kOVpyUfmU _21ioM3BY1A _49q2va7Cj1 _0ZqVxaHKt7 _3b00HoYbGa _3jFxiYjOvk _1UtDYzy7kJ _0wOv4Q18ZR _1q8flZXzJH _4slB72qWX3 _01wY7FutHW _0R5xzg9r67 _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4",
            t1,
            t2,
            t3,
            t4,
            t5,
            xcss
        ]);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = xcss;
        $[6] = t6;
    } else t6 = $[6];
    const t7 = isDisabled || undefined;
    let t8;
    if ($[7] !== children || $[8] !== id || $[9] !== t6 || $[10] !== t7 || $[11] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("label", {
            className: t6,
            "data-testid": testId,
            "data-disabled": t7,
            id: id,
            children: children
        });
        $[7] = children;
        $[8] = id;
        $[9] = t6;
        $[10] = t7;
        $[11] = testId;
        $[12] = t8;
    } else t8 = $[12];
    return t8;
} : function Label({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("label", {
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _3iDTPbgBM8 _3kOVpyUfmU _21ioM3BY1A _49q2va7Cj1 _0ZqVxaHKt7 _3b00HoYbGa _3jFxiYjOvk _1UtDYzy7kJ _0wOv4Q18ZR _1q8flZXzJH _4slB72qWX3 _01wY7FutHW _0R5xzg9r67 _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4",
            label && "_2mHwu8RsfN _2iEGP2a3NQ",
            (isChecked || isIndeterminate) && "_49q2vakLmD _0ZqVxakLmD _3jFxiY6BYM _4slB72XLOx _1IEstyXLOx _01wY7FutHW _0R5xzg9r67 _2m1JOU6BYM _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4",
            isInvalid && "_0ZqVxanod9 _1IEstynod9 _0R5xzgnod9 _4dUVtQBvTi",
            isDisabled && "_49q2vaVrZW _0ZqVxaVrZW _1UtDYzot27 _0wOv4Qsyl5 _4slB72VrZW _1IEstyVrZW _01wY7FVrZW _0R5xzgVrZW _1ixXUak5Cz _4dUVtQ5l5r _2o2XD95l5r",
            isDisabled && (isChecked || isIndeterminate) && "_3jFxiYoM2E _0D4MlqoM2E _2m1JOUoM2E",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
};
var $1634ca3e0554fde5$export$2e2bcd8739ae039 = $1634ca3e0554fde5$var$Label;
module.exports["default"] = $1634ca3e0554fde5$export$2e2bcd8739ae039;

});

parcelRegister("cAK2R", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $4870a5341200be20$var$labelTextStyles = null;
const $4870a5341200be20$var$LabelText = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LabelText(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1xC2CJvmHw _4xdlr0DIqT"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: t1,
            children: children
        });
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : function LabelText({ children: children }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            "_1xC2CJvmHw _4xdlr0DIqT"
        ]),
        children: children
    });
};
var $4870a5341200be20$export$2e2bcd8739ae039 = $4870a5341200be20$var$LabelText;
module.exports["default"] = $4870a5341200be20$export$2e2bcd8739ae039;

});

parcelRegister("kbRVk", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $126a273b3177dba3$var$requiredIndicatorStyles = null;
const $126a273b3177dba3$var$RequiredIndicator = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RequiredIndicator() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "aria-hidden": true,
            className: (0, $hekY6.default)([
                "_1UtDYzAyGJ _0LQT5EFQfX"
            ]),
            children: "*"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function RequiredIndicator() {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "aria-hidden": true,
        className: (0, $hekY6.default)([
            "_1UtDYzAyGJ _0LQT5EFQfX"
        ]),
        children: "*"
    });
};
var $126a273b3177dba3$export$2e2bcd8739ae039 = $126a273b3177dba3$var$RequiredIndicator;
module.exports["default"] = $126a273b3177dba3$export$2e2bcd8739ae039;

});

parcelRegister("e3Wrf", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $iDrrr = parcelRequire("iDrrr");

const $f7ddda300dd34381$var$packageName = "platform-pkg";
const $f7ddda300dd34381$var$packageVersion = "0.0.0-use.local";
const $f7ddda300dd34381$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $f7ddda300dd34381$var$packageName,
    packageVersion: $f7ddda300dd34381$var$packageVersion
};
const $f7ddda300dd34381$var$lineHeightBase = 20;
const $f7ddda300dd34381$var$lineHeightCompact = 16;
const $f7ddda300dd34381$var$compactVerticalPadding = 2;
const $f7ddda300dd34381$var$verticalPadding = 6;
const $f7ddda300dd34381$var$borderWidth = 2;
const $f7ddda300dd34381$var$baseStyles = null;
const $f7ddda300dd34381$var$inputMotionStyles = {
    legacy: "_23rrnH5Vpu",
    base: "_23rrnHGIwA"
};
const $f7ddda300dd34381$var$finessePlaceholderStyles = null;
const $f7ddda300dd34381$var$appearanceStyles = {
    standard: "_3hxITi6wH8 _1mHXSFHKt7 _3OEoix7Cj1 _39nh0ghQC5 _2jpXBkVrZW _31SgFAHKt7 _2zr3nGqWX3 _3LfWyLFQfX _2vsVfZFQfX _2DQpWtXJux _0SosFGXJux _1CDq3qgVvo _2FTXAcgVvo _0tVs2sXJux _3JVwBfXJux _0xkEdpnXvL _1iy5hxutHW _0ui43CPhRM _2UNgvCnXvL _1LO7QkVrZW",
    subtle: "_3hxITi6wH8 _1mHXSFjOvk _3OEoixjOvk _31SgFAHKt7 _2zr3nGqWX3 _3LfWyLFQfX _2vsVfZFQfX _2DQpWtXJux _0SosFGXJux _1CDq3qgVvo _2FTXAcgVvo _3JVwBfXJux _0tVs2sXJux _0xkEdpnXvL _1iy5hxutHW _0ui43CPhRM",
    none: "_3hxITiYbGa _1mHXSFjOvk _3OEoixjOvk _31SgFAjOvk _2zr3nGjOvk _3LfWyLFQfX _0SosFGgVvo _2vsVfZFQfX _2DQpWtgVvo _1CDq3qgVvo _3JVwBfgVvo _2FTXAcgVvo _0tVs2sgVvo _0xkEdpjOvk _1iy5hxjOvk _0ui43Cw5zn"
}; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on touch devices with small viewports, the textarea uses font.body (default),
// and font.body.large (16px) for touch devices (pointer: coarse) with screens narrower than 30rem.
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $f7ddda300dd34381$var$fontStyles = {
    default: "_2sNsIgmnOE _1gitD220Hp",
    monospace: "_2sNsIgmnOE _0WKd3Gfx9v _1gitD220Hp _3n0EfXdh5F"
};
const $f7ddda300dd34381$var$resizeStyles = {
    horizontal: "_2HIj7GD4qA",
    vertical: "_2HIj7GbI28",
    auto: "_2HIj7GZSoF",
    smart: "_2HIj7GYbGa",
    none: "_2HIj7GYbGa"
};
const $f7ddda300dd34381$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $f7ddda300dd34381$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $f7ddda300dd34381$var$InnerTextArea = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(59);
    const ourRef = (0, $cozmU.useRef)(null);
    let onBlur;
    let onChange;
    let onFocus;
    let rest;
    let style;
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    let testId;
    let value;
    if ($[0] !== props) {
        ({ resize: t0, appearance: t1, isCompact: t2, isRequired: t3, isReadOnly: t4, isDisabled: t5, isInvalid: t6, isMonospaced: t7, minimumRows: t8, testId: testId, maxHeight: t9, onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props);
        $[0] = props;
        $[1] = onBlur;
        $[2] = onChange;
        $[3] = onFocus;
        $[4] = rest;
        $[5] = style;
        $[6] = t0;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
        $[16] = testId;
        $[17] = value;
    } else {
        onBlur = $[1];
        onChange = $[2];
        onFocus = $[3];
        rest = $[4];
        style = $[5];
        t0 = $[6];
        t1 = $[7];
        t2 = $[8];
        t3 = $[9];
        t4 = $[10];
        t5 = $[11];
        t6 = $[12];
        t7 = $[13];
        t8 = $[14];
        t9 = $[15];
        testId = $[16];
        value = $[17];
    }
    const resize = t0 === undefined ? "smart" : t0;
    const appearance = t1 === undefined ? "standard" : t1;
    const isCompact = t2 === undefined ? false : t2;
    const isRequired = t3 === undefined ? false : t3;
    const isReadOnly = t4 === undefined ? false : t4;
    const isDisabled = t5 === undefined ? false : t5;
    const isInvalid = t6 === undefined ? false : t6;
    const isMonospaced = t7 === undefined ? false : t7;
    const minimumRows = t8 === undefined ? 2 : t8;
    const maxHeight = t9 === undefined ? "50vh" : t9;
    const isInputMotionEnabled = (0, $iDrrr.fg)("platform-dst-motion-uplift-input");
    const isInteractive = !isDisabled && !isReadOnly;
    const borderHeight = appearance === "none" ? 2 : 1;
    let t10;
    if ($[18] !== resize) {
        t10 = ()=>{
            const el = ourRef.current;
            if (resize === "smart" && el) $f7ddda300dd34381$var$setSmartHeight(el);
        };
        $[18] = resize;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== resize || $[21] !== value) {
        t11 = [
            resize,
            value
        ];
        $[20] = resize;
        $[21] = value;
        $[22] = t11;
    } else t11 = $[22];
    (0, $cozmU.useEffect)(t10, t11);
    let t12;
    if ($[23] !== onBlur) {
        t12 = {
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: "blurred",
            ...$f7ddda300dd34381$var$analyticsParams
        };
        $[23] = onBlur;
        $[24] = t12;
    } else t12 = $[24];
    const onBlurWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t12);
    let t13;
    if ($[25] !== onFocus) {
        t13 = {
            fn: (event_0)=>{
                onFocus && onFocus(event_0);
            },
            action: "focused",
            ...$f7ddda300dd34381$var$analyticsParams
        };
        $[25] = onFocus;
        $[26] = t13;
    } else t13 = $[26];
    const onFocusWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t13);
    let t14;
    if ($[27] !== ref) {
        t14 = (elementRef)=>{
            ourRef.current = elementRef;
            if (ref && typeof ref === "object") ref.current = elementRef;
            if (ref && typeof ref === "function") ref(elementRef);
        };
        $[27] = ref;
        $[28] = t14;
    } else t14 = $[28];
    const getTextAreaRef = t14;
    let t15;
    if ($[29] !== onChange || $[30] !== resize) {
        t15 = (e)=>{
            const el_0 = ourRef.current;
            if (resize === "smart" && el_0) $f7ddda300dd34381$var$setSmartHeight(el_0);
            onChange && onChange(e);
        };
        $[29] = onChange;
        $[30] = resize;
        $[31] = t15;
    } else t15 = $[31];
    const handleOnChange = t15;
    const t16 = isInvalid ? isInvalid : undefined;
    const t17 = isCompact ? isCompact : undefined;
    const t18 = testId ? testId : undefined;
    let t19;
    if ($[32] !== t16 || $[33] !== t17 || $[34] !== t18) {
        t19 = {
            "data-invalid": t16,
            "data-compact": t17,
            "data-testid": t18
        };
        $[32] = t16;
        $[33] = t17;
        $[34] = t18;
        $[35] = t19;
    } else t19 = $[35];
    const controlProps = t19;
    const t20 = (0, $hekY6.default)([
        "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _0bjKvDKTcp _2sNsIgmnOE _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAIZbP _2WAcuGIZbP _2V7sgONvrM _3iDTPbvLZJ _24h04i2Njc _39xV02N91d _4ouGXIdnbC _1EqgXlN91d _1mT5xdRAKS _1UtDYzy7kJ _1T2N03wPeg _2IasYonod9 _03v5H87Cj1 _32yk65FKgL _24bGaTot27 _02aXbKsyl5 _0OS5PY7dHp _1kg4OzZqHV _3tCyJvYbGa _2DoaPjYbGa _3pNDujnod9 _1cY5OfqWX3 _0sBZ7MFKgL _30pU6CVrZW _3AxjleKGUX _3MV4MUot27 _1yFQeXQWvZ _3TNCtG1AUN _3OInhJnXvL _1xHRfPutHW _4skx3vPhRM",
        !isInputMotionEnabled && $f7ddda300dd34381$var$inputMotionStyles.legacy,
        isInputMotionEnabled && isInteractive && $f7ddda300dd34381$var$inputMotionStyles.base,
        (0, $iDrrr.fg)("platform-dst-tokens-finesse") && "_3AxjleZpcK",
        $f7ddda300dd34381$var$appearanceStyles[appearance],
        $f7ddda300dd34381$var$fontStyles[isMonospaced ? "monospace" : "default"],
        $f7ddda300dd34381$var$resizeStyles[resize],
        "_22P5CgPgdP _2Ombu6q5bj"
    ]);
    const t21 = $f7ddda300dd34381$var$lineHeightCompact * minimumRows + $f7ddda300dd34381$var$compactVerticalPadding * 2 + borderHeight * 2;
    let t22;
    if ($[36] !== t21) {
        t22 = (0, $9aYkv.default)(t21, "px");
        $[36] = t21;
        $[37] = t22;
    } else t22 = $[37];
    const t23 = $f7ddda300dd34381$var$lineHeightBase * minimumRows + $f7ddda300dd34381$var$verticalPadding * 2 + borderHeight * 2;
    let t24;
    if ($[38] !== t23) {
        t24 = (0, $9aYkv.default)(t23, "px");
        $[38] = t23;
        $[39] = t24;
    } else t24 = $[39];
    let t25;
    if ($[40] !== maxHeight || $[41] !== style || $[42] !== t22 || $[43] !== t24) {
        t25 = {
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": t22,
            "--_eorxnz": t24
        };
        $[40] = maxHeight;
        $[41] = style;
        $[42] = t22;
        $[43] = t24;
        $[44] = t25;
    } else t25 = $[44];
    let t26;
    if ($[45] !== controlProps || $[46] !== getTextAreaRef || $[47] !== handleOnChange || $[48] !== isDisabled || $[49] !== isReadOnly || $[50] !== isRequired || $[51] !== minimumRows || $[52] !== onBlurWithAnalytics || $[53] !== onFocusWithAnalytics || $[54] !== rest || $[55] !== t20 || $[56] !== t25 || $[57] !== value) {
        t26 = /*#__PURE__*/ (0, $8aG6j.jsx)("textarea", {
            ...controlProps,
            value: value,
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired,
            ref: getTextAreaRef,
            onChange: handleOnChange,
            onBlur: onBlurWithAnalytics,
            onFocus: onFocusWithAnalytics,
            rows: minimumRows,
            ...rest,
            className: t20,
            style: t25
        });
        $[45] = controlProps;
        $[46] = getTextAreaRef;
        $[47] = handleOnChange;
        $[48] = isDisabled;
        $[49] = isReadOnly;
        $[50] = isRequired;
        $[51] = minimumRows;
        $[52] = onBlurWithAnalytics;
        $[53] = onFocusWithAnalytics;
        $[54] = rest;
        $[55] = t20;
        $[56] = t25;
        $[57] = value;
        $[58] = t26;
    } else t26 = $[58];
    return t26;
} : (props, ref)=>{
    const ourRef = (0, $cozmU.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const isInputMotionEnabled = (0, $iDrrr.fg)('platform-dst-motion-uplift-input');
    const isInteractive = !isDisabled && !isReadOnly;
    const borderHeight = (0, $cozmU.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $cozmU.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $f7ddda300dd34381$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$f7ddda300dd34381$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event_0)=>{
            onFocus && onFocus(event_0);
        },
        action: 'focused',
        ...$f7ddda300dd34381$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $cozmU.useCallback)((e)=>{
        const el_0 = ourRef.current;
        if (resize === 'smart' && el_0) $f7ddda300dd34381$var$setSmartHeight(el_0);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _0bjKvDKTcp _2sNsIgmnOE _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAIZbP _2WAcuGIZbP _2V7sgONvrM _3iDTPbvLZJ _24h04i2Njc _39xV02N91d _4ouGXIdnbC _1EqgXlN91d _1mT5xdRAKS _1UtDYzy7kJ _1T2N03wPeg _2IasYonod9 _03v5H87Cj1 _32yk65FKgL _24bGaTot27 _02aXbKsyl5 _0OS5PY7dHp _1kg4OzZqHV _3tCyJvYbGa _2DoaPjYbGa _3pNDujnod9 _1cY5OfqWX3 _0sBZ7MFKgL _30pU6CVrZW _3AxjleKGUX _3MV4MUot27 _1yFQeXQWvZ _3TNCtG1AUN _3OInhJnXvL _1xHRfPutHW _4skx3vPhRM",
            !isInputMotionEnabled && $f7ddda300dd34381$var$inputMotionStyles.legacy,
            isInputMotionEnabled && isInteractive && $f7ddda300dd34381$var$inputMotionStyles.base,
            (0, $iDrrr.fg)('platform-dst-tokens-finesse') && "_3AxjleZpcK",
            $f7ddda300dd34381$var$appearanceStyles[appearance],
            $f7ddda300dd34381$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $f7ddda300dd34381$var$resizeStyles[resize],
            "_22P5CgPgdP _2Ombu6q5bj"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $9aYkv.default)($f7ddda300dd34381$var$lineHeightCompact * minimumRows + $f7ddda300dd34381$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $9aYkv.default)($f7ddda300dd34381$var$lineHeightBase * minimumRows + $f7ddda300dd34381$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $f7ddda300dd34381$var$TextArea = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)($f7ddda300dd34381$var$InnerTextArea, {
            ref: ref,
            ...props
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, $8aG6j.jsx)($f7ddda300dd34381$var$InnerTextArea, {
        ref: ref,
        ...props
    })));
$f7ddda300dd34381$var$TextArea.displayName = 'TextArea';
var $f7ddda300dd34381$export$2e2bcd8739ae039 = $f7ddda300dd34381$var$TextArea;
module.exports["default"] = $f7ddda300dd34381$export$2e2bcd8739ae039;

});

parcelRegister("iXRmn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $bbe556224ecd1c1b$export$2eb95677cf2465e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(null);
module.exports["FlagContext"] = $bbe556224ecd1c1b$export$2eb95677cf2465e1;

});

parcelRegister("7akNQ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $a2foB = parcelRequire("a2foB");


var $FKQbh = parcelRequire("FKQbh");


var $iXRmn = parcelRequire("iXRmn");


var $lqtHz = parcelRequire("lqtHz");

const $08beb25a8c4ef160$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
const $08beb25a8c4ef160$export$a4270ab432ac8a58 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FlagsProvider(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, shouldRenderToParent: shouldRenderToParent } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [flags, setFlags] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (id)=>{
            setFlags((current)=>current.slice(0).filter((flag)=>flag.id !== id));
        };
        $[1] = t2;
    } else t2 = $[1];
    const removeFlag = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        };
        $[2] = t3;
    } else t3 = $[2];
    const api = t3;
    let t4;
    if ($[3] !== children) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
            value: api,
            children: children
        });
        $[3] = children;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== flags) {
        t5 = flags.map($08beb25a8c4ef160$var$_temp);
        $[5] = flags;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== shouldRenderToParent || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
            onDismissed: removeFlag,
            shouldRenderToParent: shouldRenderToParent,
            children: t5
        });
        $[7] = shouldRenderToParent;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t4 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                t4,
                t6
            ]
        });
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : function FlagsProvider({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $cozmU.useState)([]);
    const removeFlag = (0, $cozmU.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $cozmU.useMemo)(()=>({
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag_1)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
                    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
                    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
                        ...restProps,
                        key: flag_1.id
                    });
                })
            })
        ]
    });
};
function $08beb25a8c4ef160$var$_temp(flag_1) {
    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
        ...restProps,
        key: flag_1.id
    });
}
module.exports["FlagsProvider"] = $08beb25a8c4ef160$export$a4270ab432ac8a58;

});

parcelRegister("4MnFz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $iXRmn = parcelRequire("iXRmn");

const $878d7a55fd1744f7$export$2879604e6aec4ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error("Unable to find FlagProviderContext");
    return api;
} : function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
};
module.exports["useFlags"] = $878d7a55fd1744f7$export$2879604e6aec4ab;

});

parcelRegister("303LV", function(module, exports) {
$parcel$export(module.exports, "default", () => $22f44c32aa84ec90$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $22f44c32aa84ec90$var$n() {
    return $22f44c32aa84ec90$var$n = Object.assign ? Object.assign.bind() : function(e) {
        for(var n = 1; n < arguments.length; n++){
            var r = arguments[n];
            for(var t in r)Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
        }
        return e;
    }, $22f44c32aa84ec90$var$n.apply(this, arguments);
}
const $22f44c32aa84ec90$var$r = [
    "children",
    "options"
], $22f44c32aa84ec90$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
}, $22f44c32aa84ec90$var$o = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, n)=>(e[n.toLowerCase()] = n, e), {
    class: "className",
    for: "htmlFor"
}), $22f44c32aa84ec90$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $22f44c32aa84ec90$var$c = [
    "style",
    "script",
    "pre"
], $22f44c32aa84ec90$var$i = [
    "src",
    "href",
    "data",
    "formAction",
    "srcDoc",
    "action"
], $22f44c32aa84ec90$var$u = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $22f44c32aa84ec90$var$l = /\n{2,}$/, $22f44c32aa84ec90$var$s = /^(\s*>[\s\S]*?)(?=\n\n|$)/, $22f44c32aa84ec90$var$f = /^ *> ?/gm, $22f44c32aa84ec90$var$_ = /^(?:\[!([^\]]*)\]\n)?([\s\S]*)/, $22f44c32aa84ec90$var$d = /^ {2,}\n/, $22f44c32aa84ec90$var$p = /^(?:([-*_])( *\1){2,}) *(?:\n *)+\n/, $22f44c32aa84ec90$var$y = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $22f44c32aa84ec90$var$h = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $22f44c32aa84ec90$var$g = /^(`+)((?:\\`|(?!\1)`|[^`])+)\1/, $22f44c32aa84ec90$var$m = /^(?:\n *)*\n/, $22f44c32aa84ec90$var$k = /\r\n?/g, $22f44c32aa84ec90$var$x = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $22f44c32aa84ec90$var$q = /^\[\^([^\]]+)]/, $22f44c32aa84ec90$var$v = /\f/g, $22f44c32aa84ec90$var$b = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $22f44c32aa84ec90$var$$ = /^\s*?\[(x|\s)\]/, $22f44c32aa84ec90$var$S = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $22f44c32aa84ec90$var$z = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $22f44c32aa84ec90$var$E = /^([^\n]+)\n *(=|-)\2{2,} *\n/, $22f44c32aa84ec90$var$A = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $22f44c32aa84ec90$var$R = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $22f44c32aa84ec90$var$B = /^<!--[\s\S]*?(?:-->)/, $22f44c32aa84ec90$var$L = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $22f44c32aa84ec90$var$O = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $22f44c32aa84ec90$var$j = /^\{.*\}$/, $22f44c32aa84ec90$var$C = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $22f44c32aa84ec90$var$I = /^<([^ >]+[:@\/][^ >]+)>/, $22f44c32aa84ec90$var$T = /-([a-z])?/gi, $22f44c32aa84ec90$var$M = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $22f44c32aa84ec90$var$w = /^[^\n]+(?:  \n|\n{2,})/, $22f44c32aa84ec90$var$D = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $22f44c32aa84ec90$var$F = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $22f44c32aa84ec90$var$P = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $22f44c32aa84ec90$var$Z = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $22f44c32aa84ec90$var$N = /\t/g, $22f44c32aa84ec90$var$G = /(^ *\||\| *$)/g, $22f44c32aa84ec90$var$U = /^ *:-+: *$/, $22f44c32aa84ec90$var$V = /^ *:-+ *$/, $22f44c32aa84ec90$var$H = /^ *-+: *$/, $22f44c32aa84ec90$var$Q = (e)=>`(?=[\\s\\S]+?\\1${e ? "\\1" : ""})`, $22f44c32aa84ec90$var$W = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|\\\\\\1|[\\s\\S])+?)", $22f44c32aa84ec90$var$J = RegExp(`^([*_])\\1${$22f44c32aa84ec90$var$Q(1)}${$22f44c32aa84ec90$var$W}\\1\\1(?!\\1)`), $22f44c32aa84ec90$var$K = RegExp(`^([*_])${$22f44c32aa84ec90$var$Q(0)}${$22f44c32aa84ec90$var$W}\\1(?!\\1)`), $22f44c32aa84ec90$var$X = RegExp(`^(==)${$22f44c32aa84ec90$var$Q(0)}${$22f44c32aa84ec90$var$W}\\1`), $22f44c32aa84ec90$var$Y = RegExp(`^(~~)${$22f44c32aa84ec90$var$Q(0)}${$22f44c32aa84ec90$var$W}\\1`), $22f44c32aa84ec90$var$ee = /^(:[a-zA-Z0-9-_]+:)/, $22f44c32aa84ec90$var$ne = /^\\([^0-9A-Za-z\s])/, $22f44c32aa84ec90$var$re = /\\([^0-9A-Za-z\s])/g, $22f44c32aa84ec90$var$te = /^[\s\S](?:(?!  \n|[0-9]\.|http)[^=*_~\-\n:<`\\\[!])*/, $22f44c32aa84ec90$var$oe = /^\n+/, $22f44c32aa84ec90$var$ae = /^([ \t]*)/, $22f44c32aa84ec90$var$ce = /(?:^|\n)( *)$/, $22f44c32aa84ec90$var$ie = "(?:\\d+\\.)", $22f44c32aa84ec90$var$ue = "(?:[*+-])";
function $22f44c32aa84ec90$var$le(e) {
    return "( *)(" + (1 === e ? $22f44c32aa84ec90$var$ie : $22f44c32aa84ec90$var$ue) + ") +";
}
const $22f44c32aa84ec90$var$se = $22f44c32aa84ec90$var$le(1), $22f44c32aa84ec90$var$fe = $22f44c32aa84ec90$var$le(2);
function $22f44c32aa84ec90$var$_e(e) {
    return RegExp("^" + (1 === e ? $22f44c32aa84ec90$var$se : $22f44c32aa84ec90$var$fe));
}
const $22f44c32aa84ec90$var$de = $22f44c32aa84ec90$var$_e(1), $22f44c32aa84ec90$var$pe = $22f44c32aa84ec90$var$_e(2);
function $22f44c32aa84ec90$var$ye(e) {
    return RegExp("^" + (1 === e ? $22f44c32aa84ec90$var$se : $22f44c32aa84ec90$var$fe) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $22f44c32aa84ec90$var$ie : $22f44c32aa84ec90$var$ue) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $22f44c32aa84ec90$var$he = $22f44c32aa84ec90$var$ye(1), $22f44c32aa84ec90$var$ge = $22f44c32aa84ec90$var$ye(2);
function $22f44c32aa84ec90$var$me(e) {
    const n = 1 === e ? $22f44c32aa84ec90$var$ie : $22f44c32aa84ec90$var$ue;
    return RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
}
const $22f44c32aa84ec90$var$ke = $22f44c32aa84ec90$var$me(1), $22f44c32aa84ec90$var$xe = $22f44c32aa84ec90$var$me(2);
function $22f44c32aa84ec90$var$qe(e, n) {
    const r = 1 === n, t = r ? $22f44c32aa84ec90$var$ke : $22f44c32aa84ec90$var$xe, o = r ? $22f44c32aa84ec90$var$he : $22f44c32aa84ec90$var$ge, a = r ? $22f44c32aa84ec90$var$de : $22f44c32aa84ec90$var$pe;
    return {
        t: (e)=>a.test(e),
        o: $22f44c32aa84ec90$var$je(function(e, n) {
            const r = $22f44c32aa84ec90$var$ce.exec(n.prevCapture);
            return r && (n.list || !n.inline && !n.simple) ? t.exec(e = r[1] + e) : null;
        }),
        i: 1,
        u (e, n, t) {
            const c = r ? +e[2] : void 0, i = e[0].replace($22f44c32aa84ec90$var$l, "\n").match(o);
            let u = !1;
            return {
                items: i.map(function(e, r) {
                    const o = a.exec(e)[0].length, c = RegExp("^ {1," + o + "}", "gm"), l = e.replace(c, "").replace(a, ""), s = r === i.length - 1, f = -1 !== l.indexOf("\n\n") || s && u;
                    u = f;
                    const _ = t.inline, d = t.list;
                    let p;
                    t.list = !0, f ? (t.inline = !1, p = $22f44c32aa84ec90$var$Se(l) + "\n\n") : (t.inline = !0, p = $22f44c32aa84ec90$var$Se(l));
                    const y = n(p, t);
                    return t.inline = _, t.list = d, y;
                }),
                ordered: r,
                start: c
            };
        },
        l: (n, r, t)=>e(n.ordered ? "ol" : "ul", {
                key: t.key,
                start: "20" === n.type ? n.start : void 0
            }, n.items.map(function(n, o) {
                return e("li", {
                    key: o
                }, r(n, t));
            }))
    };
}
const $22f44c32aa84ec90$var$ve = RegExp("^\\[((?:\\[[^\\[\\]]*(?:\\[[^\\[\\]]*\\][^\\[\\]]*)*\\]|[^\\[\\]])*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $22f44c32aa84ec90$var$be = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/;
function $22f44c32aa84ec90$var$$e(e) {
    return "string" == typeof e;
}
function $22f44c32aa84ec90$var$Se(e) {
    let n = e.length;
    for(; n > 0 && e[n - 1] <= " ";)n--;
    return e.slice(0, n);
}
function $22f44c32aa84ec90$var$ze(e, n) {
    return e.startsWith(n);
}
function $22f44c32aa84ec90$var$Ee(e, n, r) {
    if (Array.isArray(r)) {
        for(let n = 0; n < r.length; n++)if ($22f44c32aa84ec90$var$ze(e, r[n])) return !0;
        return !1;
    }
    return r(e, n);
}
function $22f44c32aa84ec90$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $22f44c32aa84ec90$var$Re(e) {
    return $22f44c32aa84ec90$var$H.test(e) ? "right" : $22f44c32aa84ec90$var$U.test(e) ? "center" : $22f44c32aa84ec90$var$V.test(e) ? "left" : null;
}
function $22f44c32aa84ec90$var$Be(e, n, r, t) {
    const o = r.inTable;
    r.inTable = !0;
    let a = [
        []
    ], c = "";
    function i() {
        if (!c) return;
        const e = a[a.length - 1];
        e.push.apply(e, n(c, r)), c = "";
    }
    return e.trim().split(/(`[^`]*`|\\\||\|)/).filter(Boolean).forEach((e, n, r)=>{
        "|" === e.trim() && (i(), t) ? 0 !== n && n !== r.length - 1 && a.push([]) : c += e;
    }), i(), r.inTable = o, a;
}
function $22f44c32aa84ec90$var$Le(e, n, r) {
    r.inline = !0;
    const t = e[2] ? e[2].replace($22f44c32aa84ec90$var$G, "").split("|").map($22f44c32aa84ec90$var$Re) : [], o = e[3] ? function(e, n, r) {
        return e.trim().split("\n").map(function(e) {
            return $22f44c32aa84ec90$var$Be(e, n, r, !0);
        });
    }(e[3], n, r) : [], a = $22f44c32aa84ec90$var$Be(e[1], n, r, !!o.length);
    return r.inline = !1, o.length ? {
        align: t,
        cells: o,
        header: a,
        type: "25"
    } : {
        children: a,
        type: "21"
    };
}
function $22f44c32aa84ec90$var$Oe(e, n) {
    return null == e.align[n] ? {} : {
        textAlign: e.align[n]
    };
}
function $22f44c32aa84ec90$var$je(e) {
    return e.inline = 1, e;
}
function $22f44c32aa84ec90$var$Ce(e) {
    return $22f44c32aa84ec90$var$je(function(n, r) {
        return r.inline ? e.exec(n) : null;
    });
}
function $22f44c32aa84ec90$var$Ie(e) {
    return $22f44c32aa84ec90$var$je(function(n, r) {
        return r.inline || r.simple ? e.exec(n) : null;
    });
}
function $22f44c32aa84ec90$var$Te(e) {
    return function(n, r) {
        return r.inline || r.simple ? null : e.exec(n);
    };
}
function $22f44c32aa84ec90$var$Me(e) {
    return $22f44c32aa84ec90$var$je(function(n) {
        return e.exec(n);
    });
}
const $22f44c32aa84ec90$var$we = /(javascript|vbscript|data(?!:image)):/i;
function $22f44c32aa84ec90$export$3e2338ea76b578c9(e) {
    try {
        const n = decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "");
        if ($22f44c32aa84ec90$var$we.test(n)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $22f44c32aa84ec90$var$Fe(e) {
    return e ? e.replace($22f44c32aa84ec90$var$re, "$1") : e;
}
function $22f44c32aa84ec90$var$Pe(e, n, r) {
    const t = r.inline || !1, o = r.simple || !1;
    r.inline = !0, r.simple = !0;
    const a = e(n, r);
    return r.inline = t, r.simple = o, a;
}
function $22f44c32aa84ec90$var$Ze(e, n, r) {
    const t = r.inline || !1, o = r.simple || !1;
    r.inline = !1, r.simple = !0;
    const a = e(n, r);
    return r.inline = t, r.simple = o, a;
}
function $22f44c32aa84ec90$var$Ne(e, n, r) {
    const t = r.inline || !1;
    r.inline = !1;
    const o = e(n, r);
    return r.inline = t, o;
}
const $22f44c32aa84ec90$var$Ge = (e, n, r)=>({
        children: $22f44c32aa84ec90$var$Pe(n, e[2], r)
    });
function $22f44c32aa84ec90$var$Ue() {
    return {};
}
function $22f44c32aa84ec90$var$Ve() {
    return null;
}
function $22f44c32aa84ec90$var$He(...e) {
    return e.filter(Boolean).join(" ");
}
function $22f44c32aa84ec90$var$Qe(e, n, r) {
    let t = e;
    const o = n.split(".");
    for(; o.length && (t = t[o[0]], void 0 !== t);)o.shift();
    return t || r;
}
function $22f44c32aa84ec90$export$69f434acfbdb0b32(r = "", t = {}) {
    t.overrides = t.overrides || {}, t.namedCodesToUnicode = t.namedCodesToUnicode ? $22f44c32aa84ec90$var$n({}, $22f44c32aa84ec90$var$a, t.namedCodesToUnicode) : $22f44c32aa84ec90$var$a;
    const l = t.slugify || $22f44c32aa84ec90$export$c383cdd2a518017a, G = t.sanitizer || $22f44c32aa84ec90$export$3e2338ea76b578c9, U = t.createElement || $cozmU.createElement, V = [
        $22f44c32aa84ec90$var$s,
        $22f44c32aa84ec90$var$y,
        $22f44c32aa84ec90$var$h,
        t.enforceAtxHeadings ? $22f44c32aa84ec90$var$z : $22f44c32aa84ec90$var$S,
        $22f44c32aa84ec90$var$E,
        $22f44c32aa84ec90$var$M,
        $22f44c32aa84ec90$var$ke,
        $22f44c32aa84ec90$var$xe
    ], H = [
        ...V,
        $22f44c32aa84ec90$var$w,
        $22f44c32aa84ec90$var$A,
        $22f44c32aa84ec90$var$B,
        $22f44c32aa84ec90$var$O
    ];
    function Q(e, n) {
        for(let r = 0; r < e.length; r++)if (e[r].test(n)) return !0;
        return !1;
    }
    function W(e, r, ...o) {
        const a = $22f44c32aa84ec90$var$Qe(t.overrides, e + ".props", {});
        return U(function(e, n) {
            const r = $22f44c32aa84ec90$var$Qe(n, e);
            return r ? "function" == typeof r || "object" == typeof r && "render" in r ? r : $22f44c32aa84ec90$var$Qe(n, e + ".component", e) : e;
        }(e, t.overrides), $22f44c32aa84ec90$var$n({}, r, a, {
            className: $22f44c32aa84ec90$var$He(null == r ? void 0 : r.className, a.className) || void 0
        }), ...o);
    }
    function re(e) {
        e = e.replace($22f44c32aa84ec90$var$b, "");
        let n = !1;
        t.forceInline ? n = !0 : t.forceBlock || (n = !1 === $22f44c32aa84ec90$var$Z.test(e));
        const r = fe(se(n ? e : $22f44c32aa84ec90$var$Se(e).replace($22f44c32aa84ec90$var$oe, "") + "\n\n", {
            inline: n
        }));
        for(; $22f44c32aa84ec90$var$$e(r[r.length - 1]) && !r[r.length - 1].trim();)r.pop();
        if (null === t.wrapper) return r;
        const o = t.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || t.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? W("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return U(o, {
            key: "outer"
        }, a);
    }
    function ce(e, n) {
        if (!n || !n.trim()) return null;
        const r = n.match($22f44c32aa84ec90$var$u);
        return r ? r.reduce(function(n, r) {
            const t = r.indexOf("=");
            if (-1 !== t) {
                const a = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($22f44c32aa84ec90$var$L) && (e = e.replace($22f44c32aa84ec90$var$T, function(e, n) {
                        return n.toUpperCase();
                    })), e;
                })(r.slice(0, t)).trim(), c = function(e) {
                    const n = e[0];
                    return ('"' === n || "'" === n) && e.length >= 2 && e[e.length - 1] === n ? e.slice(1, -1) : e;
                }(r.slice(t + 1).trim()), u = $22f44c32aa84ec90$var$o[a] || a;
                if ("ref" === u) return n;
                const l = n[u] = function(e, n, r, t) {
                    return "style" === n ? (function(e) {
                        const n = [];
                        let r = "", t = !1, o = !1, a = "";
                        if (!e) return n;
                        for(let c = 0; c < e.length; c++){
                            const i = e[c];
                            if ('"' !== i && "'" !== i || t || (o ? i === a && (o = !1, a = "") : (o = !0, a = i)), "(" === i && r.endsWith("url") ? t = !0 : ")" === i && t && (t = !1), ";" !== i || o || t) r += i;
                            else {
                                const e = r.trim();
                                if (e) {
                                    const r = e.indexOf(":");
                                    if (r > 0) {
                                        const t = e.slice(0, r).trim(), o = e.slice(r + 1).trim();
                                        n.push([
                                            t,
                                            o
                                        ]);
                                    }
                                }
                                r = "";
                            }
                        }
                        const c = r.trim();
                        if (c) {
                            const e = c.indexOf(":");
                            if (e > 0) {
                                const r = c.slice(0, e).trim(), t = c.slice(e + 1).trim();
                                n.push([
                                    r,
                                    t
                                ]);
                            }
                        }
                        return n;
                    })(r).reduce(function(n, [r, o]) {
                        return n[r.replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t(o, e, r), n;
                    }, {}) : -1 !== $22f44c32aa84ec90$var$i.indexOf(n) ? t($22f44c32aa84ec90$var$Fe(r), e, n) : (r.match($22f44c32aa84ec90$var$j) && (r = $22f44c32aa84ec90$var$Fe(r.slice(1, r.length - 1))), "true" === r || "false" !== r && r);
                }(e, a, c, G);
                "string" == typeof l && ($22f44c32aa84ec90$var$A.test(l) || $22f44c32aa84ec90$var$O.test(l)) && (n[u] = re(l.trim()));
            } else "style" !== r && (n[$22f44c32aa84ec90$var$o[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    const ie = [], ue = {}, le = {
        0: {
            t: [
                ">"
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$s),
            i: 1,
            u (e, n, r) {
                const [, t, o] = e[0].replace($22f44c32aa84ec90$var$f, "").match($22f44c32aa84ec90$var$_);
                return {
                    alert: t,
                    children: n(o, r)
                };
            },
            l (e, n, r) {
                const t = {
                    key: r.key
                };
                return e.alert && (t.className = "markdown-alert-" + l(e.alert.toLowerCase(), $22f44c32aa84ec90$export$c383cdd2a518017a), e.children.unshift({
                    attrs: {},
                    children: [
                        {
                            type: "27",
                            text: e.alert
                        }
                    ],
                    noInnerParse: !0,
                    type: "11",
                    tag: "header"
                })), W("blockquote", t, n(e.children, r));
            }
        },
        1: {
            t: [
                "  "
            ],
            o: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$d),
            i: 1,
            u: $22f44c32aa84ec90$var$Ue,
            l: (e, n, r)=>W("br", {
                    key: r.key
                })
        },
        2: {
            t: [
                "--",
                "__",
                "**",
                "- ",
                "* ",
                "_ "
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$p),
            i: 1,
            u: $22f44c32aa84ec90$var$Ue,
            l: (e, n, r)=>W("hr", {
                    key: r.key
                })
        },
        3: {
            t: [
                "    "
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$h),
            i: 0,
            u: (e)=>({
                    lang: void 0,
                    text: $22f44c32aa84ec90$var$Fe($22f44c32aa84ec90$var$Se(e[0].replace(/^ {4}/gm, "")))
                }),
            l: (e, r, t)=>W("pre", {
                    key: t.key
                }, W("code", $22f44c32aa84ec90$var$n({}, e.attrs, {
                    className: e.lang ? "lang-" + e.lang : ""
                }), e.text))
        },
        4: {
            t: [
                "```",
                "~~~"
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$y),
            i: 0,
            u: (e)=>({
                    attrs: ce("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: "3"
                })
        },
        5: {
            t: [
                "`"
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$g),
            i: 3,
            u: (e)=>({
                    text: $22f44c32aa84ec90$var$Fe(e[2])
                }),
            l: (e, n, r)=>W("code", {
                    key: r.key
                }, e.text)
        },
        6: {
            t: [
                "[^"
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$x),
            i: 0,
            u: (e)=>(ie.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            l: $22f44c32aa84ec90$var$Ve
        },
        7: {
            t: [
                "[^"
            ],
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$q),
            i: 1,
            u: (e)=>({
                    target: "#" + l(e[1], $22f44c32aa84ec90$export$c383cdd2a518017a),
                    text: e[1]
                }),
            l: (e, n, r)=>W("a", {
                    key: r.key,
                    href: G(e.target, "a", "href")
                }, W("sup", {
                    key: r.key
                }, e.text))
        },
        8: {
            t: [
                "[ ]",
                "[x]"
            ],
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$$),
            i: 1,
            u: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            l: (e, n, r)=>W("input", {
                    checked: e.completed,
                    key: r.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        9: {
            t: [
                "#"
            ],
            o: $22f44c32aa84ec90$var$Te(t.enforceAtxHeadings ? $22f44c32aa84ec90$var$z : $22f44c32aa84ec90$var$S),
            i: 1,
            u: (e, n, r)=>({
                    children: $22f44c32aa84ec90$var$Pe(n, e[2], r),
                    id: l(e[2], $22f44c32aa84ec90$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            l: (e, n, r)=>W("h" + e.level, {
                    id: e.id,
                    key: r.key
                }, n(e.children, r))
        },
        10: {
            t: (e)=>{
                const n = e.indexOf("\n");
                return n > 0 && n < e.length - 1 && ("=" === e[n + 1] || "-" === e[n + 1]);
            },
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$E),
            i: 1,
            u: (e, n, r)=>({
                    children: $22f44c32aa84ec90$var$Pe(n, e[1], r),
                    level: "=" === e[2] ? 1 : 2,
                    type: "9"
                })
        },
        11: {
            t: [
                "<"
            ],
            o: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$A),
            i: 1,
            u (e, n, r) {
                const [, t] = e[3].match($22f44c32aa84ec90$var$ae), o = RegExp("^" + t, "gm"), a = e[3].replace(o, ""), i = Q(H, a) ? $22f44c32aa84ec90$var$Ne : $22f44c32aa84ec90$var$Pe, u = e[1].toLowerCase(), l = -1 !== $22f44c32aa84ec90$var$c.indexOf(u), s = (l ? u : e[1]).trim(), f = {
                    attrs: ce(s, e[2]),
                    noInnerParse: l,
                    tag: s
                };
                if (r.inAnchor = r.inAnchor || "a" === u, l) f.text = e[3];
                else {
                    const e = r.inHTML;
                    r.inHTML = !0, f.children = i(n, a, r), r.inHTML = e;
                }
                return r.inAnchor = !1, f;
            },
            l: (e, r, t)=>W(e.tag, $22f44c32aa84ec90$var$n({
                    key: t.key
                }, e.attrs), e.text || (e.children ? r(e.children, t) : ""))
        },
        13: {
            t: [
                "<"
            ],
            o: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$O),
            i: 1,
            u (e) {
                const n = e[1].trim();
                return {
                    attrs: ce(n, e[2] || ""),
                    tag: n
                };
            },
            l: (e, r, t)=>W(e.tag, $22f44c32aa84ec90$var$n({}, e.attrs, {
                    key: t.key
                }))
        },
        12: {
            t: [
                "\x3c!--"
            ],
            o: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$B),
            i: 1,
            u: ()=>({}),
            l: $22f44c32aa84ec90$var$Ve
        },
        14: {
            t: [
                "!["
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$be),
            i: 1,
            u: (e)=>({
                    alt: $22f44c32aa84ec90$var$Fe(e[1]),
                    target: $22f44c32aa84ec90$var$Fe(e[2]),
                    title: $22f44c32aa84ec90$var$Fe(e[3])
                }),
            l: (e, n, r)=>W("img", {
                    key: r.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: G(e.target, "img", "src")
                })
        },
        15: {
            t: [
                "["
            ],
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$ve),
            i: 3,
            u: (e, n, r)=>({
                    children: $22f44c32aa84ec90$var$Ze(n, e[1], r),
                    target: $22f44c32aa84ec90$var$Fe(e[2]),
                    title: $22f44c32aa84ec90$var$Fe(e[3])
                }),
            l: (e, n, r)=>W("a", {
                    key: r.key,
                    href: G(e.target, "a", "href"),
                    title: e.title
                }, n(e.children, r))
        },
        16: {
            t: [
                "<"
            ],
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$I),
            i: 0,
            u (e) {
                let n = e[1], r = !1;
                return -1 !== n.indexOf("@") && -1 === n.indexOf("//") && (r = !0, n = n.replace("mailto:", "")), {
                    children: [
                        {
                            text: n,
                            type: "27"
                        }
                    ],
                    target: r ? "mailto:" + n : n,
                    type: "15"
                };
            }
        },
        17: {
            t: (e, n)=>!n.inAnchor && !t.disableAutoLink && ($22f44c32aa84ec90$var$ze(e, "http://") || $22f44c32aa84ec90$var$ze(e, "https://")),
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$C),
            i: 0,
            u: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: "27"
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: "15"
                })
        },
        20: $22f44c32aa84ec90$var$qe(W, 1),
        33: $22f44c32aa84ec90$var$qe(W, 2),
        19: {
            t: [
                "\n"
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$m),
            i: 3,
            u: $22f44c32aa84ec90$var$Ue,
            l: ()=>"\n"
        },
        21: {
            o: $22f44c32aa84ec90$var$je(function(e, n) {
                if (n.inline || n.simple || n.inHTML && -1 === e.indexOf("\n\n") && -1 === n.prevCapture.indexOf("\n\n")) return null;
                let r = "", t = 0;
                for(;;){
                    const n = e.indexOf("\n", t), o = e.slice(t, -1 === n ? void 0 : n + 1);
                    if (Q(V, o)) break;
                    if (r += o, -1 === n || !o.trim()) break;
                    t = n + 1;
                }
                const o = $22f44c32aa84ec90$var$Se(r);
                return "" === o ? null : [
                    r,
                    ,
                    o
                ];
            }),
            i: 3,
            u: $22f44c32aa84ec90$var$Ge,
            l: (e, n, r)=>W("p", {
                    key: r.key
                }, n(e.children, r))
        },
        22: {
            t: [
                "["
            ],
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$D),
            i: 0,
            u: (e)=>(ue[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            l: $22f44c32aa84ec90$var$Ve
        },
        23: {
            t: [
                "!["
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$F),
            i: 0,
            u: (e)=>({
                    alt: e[1] ? $22f44c32aa84ec90$var$Fe(e[1]) : void 0,
                    ref: e[2]
                }),
            l: (e, n, r)=>ue[e.ref] ? W("img", {
                    key: r.key,
                    alt: e.alt,
                    src: G(ue[e.ref].target, "img", "src"),
                    title: ue[e.ref].title
                }) : null
        },
        24: {
            t: (e)=>"[" === e[0] && -1 === e.indexOf("]("),
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$P),
            i: 0,
            u: (e, n, r)=>({
                    children: n(e[1], r),
                    fallbackChildren: e[0],
                    ref: e[2]
                }),
            l: (e, n, r)=>ue[e.ref] ? W("a", {
                    key: r.key,
                    href: G(ue[e.ref].target, "a", "href"),
                    title: ue[e.ref].title
                }, n(e.children, r)) : W("span", {
                    key: r.key
                }, e.fallbackChildren)
        },
        25: {
            t: [
                "|"
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$M),
            i: 1,
            u: $22f44c32aa84ec90$var$Le,
            l (e, n, r) {
                const t = e;
                return W("table", {
                    key: r.key
                }, W("thead", null, W("tr", null, t.header.map(function(e, o) {
                    return W("th", {
                        key: o,
                        style: $22f44c32aa84ec90$var$Oe(t, o)
                    }, n(e, r));
                }))), W("tbody", null, t.cells.map(function(e, o) {
                    return W("tr", {
                        key: o
                    }, e.map(function(e, o) {
                        return W("td", {
                            key: o,
                            style: $22f44c32aa84ec90$var$Oe(t, o)
                        }, n(e, r));
                    }));
                })));
            }
        },
        27: {
            o: $22f44c32aa84ec90$var$je(function(e, n) {
                let r;
                return $22f44c32aa84ec90$var$ze(e, ":") && (r = $22f44c32aa84ec90$var$ee.exec(e)), r || $22f44c32aa84ec90$var$te.exec(e);
            }),
            i: 4,
            u (e) {
                const n = e[0];
                return {
                    text: -1 === n.indexOf("&") ? n : n.replace($22f44c32aa84ec90$var$R, (e, n)=>t.namedCodesToUnicode[n] || e)
                };
            },
            l: (e)=>e.text
        },
        28: {
            t: [
                "**",
                "__"
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$J),
            i: 2,
            u: (e, n, r)=>({
                    children: n(e[2], r)
                }),
            l: (e, n, r)=>W("strong", {
                    key: r.key
                }, n(e.children, r))
        },
        29: {
            t: (e)=>{
                const n = e[0];
                return ("*" === n || "_" === n) && e[1] !== n;
            },
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$K),
            i: 3,
            u: (e, n, r)=>({
                    children: n(e[2], r)
                }),
            l: (e, n, r)=>W("em", {
                    key: r.key
                }, n(e.children, r))
        },
        30: {
            t: [
                "\\"
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$ne),
            i: 1,
            u: (e)=>({
                    text: e[1],
                    type: "27"
                })
        },
        31: {
            t: [
                "=="
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$X),
            i: 3,
            u: $22f44c32aa84ec90$var$Ge,
            l: (e, n, r)=>W("mark", {
                    key: r.key
                }, n(e.children, r))
        },
        32: {
            t: [
                "~~"
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$Y),
            i: 3,
            u: $22f44c32aa84ec90$var$Ge,
            l: (e, n, r)=>W("del", {
                    key: r.key
                }, n(e.children, r))
        }
    };
    !0 === t.disableParsingRawHTML && (delete le[11], delete le[13]);
    const se = function(e) {
        var n = Object.keys(e);
        function r(t, o) {
            var a = [];
            if (o.prevCapture = o.prevCapture || "", t.trim()) for(; t;)for(var c = 0; c < n.length;){
                var i = n[c], u = e[i];
                if (!u.t || $22f44c32aa84ec90$var$Ee(t, o, u.t)) {
                    var l = u.o(t, o);
                    if (l && l[0]) {
                        t = t.substring(l[0].length);
                        var s = u.u(l, r, o);
                        o.prevCapture += l[0], s.type || (s.type = i), a.push(s);
                        break;
                    }
                    c++;
                } else c++;
            }
            return o.prevCapture = "", a;
        }
        return n.sort(function(n, r) {
            return e[n].i - e[r].i || (n < r ? -1 : 1);
        }), function(e, n) {
            return r(function(e) {
                return e.replace($22f44c32aa84ec90$var$k, "\n").replace($22f44c32aa84ec90$var$v, "").replace($22f44c32aa84ec90$var$N, "    ");
            }(e), n);
        };
    }(le), fe = function(e, n) {
        return function r(t, o = {}) {
            if (Array.isArray(t)) {
                const e = o.key, n = [];
                let a = !1;
                for(let e = 0; e < t.length; e++){
                    o.key = e;
                    const c = r(t[e], o), i = $22f44c32aa84ec90$var$$e(c);
                    i && a ? n[n.length - 1] += c : null !== c && n.push(c), a = i;
                }
                return o.key = e, n;
            }
            return function(r, t, o) {
                const a = e[r.type].l;
                return n ? n(()=>a(r, t, o), r, t, o) : a(r, t, o);
            }(t, r, o);
        };
    }(le, t.renderRule), _e = re(r);
    return ie.length ? W("div", null, _e, W("footer", {
        key: "footer"
    }, ie.map(function(e) {
        return W("div", {
            id: l(e.identifier, $22f44c32aa84ec90$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, fe(se(e.footnote, {
            inline: !0
        })));
    }))) : _e;
}
var $22f44c32aa84ec90$export$2e2bcd8739ae039 = (n)=>{
    let { children: t, options: o } = n, a = function(e, n) {
        if (null == e) return {};
        var r, t, o = {}, a = Object.keys(e);
        for(t = 0; t < a.length; t++)n.indexOf(r = a[t]) >= 0 || (o[r] = e[r]);
        return o;
    }(n, $22f44c32aa84ec90$var$r);
    return $cozmU.cloneElement($22f44c32aa84ec90$export$69f434acfbdb0b32(null == t ? "" : t, o), a);
};
 //# sourceMappingURL=index.modern.js.map

});

parcelRegister("4nIKB", function(module, exports) {

var $7ZH1D = parcelRequire("7ZH1D");


var $04KxR = parcelRequire("04KxR");

function $330c05f262f9f947$export$c9058316764c140e(refs) {
    return (0, $04KxR.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $7ZH1D.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $330c05f262f9f947$export$c9058316764c140e;

});

parcelRegister("04KxR", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $00e47aba7bcb22e2$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $00e47aba7bcb22e2$export$35a19128eb4acba4;

});

parcelRegister("lUcpS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $k78uC = parcelRequire("k78uC");


var $8IfK6 = parcelRequire("8IfK6");

const $91b0a64470223be6$export$5bf35293e545f20c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (...t1)=>{
            const params = t1;
            const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
            event.fire((0, $k78uC.EVENT_CHANNEL));
        };
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const fireEvent = t0;
    let t1;
    if ($[2] !== fireEvent) {
        t1 = {
            fireEvent: fireEvent
        };
        $[2] = fireEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireEvent = (0, $cozmU.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
        event.fire((0, $k78uC.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $91b0a64470223be6$export$5bf35293e545f20c;

});

parcelRegister("k78uC", function(module, exports) {
const $0de3cce3bcdfa361$export$3f072f06b90c3985 = 'peopleTeams';
module.exports["EVENT_CHANNEL"] = $0de3cce3bcdfa361$export$3f072f06b90c3985;

});

parcelRegister("8IfK6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::378c0a04d2cca8641793d5a92fac3d1a>>
 * @codegenCommand afm workspace @atlassian/analytics-tooling analytics:codegen teams-app-internal-analytics
 */ const $fcb00cbaaafbad36$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $fcb00cbaaafbad36$export$2e2bcd8739ae039 = $fcb00cbaaafbad36$var$createEventPayload;
module.exports["default"] = $fcb00cbaaafbad36$export$2e2bcd8739ae039;

});

parcelRegister("cSSWJ", function(module, exports) {
const $e8b102093dcaac45$export$849551cf61929d4f = {
    packageName: "platform-pkg" ?? '',
    packageVersion: "0.0.0-use.local" ?? ''
};
const $e8b102093dcaac45$export$efd16d9cf43b6e97 = 'teamProfileCard';
const $e8b102093dcaac45$export$7611b3e6899481f9 = 'profilecard';
const $e8b102093dcaac45$export$4c23d6e68fa71371 = 'rovoAgentProfilecard';
module.exports["PACKAGE_META_DATA"] = $e8b102093dcaac45$export$849551cf61929d4f;
module.exports["TEAM_SUBJECT"] = $e8b102093dcaac45$export$efd16d9cf43b6e97;
module.exports["USER_SUBJECT"] = $e8b102093dcaac45$export$7611b3e6899481f9;
module.exports["AGENT_SUBJECT"] = $e8b102093dcaac45$export$4c23d6e68fa71371;

});

parcelRegister("4PAHv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $7G50J = parcelRequire("7G50J");


var $hMCZS = parcelRequire("hMCZS");


var $lUcpS = parcelRequire("lUcpS");


var $dSW04 = parcelRequire("dSW04");


var $dRAjC = parcelRequire("dRAjC");


var $4k5Wq = parcelRequire("4k5Wq");


var $kb2tZ = parcelRequire("kb2tZ");


var $hIwXM = parcelRequire("hIwXM");

const $fe1c8bc12e81e628$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $cozmU.useState)();
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)();
    const [isPermitted, setIsPermitted] = (0, $cozmU.useState)(true);
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const creatorUserId = (0, $cozmU.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $dRAjC.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const navResult = (0, $hMCZS.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: creatorUserId || ''
        },
        cloudId: props.cloudId
    });
    let profileHref = navResult.href;
    const getCreator = (0, $cozmU.useCallback)(async ({ creator_type: creator_type, creator: creator, authoringTeam: authoringTeam })=>{
        try {
            let userCreatorInfo;
            const currentCreatorUserId = creator_type === 'CUSTOMER' && creator ? (0, $dRAjC.getAAIDFromARI)(creator) : undefined;
            if (currentCreatorUserId && props.cloudId) {
                userCreatorInfo = await props.resourceClient.getProfile(props.cloudId, currentCreatorUserId, fireEvent);
                profileHref = (0, $hMCZS.navigateToTeamsApp)({
                    type: 'USER',
                    payload: {
                        userId: currentCreatorUserId
                    },
                    cloudId: props.cloudId
                }).href;
            }
            const creatorInfo = (0, $7G50J.getAgentCreator)({
                creatorType: creator_type,
                authoringTeam: authoringTeam ? {
                    displayName: authoringTeam.displayName ?? '',
                    profileLink: authoringTeam.profileUrl ?? undefined
                } : undefined,
                userCreator: userCreatorInfo ? {
                    name: userCreatorInfo.fullName ?? '',
                    profileLink: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${currentCreatorUserId}`
                } : undefined,
                forgeCreator: creator ?? undefined
            });
            return creatorInfo;
        } catch  {
            return undefined;
        }
    }, [
        fireEvent,
        props.cloudId,
        props.resourceClient,
        profileHref
    ]);
    const fetchData = (0, $cozmU.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileResult = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireEvent);
            const profileData = profileResult.restData;
            const creatorInfoProps = {
                creator_type: profileData?.creator_type,
                creator: profileData?.creator || undefined,
                authoringTeam: profileResult.aggData?.authoringTeam ?? undefined
            };
            const agentCreatorInfo = await getCreator(creatorInfoProps);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            if (err instanceof (0, $dSW04.AgentForbiddenError)) setIsPermitted(false);
            else setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireEvent,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    // Depend on accountId rather than fetchData to avoid a re-fetch loop:
    // agentData changes → creatorUserId → getCreator → fetchData ref changes → useEffect re-fires.
    // Reset state on accountId change so stale data from the previous agent isn't briefly shown.
    (0, $cozmU.useEffect)(()=>{
        setAgentData(undefined);
        setError(undefined);
        setIsLoading(true);
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.accountId
    ]);
    const forbiddenAgent = (0, $cozmU.useMemo)(()=>(0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') ? {
            id: '',
            named_id: '',
            name: props.agentName ?? '',
            description: '\u00A0',
            creator_type: 'CUSTOMER',
            is_default: false,
            actor_type: 'AGENT',
            user_defined_conversation_starters: null,
            favourite: false,
            favourite_count: 0,
            identity_account_id: props.accountId,
            creatorInfo: undefined
        } : undefined, [
        props.agentName,
        props.accountId
    ]);
    if (!isPermitted) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb2tZ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hIwXM.AgentProfileCardLazy), {
                agent: (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') ? forbiddenAgent : {
                    id: '',
                    named_id: '',
                    name: props.agentName ?? '',
                    description: '\u00A0',
                    creator_type: 'CUSTOMER',
                    is_default: false,
                    actor_type: 'AGENT',
                    user_defined_conversation_starters: null,
                    favourite: false,
                    favourite_count: 0,
                    identity_account_id: props.accountId,
                    creatorInfo: undefined
                },
                isLoading: false,
                resourceClient: props.resourceClient,
                cloudId: props.cloudId,
                hideAgentActions: true,
                hideConversationStarters: true,
                hideAiDisclaimer: true,
                hideStarButton: props.hideStarButton,
                showCreatorNameWithoutLink: props.showCreatorNameWithoutLink,
                footerComponent: props.footerComponent
            })
        })
    });
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb2tZ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4k5Wq.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: fireEvent
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hIwXM.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId,
            onDeleteAgent: props.onDeleteAgent,
            hideMoreActions: props.hideMoreActions,
            hideAiDisclaimer: props.hideAiDisclaimer,
            hideConversationStarters: props.hideConversationStarters,
            hideAgentActions: props.hideAgentActions,
            hideStarButton: props.hideStarButton,
            showCreatorNameWithoutLink: props.showCreatorNameWithoutLink,
            footerComponent: props.footerComponent
        })
    });
};
module.exports["AgentProfileCardResourced"] = $fe1c8bc12e81e628$export$4b013ffffcb40af8;

});

parcelRegister("7G50J", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $i1t43 = parcelRequire("i1t43");


var $etoPX = parcelRequire("etoPX");


var $NlHoa = parcelRequire("NlHoa");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");


var $6h4xM = parcelRequire("6h4xM");


var $i4kCF = parcelRequire("i4kCF");


var $hq9Cp = parcelRequire("hq9Cp");


var $fNIRw = parcelRequire("fNIRw");

const $f5fec235121c7193$var$styles = {
    clickableItem: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
    rovoIconWrapper: "_3iDTPbQ4SZ",
    name: "_37wbyuI7V3 _0hPCNLchRC",
    description: "_3SamIHPgdg _3zvHkHdC7N _3W2Oc8wPeg",
    headingWrapper: "_1mT5xdRAKS",
    hiddenIconWrapper: "_313842FQfX"
};
const $f5fec235121c7193$export$7cbebf266a9bcc3c = ({ creatorType: creatorType, authoringTeam: authoringTeam, userCreator: userCreator, forgeCreator: forgeCreator })=>{
    if (creatorType === 'SYSTEM') return {
        type: 'SYSTEM'
    };
    if ((0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(creatorType) : creatorType === 'FORGE' || creatorType === 'THIRD_PARTY' // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
    ) return {
        // @todo: remove cast in rovo_agent_support_a2a_avatar cleanup
        type: (0, $iDrrr.fg)('jira_improve_agent_profile_for_a2a') ? creatorType : 'FORGE',
        name: forgeCreator ?? ''
    };
    if (creatorType === 'OOTB') return {
        type: 'OOTB'
    };
    if (creatorType === 'CUSTOMER') {
        if (authoringTeam) return {
            type: 'CUSTOMER',
            name: authoringTeam.displayName,
            profileLink: authoringTeam.profileLink ?? ''
        };
        if (!userCreator?.profileLink) return undefined;
        return {
            type: 'CUSTOMER',
            name: userCreator.name,
            profileLink: userCreator.profileLink,
            status: userCreator.status
        };
    }
    return;
};
const $f5fec235121c7193$export$f35b2eeaa7e3db15 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading, showCreatorNameWithoutLink: t1 } = t0;
    const showCreatorNameWithoutLink = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== creator || $[1] !== formatMessage || $[2] !== isLoading || $[3] !== onCreatorLinkClick || $[4] !== showCreatorNameWithoutLink) {
        const getCreatorRender = ()=>{
            if (isLoading) return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                    testId: "agent-profile-creator-skeleton",
                    isShimmering: true,
                    height: 18,
                    width: 100
                })
            });
            if (!creator) return null;
            if (creator.type === "SYSTEM" || creator.type === "OOTB") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    testId: "atlassian-icon"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                    label: "",
                    size: "small",
                    appearance: "brand"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"))
            });
            if (creator.type === "CUSTOMER") {
                const creatorName = `${creator.name} ${creator.status === "inactive" ? formatMessage((0, $fNIRw.messages).agentDeactivated) : ""}`;
                return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                    creatorNameWithLink: showCreatorNameWithoutLink ? creatorName : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                        href: creator.profileLink,
                        onClick: ()=>onCreatorLinkClick(),
                        target: "_blank"
                    }, creatorName)
                });
            }
            if (creator.type === "REMOTE_A2A") return formatMessage((0, $fNIRw.messages).remoteAgentCreatedBy, {
                creatorNameWithLink: creator.name
            });
            if (creator.type === "THIRD_PARTY" || creator.type === "FORGE") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: creator.name
            });
            return null;
        };
        t2 = getCreatorRender();
        $[0] = creator;
        $[1] = formatMessage;
        $[2] = isLoading;
        $[3] = onCreatorLinkClick;
        $[4] = showCreatorNameWithoutLink;
        $[5] = t2;
    } else t2 = $[5];
    const creatorRender = t2;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $ieeJu.expValEquals)("platform_editor_agent_mentions", "isEnabled", true) && (0, $iDrrr.fg)("platform_editor_agent_mentions_drop_one_fixes") || (0, $iDrrr.fg)("platform_editor_agent_card_fixes");
        $[6] = t3;
    } else t3 = $[6];
    const hideCreatorIcon = t3;
    if ((0, $iDrrr.fg)("jira_improve_agent_profile_for_a2a")) {
        const showRovoIcon = !hideCreatorIcon && creator?.type !== "REMOTE_A2A";
        let t4;
        if ($[7] !== creatorRender || $[8] !== showRovoIcon) {
            t4 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f5fec235121c7193$var$styles.clickableItem
            }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
                testId: "rovo-icon-wrapper",
                "aria-hidden": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
                appearance: "brand",
                size: "small"
            })) : null, creatorRender) : null;
            $[7] = creatorRender;
            $[8] = showRovoIcon;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t4;
    if ($[10] !== creatorRender) {
        t4 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.clickableItem
        }, !hideCreatorIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
            appearance: "brand",
            size: "small"
        })), creatorRender) : null;
        $[10] = creatorRender;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ({ creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading, showCreatorNameWithoutLink: showCreatorNameWithoutLink = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const getCreatorRender = ()=>{
        if (isLoading) return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                testId: "agent-profile-creator-skeleton",
                isShimmering: true,
                height: 18,
                width: 100
            })
        });
        if (!creator) return null;
        if (creator.type === 'SYSTEM' || creator.type === 'OOTB') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                testId: "atlassian-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                label: "",
                size: "small",
                appearance: "brand"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"))
        });
        if (creator.type === 'CUSTOMER') {
            const creatorName = `${creator.name} ${creator.status === 'inactive' ? formatMessage((0, $fNIRw.messages).agentDeactivated) : ''}`;
            return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: showCreatorNameWithoutLink ? creatorName : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: creator.profileLink,
                    onClick: ()=>onCreatorLinkClick(),
                    target: "_blank"
                }, creatorName)
            });
        }
        if (creator.type === 'REMOTE_A2A') return formatMessage((0, $fNIRw.messages).remoteAgentCreatedBy, {
            creatorNameWithLink: creator.name
        });
         // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
        if (creator.type === 'THIRD_PARTY' || creator.type === 'FORGE') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: creator.name
        });
        return null;
    };
    const creatorRender = getCreatorRender();
    const hideCreatorIcon = (0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') || (0, $iDrrr.fg)('platform_editor_agent_card_fixes');
    if ((0, $iDrrr.fg)('jira_improve_agent_profile_for_a2a')) {
        const showRovoIcon = !hideCreatorIcon && creator?.type !== 'REMOTE_A2A';
        return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.clickableItem
        }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
            appearance: "brand",
            size: "small"
        })) : null, creatorRender) : null;
    }
    return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.clickableItem
    }, !hideCreatorIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
        testId: "rovo-icon-wrapper",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
        appearance: "brand",
        size: "small"
    })), creatorRender) : null;
};
const $f5fec235121c7193$export$e02348ba0b01a210 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: t1, renderAdditionalContent: renderAdditionalContent } = t0;
    const showStarButton = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== agentName) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "medium"
        }, agentName);
        $[0] = agentName;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== formatMessage || $[3] !== isHidden) {
        t3 = isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.hiddenIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: formatMessage((0, $fNIRw.messages).hiddenTooltip),
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6h4xM.HiddenIcon), {
            label: formatMessage((0, $fNIRw.messages).hiddenIcon)
        })));
        $[2] = formatMessage;
        $[3] = isHidden;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== headingRender || $[6] !== t2 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075",
            xcss: $f5fec235121c7193$var$styles.headingWrapper
        }, t2, headingRender, t3);
        $[5] = headingRender;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== agentName || $[10] !== isStarred || $[11] !== onStarToggle || $[12] !== showStarButton) {
        t5 = showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4kCF.StarIconButton), {
            isStarred: isStarred,
            handleToggle: onStarToggle,
            agentName: agentName
        });
        $[9] = agentName;
        $[10] = isStarred;
        $[11] = onStarToggle;
        $[12] = showStarButton;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $f5fec235121c7193$var$styles.name,
            space: "space.100",
            alignBlock: "center"
        }, t4, t5);
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== agentDescription) {
        t7 = !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.description,
            as: "p"
        }, agentDescription);
        $[17] = agentDescription;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== renderAdditionalContent) {
        t8 = !!renderAdditionalContent && renderAdditionalContent();
        $[19] = renderAdditionalContent;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== creatorRender || $[22] !== starCountRender || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t6, creatorRender, t7, starCountRender, t8);
        $[21] = creatorRender;
        $[22] = starCountRender;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
} : ({ agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: showStarButton = true, renderAdditionalContent: renderAdditionalContent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $f5fec235121c7193$var$styles.name,
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        xcss: $f5fec235121c7193$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "medium"
    }, agentName), headingRender, isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.hiddenIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $fNIRw.messages).hiddenTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6h4xM.HiddenIcon), {
        label: formatMessage((0, $fNIRw.messages).hiddenIcon)
    })))), showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4kCF.StarIconButton), {
        isStarred: isStarred,
        handleToggle: onStarToggle,
        agentName: agentName
    })), creatorRender, !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.description,
        as: "p"
    }, agentDescription), starCountRender, !!renderAdditionalContent && renderAdditionalContent());
};
module.exports["getAgentCreator"] = $f5fec235121c7193$export$7cbebf266a9bcc3c;
module.exports["AgentProfileCreator"] = $f5fec235121c7193$export$f35b2eeaa7e3db15;
module.exports["AgentProfileInfo"] = $f5fec235121c7193$export$e02348ba0b01a210;

});

parcelRegister("6h4xM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bsSbN = parcelRequire("bsSbN");

const $fc7d462f5dd0deaa$export$bce21421c351deb1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), props);
module.exports["HiddenIcon"] = $fc7d462f5dd0deaa$export$bce21421c351deb1;

});

parcelRegister("i4kCF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $6Cex3 = parcelRequire("6Cex3");


var $lbT4j = parcelRequire("lbT4j");


var $iMnC5 = parcelRequire("iMnC5");


var $4ssVW = parcelRequire("4ssVW");

const $fbe2d7b3097e2d22$var$styles = {
    hidden: "_1YKVNsdnbC"
};
const $fbe2d7b3097e2d22$export$703abb8bd2abdfa5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { isStarred: isStarred, handleToggle: handleToggle, visible: t1, agentName: agentName } = t0;
    const visible = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const t2 = !visible && $fbe2d7b3097e2d22$var$styles.hidden;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $w6R6I.cx)(t2);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== isHovered || $[3] !== isStarred) {
        t4 = (iconProps)=>isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                ...iconProps,
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            });
        $[2] = isHovered;
        $[3] = isStarred;
        $[4] = t4;
    } else t4 = $[4];
    const t5 = isStarred ? (0, $4ssVW.default).removeFromFavouritesLabel : (0, $4ssVW.default).clickToFavouriteLabel;
    let t6;
    if ($[5] !== agentName || $[6] !== formatMessage || $[7] !== t5) {
        t6 = formatMessage(t5, {
            agentName: agentName
        });
        $[5] = agentName;
        $[6] = formatMessage;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    let t8;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>setIsHovered(true);
        t8 = ()=>setIsHovered(false);
        $[9] = t7;
        $[10] = t8;
    } else {
        t7 = $[9];
        t8 = $[10];
    }
    let t9;
    if ($[11] !== handleToggle || $[12] !== t4 || $[13] !== t6) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: t4,
            label: t6,
            onClick: handleToggle,
            onMouseEnter: t7,
            onMouseLeave: t8
        });
        $[11] = handleToggle;
        $[12] = t4;
        $[13] = t6;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== t3 || $[16] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t3
        }, t9);
        $[15] = t3;
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    return t10;
} : ({ isStarred: isStarred, handleToggle: handleToggle, visible: visible = true, agentName: agentName })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(!visible && $fbe2d7b3097e2d22$var$styles.hidden)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (iconProps)=>isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                ...iconProps,
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            }),
        label: formatMessage(isStarred ? (0, $4ssVW.default).removeFromFavouritesLabel : (0, $4ssVW.default).clickToFavouriteLabel, {
            agentName: agentName
        }),
        onClick: handleToggle,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }));
};
module.exports["StarIconButton"] = $fbe2d7b3097e2d22$export$703abb8bd2abdfa5;

});

parcelRegister("4ssVW", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a47d9a7d981bdb91$var$message = (0, $kSwu1.defineMessages)({
    removeFromFavouritesLabel: {
        id: "rovo-chat.browse-agents.remove-from-favourites-label",
        defaultMessage: "Remove {agentName} from favourites"
    },
    clickToFavouriteLabel: {
        id: "rovo-chat.browse-agents.click-to-favourite-label",
        defaultMessage: "Add {agentName} to favourites"
    }
});
var $a47d9a7d981bdb91$export$2e2bcd8739ae039 = $a47d9a7d981bdb91$var$message;
module.exports["default"] = $a47d9a7d981bdb91$export$2e2bcd8739ae039;

});

parcelRegister("hq9Cp", function(module, exports) {
const $84118747f7725463$export$3055eac4de8cbd2b = (creatorType)=>creatorType === 'THIRD_PARTY' || creatorType === 'FORGE' || creatorType === 'REMOTE_A2A';
module.exports["isForgeAgentByCreatorType"] = $84118747f7725463$export$3055eac4de8cbd2b;

});

parcelRegister("fNIRw", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $246a354bdf98d3ad$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    agentCreatedBy: {
        id: "ai-mate.agent-profile-info.created-by",
        defaultMessage: "Rovo Agent by {creatorNameWithLink}"
    },
    remoteAgentCreatedBy: {
        id: "ai-mate.agent-profile-info.agent-by",
        defaultMessage: "Agent by {creatorNameWithLink}"
    },
    agentDeactivated: {
        id: "ai-mate.agent-profile-info.deactivated",
        defaultMessage: "(deactivated)"
    },
    starredCount: {
        id: "ai-mate.agent-profile-info.starred-count",
        defaultMessage: "{count} starred"
    },
    hiddenIcon: {
        id: "ai-mate.agent-profile-info.hidden-icon",
        defaultMessage: "Hidden"
    },
    hiddenTooltip: {
        id: "ai-mate.agent-profile-info.hidden-tooltip",
        defaultMessage: "Agent won't show in search results"
    },
    starAgentTooltip: {
        id: "ai-mate.agent-profile-info.star-agent-tooltip",
        defaultMessage: "Star Agent"
    },
    creatorLabel: {
        id: "ai-mate.agent-profile-info.creator",
        defaultMessage: "Creator"
    }
});
module.exports["messages"] = $246a354bdf98d3ad$export$defe85febe8b728c;

});

parcelRegister("dSW04", function(module, exports) {
class $99c5d70c0df67415$export$a6d78d75d03919f1 extends Error {
    constructor(){
        super('Agent access forbidden');
        this.status = 403;
        this.name = 'AgentForbiddenError';
    }
}
module.exports["AgentForbiddenError"] = $99c5d70c0df67415$export$a6d78d75d03919f1;

});

parcelRegister("dRAjC", function(module, exports) {
const $d2643a1af3062f27$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $d2643a1af3062f27$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($d2643a1af3062f27$export$470b0d72e4fdc43a, '');
};
module.exports["USER_ARI_PREFIX"] = $d2643a1af3062f27$export$470b0d72e4fdc43a;
module.exports["getAAIDFromARI"] = $d2643a1af3062f27$export$3761e66a04602cbd;

});

parcelRegister("4k5Wq", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $5avUB = parcelRequire("5avUB");


var $4aRua = parcelRequire("4aRua");


var $eU2tf = parcelRequire("eU2tf");


var $hHYlx = parcelRequire("hHYlx");


var $cSSWJ = parcelRequire("cSSWJ");

const $0f12e30f7425acf6$var$ErrorMessage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(18);
    let t0;
    if ($[0] !== props.errorType) {
        t0 = props.errorType || {
            reason: "default"
        };
        $[0] = props.errorType;
        $[1] = t0;
    } else t0 = $[1];
    const errorType = t0;
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    let t1;
    let t2;
    if ($[2] !== errorReason || $[3] !== fireAnalytics || $[4] !== hasRetry) {
        t1 = ()=>{
            fireAnalytics("ui.profilecard.rendered.error", {
                hasRetry: hasRetry,
                errorType: errorReason,
                firedAt: Math.round(performance.now()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
        };
        t2 = [
            errorReason,
            fireAnalytics,
            hasRetry
        ];
        $[2] = errorReason;
        $[3] = fireAnalytics;
        $[4] = hasRetry;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[7] !== errorReason || $[8] !== reload) {
        t3 = ()=>{
            if (errorReason === "NotFound") return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hHYlx.ErrorTitle), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorUserNotFound
                })
            });
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorTitle), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...(0, $eU2tf.default).errorGeneric
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                    reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: "color.text.subtlest",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                            ...(0, $eU2tf.default).errorRetrySuggestion
                        })
                    })
                ]
            });
        };
        $[7] = errorReason;
        $[8] = reload;
        $[9] = t3;
    } else t3 = $[9];
    const errorContent = t3;
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
            label: "icon error"
        });
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== errorContent) {
        t5 = errorContent();
        $[11] = errorContent;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== reload) {
        t6 = reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            onClick: reload,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                ...(0, $eU2tf.default).errorTryAgain
            })
        });
        $[13] = reload;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorWrapper), {
            testId: "profilecard-error",
            children: [
                t4,
                t5,
                t6
            ]
        });
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $cozmU.useEffect)(()=>{
        fireAnalytics('ui.profilecard.rendered.error', {
            hasRetry: hasRetry,
            errorType: errorReason,
            firedAt: Math.round(performance.now()),
            ...(0, $cSSWJ.PACKAGE_META_DATA)
        });
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hHYlx.ErrorTitle), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                ...(0, $eU2tf.default).errorUserNotFound
            })
        });
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorTitle), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorGeneric
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    color: "color.text.subtlest",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...(0, $eU2tf.default).errorRetrySuggestion
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                label: "icon error"
            }),
            errorContent(),
            reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                onClick: reload,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorTryAgain
                })
            })
        ]
    });
};
var $0f12e30f7425acf6$export$2e2bcd8739ae039 = $0f12e30f7425acf6$var$ErrorMessage;
module.exports["default"] = $0f12e30f7425acf6$export$2e2bcd8739ae039;

});

parcelRegister("eU2tf", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fe57f9d19e98fdc0$var$messages = (0, $kSwu1.defineMessages)({
    inactiveAccountMsg: {
        id: "pt.profile-card.inactive.account",
        defaultMessage: "Account deactivated"
    },
    generalDescMsgForDisabledUser: {
        id: "pt.profile-card.general.msg.disabled.user",
        defaultMessage: "You can no longer collaborate with this person."
    },
    inactiveAccountDescMsgNoDate: {
        id: "pt.profile-card.inactive.account.no.date",
        defaultMessage: "Their account has been deactivated."
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.inactive.account.has.date.this.week",
        defaultMessage: "Their account was deactivated this week."
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.inactive.account.has.date.this.month",
        defaultMessage: "Their account was deactivated this month."
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.inactive.account.has.date.last.month",
        defaultMessage: "Their account was deactivated last month."
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.inactive.account.has.date.a.few.months",
        defaultMessage: "Their account has been deactivated for a few months."
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.inactive.account.has.date.several.months",
        defaultMessage: "Their account has been deactivated for several months."
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.inactive.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deactivated for more than a year."
    },
    closedAccountMsg: {
        id: "pt.profile-card.closed.account",
        defaultMessage: "Account deleted"
    },
    closedAccountDescMsgNoDate: {
        id: "pt.profile-card.closed.account.no.date",
        defaultMessage: "Their account has been deleted."
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.closed.account.has.date.this.week",
        defaultMessage: "Their account was deleted this week."
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.closed.account.has.date.this.month",
        defaultMessage: "Their account was deleted this month."
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.closed.account.has.date.last.month",
        defaultMessage: "Their account was deleted last month."
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.closed.account.has.date.a.few.months",
        defaultMessage: "Their account has been deleted for a few months."
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.closed.account.has.date.several.months",
        defaultMessage: "Their account has been deleted for several months."
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.closed.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deleted for more than a year."
    },
    disabledAccountDefaultName: {
        id: "pt.profile-card.disabled.account.default.name",
        defaultMessage: "Former user"
    },
    teamViewProfile: {
        id: "pt.team-profile-card.team.action.view-profile",
        defaultMessage: "View profile"
    },
    memberCount: {
        id: "pt.team-profile-card.team.member.count",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}"
    },
    memberCountIncludingYou: {
        id: "pt.team-profile-card.team.member.count-including-you",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    membersMoreThan50: {
        id: "pt.team-profile-card.team.member.many",
        defaultMessage: "Team \u2022 50+ members"
    },
    membersMoreThan50IncludingYou: {
        id: "pt.team-profile-card.team.member.many-including-you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    teamErrorTitle: {
        id: "pt.team-profile-card.error.title",
        defaultMessage: "We\u2019re having trouble retrieving this teams information"
    },
    teamErrorText: {
        id: "pt.team-profile-card.error.suggestion",
        defaultMessage: "Wait a few moments, then try again."
    },
    teamErrorButton: {
        id: "pt.team-profile-card.error.refresh-button",
        defaultMessage: "Try again"
    },
    teamForbiddenErrorStateTitle: {
        id: "pt.team-profile-card.forbidden-error-state.title",
        defaultMessage: "We can\u2019t show you this team"
    },
    teamForbiddenErrorStateDescription: {
        id: "pt.team-profile-card.forbidden-error-state.description",
        defaultMessage: "You don\u2019t have access to view this team."
    },
    managerSectionHeading: {
        id: "pt.team-profile-card.manager.heading",
        defaultMessage: "Manager"
    },
    directReportsSectionHeading: {
        id: "pt.team-profile-card.directReports.heading",
        defaultMessage: "Direct reports"
    },
    teamProfileCardAriaLabel: {
        id: "pt.team-profile-card.aria-label",
        defaultMessage: "More information about this team"
    },
    giveKudosButton: {
        id: "pt.profile-card.give-kudos",
        defaultMessage: "Give kudos"
    },
    // Remove this as part of the FG Cleanup for jfp_a11y_team_profile_card_actions_label
    profileCardMoreIconLabel: {
        id: "pt.profile-card.more-icon-label",
        defaultMessage: "More"
    },
    profileCardMoreIconLabelWithName: {
        id: "pt.profile-card.more-icon-label-with-name",
        defaultMessage: "More actions for {fullName}"
    },
    profileCardMoreReportingLinesLabel: {
        id: "pt.user-profile-card.reporting-lines.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {profile} other {profiles}}"
    },
    profileCardMoreMembersLabel: {
        id: "pt.team.profile-card.members.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {members} other {members}}"
    },
    archivedLozenge: {
        id: "pt.team-profile-card.archived-lozenge",
        defaultMessage: "Archived"
    },
    errorUserNotFound: {
        id: "pt.profile-card.error.user-not-found",
        defaultMessage: "The user is no longer available for the site"
    },
    errorGeneric: {
        id: "pt.profile-card.error.generic",
        defaultMessage: "Oops, looks like we\u2019re having issues"
    },
    errorRetrySuggestion: {
        id: "pt.profile-card.error.retry-suggestion",
        defaultMessage: "Try again and we\u2019ll give it another shot"
    },
    errorTryAgain: {
        id: "pt.profile-card.error.try-again-button",
        defaultMessage: "Try again"
    },
    errorDialogLabel: {
        id: "pt.profile-card.error.dialog-label",
        defaultMessage: "Profile card error"
    },
    loadingDialogLabel: {
        id: "pt.profile-card.loading.dialog-label",
        defaultMessage: "Loading profile card"
    },
    serviceAccountLabel: {
        id: "pt.profile-card.service-account.label",
        defaultMessage: "SERVICE ACCOUNT"
    },
    botAccountLabel: {
        id: "pt.profile-card.bot-account.label",
        defaultMessage: "APP"
    },
    viewManagerProfile: {
        id: "pt.profile-card.view-manager-profile",
        defaultMessage: "View {name} profile"
    }
});
var $fe57f9d19e98fdc0$export$2e2bcd8739ae039 = $fe57f9d19e98fdc0$var$messages;
module.exports["default"] = $fe57f9d19e98fdc0$export$2e2bcd8739ae039;

});

parcelRegister("hHYlx", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");

const $3b2daa1fed2d9894$var$styles = {
    errorWrapper: "_2fwxA5DIqT _0Of8r2NHnM _1ZnuxbNHnM _1wydGWNHnM _2Zuz6QNHnM",
    errorTitle: "_3138422ADO",
    teamErrorText: "_1UtDYzKGUX _3138422ADO"
};
const $3b2daa1fed2d9894$export$bb27b7e39840238f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.errorWrapper);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t0,
            ...props
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.errorWrapper),
        ...props
    });
const $3b2daa1fed2d9894$export$b065fd053267ec81 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props.children) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $3b2daa1fed2d9894$var$styles.errorTitle,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                color: "color.text",
                children: props.children
            })
        });
        $[0] = props.children;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $3b2daa1fed2d9894$var$styles.errorTitle,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            color: "color.text",
            children: props.children
        })
    });
const $3b2daa1fed2d9894$export$90d92ccfb27352c6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.teamErrorText);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props.children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t0,
            children: props.children
        });
        $[1] = props.children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.teamErrorText),
        children: props.children
    });
module.exports["ErrorWrapper"] = $3b2daa1fed2d9894$export$bb27b7e39840238f;
module.exports["ErrorTitle"] = $3b2daa1fed2d9894$export$b065fd053267ec81;

});

parcelRegister("kb2tZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $ieeJu = parcelRequire("ieeJu");

const $d107d3e886647d93$var$styles = {
    wrapper: "_0bjKvD8fU6 _39xV02wBC3 _0KLXruoI2d _2OUyjtGk8v",
    wrapperLegacy: "_0bjKvD8fU6 _39xV02wBC3 _0KLXruoI2d"
};
const $d107d3e886647d93$export$2c6604b50c274e6f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    if ((0, $ieeJu.expValEquals)("platform_editor_agent_mentions", "isEnabled", true) && (0, $iDrrr.fg)("platform_editor_agent_mentions_drop_one_fixes") || (0, $iDrrr.fg)("platform_editor_agent_card_fixes")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $d107d3e886647d93$var$styles.wrapper,
                children: children
            });
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $d107d3e886647d93$var$styles.wrapperLegacy,
            children: children
        });
        $[2] = children;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ children: children })=>{
    if ((0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') || (0, $iDrrr.fg)('platform_editor_agent_card_fixes')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $d107d3e886647d93$var$styles.wrapper,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $d107d3e886647d93$var$styles.wrapperLegacy,
        children: children
    });
};
module.exports["AgentProfileCardWrapper"] = $d107d3e886647d93$export$2c6604b50c274e6f;

});

parcelRegister("hIwXM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $795534535f4e0b8b$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("ijYTw")));
module.exports["AgentProfileCardLazy"] = $795534535f4e0b8b$export$ed0ca9c1d49ea0bf;

});

parcelRegister("ijYTw", function(module, exports) {

let $d5693cb35395e271$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d5693cb35395e271$var$load("cBeoH"),
    $d5693cb35395e271$var$load("lN9TX"),
    $d5693cb35395e271$var$load("6wr18"),
    $d5693cb35395e271$var$load("iYJZz"),
    $d5693cb35395e271$var$load("jqoep"),
    $d5693cb35395e271$var$load("ea3NB"),
    $d5693cb35395e271$var$load("ffEVr"),
    $d5693cb35395e271$var$load("7EorR"),
    $d5693cb35395e271$var$load("hhss7"),
    $d5693cb35395e271$var$load("68aog")
]).then(()=>parcelRequire('ark00'));

});

parcelRegister("9iaFM", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $1tDzb = parcelRequire("1tDzb");


var $3LWAs = parcelRequire("3LWAs");

function $f21d3adc78722ef1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f21d3adc78722ef1$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const $f21d3adc78722ef1$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const $f21d3adc78722ef1$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const $f21d3adc78722ef1$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $f21d3adc78722ef1$var$justifyItemsMap = {
    start: {
        name: "lno2ya",
        styles: "justify-items:start"
    },
    center: {
        name: "1wg53za",
        styles: "justify-items:center"
    },
    end: {
        name: "3f7lhf",
        styles: "justify-items:end"
    },
    stretch: {
        name: "16hnylu",
        styles: "justify-items:stretch"
    }
};
const $f21d3adc78722ef1$var$alignContentMap = {
    start: {
        name: "iqu4as",
        styles: "align-content:start"
    },
    center: {
        name: "13vy23x",
        styles: "align-content:center"
    },
    end: {
        name: "1fj2toh",
        styles: "align-content:end"
    },
    'space-between': {
        name: "1pem0lx",
        styles: "align-content:space-between"
    },
    'space-around': {
        name: "127p7gk",
        styles: "align-content:space-around"
    },
    'space-evenly': {
        name: "kcqjal",
        styles: "align-content:space-evenly"
    },
    stretch: {
        name: "1f8yzab",
        styles: "align-content:stretch"
    }
};
const $f21d3adc78722ef1$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    }
};
const $f21d3adc78722ef1$var$baseStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${$f21d3adc78722ef1$var$gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${$f21d3adc78722ef1$var$gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${$f21d3adc78722ef1$var$gridTemplateRowsVar})`
});
const $f21d3adc78722ef1$var$gridAutoFlowMap = {
    row: {
        name: "k3yepi",
        styles: "grid-auto-flow:row"
    },
    column: {
        name: "qu4z1d",
        styles: "grid-auto-flow:column"
    },
    dense: {
        name: "mgx7bc",
        styles: "grid-auto-flow:dense"
    },
    'row dense': {
        name: "1u50cee",
        styles: "grid-auto-flow:row dense"
    },
    'column dense': {
        name: "5ak4pc",
        styles: "grid-auto-flow:column dense"
    }
};
const $f21d3adc78722ef1$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, $1tDzb.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ const style = (0, $cozmU.useMemo)(()=>({
            [$f21d3adc78722ef1$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [$f21d3adc78722ef1$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [$f21d3adc78722ef1$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $f21d3adc78722ef1$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $3LWAs.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $3LWAs.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $3LWAs.spaceStylesMap).rowGap[rowGap],
            alignItems && $f21d3adc78722ef1$var$alignItemsMap[alignItems],
            alignContent && $f21d3adc78722ef1$var$alignContentMap[alignContent],
            justifyContent && $f21d3adc78722ef1$var$justifyContentMap[justifyContent],
            autoFlow && $f21d3adc78722ef1$var$gridAutoFlowMap[autoFlow],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$f21d3adc78722ef1$export$ef2184bd89960b14.displayName = 'Grid';
module.exports["Grid"] = $f21d3adc78722ef1$export$ef2184bd89960b14;

});

parcelRegister("gnKXs", function(module, exports) {
const $cd9ae1db5a8ec9c9$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
module.exports["media"] = $cd9ae1db5a8ec9c9$export$987d49ffe1b0900f;

});

parcelRegister("ez9xU", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $jmUhx = parcelRequire("jmUhx");


var $iMnC5 = parcelRequire("iMnC5");


var $4ez2K = parcelRequire("4ez2K");


var $hBYtq = parcelRequire("hBYtq");


var $eytcg = parcelRequire("eytcg");

const $c25508467e1a19ee$var$triggerStyles = {
    button: "_23rrnHyKLB _3hxITiYbGa _0Of8r22ADO _1wydGW2ADO _2Zuz6Q5zaO _1Znuxb5zaO _0KLXrujOvk _0wOv4Q7zJH _39xV02N91d _1eOmH6o126",
    text: "_2sNsIg7NXe _1UtDYzKGUX"
};
const $c25508467e1a19ee$var$DefaultTrigger = ({ open: open })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $c25508467e1a19ee$var$triggerStyles.button,
        onClick: ()=>open()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c25508467e1a19ee$var$triggerStyles.text
    }, formatMessage((0, $eytcg.messages).defaultTriggerLabel))));
};

const $c25508467e1a19ee$var$LazyRovoSettingsModalProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("1TGMk")).then((mod)=>({
            default: mod.RovoSettingsModalLazy
        }))); /**
       * Self-contained entrypoint for the Rovo Settings modal.
       *
       * The trigger renders eagerly. The provider tree and modal
       * are lazy-loaded only when the user first clicks the trigger.
       * Subsequent opens reuse the mounted provider — no re-mount or re-fetch.
       */ 
const $c25508467e1a19ee$export$f2c3f3e62df426ba = ({ children: renderTrigger, ...providerProps })=>{
    const [isActivated, setIsActivated] = (0, $cozmU.useState)(false);
    const pendingOpenOptions = (0, $cozmU.useRef)(undefined);
    const openModalRef = (0, $cozmU.useRef)(null);
    const open = (0, $cozmU.useCallback)((options)=>{
        if (openModalRef.current) // Provider already mounted — open directly
        openModalRef.current(options);
        else {
            // First click — store options and mount the provider
            pendingOpenOptions.current = options;
            setIsActivated(true);
        }
    }, []); // Calling the render function directly (rather than mounting it as a
    // component) makes React diff the returned JSX in-place against the previous
    // render, so the trigger element survives parent re-renders even if the
    // render function's identity changes (e.g. inline arrows).
    const triggerNode = renderTrigger ? renderTrigger({
        open: open
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c25508467e1a19ee$var$DefaultTrigger, {
        open: open
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: ()=>null
    }, triggerNode, isActivated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c25508467e1a19ee$var$LazyRovoSettingsModalProvider, {
        ...providerProps,
        pendingOpenOptions: pendingOpenOptions,
        openModalRef: openModalRef
    })));
};
module.exports["RovoSettingsModal"] = $c25508467e1a19ee$export$f2c3f3e62df426ba;

});

parcelRegister("eytcg", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $2c6792bc438bfd46$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    modalTitle: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.modal-title.non-final",
        defaultMessage: "Sources & apps"
    },
    searchPlaceholder: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.search-placeholder.non-final",
        defaultMessage: "Search settings"
    },
    defaultTriggerLabel: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.default-trigger-label.non-final",
        defaultMessage: "Explore all apps"
    }
});
module.exports["messages"] = $2c6792bc438bfd46$export$defe85febe8b728c;

});

parcelRegister("1TGMk", function(module, exports) {

let $161c1c6e50e4de6a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $161c1c6e50e4de6a$var$load("kT6dz"),
    $161c1c6e50e4de6a$var$load("cBeoH"),
    $161c1c6e50e4de6a$var$load("lN9TX"),
    $161c1c6e50e4de6a$var$load("6wr18"),
    $161c1c6e50e4de6a$var$load("7SteV"),
    $161c1c6e50e4de6a$var$load("5JmXn"),
    $161c1c6e50e4de6a$var$load("7EorR"),
    $161c1c6e50e4de6a$var$load("Wowvf"),
    $161c1c6e50e4de6a$var$load("hhss7"),
    $161c1c6e50e4de6a$var$load("cGkFm"),
    $161c1c6e50e4de6a$var$load("cnIRE"),
    $161c1c6e50e4de6a$var$load("iGm97"),
    $161c1c6e50e4de6a$var$load("he7Ox"),
    $161c1c6e50e4de6a$var$load("ffEVr"),
    $161c1c6e50e4de6a$var$load("hsRa9"),
    $161c1c6e50e4de6a$var$load("bEleE"),
    $161c1c6e50e4de6a$var$load("45r7q"),
    $161c1c6e50e4de6a$var$load("cKDij")
]).then(()=>parcelRequire('7bLo5'));

});

parcelRegister("cFVPs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3U8XR = parcelRequire("3U8XR");


var $iTJtk = parcelRequire("iTJtk");


var $9DHhW = parcelRequire("9DHhW");


var $jU6s6 = parcelRequire("jU6s6");


var $4dW9D = parcelRequire("4dW9D");


var $96Ikf = parcelRequire("96Ikf");


var $iCEWf = parcelRequire("iCEWf");


var $jLdbZ = parcelRequire("jLdbZ");

const $a12da25560425c44$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $cozmU.useContext)((0, $jU6s6.AIEventsInstrumentationContext));
    const aiEventAttributesOverride = (0, $cozmU.useRef)({});
    if (customConfig) context = {
        config: {
            ...(0, $4dW9D.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $jLdbZ.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, aiFeatureId: aiFeatureId, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const validateAndUpdateAISession = (0, $cozmU.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $3U8XR.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $iCEWf.AISessionState).unset,
            nextState: (0, $3U8XR.P).union((0, $iCEWf.AISessionState).viewed, (0, $iCEWf.AISessionState).error, (0, $iCEWf.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $iCEWf.AISessionState).initiated,
            nextState: (0, $3U8XR.P).union((0, $iCEWf.AISessionState).submitted, (0, $iCEWf.AISessionState).actioned, (0, $iCEWf.AISessionState).adopted, (0, $iCEWf.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $cozmU.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $iTJtk.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const createAndMergeEventPayload = (0, $cozmU.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                aiFeatureId: aiFeatureId,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes,
                ...aiEventAttributesOverride.current
            }
        };
        return (0, $3U8XR.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $96Ikf.getTagsWithPlatformTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $3U8XR.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $3U8XR.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        product,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents,
        aiExperienceName,
        aiFeatureName,
        aiFeatureId,
        proactiveGeneratedAI,
        userGeneratedAI,
        isAIFeature
    ]);
    const trackAIInteractionInit = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $cozmU.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'discarded',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAdopted = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).adopted)) return;
        const event = createAndMergeEventPayload({
            action: 'adopted',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $cozmU.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const updateAIAttributes = (0, $cozmU.useCallback)((newAttributes)=>{
        aiEventAttributesOverride.current = {
            ...aiEventAttributesOverride.current,
            ...newAttributes
        };
    }, []);
    const baseReturn = {
        updateAIAttributes: updateAIAttributes,
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIResultAdopted: trackAIResultAdopted,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID
    };
    return $a12da25560425c44$var$useStableMethods(baseReturn);
};
/**
 * Returns an object with the same shape as `methods`, but with every method
 * replaced by a stable wrapper that delegates to the latest version. The
 * wrappers are created once on mount; they always read the freshest closure
 * via a ref, so calls observe the same behaviour as calling the unstable
 * methods directly.
 */ function $a12da25560425c44$var$useStableMethods(methods) {
    const ref = (0, $cozmU.useRef)(methods);
    ref.current = methods;
    return (0, $cozmU.useMemo)(()=>{
        const out = {};
        for (const key of Object.keys(ref.current))out[key] = (...args)=>ref.current[key](...args);
        return out;
    // Wrappers always read from `ref.current`; no deps needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useAIEventsInstrumentation"] = $a12da25560425c44$export$ddf49ad062368ad2;

});

parcelRegister("3U8XR", function(module, exports) {
const $2d7d8e3cc345803e$var$t = Symbol.for("@ts-pattern/matcher"), $2d7d8e3cc345803e$var$e = Symbol.for("@ts-pattern/isVariadic"), $2d7d8e3cc345803e$var$n = "@ts-pattern/anonymous-select-key", $2d7d8e3cc345803e$var$r = (t)=>Boolean(t && "object" == typeof t), $2d7d8e3cc345803e$var$i = (e)=>e && !!e[$2d7d8e3cc345803e$var$t], $2d7d8e3cc345803e$var$o = (n, s, c)=>{
    if ($2d7d8e3cc345803e$var$i(n)) {
        const e = n[$2d7d8e3cc345803e$var$t](), { matched: r, selections: i } = e.match(s);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($2d7d8e3cc345803e$var$r(n)) {
        if (!$2d7d8e3cc345803e$var$r(s)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(s)) return !1;
            let t = [], r = [], a = [];
            for (const o of n.keys()){
                const s = n[o];
                $2d7d8e3cc345803e$var$i(s) && s[$2d7d8e3cc345803e$var$e] ? a.push(s) : a.length ? r.push(s) : t.push(s);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (s.length < t.length + r.length) return !1;
                const e = s.slice(0, t.length), n = 0 === r.length ? [] : s.slice(-r.length), i = s.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$2d7d8e3cc345803e$var$o(t, e[n], c)) && r.every((t, e)=>$2d7d8e3cc345803e$var$o(t, n[e], c)) && (0 === a.length || $2d7d8e3cc345803e$var$o(a[0], i, c));
            }
            return n.length === s.length && n.every((t, e)=>$2d7d8e3cc345803e$var$o(t, s[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in s || $2d7d8e3cc345803e$var$i(a = r) && "optional" === a[$2d7d8e3cc345803e$var$t]().matcherType) && $2d7d8e3cc345803e$var$o(r, s[e], c);
        });
    }
    return Object.is(s, n);
}, $2d7d8e3cc345803e$var$s = (e)=>{
    var n, o, a;
    return $2d7d8e3cc345803e$var$r(e) ? $2d7d8e3cc345803e$var$i(e) ? null != (n = null == (o = (a = e[$2d7d8e3cc345803e$var$t]()).getSelectionKeys) ? void 0 : o.call(a)) ? n : [] : Array.isArray(e) ? $2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s) : $2d7d8e3cc345803e$var$c(Object.values(e), $2d7d8e3cc345803e$var$s) : [];
}, $2d7d8e3cc345803e$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $2d7d8e3cc345803e$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$2d7d8e3cc345803e$var$o(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $2d7d8e3cc345803e$var$o(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $2d7d8e3cc345803e$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$2d7d8e3cc345803e$var$l(t),
        and: (e)=>$2d7d8e3cc345803e$var$m(t, e),
        or: (e)=>$2d7d8e3cc345803e$var$d(t, e),
        select: (e)=>void 0 === e ? $2d7d8e3cc345803e$var$y(t) : $2d7d8e3cc345803e$var$y(e, t)
    });
}
function $2d7d8e3cc345803e$var$h(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$2d7d8e3cc345803e$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$2d7d8e3cc345803e$var$h($2d7d8e3cc345803e$var$l(t)),
        select: (e)=>$2d7d8e3cc345803e$var$h(void 0 === e ? $2d7d8e3cc345803e$var$y(t) : $2d7d8e3cc345803e$var$y(e, t))
    });
}
function $2d7d8e3cc345803e$var$l(e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($2d7d8e3cc345803e$var$s(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $2d7d8e3cc345803e$var$o(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$s(e),
                matcherType: "optional"
            })
    });
}
const $2d7d8e3cc345803e$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $2d7d8e3cc345803e$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $2d7d8e3cc345803e$var$m(...e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$2d7d8e3cc345803e$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s),
                matcherType: "and"
            })
    });
}
function $2d7d8e3cc345803e$var$d(...e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$2d7d8e3cc345803e$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s),
                matcherType: "or"
            })
    });
}
function $2d7d8e3cc345803e$var$p(e) {
    return {
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $2d7d8e3cc345803e$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $2d7d8e3cc345803e$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $2d7d8e3cc345803e$var$o(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $2d7d8e3cc345803e$var$n
                    ].concat(void 0 === i ? [] : $2d7d8e3cc345803e$var$s(i))
            })
    });
}
function $2d7d8e3cc345803e$var$v(t) {
    return "number" == typeof t;
}
function $2d7d8e3cc345803e$var$b(t) {
    return "string" == typeof t;
}
function $2d7d8e3cc345803e$var$w(t) {
    return "bigint" == typeof t;
}
const $2d7d8e3cc345803e$var$S = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return !0;
})), $2d7d8e3cc345803e$var$O = $2d7d8e3cc345803e$var$S, $2d7d8e3cc345803e$var$j = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length >= t))(e))),
        length: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && Boolean(t.match(n))))));
        }
    }), $2d7d8e3cc345803e$var$K = $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$b)), $2d7d8e3cc345803e$var$x = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        between: (e, n)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t, e)=>$2d7d8e3cc345803e$var$p((n)=>$2d7d8e3cc345803e$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e < t))(e))),
        gt: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e > t))(e))),
        lte: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e <= t))(e))),
        gte: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e >= t))(e))),
        int: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && t > 0))),
        negative: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && t < 0)))
    }), $2d7d8e3cc345803e$var$E = $2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$v)), $2d7d8e3cc345803e$var$A = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        between: (e, n)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t, e)=>$2d7d8e3cc345803e$var$p((n)=>$2d7d8e3cc345803e$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e < t))(e))),
        gt: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e > t))(e))),
        lte: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e <= t))(e))),
        gte: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e >= t))(e))),
        positive: ()=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$w(t) && t > 0))),
        negative: ()=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$w(t) && t < 0)))
    }), $2d7d8e3cc345803e$var$P = $2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$w)), $2d7d8e3cc345803e$var$T = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return "boolean" == typeof t;
})), $2d7d8e3cc345803e$var$B = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return "symbol" == typeof t;
})), $2d7d8e3cc345803e$var$_ = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return null == t;
})), $2d7d8e3cc345803e$var$k = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return null != t;
}));
var $2d7d8e3cc345803e$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $2d7d8e3cc345803e$var$t,
    optional: $2d7d8e3cc345803e$var$l,
    array: function(...e) {
        return $2d7d8e3cc345803e$var$h({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $2d7d8e3cc345803e$var$s(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$2d7d8e3cc345803e$var$o(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $2d7d8e3cc345803e$var$s(e[0])
                })
        });
    },
    set: function(...e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $2d7d8e3cc345803e$var$f(t, (t)=>$2d7d8e3cc345803e$var$o(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $2d7d8e3cc345803e$var$s(e[0])
                })
        });
    },
    map: function(...e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [s, c] = e;
                        return {
                            matched: $2d7d8e3cc345803e$var$g(t, (t, e)=>{
                                const n = $2d7d8e3cc345803e$var$o(s, e, r), i = $2d7d8e3cc345803e$var$o(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$2d7d8e3cc345803e$var$s(e[0]),
                            ...$2d7d8e3cc345803e$var$s(e[1])
                        ]
                })
        });
    },
    intersection: $2d7d8e3cc345803e$var$m,
    union: $2d7d8e3cc345803e$var$d,
    not: function(e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$2d7d8e3cc345803e$var$o(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $2d7d8e3cc345803e$var$p,
    select: $2d7d8e3cc345803e$var$y,
    any: $2d7d8e3cc345803e$var$S,
    _: $2d7d8e3cc345803e$var$O,
    string: $2d7d8e3cc345803e$var$K,
    number: $2d7d8e3cc345803e$var$E,
    bigint: $2d7d8e3cc345803e$var$P,
    boolean: $2d7d8e3cc345803e$var$T,
    symbol: $2d7d8e3cc345803e$var$B,
    nullish: $2d7d8e3cc345803e$var$_,
    nonNullable: $2d7d8e3cc345803e$var$k,
    instanceOf: function(t) {
        return $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$export$ce1e7a33533a73d9(t)));
    }
};
class $2d7d8e3cc345803e$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $2d7d8e3cc345803e$var$$ = {
    matched: !1,
    value: void 0
};
function $2d7d8e3cc345803e$export$4659b591c19bdf3d(t) {
    return new $2d7d8e3cc345803e$var$I(t, $2d7d8e3cc345803e$var$$);
}
class $2d7d8e3cc345803e$var$I {
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let s = !1, c = {};
        const a = (t, e)=>{
            s = !0, c[t] = e;
        }, u = !r.some((t)=>$2d7d8e3cc345803e$var$o(t, this.input, a)) || i && !Boolean(i(this.input)) ? $2d7d8e3cc345803e$var$$ : {
            matched: !0,
            value: e(s ? $2d7d8e3cc345803e$var$n in c ? c[$2d7d8e3cc345803e$var$n] : c : this.input, this.input)
        };
        return new $2d7d8e3cc345803e$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $2d7d8e3cc345803e$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $2d7d8e3cc345803e$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive(t = $2d7d8e3cc345803e$var$L) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
    narrow() {
        return this;
    }
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
}
function $2d7d8e3cc345803e$var$L(t) {
    throw new $2d7d8e3cc345803e$export$6c1467edb54d3773(t);
}
 //# sourceMappingURL=index.js.map
module.exports["P"] = $2d7d8e3cc345803e$export$56c0d5a1e737357d;
module.exports["match"] = $2d7d8e3cc345803e$export$4659b591c19bdf3d;

});

parcelRegister("jU6s6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $1f90c1a79bae927c$export$4f059feb37b5835e = (0, $cozmU.createContext)(null);
module.exports["AIEventsInstrumentationContext"] = $1f90c1a79bae927c$export$4f059feb37b5835e;

});

parcelRegister("4dW9D", function(module, exports) {

var $iCEWf = parcelRequire("iCEWf");

const $7545c0c100898f47$export$5013b36eeed4ec19 = {
    isAIFeature: 1,
    actionSubjectId: 'client',
    eventDispatcherSource: (0, $iCEWf.EventDispatcherSources).JSLib,
    skipAISessionValidation: false,
    useDefaultGASv3EventSchema: false,
    enablePlatformEvents: false
};
module.exports["defaultAIEventsInstrumentationConfigValues"] = $7545c0c100898f47$export$5013b36eeed4ec19;

});

parcelRegister("iCEWf", function(module, exports) {
var $d6416e2c87d11da8$export$af92e0e920a45719 = /*#__PURE__*/ function(AISessionState) {
    AISessionState["unset"] = "[AIInteraction]:UNSET";
    AISessionState["initiated"] = "[AIInteraction]:INITIATED";
    AISessionState["viewed"] = "[AIInteraction]:VIEWED";
    AISessionState["error"] = "[AIInteraction]:ERROR";
    AISessionState["dismissed"] = "[AIInteraction]:DISMISSED";
    AISessionState["actioned"] = "[AIInteraction]:ACTIONED";
    AISessionState["adopted"] = "[AIInteraction]:ADOPTED";
    AISessionState["discarded"] = "[AIInteraction]:DISCARDED";
    AISessionState["submitted"] = "[AIInteraction]:SUBMITTED";
    return AISessionState;
}({});
var $d6416e2c87d11da8$export$7052d5b66e36f60f = /*#__PURE__*/ function(EventDispatcherSources) {
    EventDispatcherSources["JSLib"] = "name:@atlassian/ai-analytics|language:javascript";
    return EventDispatcherSources;
}({});
module.exports["AISessionState"] = $d6416e2c87d11da8$export$af92e0e920a45719;
module.exports["EventDispatcherSources"] = $d6416e2c87d11da8$export$7052d5b66e36f60f;

});

parcelRegister("96Ikf", function(module, exports) {
const $3836d38b50a38c42$export$e053e424fcbfebe9 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};
module.exports["getTagsWithPlatformTag"] = $3836d38b50a38c42$export$e053e424fcbfebe9;

});

parcelRegister("jLdbZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1r1cI = parcelRequire("1r1cI");


var $7mJer = parcelRequire("7mJer");


var $iCEWf = parcelRequire("iCEWf");

const $e5d5cfe1f6d4c858$export$259576f4e7ac6488 = (customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig)=>{
    const singleInstrumentationIDRef = (0, $cozmU.useRef)(undefined);
    const aiSessionStateRef = (0, $cozmU.useRef)((0, $iCEWf.AISessionState).unset);
    const setAISessionState = (0, $cozmU.useCallback)((nextState)=>{
        aiSessionStateRef.current = nextState;
    }, []);
    const getAISessionState = (0, $cozmU.useCallback)(()=>{
        return aiSessionStateRef.current;
    }, []);
    const refreshSingleInstrumentationID = (0, $cozmU.useCallback)((customSingleInstrumentationIDFromEvent)=>{
        const nextSingleInstrumentationID = (0, $1r1cI.getNewSingleInstrumentationID)(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig);
        singleInstrumentationIDRef.current = nextSingleInstrumentationID;
        if (cookieSingleInstrumentationConfig) (0, $7mJer.setSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName, nextSingleInstrumentationID);
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig
    ]);
    const getSingleInstrumentationID = (0, $cozmU.useCallback)(()=>{
        // this handles a race condition when we have a new singleInstrumentationID from the user config
        // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
        // singleInstrumentationID at first step and then return a new one.
        if (customSingleInstrumentationIDFromUserConfig && customSingleInstrumentationIDFromUserConfig !== singleInstrumentationIDRef.current) {
            refreshSingleInstrumentationID();
            return singleInstrumentationIDRef.current;
        }
        if (cookieSingleInstrumentationConfig) return (0, $7mJer.readSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName);
        return singleInstrumentationIDRef.current;
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig,
        refreshSingleInstrumentationID
    ]);
    return {
        refreshSingleInstrumentationID: refreshSingleInstrumentationID,
        getSingleInstrumentationID: getSingleInstrumentationID,
        setAISessionState: setAISessionState,
        getAISessionState: getAISessionState
    };
};
module.exports["useAIInstrumentationSetup"] = $e5d5cfe1f6d4c858$export$259576f4e7ac6488;

});

parcelRegister("1r1cI", function(module, exports) {

var $3U8XR = parcelRequire("3U8XR");


var $03RpJ = parcelRequire("03RpJ");

function $d83e4e74e28b2b37$export$cee2a1482be61648(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig) {
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. from cookie lib
    // 4. default behaviour generates through the crypto API
    return (0, $3U8XR.match)({
        customSingleInstrumentationIDFromEvent: customSingleInstrumentationIDFromEvent,
        customSingleInstrumentationIDFromUserConfig: customSingleInstrumentationIDFromUserConfig
    }).with({
        customSingleInstrumentationIDFromEvent: (0, $3U8XR.P).string
    }, (result)=>result.customSingleInstrumentationIDFromEvent).with({
        customSingleInstrumentationIDFromUserConfig: (0, $3U8XR.P).string
    }, (result)=>result.customSingleInstrumentationIDFromUserConfig)// we can't use the crypto API in the browser due to SSR issues?
    // https://atlassian.slack.com/archives/C051ARA9QGH/p1749587419868869
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    .otherwise(()=>(0, $03RpJ.default)());
}
module.exports["getNewSingleInstrumentationID"] = $d83e4e74e28b2b37$export$cee2a1482be61648;

});

parcelRegister("7mJer", function(module, exports) {

var $1Qi0Q = parcelRequire("1Qi0Q");

var $lnexi = parcelRequire("lnexi");

const $0ca840bf5f9ee98d$export$72d8c154d3f75075 = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';
const $0ca840bf5f9ee98d$export$35ae1861d13fb6c8 = (uniqueCookieFeatureName)=>`AI_INSTRUMENTATION_FEATURE_ID_${uniqueCookieFeatureName}`;
const $0ca840bf5f9ee98d$export$9a4eaf99327c19fe = (uniqueCookieFeatureName, nextSingleInstrumentationID)=>(0, $lnexi.setCookie)($0ca840bf5f9ee98d$export$35ae1861d13fb6c8(uniqueCookieFeatureName), nextSingleInstrumentationID, {
        expires: 7,
        domain: location.hostname,
        sameSite: 'strict'
    });
const $0ca840bf5f9ee98d$export$d6fb1caea334c7c7 = (uniqueCookieFeatureName)=>(0, $1Qi0Q.getCookie)($0ca840bf5f9ee98d$export$35ae1861d13fb6c8(uniqueCookieFeatureName)) || $0ca840bf5f9ee98d$export$72d8c154d3f75075;
module.exports["setSingleInstrumentationIDCookie"] = $0ca840bf5f9ee98d$export$9a4eaf99327c19fe;
module.exports["readSingleInstrumentationIDCookie"] = $0ca840bf5f9ee98d$export$d6fb1caea334c7c7;

});

parcelRegister("aZ9If", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6dd963a85e6ff5109cc3c4973c0fbdf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ff722a3b4d1cbe6$var$_react = $7ff722a3b4d1cbe6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $7ff722a3b4d1cbe6$var$_iconNew = $7ff722a3b4d1cbe6$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $7ff722a3b4d1cbe6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TeamworkGraph".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/teamwork-graph
 * Usage guidance:
 * Reserved for Teamwork Graph features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7ff722a3b4d1cbe6$var$TeamworkGraphIcon = (props)=>/*#__PURE__*/ $7ff722a3b4d1cbe6$var$_react.default.createElement($7ff722a3b4d1cbe6$var$_iconNew.default, Object.assign({
        name: "TeamworkGraphIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 12.25a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m8.5 0a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m0-8.5a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m-7 8.5a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0m-1.5-8.5a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m1.5 0c0 .61-.169 1.18-.46 1.668l4.04 4.042a3.25 3.25 0 1 1-1.074 1.047L5.492 6.492A3.25 3.25 0 1 1 7 3.75m8.5 0a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0"/>`
    }, props));
$7ff722a3b4d1cbe6$var$TeamworkGraphIcon.displayName = 'TeamworkGraphIcon';
var $7ff722a3b4d1cbe6$var$_default = module.exports.default = $7ff722a3b4d1cbe6$var$TeamworkGraphIcon;

});

parcelRegister("cow67", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5fa619d4dc0abdbd4993ef2902e26740>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90609fd80a141ebe$var$_react = $90609fd80a141ebe$var$_interopRequireDefault((parcelRequire("cozmU")));

var $90609fd80a141ebe$var$_iconNew = $90609fd80a141ebe$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $90609fd80a141ebe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FileMarkdown".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/file-markdown
 * Usage guidance:
 * Reserved for representing a Markdown document filetype.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90609fd80a141ebe$var$FileMarkdownIcon = (props)=>/*#__PURE__*/ $90609fd80a141ebe$var$_react.default.createElement($90609fd80a141ebe$var$_iconNew.default, Object.assign({
        name: "FileMarkdownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12 8.5V5.25c0-.519-.206-1.017-.573-1.384L8.134.573A1.96 1.96 0 0 0 6.75 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h.5v-1.5H2a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v2.5zM7.5 2.06 9.94 4.5H7.5z"/><path fill="currentcolor" d="M5.125 10a.75.75 0 0 1 .661.396L7 12.66l1.214-2.265A.75.75 0 0 1 8.875 10h.375a.75.75 0 0 1 .75.75V16H8.5v-2.962l-.839 1.566a.75.75 0 0 1-1.322 0L5.5 13.039V16H4v-5.25a.75.75 0 0 1 .75-.75zm9.125 0v3.042l.565-.402a.75.75 0 0 1 1 1.104l-1.75 2a.75.75 0 0 1-1.13 0l-1.75-2a.75.75 0 0 1 1-1.104l.565.402V10z"/>`
    }, props));
$90609fd80a141ebe$var$FileMarkdownIcon.displayName = 'FileMarkdownIcon';
var $90609fd80a141ebe$var$_default = module.exports.default = $90609fd80a141ebe$var$FileMarkdownIcon;

});

parcelRegister("3yAls", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::929aa6397f6b50305e3cbc129e860084>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2970bd779dddb386$var$_react = $2970bd779dddb386$var$_interopRequireDefault((parcelRequire("cozmU")));

var $2970bd779dddb386$var$_iconNew = $2970bd779dddb386$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $2970bd779dddb386$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PlaylistAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/playlist-add
 * Usage guidance:
 * Adding items to your playlist (feature).
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2970bd779dddb386$var$PlaylistAddIcon = (props)=>/*#__PURE__*/ $2970bd779dddb386$var$_react.default.createElement($2970bd779dddb386$var$_iconNew.default, Object.assign({
        name: "PlaylistAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10.75 7v2.25H13v1.5h-2.25V13h-1.5v-2.25H7v-1.5h2.25V7z"/><path fill="currentcolor" d="M3.999 6.624A2.626 2.626 0 0 1 6.624 4h4.053l-.341-1.6a1.124 1.124 0 0 0-1.334-.866L2.399 2.937a1.124 1.124 0 0 0-.866 1.334l1.403 6.602c.11.517.558.873 1.063.889zm1.5 6.75c0 .621.504 1.125 1.125 1.125h6.75c.621 0 1.125-.503 1.125-1.125v-6.75c0-.62-.504-1.125-1.125-1.125h-6.75c-.621 0-1.125.504-1.125 1.125zm10.5 0A2.625 2.625 0 0 1 13.374 16h-6.75a2.625 2.625 0 0 1-2.625-2.625v-.112a2.624 2.624 0 0 1-2.53-2.077L.064 4.582A2.626 2.626 0 0 1 2.088 1.47L8.689.066a2.626 2.626 0 0 1 3.114 2.022L12.21 4h1.164a2.625 2.625 0 0 1 2.625 2.625z"/>`
    }, props));
$2970bd779dddb386$var$PlaylistAddIcon.displayName = 'PlaylistAddIcon';
var $2970bd779dddb386$var$_default = module.exports.default = $2970bd779dddb386$var$PlaylistAddIcon;

});

parcelRegister("e3DmL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14f5a5a36524818b316eadcf17d87a08>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a3bfe1d0cdf69d47$var$_react = $a3bfe1d0cdf69d47$var$_interopRequireDefault((parcelRequire("cozmU")));

var $a3bfe1d0cdf69d47$var$_iconNew = $a3bfe1d0cdf69d47$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $a3bfe1d0cdf69d47$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PlaylistRemove".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/playlist-remove
 * Usage guidance:
 * Represents the action for removing things from the playlist feature.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a3bfe1d0cdf69d47$var$PlaylistRemoveIcon = (props)=>/*#__PURE__*/ $a3bfe1d0cdf69d47$var$_react.default.createElement($a3bfe1d0cdf69d47$var$_iconNew.default, Object.assign({
        name: "PlaylistRemoveIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m12.78 8.28-1.72 1.719 1.72 1.72-1.06 1.06L10 11.06l-1.72 1.72-1.06-1.06L8.94 10 7.22 8.28l1.06-1.06L10 8.939l1.72-1.72z"/><path fill="currentcolor" d="M3.999 6.624A2.626 2.626 0 0 1 6.624 4h4.053l-.341-1.6a1.124 1.124 0 0 0-1.334-.866L2.399 2.937a1.124 1.124 0 0 0-.866 1.334l1.403 6.602c.11.517.558.873 1.063.889zm1.5 6.75c0 .621.504 1.125 1.125 1.125h6.75c.621 0 1.125-.503 1.125-1.125v-6.75c0-.62-.504-1.125-1.125-1.125h-6.75c-.621 0-1.125.504-1.125 1.125zm10.5 0A2.625 2.625 0 0 1 13.374 16h-6.75a2.625 2.625 0 0 1-2.625-2.625v-.112a2.624 2.624 0 0 1-2.53-2.077L.064 4.582A2.626 2.626 0 0 1 2.088 1.47L8.689.066a2.626 2.626 0 0 1 3.114 2.022L12.21 4h1.164a2.625 2.625 0 0 1 2.625 2.625z"/>`
    }, props));
$a3bfe1d0cdf69d47$var$PlaylistRemoveIcon.displayName = 'PlaylistRemoveIcon';
var $a3bfe1d0cdf69d47$var$_default = module.exports.default = $a3bfe1d0cdf69d47$var$PlaylistRemoveIcon;

});

parcelRegister("aIn0d", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");


var $10I6z = parcelRequire("10I6z");

const $5f85a79aee555eb3$var$AI_DISCLAIMER_LINK = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $5f85a79aee555eb3$var$styles = {
    text: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
const $5f85a79aee555eb3$export$e0542ba0c737fe5c = ({ onLinkClick: onLinkClick, withLink: withLink = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const disclaimerContent = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $10I6z.i18n).disclaimerMessage));
    if (withLink) return /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
        appearance: "subtle",
        href: $5f85a79aee555eb3$var$AI_DISCLAIMER_LINK,
        target: "_blank",
        onClick: onLinkClick
    }, disclaimerContent);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($5f85a79aee555eb3$var$styles.text)
    }, disclaimerContent);
};
module.exports["AIDisclaimer"] = $5f85a79aee555eb3$export$e0542ba0c737fe5c;

});

parcelRegister("10I6z", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1ae8fb340800d3e1$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    disclaimerMessage: {
        id: "ai-disclaimer.disclaimerMessage",
        defaultMessage: "Uses AI. Verify results."
    }
});
module.exports["i18n"] = $1ae8fb340800d3e1$export$a7357cdd1f0b0168;

});

parcelRegister("2eX69", function(module, exports) {

var $e9nC3 = parcelRequire("e9nC3");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $5BnIc = parcelRequire("5BnIc");


var $9C5oc = parcelRequire("9C5oc");


var $h45y6 = parcelRequire("h45y6");

const $a45798977a968ec1$var$MAX_SUMMARY_LENGTH_CHARS = 100;
const $a45798977a968ec1$var$singleLineTruncatedText = (text, length = $a45798977a968ec1$var$MAX_SUMMARY_LENGTH_CHARS)=>{
    const singleLineText = text.replace(/\n/g, ' ');
    return (0, $9C5oc.default)(singleLineText, length);
};
class $a45798977a968ec1$export$2e2bcd8739ae039 extends (0, $cozmU.Component) {
    async componentDidMount() {
        const anonymousFeedback = !await this.shouldShowOptInCheckboxesNew();
        this.setState({
            anonymousFeedback: anonymousFeedback
        });
    }
    getGatewayUrl() {
        const { customGatewayUrl: customGatewayUrl, url: url } = this.props;
        if (customGatewayUrl) return customGatewayUrl;
        if (url) return url;
        return $a45798977a968ec1$export$2e2bcd8739ae039.defaultProps.url;
    }
    getFeedbackUrl() {
        const { customFeedbackUrl: customFeedbackUrl, url: url } = this.props;
        if (customFeedbackUrl) return customFeedbackUrl;
        if (url) return url;
        return $a45798977a968ec1$export$2e2bcd8739ae039.defaultProps.url;
    }
    getPackageVersion() {
        return "0.0.0-use.local";
    }
    async getEntitlementInformation() {
        const url = this.getGatewayUrl();
        // jira / confluence / bitbucket / trello
        let productName;
        let productEntitlement;
        let entitlementDetails;
        let productKey;
        if (window.location.host.includes('bitbucket.org')) {
            productName = 'Bitbucket';
            productKey = 'bitbucket';
            entitlementDetails = JSON.parse(JSON.stringify(document.querySelector('meta[id="bb-bootstrap"]')?.getAttribute('data-current-user')));
            const hasPremium = entitlementDetails['hasPremium'];
            productEntitlement = hasPremium ? 'PREMIUM' : 'STANDARD';
        } else if ([
            'trellis.coffee',
            'trello.com'
        ].includes(window.location.host)) {
            productName = 'Trello';
            productKey = 'trello';
        } else {
            if (document.querySelector('meta[id="confluence-context-path"]')) {
                productName = 'Confluence';
                productKey = 'pricingplan.confluence.ondemand';
            } else {
                productName = 'Jira';
                productKey = 'jira-software.ondemand';
            }
            try {
                entitlementDetails = await fetch(`${url}/customer-context/entitlements/${window.location.host}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    ...(0, $5BnIc.isApiGatewayUrl)(url) ? {
                        credentials: 'include'
                    } : {}
                });
            } catch (e) {
                entitlementDetails = undefined;
            }
        }
        let entitlement;
        const entitlementInformation = [];
        const cloudSiteId = entitlementDetails?.cloudSiteId || '';
        if (entitlementDetails?.children) entitlement = entitlementDetails?.children.find((entitlement)=>{
            return entitlement.key === productKey;
        });
        entitlementInformation.push({
            id: 'product',
            value: productName ? productName?.toLowerCase() : ''
        }, {
            id: 'hostingType',
            value: entitlement?.product ? entitlement.product.hostingType : 'CLOUD'
        }, {
            id: 'entitlementEdition',
            value: productEntitlement ?? ''
        }, {
            id: 'cloudId',
            value: cloudSiteId
        });
        return entitlementInformation;
    }
    getTypeFieldValue(dtype) {
        switch(dtype){
            case 'bug':
                return this.props.typeBugDefaultValue;
            case 'comment':
                return this.props.typeCommentDefaultValue;
            case 'suggestion':
                return this.props.typeSuggestionDefaultValue;
            case 'question':
                return this.props.typeQuestionDefaultValue;
            case 'empty':
            default:
                return this.props.typeEmptyDefaultValue;
        }
    }
    async getAtlassianID() {
        const { atlassianAccountId: atlassianAccountId, shouldGetEntitlementDetails: shouldGetEntitlementDetails } = this.props;
        try {
            if (atlassianAccountId || !shouldGetEntitlementDetails) return atlassianAccountId;
            const url = this.getGatewayUrl();
            const result = await fetch(`${url}/me`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                ...(0, $5BnIc.isApiGatewayUrl)(url) ? {
                    credentials: 'include'
                } : {}
            });
            const json = await result.json();
            return json.account_id;
        } catch (e) {
            return undefined;
        }
    }
    shouldShowOptInCheckboxes() {
        if (this.props.anonymousFeedback) return !this.props.anonymousFeedback;
        if (this.props.atlassianAccountId) return true;
        let response;
        this.getAtlassianID().then((result)=>{
            response = result !== undefined;
        }).catch(()=>{
            response = false;
        });
        // @ts-ignore
        return response;
    }
    shouldShowOptInCheckboxesNew() {
        return new Promise((resolve)=>{
            if (this.props.anonymousFeedback) resolve(!this.props.anonymousFeedback);
            if (this.props.atlassianAccountId) resolve(true);
            this.getAtlassianID().then((result)=>{
                resolve(result !== undefined);
            }).catch(()=>{
                resolve(false);
            });
        });
    }
    getDescription(formValues) {
        return formValues.description || this.props.descriptionDefaultValue;
    }
    getSummary(formValues) {
        return $a45798977a968ec1$var$singleLineTruncatedText(formValues.description, this.props.summaryTruncateLength) || this.props.summaryDefaultValue;
    }
    getCustomerName() {
        return this.props.name ?? this.props.customerNameDefaultValue;
    }
    addEmailToContext() {
        const contextField = this.props.additionalFields.find((field)=>{
            return field.id === 'customfield_10047';
        });
        if (contextField) contextField.value = `${contextField.value}
        email: ${this.props.email}`;
        else this.props.additionalFields.push({
            id: 'customfield_10047',
            value: `email: ${this.props.email}`
        });
    }
    addAccountIdToContext(atlassianID) {
        if (atlassianID) {
            const contextField = this.props.additionalFields.find((field)=>{
                return field.id === 'customfield_10047';
            });
            if (contextField) contextField.value = `${contextField.value}
			atlassian-account-id: ${atlassianID}`;
        }
    }
    async mapFormToJSD(formValues) {
        let entitlementInformation = null;
        if (this.props?.shouldGetEntitlementDetails) entitlementInformation = await this.getEntitlementInformation();
        if (this.props?.email) this.addEmailToContext();
        const atlassianID = await this.getAtlassianID();
        this.addAccountIdToContext(atlassianID);
        return {
            fields: [
                ...entitlementInformation !== null && entitlementInformation || [],
                this.props.showTypeField ? {
                    id: this.props.typeFieldId,
                    value: this.getTypeFieldValue(formValues.type)
                } : undefined,
                {
                    id: this.props.summaryFieldId,
                    value: this.getSummary(formValues)
                },
                {
                    id: this.props.descriptionFieldId,
                    value: this.getDescription(formValues)
                },
                {
                    id: 'aaidOrHash',
                    value: formValues.canBeContacted ? atlassianID : undefined
                },
                {
                    id: this.props.customerNameFieldId,
                    value: this.getCustomerName()
                },
                formValues.canBeContacted ? {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedAgreeValue
                } : {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedDeclineValue
                },
                formValues.enrollInResearchGroup ? {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchAgreeValue
                } : {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchDeclineValue
                },
                ...this.props.additionalFields
            ].filter(Boolean)
        };
    }
    render() {
        const anonymousFeedback = !this.shouldShowOptInCheckboxes();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h45y6.default), {
            customContent: this.props.customContent,
            feedbackTitle: this.props.feedbackTitle,
            feedbackTitleDetails: this.props.feedbackTitleDetails,
            showTypeField: this.props.showTypeField,
            showDefaultTextFields: this.props.showDefaultTextFields,
            hasDescriptionDefaultValue: !!this.props.descriptionDefaultValue,
            canBeContactedLabel: this.props.canBeContactedLabel,
            enrolInResearchLabel: this.props.enrolInResearchLabel,
            summaryPlaceholder: this.props.summaryPlaceholder,
            submitButtonLabel: this.props.submitButtonLabel,
            cancelButtonLabel: this.props.cancelButtonLabel,
            feedbackGroupLabels: this.props.feedbackGroupLabels,
            onSubmit: this.postFeedback,
            onClose: this.props.onClose,
            onCancel: this.props.onCancel,
            locale: this.props.locale,
            anonymousFeedback: (0, $iDrrr.fg)('platform.proforma-form-builder-feedback_hupaz') ? this.state.anonymousFeedback : anonymousFeedback,
            selectLabel: this.props.selectLabel,
            customTextAreaLabel: this.props.customTextAreaLabel,
            customFeedbackOptions: this.props.customFeedbackOptions,
            shouldReturnFocusRef: this.props.shouldReturnFocusRef,
            dialogRef: this.props.dialogRef,
            disableSubmitButton: this.props.disableSubmitButton,
            ...(0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                enrolInResearchLink: this.props.enrolInResearchLink,
                canBeContactedLink: this.props.canBeContactedLink
            },
            showRequiredFieldsSummary: this.props.showRequiredFieldsSummary
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            anonymousFeedback: true
        };
        this.postFeedback = async (formValues)=>{
            const entrypointId = this.props.entrypointId;
            let fetchUrl = this.getFeedbackUrl();
            // Don't dispatch unless we have suitable props (allows tests to pass through empty strings and avoid redundant network calls)
            if (entrypointId) {
                const formData = await this.mapFormToJSD(formValues);
                const body = {
                    feedback: {
                        entrypointId: this.props.entrypointId,
                        entrypointUiVersion: this.getPackageVersion(),
                        ...formData
                    }
                };
                if ((0, $5BnIc.isApiGatewayUrl)(fetchUrl)) fetchUrl += '/feedback-collector-api';
                else if (!this.props.customFeedbackUrl) fetchUrl = 'https://feedback-collector-api.services.atlassian.com';
                const postData = (0, $e9nC3.Buffer).from(JSON.stringify(body)).toString('base64');
                fetch(`${fetchUrl}/v2/feedback`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        data: postData
                    }),
                    credentials: 'include'
                });
            }
            this.props.onClose();
            // slightly delay confirming submit since we don't wait for the REST call to succeed
            //
            // Because `onClose` is invoked prior to this timeout triggering, the `componentWillUnmount`
            // may occur before the `onSubmit` is called. To prevent prematurely cancelling the
            // network request, we deliberately don't clear this timeout inside `componentWillUnmount`.
            //
            setTimeout(()=>this.props.onSubmit(formValues), this.props.timeoutOnSubmit);
        };
    }
}
$a45798977a968ec1$export$2e2bcd8739ae039.defaultProps = {
    locale: 'en',
    url: '/gateway/api',
    shouldGetEntitlementDetails: true,
    canBeContactedFieldId: 'customfield_10043',
    canBeContactedAgreeValue: [
        {
            id: '10109'
        }
    ],
    canBeContactedDeclineValue: [
        {
            id: '10111'
        }
    ],
    additionalFields: [],
    customerNameFieldId: 'customfield_10045',
    customerNameDefaultValue: 'unknown',
    descriptionFieldId: 'description',
    descriptionDefaultValue: '',
    enrollInResearchFieldId: 'customfield_10044',
    enrollInResearchAgreeValue: [
        {
            id: '10110'
        }
    ],
    enrollInResearchDeclineValue: [
        {
            id: '10112'
        }
    ],
    summaryFieldId: 'summary',
    summaryDefaultValue: '',
    summaryTruncateLength: 100,
    timeoutOnSubmit: 700,
    typeFieldId: 'customfield_10042',
    typeBugDefaultValue: {
        id: '10105'
    },
    typeCommentDefaultValue: {
        id: '10106'
    },
    typeSuggestionDefaultValue: {
        id: '10107'
    },
    typeQuestionDefaultValue: {
        id: '10108'
    },
    typeEmptyDefaultValue: {
        id: 'empty'
    },
    showTypeField: true,
    showDefaultTextFields: true,
    anonymousFeedback: false,
    onClose: ()=>{},
    onSubmit: ()=>{}
};
module.exports["default"] = $a45798977a968ec1$export$2e2bcd8739ae039;

});

parcelRegister("5BnIc", function(module, exports) {
const $db292a71bf6452ef$export$f0f6fc934288a17c = (url)=>[
        '/gateway/api'
    ].includes(url);
module.exports["isApiGatewayUrl"] = $db292a71bf6452ef$export$f0f6fc934288a17c;

});

parcelRegister("9C5oc", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c5409c9e56ee67a$export$2e2bcd8739ae039);
function $0c5409c9e56ee67a$export$2e2bcd8739ae039(text, maxLength) {
    if (!text || !maxLength) return text;
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
}

});

parcelRegister("h45y6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $2uDbg = parcelRequire("2uDbg");


var $7BfeF = parcelRequire("7BfeF");


var $dUI0h = parcelRequire("dUI0h");


var $2Nu0e = parcelRequire("2Nu0e");


var $dTHYM = parcelRequire("dTHYM");


var $dQLwo = parcelRequire("dQLwo");


var $hpa99 = parcelRequire("hpa99");


var $i1t43 = parcelRequire("i1t43");


var $fEPJS = parcelRequire("fEPJS");


var $7aRdF = parcelRequire("7aRdF");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $iDrrr = parcelRequire("iDrrr");


var $1VhsF = parcelRequire("1VhsF");


var $6wGOF = parcelRequire("6wGOF");


var $e3Wrf = parcelRequire("e3Wrf");


var $5r21M = parcelRequire("5r21M");


var $hTUp6 = parcelRequire("hTUp6");

const $dcf72f8838f67ff8$var$LinkWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            paddingInlineStart: "var(--ds-space-300, 24px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginInlineStart: "var(--ds-space-050, 4px)"
        }
    }, children);
};
const $dcf72f8838f67ff8$var$FeedbackForm = ({ showTypeField: showTypeField = true, showDefaultTextFields: showDefaultTextFields = true, customContent: customContent, onClose: onClose, onCancel: onCancel, onSubmit: onSubmit, feedbackTitle: feedbackTitle, feedbackTitleDetails: feedbackTitleDetails, feedbackGroupLabels: feedbackGroupLabels, summaryPlaceholder: summaryPlaceholder, canBeContactedLabel: canBeContactedLabel, canBeContactedLink: canBeContactedLink, enrolInResearchLabel: enrolInResearchLabel, enrolInResearchLink: enrolInResearchLink, submitButtonLabel: submitButtonLabel, cancelButtonLabel: cancelButtonLabel, anonymousFeedback: anonymousFeedback, hasDescriptionDefaultValue: hasDescriptionDefaultValue, selectLabel: selectLabel, customTextAreaLabel: customTextAreaLabel, customFeedbackOptions: customFeedbackOptions = [], shouldReturnFocusRef: shouldReturnFocusRef, dialogRef: dialogRef, disableSubmitButton: disableSubmitButton, showRequiredFieldsSummary: showRequiredFieldsSummary = true })=>{
    const [canBeContacted, setCanBeContacted] = (0, $cozmU.useState)(false);
    const [description, setDescription] = (0, $cozmU.useState)('');
    const [enrollInResearchGroup, setEnrollInResearchGroup] = (0, $cozmU.useState)(false);
    const [type, setType] = (0, $cozmU.useState)('empty');
    const [isSubmitting, setIsSubmitting] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isTypeSelected = ()=>type !== 'empty';
    const validateType = (value)=>showTypeField && (!value || value === 'empty') ? formatMessage((0, $5r21M.messages).validationErrorTypeRequired) : undefined;
    const validateDescription = (value)=>{
        if (!showDefaultTextFields || hasDescriptionDefaultValue) return undefined;
        return !value || !value.trim() ? formatMessage((0, $5r21M.messages).validationErrorDescriptionRequired) : undefined;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleCancel = (...args)=>{
        onCancel?.(...args);
        // Forward every arg the click handler received so consumers retain the full
        // pre-change runtime contract (originating event + Atlaskit UI analytics event).
        onClose(...args);
    };
    const canShowTextField = isTypeSelected() || !showTypeField;
    const isDisabled = isSubmitting || disableSubmitButton;
    const getFieldLabels = (record)=>({
            bug: record?.bug?.fieldLabel || formatMessage((0, $5r21M.messages).formBugLabel),
            comment: record?.comment?.fieldLabel || formatMessage((0, $5r21M.messages).formCommentLabel),
            suggestion: record?.suggestion?.fieldLabel || formatMessage((0, $5r21M.messages).formSuggestionLabel),
            question: record?.question?.fieldLabel || formatMessage((0, $5r21M.messages).formQuestionLabel),
            empty: record?.empty?.fieldLabel || formatMessage((0, $5r21M.messages).formEmptyLabel),
            not_relevant: record?.not_relevant?.fieldLabel || formatMessage((0, $5r21M.messages).formNotRelevantLabel),
            not_accurate: record?.not_accurate?.fieldLabel || formatMessage((0, $5r21M.messages).formNotAccurateLabel),
            too_slow: record?.too_slow?.fieldLabel || formatMessage((0, $5r21M.messages).formTooSlowLabel),
            unhelpful_links: record?.unhelpful_links?.fieldLabel || formatMessage((0, $5r21M.messages).formUnhelpfulLinksLabel),
            other: record?.other?.fieldLabel || formatMessage((0, $5r21M.messages).formOtherLabel)
        });
    const getSelectOptions = (record)=>[
            {
                label: record?.question?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionQuestionLabel),
                value: 'question'
            },
            {
                label: record?.comment?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionCommentLabel),
                value: 'comment'
            },
            {
                label: record?.bug?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionBugLabel),
                value: 'bug'
            },
            {
                label: record?.suggestion?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionSuggestionLabel),
                value: 'suggestion'
            }
        ];
    const getDefaultPlaceholder = (record)=>record?.empty?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionDefaultPlaceholder);
    const focusRef = (0, $cozmU.useRef)();
    const selectOptions = customFeedbackOptions.length > 0 ? customFeedbackOptions : getSelectOptions(feedbackGroupLabels);
    const renderContactLabelAppify = ()=>{
        if ((0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $5r21M.messages).canBeContactedLabelAppifyWithResponseWithoutLink;
        return (0, $5r21M.messages).canBeContactedLabelAppifyWithResponse;
    };
    const renderContactLabel = ()=>{
        if ((0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $5r21M.messages).canBeContactedLabelWithResponseWithoutLink;
        return (0, $5r21M.messages).canBeContactedLabelWithResponse;
    };
    const requiredFieldsSummary = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("p", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text-subtle, #505258)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: "var(--ds-space-300, 24px)"
        }
    }, formatMessage((0, $5r21M.messages).requiredFieldsSummary), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null));
    const feedbackIsAnonymous = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("p", null, formatMessage((0, $5r21M.messages).feedbackIsAnonymous));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        ref: dialogRef,
        shouldCloseOnOverlayClick: false,
        onClose: onClose,
        testId: "feedbackCollectorModalDialog",
        shouldReturnFocus: shouldReturnFocusRef,
        shouldScrollInViewport: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: async ()=>{
            setIsSubmitting(true);
            try {
                await onSubmit({
                    canBeContacted: canBeContacted,
                    description: description,
                    enrollInResearchGroup: enrollInResearchGroup,
                    type: type
                });
            } finally{
                setIsSubmitting(false);
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, feedbackTitle || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).feedbackTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, (0, $iDrrr.fg)('ak_feedback_collector_hide_required_summary') ? showRequiredFieldsSummary && requiredFieldsSummary : requiredFieldsSummary, feedbackTitleDetails, customContent, showTypeField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "topic",
        id: "topic",
        label: selectLabel || formatMessage((0, $5r21M.messages).selectionOptionDefaultLabel),
        isRequired: true,
        validate: validateType
    }, ({ fieldProps: { id: id, ...restProps }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
            ...restProps,
            value: selectOptions.find((opt)=>opt.value === type) ?? null,
            onChange: (option)=>{
                if (!option || option instanceof Array) return;
                setType(option.value);
                restProps.onChange?.(option.value);
            },
            menuPosition: "fixed",
            options: selectOptions,
            shouldPreventEscapePropagation: true,
            // @ts-ignore
            ref: focusRef,
            placeholder: getDefaultPlaceholder(feedbackGroupLabels),
            inputId: id,
            isInvalid: !!error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)))) : null, showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $5r21M.messages).defaultCustomTextAreaLabel),
        isRequired: true,
        name: "description",
        id: "description",
        validate: validateDescription
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
            ...fieldProps,
            name: "foo",
            minimumRows: 6,
            placeholder: summaryPlaceholder || undefined,
            onChange: (e)=>{
                setDescription(e.target.value);
                fieldProps.onChange(e.target.value);
            },
            value: description
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)))), !anonymousFeedback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Nu0e.Fieldset), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("legend", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).optInOptionsLegend)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "can-be-contacted"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            ...fieldProps,
            "aria-describedby": undefined,
            label: canBeContactedLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...(0, $iDrrr.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(),
                ...!(0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                                href: "https://www.atlassian.com/legal/privacy-policy",
                                target: "_blank"
                            }, chunks)
                    }
                }
            }),
            onChange: (event)=>setCanBeContacted(event.target.checked)
        }), canBeContactedLabel && canBeContactedLink && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, canBeContactedLink), !canBeContactedLabel && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: "https://www.atlassian.com/legal/privacy-policy",
            target: "_blank"
        }, formatMessage((0, $5r21M.messages).privacyPolicy))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "enroll-in-research-group"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            ...fieldProps,
            "aria-describedby": undefined,
            label: enrolInResearchLabel || formatMessage((0, $5r21M.messages).enrolInResearchLabel),
            onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
        }), enrolInResearchLabel && enrolInResearchLink && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, enrolInResearchLink)))) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: 'anonymousFeedback'
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            title: formatMessage((0, $5r21M.messages).feedbackIsAnonymousTitle),
            appearance: 'information'
        }, feedbackIsAnonymous))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: handleCancel
    }, cancelButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).cancelButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "primary",
        type: "submit",
        isDisabled: isSubmitting || isDisabled,
        testId: "feedbackCollectorSubmitBtn"
    }, submitButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).submitButtonLabel)))));
};
const $dcf72f8838f67ff8$var$FeedbackFormWithIntl = ({ locale: locale, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hTUp6.IntlProviderWithResolvedMessages), {
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$FeedbackForm, props));
};
var $dcf72f8838f67ff8$export$2e2bcd8739ae039 = $dcf72f8838f67ff8$var$FeedbackFormWithIntl;
module.exports["default"] = $dcf72f8838f67ff8$export$2e2bcd8739ae039;

});

parcelRegister("5r21M", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $0eef762dd50d9f91$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    feedbackTitle: {
        id: "feedback-collector.feedback-title",
        defaultMessage: "Share your thoughts"
    },
    enrolInResearchLabel: {
        id: "feedback-collector.enrol-in-research.label",
        defaultMessage: "I'd like to participate in product research"
    },
    canBeContactedLabelWithResponse: {
        id: "feedback-collector.can-be-contacted.label-with-response",
        defaultMessage: "Yes, Atlassian teams can reply to my feedback and ask for more details about my experience to improve Atlassian products and services. Without this, I won't get a response. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelWithResponseWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-with-response-without-link",
        defaultMessage: "Yes, Atlassian teams can reply to my feedback and ask for more details about my experience to improve Atlassian products and services. Without this, I won't get a response. I acknowledge the Atlassian Privacy Policy."
    },
    privacyPolicy: {
        id: "feedback-collector.privacy-policy",
        defaultMessage: "Atlassian Privacy Policy"
    },
    summaryPlaceholder: {
        id: "feedback-collector.summary-placeholder",
        defaultMessage: "Let us know what's on your mind"
    },
    formCommentLabel: {
        id: "feedback-collector.form.comment.label",
        defaultMessage: "Let us know what's on your mind"
    },
    submitButtonLabel: {
        id: "feedback-collector.submit-button.label",
        defaultMessage: "Send feedback"
    },
    cancelButtonLabel: {
        id: "feedback-collector.cancel-button.label",
        defaultMessage: "Cancel"
    },
    giveFeedback: {
        id: "proforma-form-builder.give-feedback",
        defaultMessage: "Give feedback"
    },
    formBugLabel: {
        id: "feedback-collector.form.bug.label",
        defaultMessage: "Describe the bug or issue"
    },
    formSuggestionLabel: {
        id: "feedback-collector.form.suggestion.label",
        defaultMessage: "Let us know what you'd like to improve"
    },
    formQuestionLabel: {
        id: "feedback-collector.form.question.label",
        defaultMessage: "What would you like to know?"
    },
    formEmptyLabel: {
        id: "feedback-collector.form.empty.label",
        defaultMessage: "Select an option"
    },
    formNotRelevantLabel: {
        id: "feedback-collector.form.not-relevant.label",
        defaultMessage: "Wasn't relevant"
    },
    formNotAccurateLabel: {
        id: "feedback-collector.form.not-accurate.label",
        defaultMessage: "Wasn't accurate"
    },
    formTooSlowLabel: {
        id: "feedback-collector.form.too-slow.label",
        defaultMessage: "Too slow"
    },
    formUnhelpfulLinksLabel: {
        id: "feedback-collector.form.unhelpful-links.label",
        defaultMessage: "Unhelpful links"
    },
    formOtherLabel: {
        id: "feedback-collector.form.other.label",
        defaultMessage: "Other"
    },
    selectionOptionQuestionLabel: {
        id: "feedback-collector.option.question.label",
        defaultMessage: "Ask a question"
    },
    selectionOptionCommentLabel: {
        id: "feedback-collector.option.comment.label",
        defaultMessage: "Leave a comment"
    },
    selectionOptionBugLabel: {
        id: "feedback-collector.option.bug.label",
        defaultMessage: "Report a bug"
    },
    selectionOptionSuggestionLabel: {
        id: "feedback-collector.option.suggestion.label",
        defaultMessage: "Suggest an improvement"
    },
    selectionOptionDefaultLabel: {
        id: "feedback-collector.option.default.label",
        defaultMessage: "Select feedback"
    },
    selectionOptionDefaultPlaceholder: {
        id: "feedback-collector.option.default.placeholder",
        defaultMessage: "Choose one"
    },
    feedbackIconLabel: {
        id: "proforma-form-builder.feedback-icon-label",
        defaultMessage: "Feedback"
    },
    feedbackSuccessFlagDescription: {
        id: "feedback-collector.success-flag.description",
        defaultMessage: "Your valuable feedback helps us continually improve our products."
    },
    feedbackSuccessFlagTitle: {
        id: "feedback-collector.success-flag.title",
        defaultMessage: "Thanks!"
    },
    feedbackIsAnonymousTitle: {
        id: "feedback-collector.anonymous.title",
        defaultMessage: "Anonymous feedback"
    },
    feedbackIsAnonymous: {
        id: "feedback-collector.anonymous",
        defaultMessage: "This feedback is being submitted anonymously. Atlassian will not be able to contact you directly regarding this feedback"
    },
    requiredFieldsSummary: {
        id: "feedback-collector.required.fields.summary",
        defaultMessage: "Required fields are marked with an asterisk"
    },
    defaultCustomTextAreaLabel: {
        id: "feedback-collector.default.custom.textarea.label",
        defaultMessage: "What's on your mind?"
    },
    canBeContactedLabelAppifyWithResponse: {
        id: "feedback-collector.can-be-contacted.label-appify-with-response",
        defaultMessage: "Yes, Atlassian teams can reply to my feedback and ask for more details about my experience to improve Atlassian apps and services. Without this, I won't get a response. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelAppifyWithResponseWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-appify-with-response-without-link",
        defaultMessage: "Yes, Atlassian teams can reply to my feedback and ask for more details about my experience to improve Atlassian apps and services. Without this, I won't get a response. I acknowledge the Atlassian Privacy Policy."
    },
    feedbackSuccessFlagDescriptionAppify: {
        id: "feedback-collector.success-flag.description-appify",
        defaultMessage: "Your valuable feedback helps us continually improve our apps."
    },
    validationErrorTypeRequired: {
        id: "feedback-collector.validation.type.required",
        defaultMessage: "Please select a feedback type"
    },
    validationErrorDescriptionRequired: {
        id: "feedback-collector.validation.description.required",
        defaultMessage: "Please provide a description"
    },
    optInOptionsLegend: {
        id: "feedback-collector.opt-in.options.legend",
        defaultMessage: "Atlassian opt-in options"
    }
});
module.exports["messages"] = $0eef762dd50d9f91$export$defe85febe8b728c;

});

parcelRegister("hTUp6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $b2A1s = parcelRequire("b2A1s");

const $fb8b4f9502ba72fc$export$f793de1293176fe6 = ({ children: children, locale: locale })=>{
    const [resolvedMessagesForLocale, setResolvedMessagesForLocale] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        const fetchMessageLocale = async ()=>{
            if (locale) {
                const messages = await (0, $b2A1s.getMessagesForLocale)(locale);
                setResolvedMessagesForLocale(messages);
            }
        };
        fetchMessageLocale();
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: locale || 'en',
        defaultLocale: "en",
        messages: resolvedMessagesForLocale
    }, children);
};
module.exports["IntlProviderWithResolvedMessages"] = $fb8b4f9502ba72fc$export$f793de1293176fe6;

});

parcelRegister("b2A1s", function(module, exports) {
const $e1a3f1d7e16f1235$var$isNestedMessagesModule = (value)=>'default' in value && typeof value.default === 'object' && value.default !== null;
const $e1a3f1d7e16f1235$var$unwrapMessages = (messages)=>{
    const defaultExport = messages.default;
    return $e1a3f1d7e16f1235$var$isNestedMessagesModule(defaultExport) ? defaultExport.default : defaultExport;
};





























const $e1a3f1d7e16f1235$var$messagesLoaders = {
    cs: ()=>(parcelRequire("gR4U1")),
    da: ()=>(parcelRequire("f1jrk")),
    de: ()=>(parcelRequire("aOLRB")),
    en: ()=>(parcelRequire("6kEFl")),
    en_GB: ()=>(parcelRequire("bjsxN")),
    en_ZZ: ()=>(parcelRequire("9DhD6")),
    es: ()=>(parcelRequire("ddpWy")),
    fi: ()=>(parcelRequire("5XvgX")),
    fr: ()=>(parcelRequire("cZf5E")),
    hr: ()=>(parcelRequire("CsODP")),
    hu: ()=>(parcelRequire("hPRyr")),
    it: ()=>(parcelRequire("z7zpe")),
    ja: ()=>(parcelRequire("8pzcT")),
    ko: ()=>(parcelRequire("1I2b8")),
    nb: ()=>(parcelRequire("gPBz3")),
    nl: ()=>(parcelRequire("78iTh")),
    pl: ()=>(parcelRequire("gHYE1")),
    pt_BR: ()=>(parcelRequire("9qN1z")),
    ru: ()=>(parcelRequire("dNwJi")),
    sl: ()=>(parcelRequire("fXweJ")),
    sr_RS: ()=>(parcelRequire("nFTVL")),
    sr_YR: ()=>(parcelRequire("bsw4B")),
    sv: ()=>(parcelRequire("97qPc")),
    th: ()=>(parcelRequire("bZmWu")),
    tr: ()=>(parcelRequire("aspSd")),
    uk: ()=>(parcelRequire("kWvvj")),
    vi: ()=>(parcelRequire("c5Sph")),
    zh: ()=>(parcelRequire("ecWO0")),
    zh_TW: ()=>(parcelRequire("dpkEO"))
};
const $e1a3f1d7e16f1235$var$getMessages = async (locale)=>{
    const loadMessages = $e1a3f1d7e16f1235$var$messagesLoaders[locale];
    if (!loadMessages) return undefined;
    try {
        const messages = await loadMessages();
        return $e1a3f1d7e16f1235$var$unwrapMessages(messages);
    } catch  {
        return undefined;
    }
};
const $e1a3f1d7e16f1235$export$d0a3169680473b6c = async (locale)=>{
    const localeKey = locale.replace('-', '_');
    const messages = await $e1a3f1d7e16f1235$var$getMessages(localeKey);
    return messages ?? $e1a3f1d7e16f1235$var$getMessages(localeKey.split(/[-_]/)[0]);
};
module.exports["getMessagesForLocale"] = $e1a3f1d7e16f1235$export$d0a3169680473b6c;

});

parcelRegister("gR4U1", function(module, exports) {

let $c455661dc243c654$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c455661dc243c654$var$load("iGnEn").then(()=>parcelRequire('6S4lG'));

});

parcelRegister("f1jrk", function(module, exports) {

let $aef60752586d2f07$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aef60752586d2f07$var$load("81CwI").then(()=>parcelRequire('9Q7ky'));

});

parcelRegister("aOLRB", function(module, exports) {

let $7e03b39534ef9cf9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7e03b39534ef9cf9$var$load("coMdg").then(()=>parcelRequire('4ELWT'));

});

parcelRegister("6kEFl", function(module, exports) {

let $49c427b32ae5dc71$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $49c427b32ae5dc71$var$load("4t3GG").then(()=>parcelRequire('aPmYJ'));

});

parcelRegister("bjsxN", function(module, exports) {

let $83c79c54c6feadd2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $83c79c54c6feadd2$var$load("lJDHR").then(()=>parcelRequire('fYO3Z'));

});

parcelRegister("9DhD6", function(module, exports) {

let $70356e70b5fecfa6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $70356e70b5fecfa6$var$load("izI99").then(()=>parcelRequire('fcttw'));

});

parcelRegister("ddpWy", function(module, exports) {

let $99f09d110267a62d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99f09d110267a62d$var$load("3LmH0").then(()=>parcelRequire('iTEZG'));

});

parcelRegister("5XvgX", function(module, exports) {

let $456ab880bb5ad2de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $456ab880bb5ad2de$var$load("9nUzh").then(()=>parcelRequire('jCyLN'));

});

parcelRegister("cZf5E", function(module, exports) {

let $9746e31b2d06b6ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9746e31b2d06b6ef$var$load("b0H0M").then(()=>parcelRequire('sjYCD'));

});

parcelRegister("CsODP", function(module, exports) {

let $0739e6f0f7a8ce09$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0739e6f0f7a8ce09$var$load("rlX60").then(()=>parcelRequire('kdtG9'));

});

parcelRegister("hPRyr", function(module, exports) {

let $cfc0bde35e1c9468$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cfc0bde35e1c9468$var$load("8XGfa").then(()=>parcelRequire('9cMV0'));

});

parcelRegister("z7zpe", function(module, exports) {

let $0699244176860d72$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0699244176860d72$var$load("kX4YP").then(()=>parcelRequire('65zeK'));

});

parcelRegister("8pzcT", function(module, exports) {

let $61fbf7e9b29a6824$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $61fbf7e9b29a6824$var$load("cYuG5").then(()=>parcelRequire('amjcb'));

});

parcelRegister("1I2b8", function(module, exports) {

let $13eb9721d58dad03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $13eb9721d58dad03$var$load("5bV9Q").then(()=>parcelRequire('3z1HI'));

});

parcelRegister("gPBz3", function(module, exports) {

let $c40e8c41f36f3f1d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c40e8c41f36f3f1d$var$load("gjrov").then(()=>parcelRequire('ePp5T'));

});

parcelRegister("78iTh", function(module, exports) {

let $5317ef0d88303541$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5317ef0d88303541$var$load("ekD3q").then(()=>parcelRequire('3sPeQ'));

});

parcelRegister("gHYE1", function(module, exports) {

let $c29fb436da7f42d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c29fb436da7f42d1$var$load("CRIov").then(()=>parcelRequire('21Pza'));

});

parcelRegister("9qN1z", function(module, exports) {

let $6ddc91febcf834c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ddc91febcf834c3$var$load("kLzqf").then(()=>parcelRequire('2YIPE'));

});

parcelRegister("dNwJi", function(module, exports) {

let $a0b93d651cd2386e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a0b93d651cd2386e$var$load("89F7K").then(()=>parcelRequire('lXD2K'));

});

parcelRegister("fXweJ", function(module, exports) {

let $b9e55f3b28230681$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b9e55f3b28230681$var$load("5ZUDB").then(()=>parcelRequire('16fIE'));

});

parcelRegister("nFTVL", function(module, exports) {

let $0472a6c8d6c4c707$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0472a6c8d6c4c707$var$load("h2pVk").then(()=>parcelRequire('byreT'));

});

parcelRegister("bsw4B", function(module, exports) {

let $857b304eeac06c5e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $857b304eeac06c5e$var$load("hKNph").then(()=>parcelRequire('diuUZ'));

});

parcelRegister("97qPc", function(module, exports) {

let $6a39935eb8b824b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6a39935eb8b824b7$var$load("bEB1L").then(()=>parcelRequire('57pGr'));

});

parcelRegister("bZmWu", function(module, exports) {

let $8ba730127f966548$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8ba730127f966548$var$load("1DxcO").then(()=>parcelRequire('grvEM'));

});

parcelRegister("aspSd", function(module, exports) {

let $79d096d1d3432597$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $79d096d1d3432597$var$load("4KHc0").then(()=>parcelRequire('13DVp'));

});

parcelRegister("kWvvj", function(module, exports) {

let $f3f1a976fda4a8c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f3f1a976fda4a8c1$var$load("fWsCx").then(()=>parcelRequire('im5if'));

});

parcelRegister("c5Sph", function(module, exports) {

let $8ce027b238ed199c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8ce027b238ed199c$var$load("eVExC").then(()=>parcelRequire('1U1j1'));

});

parcelRegister("ecWO0", function(module, exports) {

let $a57fcd3be5a7543a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a57fcd3be5a7543a$var$load("BGq3S").then(()=>parcelRequire('kBazV'));

});

parcelRegister("dpkEO", function(module, exports) {

let $9c2da245872fb648$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9c2da245872fb648$var$load("1BBYh").then(()=>parcelRequire('3tROA'));

});

parcelRegister("kWSTb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9feda705e9481f913d0df858359ce6d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f403cd42107c74dc$var$_react = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f403cd42107c74dc$var$_iconNew = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f403cd42107c74dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeSlides".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-generative-slides
 * Usage guidance:
 * Reserved for Confluence Slides
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f403cd42107c74dc$var$AiGenerativeSlidesIcon = (props)=>/*#__PURE__*/ $f403cd42107c74dc$var$_react.default.createElement($f403cd42107c74dc$var$_iconNew.default, Object.assign({
        name: "AiGenerativeSlidesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3.5H0V2h8v1.5H2.5V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5H15V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.903l-2.65 3.111-1.143-.972L4.376 12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13.115.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 3l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107A.75.75 0 0 1 12.999 0z"/>`
    }, props));
$f403cd42107c74dc$var$AiGenerativeSlidesIcon.displayName = 'AiGenerativeSlidesIcon';
var $f403cd42107c74dc$var$_default = module.exports.default = $f403cd42107c74dc$var$AiGenerativeSlidesIcon;

});

parcelRegister("4iiGe", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iTJtk = parcelRequire("iTJtk");


var $9DHhW = parcelRequire("9DHhW");

const $563438e2c71f5389$export$26781781bc6ae697 = ({ channel: channel } = {
    channel: (0, $iTJtk.FabricChannel).elements
})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const sendUIEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire(channel);
    }, [
        channel,
        createAnalyticsEvent
    ]);
    const sendTrackEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire(channel);
    }, [
        channel,
        createAnalyticsEvent
    ]);
    const sendOperationalEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire(channel);
    }, [
        channel,
        createAnalyticsEvent
    ]);
    const sendScreenEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire(channel);
    }, [
        channel,
        createAnalyticsEvent
    ]);
    return {
        sendUIEvent: sendUIEvent,
        sendTrackEvent: sendTrackEvent,
        sendOperationalEvent: sendOperationalEvent,
        sendScreenEvent: sendScreenEvent
    };
};
module.exports["usePlatformInstrumentation"] = $563438e2c71f5389$export$26781781bc6ae697;

});

parcelRegister("i8aB6", function(module, exports) {
/* eslint-disable perfectionist/sort-object-types */ 
var $cozmU = parcelRequire("cozmU");


var $34VCg = parcelRequire("34VCg");

const $89c606f0d1f4dfb4$export$fade2d05a6320d49 = ({ id: id, component: component, type: type, performanceType: performanceType })=>{
    const ufoExperience = (0, $cozmU.useRef)(new (0, $34VCg.UFOExperience)(id, {
        type: type,
        performanceType: performanceType,
        platform: {
            component: component
        }
    }));
    const start = (0, $cozmU.useCallback)((startTime)=>{
        return ufoExperience.current.start(startTime);
    }, []);
    const success = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.success(config);
    }, []);
    const mark = (0, $cozmU.useCallback)((name, timestamp)=>{
        ufoExperience.current.mark(name, timestamp);
    }, []);
    const addMetadata = (0, $cozmU.useCallback)((data)=>{
        ufoExperience.current.addMetadata(data);
    }, []);
    const markFMP = (0, $cozmU.useCallback)((timestamp)=>{
        ufoExperience.current.markFMP(timestamp);
    }, []);
    const markInlineResponse = (0, $cozmU.useCallback)((timestamp)=>{
        ufoExperience.current.markInlineResponse(timestamp);
    }, []);
    const failure = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.failure(config);
    }, []);
    const abort = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.abort(config);
    }, []);
    return {
        start: start,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        addMetadata: addMetadata,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};
module.exports["useUFOExperience"] = $89c606f0d1f4dfb4$export$fade2d05a6320d49;

});

parcelRegister("7aRa9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $cozmU.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("lsxnT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $cozmU.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $cozmU.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $cozmU.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("1YXTQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $clUfR = parcelRequire("clUfR");


var $7GLtr = parcelRequire("7GLtr");


var $awd1Q = parcelRequire("awd1Q");


var $bQm3c = parcelRequire("bQm3c");

'use no memo';
const $6f4eb0725770e50a$var$i18n = (0, $kSwu1.defineMessages)({
    now: {
        id: "time-ago.time.now",
        defaultMessage: "now"
    },
    lessThanAMinute: {
        id: "time-ago.time.lessThanAMinute",
        defaultMessage: "less than a minute ago"
    },
    onPreposition: {
        id: "time-ago.prepositions.on",
        defaultMessage: "on {datetime}"
    }
});
const $6f4eb0725770e50a$var$gradation = [
    // Less than 5 seconds -> "now"
    {
        format: ({ intl: intl })=>intl.formatMessage($6f4eb0725770e50a$var$i18n.now)
    },
    // Between 5-45 seconds -> "less than a minute ago"
    {
        threshold: 5,
        format: ({ intl: intl })=>intl.formatMessage($6f4eb0725770e50a$var$i18n.lessThanAMinute)
    },
    // Between 45 seconds-2.5 minutes -> "X minutes ago"
    {
        threshold: 45,
        factor: 60,
        unit: 'minute'
    },
    // Between 2.5-45 minutes -> "X minutes ago" (rounded to 5)
    {
        threshold: 150,
        factor: 60,
        granularity: 5,
        unit: 'minute'
    },
    // Between 45 minutes-24 hours -> "X hours ago"
    {
        threshold: 2700,
        factor: 3600,
        unit: 'hour'
    },
    // After 24 hours -> "full date"
    {
        threshold: 86400,
        format: ({ intl: intl, date: date, locale: locale, usePrepositions: usePrepositions, dateFormatOptions: dateFormatOptions, timeZone: timeZone, tenantTimeZone: tenantTimeZone })=>{
            const datetime = date.toLocaleDateString(locale, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                timeZone: (()=>{
                    // Prefer timeZone if provided, otherwise use tenantTimeZone, otherwise use browser timezone
                    const tz = timeZone || tenantTimeZone || (0, $clUfR.guessTimeZone)();
                    // Validate the timezone, use UTC as fallback for invalid values
                    return (0, $7GLtr.isValidTimeZone)(tz) ? tz : 'Etc/UTC';
                })(),
                ...dateFormatOptions
            });
            if (usePrepositions) return intl.formatMessage($6f4eb0725770e50a$var$i18n.onPreposition, {
                datetime: datetime
            });
            return datetime;
        }
    }
];
const $6f4eb0725770e50a$var$getGradationIndex = (seconds)=>{
    let i = $6f4eb0725770e50a$var$gradation.length - 1;
    while(i > 0 && seconds < ($6f4eb0725770e50a$var$gradation[i].threshold || seconds))i--;
    return i;
};
const $6f4eb0725770e50a$var$getSecondsSince = (date)=>(Date.now() - date.getTime()) / 1000;
const $6f4eb0725770e50a$export$78ae3e68d8c394bc = (intl, date, usePrepositions, dateFormatOptions, timeZone, tenantTimeZone)=>{
    const locale = (0, $awd1Q.getTranslation)().locale;
    const dateObject = new Date(date);
    const seconds = $6f4eb0725770e50a$var$getSecondsSince(dateObject);
    const i = $6f4eb0725770e50a$var$getGradationIndex(seconds);
    const customFormat = $6f4eb0725770e50a$var$gradation[i].format;
    if (customFormat) return customFormat({
        intl: intl,
        date: dateObject,
        locale: locale,
        usePrepositions: usePrepositions,
        dateFormatOptions: dateFormatOptions,
        timeZone: timeZone,
        tenantTimeZone: tenantTimeZone
    });
    // oxlint-disable-next-line compat/compat
    const localeLanguage = new Intl.Locale(locale).language;
    // oxlint-disable-next-line compat/compat
    const formatter = new Intl.RelativeTimeFormat(localeLanguage, {
        style: 'long',
        numeric: 'auto'
    });
    const granularity = $6f4eb0725770e50a$var$gradation[i].granularity || 1;
    const factor = $6f4eb0725770e50a$var$gradation[i].factor || 1;
    const value = -Math.round(seconds / factor / granularity) * granularity;
    const unit = $6f4eb0725770e50a$var$gradation[i].unit || 'second';
    return formatter.format(value, unit);
};
const $6f4eb0725770e50a$export$fc791eb9f9c39e49 = ({ date: date, usePrepositions: usePrepositions, dateFormatOptions: dateFormatOptions })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { timeZone: timeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        suppressHydrationWarning: true
    }, $6f4eb0725770e50a$export$78ae3e68d8c394bc(intl, date, usePrepositions, dateFormatOptions, timeZone, tenantTimeZone));
};
const $6f4eb0725770e50a$export$9e4a631e7281406a = ({ date: date, ...otherProps })=>{
    const [, setRenders] = (0, $cozmU.useState)(0);
    const dateObject = new Date(date);
    const seconds = $6f4eb0725770e50a$var$getSecondsSince(dateObject);
    const i = $6f4eb0725770e50a$var$getGradationIndex(seconds);
    (0, $cozmU.useEffect)(()=>{
        if (i != $6f4eb0725770e50a$var$gradation.length - 1) {
            const timeToNextGradation = ($6f4eb0725770e50a$var$gradation[i + 1].threshold || seconds) - seconds;
            const timeout = setTimeout(()=>{
                setRenders((x)=>x + 1);
            }, timeToNextGradation * 1000);
            return ()=>clearTimeout(timeout);
        }
    }, [
        i,
        seconds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f4eb0725770e50a$export$fc791eb9f9c39e49, {
        date: date,
        ...otherProps
    });
};
module.exports["formatTimeAgo"] = $6f4eb0725770e50a$export$78ae3e68d8c394bc;
module.exports["StaticTimeAgo"] = $6f4eb0725770e50a$export$fc791eb9f9c39e49;
module.exports["TimeAgo"] = $6f4eb0725770e50a$export$9e4a631e7281406a;

});

parcelRegister("clUfR", function(module, exports) {
const $dad8374cf8f904e8$export$c333b33f2586074c = ()=>{
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch  {
        return 'Etc/UTC';
    }
};
module.exports["guessTimeZone"] = $dad8374cf8f904e8$export$c333b33f2586074c;

});

parcelRegister("7GLtr", function(module, exports) {
const $0e3ee782c26ab488$export$c793e14020d7c7b = (timeZone)=>{
    try {
        Intl.DateTimeFormat(undefined, {
            timeZone: timeZone
        });
        return true;
    } catch  {
        return false;
    }
};
module.exports["isValidTimeZone"] = $0e3ee782c26ab488$export$c793e14020d7c7b;

});

parcelRegister("kDhla", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $9a24de4c41696be8$export$d4c72bab9d6cc13a = {
    fullPageEditorPresetAPI: undefined
};
const $9a24de4c41696be8$export$e324594224ef24da = {
    setEditorApi: (fullPageEditorPresetAPI)=>({ setState: setState })=>{
            setState({
                fullPageEditorPresetAPI: fullPageEditorPresetAPI
            });
        },
    resetEditorApi: ()=>({ setState: setState })=>{
            setState($9a24de4c41696be8$export$d4c72bab9d6cc13a);
        }
};
const $9a24de4c41696be8$var$FullPageEditorApiStore = (0, $8s9DV.createStore)({
    initialState: $9a24de4c41696be8$export$d4c72bab9d6cc13a,
    actions: $9a24de4c41696be8$export$e324594224ef24da,
    name: 'FullPageEditorApiStore'
});
const $9a24de4c41696be8$export$dc2b462ca736d2cc = (0, $kBr4q.createHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$6e619048e155ac67 = (0, $kBr4q.createActionsHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$4875e84e17c56c5c = (0, $kBr4q.createStateHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
module.exports["useFullPageEditorApi"] = $9a24de4c41696be8$export$dc2b462ca736d2cc;
module.exports["useFullPageEditorApiActions"] = $9a24de4c41696be8$export$6e619048e155ac67;
module.exports["useFullPageEditorApiState"] = $9a24de4c41696be8$export$4875e84e17c56c5c;

});

parcelRegister("4hCFw", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6SsN4 = parcelRequire("6SsN4");


var $w6R6I = parcelRequire("w6R6I");


var $cXtTj = parcelRequire("cXtTj");


var $7akNQ = parcelRequire("7akNQ");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $fNTq8 = parcelRequire("fNTq8");

var $cFVPs = parcelRequire("cFVPs");


var $5JhlM = parcelRequire("5JhlM");

var $bBIvl = parcelRequire("bBIvl");


var $d5gEx = parcelRequire("d5gEx");


var $gZFfs = parcelRequire("gZFfs");


var $i8aB6 = parcelRequire("i8aB6");


var $a7t2v = parcelRequire("a7t2v");


var $lgull = parcelRequire("lgull");


var $iTtzC = parcelRequire("iTtzC");

const $2795fb4dc781be1d$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $2795fb4dc781be1d$var$ANALYTICS_FROM_CODE = 'SMARTLINK';
const $2795fb4dc781be1d$var$DEFAULT_MAX_LINES = 4;
const $2795fb4dc781be1d$var$styles = {
    container: "_2sNsIg7NXe"
};
const $2795fb4dc781be1d$var$getContentTypeParam = (contentType)=>contentType === 'page' ? 'PAGE' : contentType === 'blogpost' ? 'BLOGPOST' : null;
const $2795fb4dc781be1d$var$getAnalyticsConfig = (props)=>({
        product: 'confluence',
        subproduct: 'confluence',
        source: 'confluencePage',
        aiFeatureName: 'aiSnippet',
        proactiveGeneratedAI: 1,
        userGeneratedAI: 0,
        additionalAttributes: {
            contentId: props.contentId,
            contentType: props.contentType,
            from: props.from ?? $2795fb4dc781be1d$var$ANALYTICS_FROM_CODE,
            productAttributionOverride: 'confluence'
        },
        enablePlatformEvents: true,
        skipAISessionValidation: true
    }); /**
     * Main AI Snippet component. Fetches the AI snippet data from the server and displays it.
     * If the snippet data type is not supported, it will display the fallback component.
     * If the AI snippet data is not found or another error occurs it will display the AISnippet component,
     * but with the fallback text in place of the response text.
     *
     * @param contentId - The content ID of the AI snippet
     * @param contentType - The content type of the AI snippet
     * @param cloudId - The cloud ID of the AI snippet
     * @param fallbackText - The text to display if the AI snippet fails to load
     * @param fallbackComponent - The component to display if the AI snippet is not supported
     * @param source [optional] - The source for where the AI snippet was triggered from defaults to 'smartlink'
     * @param onLoadComplete [optional] - The callback function that executes when loading has completed
     * @returns
     */ 
const $2795fb4dc781be1d$export$1b2af18ca4bb327b = (props)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $fNTq8.AIEventsInstrumentationProvider), {
        config: $2795fb4dc781be1d$var$getAnalyticsConfig(props)
    }, /*#__PURE__*/ $cozmU.createElement($2795fb4dc781be1d$export$ac90160f7ae1e32f, props));
};
const $2795fb4dc781be1d$export$ac90160f7ae1e32f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId, fallbackText: fallbackText, fallbackComponent: fallbackComponent, userId: userId, displayName: displayName, source: source = 'smartlink', maxLines: maxLines = $2795fb4dc781be1d$var$DEFAULT_MAX_LINES, isHidden: isHidden = false, onLoadComplete: onLoadComplete, showFooter: showFooter, showAwareness: showAwareness })=>{
    const [queryRef, loadQuery] = (0, $6SsN4.useQueryLoader)((0, $iTtzC.default));
    const isLoadingRef = (0, $cozmU.useRef)(true);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $cFVPs.useAIEventsInstrumentation)();
    const { start: start, success: success, failure: failure } = (0, $i8aB6.useUFOExperience)({
        id: 'ai-snippet-load',
        component: 'ai-snippet',
        type: (0, $gZFfs.ExperienceTypes).Load,
        performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult
    });
    const contentTypeParam = $2795fb4dc781be1d$var$getContentTypeParam(contentType);
    const isValidQuery = contentType && cloudId && contentId && contentTypeParam;
    const isEnabledForJira = (0, $iDrrr.fg)('jira-cc-ai-snippet-gate');
    const isTrackingEnabled = (0, $cXtTj.default).getExperimentValue('cc-ai-snippet-experiment-tracking', 'isEnabled', false);
    (0, $cozmU.useEffect)(()=>{
        if (!isHidden) trackAIInteractionInit();
        return ()=>{
            if (isLoadingRef.current && !isHidden) trackAIInteractionDismiss();
        }; // Only on component mount/unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $cozmU.useEffect)(()=>{
        isLoadingRef.current = !queryRef;
        if (queryRef) {
            if (isTrackingEnabled) success();
            onLoadComplete?.();
        }
    }, [
        queryRef,
        onLoadComplete,
        success,
        isTrackingEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isValidQuery) // Skip query if we don't have valid params as we'll just return the fallback component
        return;
        if (isTrackingEnabled) start();
        loadQuery({
            contentId: contentId,
            contentType: contentTypeParam,
            cloudId: cloudId,
            includeMe: isEnabledForJira
        });
    }, [
        contentId,
        contentTypeParam,
        cloudId,
        loadQuery,
        isValidQuery,
        isEnabledForJira,
        start,
        isTrackingEnabled
    ]);
    if (!isValidQuery) return fallbackComponent;
    const content = /*#__PURE__*/ $cozmU.createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $a7t2v.AISnippetContent), {
            text: fallbackText,
            contentId: contentId,
            showFooter: false,
            showAwareness: showAwareness,
            source: source,
            isHidden: isHidden,
            maxLines: maxLines
        }),
        onError: (error)=>{
            if (!isHidden) {
                if (isTrackingEnabled) failure({
                    metadata: {
                        errorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                        errorMessage: error.message || 'Unknown error'
                    }
                });
                trackAIResultError({
                    aiErrorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                    aiErrorMessage: error.message || 'Unknown error'
                });
            }
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($2795fb4dc781be1d$var$styles.container)
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $bBIvl.AIStreamLoading), null)
    }, queryRef ? /*#__PURE__*/ $cozmU.createElement((0, $lgull.AISnippetLoader), {
        queryRef: queryRef,
        fallbackText: fallbackText,
        contentId: contentId,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines,
        showFooter: showFooter,
        showAwareness: showAwareness
    }) : /*#__PURE__*/ $cozmU.createElement((0, $bBIvl.AIStreamLoading), null))));
    return /*#__PURE__*/ $cozmU.createElement((0, $7akNQ.FlagsProvider), null, isEnabledForJira ? content : /*#__PURE__*/ $cozmU.createElement((0, $5JhlM.AIFeedbackPropertiesProvider), {
        entrypointId: $2795fb4dc781be1d$var$SNIPPET_ENTRYPOINT_ID,
        userId: userId,
        displayName: displayName
    }, content));
};
const $2795fb4dc781be1d$export$c9a07cebec67e951 = (props)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $d5gEx.RelayEnvironmentProvider), null, /*#__PURE__*/ $cozmU.createElement($2795fb4dc781be1d$export$1b2af18ca4bb327b, props));
};
module.exports["AISnippetWithRelayEnvironment"] = $2795fb4dc781be1d$export$c9a07cebec67e951;

});

parcelRegister("fNTq8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jU6s6 = parcelRequire("jU6s6");


var $4dW9D = parcelRequire("4dW9D");


var $jLdbZ = parcelRequire("jLdbZ");

const $8a30b5a238fd1faa$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $8a30b5a238fd1faa$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $jLdbZ.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $cozmU.useMemo)(()=>{
        $8a30b5a238fd1faa$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $4dW9D.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jU6s6.AIEventsInstrumentationContext).Provider, {
        value: contextValue
    }, children);
};
module.exports["AIEventsInstrumentationProvider"] = $8a30b5a238fd1faa$export$b5d4bc85dfbaa4f8;

});

parcelRegister("5JhlM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $2eafd2f31cb677aa$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $2eafd2f31cb677aa$export$f906c21bacdb2d8e = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $2eafd2f31cb677aa$export$e9e654940dee103b = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $2eafd2f31cb677aa$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { locale: intlLocale } = (0, $kSwu1.useIntl)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $cozmU.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId,
            displayName: displayName
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        displayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2eafd2f31cb677aa$export$f906c21bacdb2d8e.Provider, {
        value: contextValue
    }, children);
};
const $2eafd2f31cb677aa$export$ff3deb4415ee32e3 = ()=>{
    const context = (0, $cozmU.useContext)($2eafd2f31cb677aa$export$f906c21bacdb2d8e);
    if (context === undefined) throw new Error('useAIFeedbackProperties must be used within a AIFeedbackPropertiesProvider');
    return context;
};
module.exports["AIFeedbackPropertiesProvider"] = $2eafd2f31cb677aa$export$e9e654940dee103b;
module.exports["useAIFeedbackProperties"] = $2eafd2f31cb677aa$export$ff3deb4415ee32e3;

});

parcelRegister("bBIvl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $kz1Yj = parcelRequire("kz1Yj");


var $buxP3 = parcelRequire("buxP3");


var $7m1U4 = parcelRequire("7m1U4");

const $b089d8c6b56c64f6$var$styles = (0, $buxP3.xcss)({
    color: 'color.text.subtle'
});
const $b089d8c6b56c64f6$var$i18n = (0, $kSwu1.defineMessages)({
    generatingSummaryText: {
        id: "ai-stream-loading.title",
        defaultMessage: "AI is working..."
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $b089d8c6b56c64f6$export$47a62cbf3ee79fef = ({ padding: padding = 'space.300', titleMessage: titleMessage })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const title = titleMessage ?? $b089d8c6b56c64f6$var$i18n.generatingSummaryText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        padding: padding,
        xcss: $b089d8c6b56c64f6$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7m1U4.GeneratingStreamAnimation), {
        alt: formatMessage($b089d8c6b56c64f6$var$i18n.generatingSummaryAnimationAlt)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), title)));
};
module.exports["AIStreamLoading"] = $b089d8c6b56c64f6$export$47a62cbf3ee79fef;

});

parcelRegister("7m1U4", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $cozmU = parcelRequire("cozmU");

const $c344a4b7f3959518$export$3709887a1be0e305 = ({ alt: alt })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("title", null, alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "#0C66E4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "#1D7AFC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "#388BFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));
};
module.exports["GeneratingStreamAnimation"] = $c344a4b7f3959518$export$3709887a1be0e305;

});

parcelRegister("a7t2v", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $303LV = parcelRequire("303LV");


var $cXtTj = parcelRequire("cXtTj");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $cFVPs = parcelRequire("cFVPs");


var $cAiYt = parcelRequire("cAiYt");

var $aIn0d = parcelRequire("aIn0d");

var $cHkK6 = parcelRequire("cHkK6");


var $5GgqH = parcelRequire("5GgqH");

const $24521ba341a214c8$var$MAU_CRITERIA_DWELL_TIME = 3000;
const $24521ba341a214c8$var$sanitizeMarkdown = (text)=>{
    if (!text) return '';
    return text.replace(/={4,}/g, '===') // h1 headers
    .replace(/-{4,}/g, '---'); // h2 headers
};
const $24521ba341a214c8$export$3cf37822a11d3ff3 = ({ text: text, contentId: contentId, showFooter: showFooter = true, showAwareness: showAwareness = false, source: source, isHidden: isHidden, maxLines: maxLines, renderAsMarkdown: renderAsMarkdown = true })=>{
    const ref = (0, $cozmU.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $5GgqH.usePopupDwellTime)(ref, 250);
    const { trackAIResultView: trackAIResultView, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $cFVPs.useAIEventsInstrumentation)();
    // This is needed to keep the snippet value in scope when running the unmount effect
    const snippetValueRef = (0, $cozmU.useRef)(text);
    const isExperimentEnabled = (0, $cXtTj.default).getExperimentValue('cc-ai-snippet-fixes-1025', 'isEnabled', false);
    const handleLikeClicked = (0, $cozmU.useCallback)(()=>{
        trackAIFeedbackSubmit('up');
    }, [
        trackAIFeedbackSubmit
    ]);
    const handleDislikeClicked = (0, $cozmU.useCallback)(()=>{
        trackAIFeedbackSubmit('down');
    }, [
        trackAIFeedbackSubmit
    ]);
    (0, $cozmU.useEffect)(()=>{
        const currentText = snippetValueRef.current;
        return ()=>{
            const dwellTime = getDwellTime();
            if (!isHidden) {
                if (showFooter && currentText && dwellTime >= $24521ba341a214c8$var$MAU_CRITERIA_DWELL_TIME) trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: true
                    }
                });
                else trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: showFooter && !!currentText
                    },
                    doesNotMeetMAUCriteria: true
                });
            }
        };
    // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        ref: ref
    }, showAwareness && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cAiYt.AIAwareness), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        maxLines: maxLines
    }, renderAsMarkdown ? isExperimentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $303LV.default), {
        options: {
            disableParsingRawHTML: true
        }
    }, $24521ba341a214c8$var$sanitizeMarkdown(text || '')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $303LV.default), null, text || '') : text || ''), showFooter && text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aIn0d.AIDisclaimer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cHkK6.AIFeedbackComponent), {
        contentId: contentId,
        onLikeClicked: handleLikeClicked,
        onDislikeClicked: handleDislikeClicked
    })));
};
module.exports["AISnippetContent"] = $24521ba341a214c8$export$3cf37822a11d3ff3;

});

parcelRegister("cAiYt", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $etoPX = parcelRequire("etoPX");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $4aRua = parcelRequire("4aRua");


var $1kxSE = parcelRequire("1kxSE");

const $b6dbb4b671decd4a$var$styles = {
    text: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
const $b6dbb4b671decd4a$export$fde99ed387d90f1 = ({ variant: variant = 'summary' })=>{
    const MESSAGE_MAP = {
        summary: (0, $1kxSE.i18n).rovoAwarenessMessage,
        define: (0, $1kxSE.i18n).rovoAwarenessDefineMessage
    };
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const message = MESSAGE_MAP[variant];
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($b6dbb4b671decd4a$var$styles.text)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $etoPX.RovoIcon), {
        size: "xxsmall",
        appearance: "brand"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage(message))));
};
module.exports["AIAwareness"] = $b6dbb4b671decd4a$export$fde99ed387d90f1;

});

parcelRegister("1kxSE", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c8fb6889a2026e6c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    rovoAwarenessMessage: {
        id: "ai-awareness.rovoAwarenessMessage",
        defaultMessage: "Summary by Rovo"
    },
    rovoAwarenessDefineMessage: {
        id: "ai-awareness-define.message",
        defaultMessage: "Definition by Rovo"
    }
});
module.exports["i18n"] = $c8fb6889a2026e6c$export$a7357cdd1f0b0168;

});

parcelRegister("cHkK6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $2eX69 = parcelRequire("2eX69");


var $4MnFz = parcelRequire("4MnFz");


var $chu6R = parcelRequire("chu6R");


var $i1t43 = parcelRequire("i1t43");


var $iDrrr = parcelRequire("iDrrr");


var $3izAL = parcelRequire("3izAL");


var $kz1Yj = parcelRequire("kz1Yj");


var $buxP3 = parcelRequire("buxP3");


var $lpNn5 = parcelRequire("lpNn5");


var $5JhlM = parcelRequire("5JhlM");


var $gecH2 = parcelRequire("gecH2");

const $2e66c8b5b2928379$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $2e66c8b5b2928379$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $2e66c8b5b2928379$var$i18n = (0, $kSwu1.defineMessages)({
    flagTitle: {
        id: "quick-summary.feedback.flag.title",
        defaultMessage: "Thanks!"
    },
    flagDescription: {
        id: "quick-summary.feedback.flag.description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    },
    likeTooltip: {
        id: "quick-summary.like.tooltip",
        defaultMessage: "Helpful"
    },
    dislikeTooltip: {
        id: "quick-summary.dislike.tooltip",
        defaultMessage: "Not helpful"
    },
    feedbackTitle: {
        id: "quick-summary.feedback.title",
        defaultMessage: "Help us improve Atlassian Intelligence"
    },
    feedbackSummaryTitle: {
        id: "quick-summary.feedback.summary.title",
        defaultMessage: "Tell us about your experience"
    },
    feedbackSummaryPlaceholder: {
        id: "quick-summary.feedback.summary.placeholder",
        defaultMessage: "What did Atlassian Intelligence do well? What could be improved?"
    },
    canContactText: {
        id: "quick-summary.feedback.can-contact.label",
        defaultMessage: "Atlassian can contact me about this feedback. See our {privacyPolicyLink}."
    },
    privacyPolicyLink: {
        id: "quick-summary.feedback.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    improveAtlassianText: {
        id: "quick-summary.feedback.improve-atlassian",
        defaultMessage: "I\u2019d like to help improve Atlassian products by joining the {researchGroupLink}."
    },
    improveAtlassianTextAppify: {
        id: "quick-summary.feedback.improve-atlassian-appify",
        defaultMessage: "I\u2019d like to help improve Atlassian apps by joining the {researchGroupLink}."
    },
    researchGroupLink: {
        id: "quick-summary.feedback.research-group.link",
        defaultMessage: "Atlassian Research Group"
    }
});
const $2e66c8b5b2928379$var$PrivacyPolicyLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2e66c8b5b2928379$var$i18n.privacyPolicyLink));
const $2e66c8b5b2928379$var$ResearchGroupLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2e66c8b5b2928379$var$i18n.researchGroupLink));
const $2e66c8b5b2928379$var$CanContactLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$2e66c8b5b2928379$var$i18n.canContactText,
        values: {
            privacyPolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$PrivacyPolicyLink, {
                link: $2e66c8b5b2928379$var$LINK_TO_PRIVACY_POLICY
            })
        }
    });
};
const $2e66c8b5b2928379$var$EnrolLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $iDrrr.fg)('product-terminology-refresh') ? $2e66c8b5b2928379$var$i18n.improveAtlassianTextAppify : $2e66c8b5b2928379$var$i18n.improveAtlassianText,
        values: {
            researchGroupLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$ResearchGroupLink, {
                link: $2e66c8b5b2928379$var$LINK_TO_RESEARCH_GROUP
            })
        }
    });
};
const $2e66c8b5b2928379$var$DislikeIconWrapperXCSS = (0, $buxP3.xcss)({
    transform: 'rotate(180deg)'
});
const $2e66c8b5b2928379$var$ButtonWrapperXCSS = (0, $buxP3.xcss)({
    height: '24px',
    width: '24px'
});
const $2e66c8b5b2928379$export$f9f34317e5bc3551 = ({ contentId: contentId, onLikeClicked: onLikeClicked, onDislikeClicked: onDislikeClicked })=>{
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isFeedbackOpen, setIsFeedbackOpen] = (0, $cozmU.useState)(false);
    const feedbackCollectorProperties = (0, $5JhlM.useAIFeedbackProperties)();
    const [sentiment, setSentiment] = (0, $cozmU.useState)('');
    const [hasGoodFeedbackBeenSubmitted, setHasGoodFeedbackBeenSubmitted] = (0, $cozmU.useState)(false);
    const [hasBadFeedbackBeenSubmitted, setHasBadFeedbackBeenSubmitted] = (0, $cozmU.useState)(false);
    const feedbackContextString = `contentId: ${contentId} sentiment: ${sentiment}${feedbackCollectorProperties.feedbackContext.length > 0 ? ` ${feedbackCollectorProperties.feedbackContext}` : ''}`;
    const showFeedbackFlag = ()=>{
        showFlag({
            title: formatMessage($2e66c8b5b2928379$var$i18n.flagTitle),
            description: formatMessage($2e66c8b5b2928379$var$i18n.flagDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                spacing: "spacious",
                color: "var(--ds-icon-success, #6A9A23)",
                label: "success"
            }),
            isAutoDismiss: true
        });
    };
    const handleLikeClicked = ()=>{
        onLikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('good');
    };
    const handleDislikeClicked = ()=>{
        onDislikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('bad');
    };
    const onFeedbackSubmit = ()=>{
        showFeedbackFlag();
        setIsFeedbackOpen(false);
        if (sentiment === 'good') {
            setHasGoodFeedbackBeenSubmitted(true);
            setHasBadFeedbackBeenSubmitted(false);
        } else {
            setHasBadFeedbackBeenSubmitted(true);
            setHasGoodFeedbackBeenSubmitted(false);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        role: "none",
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage($2e66c8b5b2928379$var$i18n.likeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $2e66c8b5b2928379$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        "aria-label": formatMessage($2e66c8b5b2928379$var$i18n.likeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gecH2.ThumbIcon), {
            isSelected: hasGoodFeedbackBeenSubmitted
        }),
        onClick: handleLikeClicked,
        testId: "feedback-like-button",
        isDisabled: hasGoodFeedbackBeenSubmitted
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage($2e66c8b5b2928379$var$i18n.dislikeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $2e66c8b5b2928379$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        "aria-label": formatMessage($2e66c8b5b2928379$var$i18n.dislikeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $2e66c8b5b2928379$var$DislikeIconWrapperXCSS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gecH2.ThumbIcon), {
            isSelected: hasBadFeedbackBeenSubmitted
        })),
        onClick: handleDislikeClicked,
        testId: "feedback-dislike-button",
        isDisabled: hasBadFeedbackBeenSubmitted
    }))), isFeedbackOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2eX69.default), {
        locale: feedbackCollectorProperties.locale,
        onSubmit: onFeedbackSubmit,
        onClose: ()=>setIsFeedbackOpen(false),
        atlassianAccountId: feedbackCollectorProperties.userId,
        name: feedbackCollectorProperties.displayName,
        entrypointId: feedbackCollectorProperties.entrypointId,
        summaryPlaceholder: formatMessage($2e66c8b5b2928379$var$i18n.feedbackSummaryPlaceholder),
        additionalFields: [
            {
                id: feedbackCollectorProperties.feedbackContextId,
                value: feedbackContextString
            }
        ],
        feedbackTitle: formatMessage($2e66c8b5b2928379$var$i18n.feedbackTitle),
        showTypeField: false,
        customTextAreaLabel: formatMessage($2e66c8b5b2928379$var$i18n.feedbackSummaryTitle),
        canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$CanContactLabel, null),
        enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$EnrolLabel, null)
    })));
};
module.exports["AIFeedbackComponent"] = $2e66c8b5b2928379$export$f9f34317e5bc3551;

});

parcelRegister("gecH2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $c8bBH = parcelRequire("c8bBH");

const $62e24cf344a5b8b1$export$ec2ba0e929740f73 = ({ isSelected: isSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)",
        label: ""
    });
module.exports["ThumbIcon"] = $62e24cf344a5b8b1$export$ec2ba0e929740f73;

});

parcelRegister("5GgqH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $44sV7 = parcelRequire("44sV7");

const $518681ac338b53b3$export$15dda63faa44a0df = (ref, interval = 500)=>{
    const isOnScreen = (0, $44sV7.useOnScreen)(ref);
    const dwellTimeRef = (0, $cozmU.useRef)(0);
    (0, $cozmU.useEffect)(()=>{
        const incremental = setInterval(()=>{
            if (isOnScreen) dwellTimeRef.current += interval;
        }, interval);
        return ()=>{
            clearInterval(incremental);
        };
    }, [
        isOnScreen,
        interval
    ]);
    const getDwellTime = ()=>dwellTimeRef.current;
    return {
        getDwellTime: getDwellTime
    };
};
module.exports["usePopupDwellTime"] = $518681ac338b53b3$export$15dda63faa44a0df;

});

parcelRegister("44sV7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $9f61f2cd2c8e0202$export$edb9b52ab3f1abbb = (ref)=>{
    const [isIntersecting, setIntersecting] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            if (observer) observer.disconnect();
        };
    });
    return isIntersecting;
};
module.exports["useOnScreen"] = $9f61f2cd2c8e0202$export$edb9b52ab3f1abbb;

});

parcelRegister("lgull", function(module, exports) {

var $iTtzC = parcelRequire("iTtzC");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $iDrrr = parcelRequire("iDrrr");


var $5JhlM = parcelRequire("5JhlM");


var $a7t2v = parcelRequire("a7t2v");

const $a1264e7348edcdb0$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $a1264e7348edcdb0$export$f50b64530422ea99 = ({ contentId: contentId, fallbackText: fallbackText, queryRef: queryRef, source: source, isHidden: isHidden, maxLines: maxLines, showFooter: showFooter, showAwareness: showAwareness })=>{
    const data = (0, $6SsN4.usePreloadedQuery)((0, $iTtzC.default), queryRef);
    const aiSnippetText = data?.confluence_latestKnowledgeGraphObjectV2?.objectData;
    const content = /*#__PURE__*/ $cozmU.createElement((0, $a7t2v.AISnippetContent), {
        text: aiSnippetText || fallbackText,
        contentId: contentId,
        showFooter: !!aiSnippetText && showFooter,
        showAwareness: !!aiSnippetText && showAwareness,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines,
        renderAsMarkdown: !!aiSnippetText
    });
    if ((0, $iDrrr.fg)('jira-cc-ai-snippet-gate')) return /*#__PURE__*/ $cozmU.createElement((0, $5JhlM.AIFeedbackPropertiesProvider), {
        entrypointId: $a1264e7348edcdb0$var$SNIPPET_ENTRYPOINT_ID,
        userId: data?.me?.user?.accountId,
        displayName: data?.me?.user?.name
    }, content);
    return content;
};
module.exports["AISnippetLoader"] = $a1264e7348edcdb0$export$f50b64530422ea99;

});

parcelRegister("iTtzC", function(module, exports) {
/**
 * @generated SignedSource<<77586322f750ae0b68f16053ceaefeac>>
 * @relayHash 83b5f9dcca400199c020ae8cd7e6e7c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40
const $34c51f4beec18331$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeMe"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "contentId",
                "variableName": "contentId"
            },
            {
                "kind": "Variable",
                "name": "contentType",
                "variableName": "contentType"
            },
            {
                "kind": "Literal",
                "name": "objectType",
                "value": "snippet_v2"
            }
        ],
        "concreteType": "KnowledgeGraphObjectResponseV2",
        "kind": "LinkedField",
        "name": "confluence_latestKnowledgeGraphObjectV2",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "objectData"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40",
            "metadata": {},
            "name": "aiSnippetLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$34c51f4beec18331$var$node.hash = "9d618230ccff7c19cd4e4fee2e2c0a2c";
var $34c51f4beec18331$export$2e2bcd8739ae039 = $34c51f4beec18331$var$node;
module.exports["default"] = $34c51f4beec18331$export$2e2bcd8739ae039;

});

parcelRegister("di8q4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("jXuVu"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("jXuVu", function(module, exports) {

let $e87b845248feaf56$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e87b845248feaf56$var$load("kGnv3"),
    $e87b845248feaf56$var$load("kPpF9"),
    $e87b845248feaf56$var$load("cBeoH"),
    $e87b845248feaf56$var$load("lN9TX"),
    $e87b845248feaf56$var$load("gFeoL"),
    $e87b845248feaf56$var$load("6wr18"),
    $e87b845248feaf56$var$load("iNbHV"),
    $e87b845248feaf56$var$load("ffEVr"),
    $e87b845248feaf56$var$load("4Ldt2"),
    $e87b845248feaf56$var$load("5gsbh"),
    $e87b845248feaf56$var$load("hsRa9"),
    $e87b845248feaf56$var$load("bEleE"),
    $e87b845248feaf56$var$load("8OeKT"),
    $e87b845248feaf56$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("7lu50", function(module, exports) {
// old definition from tysy - not a real query being used
const $a928a12ca5fd59f3$export$adaf854818ff0d42 = (queryData)=>{
    return queryData?.entitlements?.externalCollaborator.isEntitled;
};
module.exports["getExternalCollaboratorEntitlementFromQuery"] = $a928a12ca5fd59f3$export$adaf854818ff0d42;

});

parcelRegister("9fywD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");


var $lpNn5 = parcelRequire("lpNn5");

const $43aed8c383cce8da$var$i18n = (0, $kSwu1.defineMessages)({
    externalUserLozengeText: {
        id: "external-collab-ui.user-guest-lozenge",
        defaultMessage: "Guest"
    },
    guestUserTooltip: {
        id: "external-collab-ui.user-guest-lozenge.tooltip",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    }
});
const $43aed8c383cce8da$export$4de00d985a23014d = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $43aed8c383cce8da$var$i18n.guestUserTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $43aed8c383cce8da$var$i18n.externalUserLozengeText)),
    appearance: 'default',
    isBold: false
};
const $43aed8c383cce8da$export$aa87bb37f13b8b5 = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $43aed8c383cce8da$export$4de00d985a23014d;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalUserLozengeProps"] = $43aed8c383cce8da$export$4de00d985a23014d;
module.exports["ExternalUserLozenge"] = $43aed8c383cce8da$export$aa87bb37f13b8b5;

});

parcelRegister("lSOAM", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");


var $8RwKN = parcelRequire("8RwKN");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).HOME.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $8RwKN.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const $2a47a9fc48674e91$export$c5aa7fcaede4a84d = (0, $iDdTC.metrics).pageLoad;
const $2a47a9fc48674e91$export$19ba7be4fcf34f3d = (0, $iDdTC.metrics).custom;
const $2a47a9fc48674e91$export$36d7a61d0660e29c = (0, $iDdTC.metrics).interaction;
const $2a47a9fc48674e91$var$concurrent = (0, $iDdTC.metrics).concurrent;
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createPageLoadMetric"] = $2a47a9fc48674e91$export$c5aa7fcaede4a84d;
module.exports["createCustomMetric"] = $2a47a9fc48674e91$export$19ba7be4fcf34f3d;
module.exports["createInteractionMetric"] = $2a47a9fc48674e91$export$36d7a61d0660e29c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("fd6g2", function(module, exports) {
// "confluence.fe.custom.XXX"
const $88f9a74d7687653d$export$3fe4a04f712fdf3b = 'mentions-query';
const $88f9a74d7687653d$export$18a3d3c084ff47d0 = 'profile-card-query';
const $88f9a74d7687653d$export$95463e4d15a0dca9 = 'legacy-extension-loading';
const $88f9a74d7687653d$export$5a66bfdc2ac06329 = 'fabric-publish-page';
const $88f9a74d7687653d$export$96dfe3e664538004 = 'time-to-app-idle';
const $88f9a74d7687653d$export$18a3e97ff841447b = 'share-notif-from-restrictions';
const $88f9a74d7687653d$export$d0eb1faf5fa0dbc7 = 'tc-events-fetch';
const $88f9a74d7687653d$export$ec119fee4dbc7f75 = 'tc-subcals-fetch';
const $88f9a74d7687653d$export$693c7d831f137ed3 = 'tc-jira-projects-fetch';
module.exports["MENTIONS_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$3fe4a04f712fdf3b;
module.exports["PROFILE_CARD_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$18a3d3c084ff47d0;
module.exports["LEGACY_EXTENSION_LOADING_CUSTOM_KEY"] = $88f9a74d7687653d$export$95463e4d15a0dca9;
module.exports["FABRIC_PUBLISH_PAGE_KEY"] = $88f9a74d7687653d$export$5a66bfdc2ac06329;
module.exports["TIME_TO_APP_IDLE_KEY"] = $88f9a74d7687653d$export$96dfe3e664538004;
module.exports["TEAM_CALENDARS_EVENT_FETCH_KEY"] = $88f9a74d7687653d$export$d0eb1faf5fa0dbc7;
module.exports["TEAM_CALENDARS_SUBCALS_FETCH_KEY"] = $88f9a74d7687653d$export$ec119fee4dbc7f75;
module.exports["TEAM_CALENDARS_JIRA_PROJECTS_FETCH_KEY"] = $88f9a74d7687653d$export$693c7d831f137ed3;

});

parcelRegister("bumSD", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $5hJlu = parcelRequire("5hJlu");


var $bp86Z = parcelRequire("bp86Z");

const $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH = '/gateway/api/directory/graphql';
const $226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG = {
    url: $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH,
    cacheSize: 100,
    cacheMaxAge: 300000 // - 5 minutes
};
const $226eb0cd9c5c41b1$export$441fd008df03d370 = (0, $dOBRD.default)((cloudId, _)=>{
    const profileClientConfig = {
        ...$226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG,
        productIdentifier: 'confluence',
        cloudId: cloudId
    };
    return new (0, $5hJlu.ProfileClient)(profileClientConfig, {
        userClient: new (0, $bp86Z.UserProfileClientForConfluence)(profileClientConfig)
    });
});
module.exports["getProfileClient"] = $226eb0cd9c5c41b1$export$441fd008df03d370;

});

parcelRegister("bp86Z", function(module, exports) {

var $34knR = parcelRequire("34knR");


var $9fywD = parcelRequire("9fywD");


var $7lu50 = parcelRequire("7lu50");


var $ldOrZ = parcelRequire("ldOrZ");


var $2A84u = parcelRequire("2A84u");


var $9jSPN = parcelRequire("9jSPN");


var $c0rhi = parcelRequire("c0rhi");

class $e0ed8187aad1d5de$export$8e0680112f77975e extends (0, $34knR.default) {
    async makeRequest(cloudId, userId) {
        // Note because we are only subclassing "makeRequest()", we are still using UserProfileClient's
        // default "getProfile()" function - which means we automatically get the standard
        // UserProfileClient caching of the full user profile data, including our added properties
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).start();
        const UserProfileClientForConfluencePromise = (0, $c0rhi.queryInterop)({
            query: (0, $2A84u.UserProfileClientForConfluenceQuery),
            variables: {
                userId: userId
            },
            __callerPackage__: "profile"
        });
        // If the standard user data query fails, we want to reject the returned promise because there
        // won't be any data for the caller to make a useful ProfileCard.  But if the standard user
        // data query succeeds but External Collaboration data query fails, we want to still display
        // the ProfileCard with the standard user data (that is, we don't want to reject).  In order to
        // do this, we can't use "Promise.all()" because it will return immediately when any of its
        // requests fail.  Instead we need to wait until all of the requests complete or fail, and that
        // means using "Promise.allSettled()", which has a much more complicated return object.
        const [userProfileClientForConfluenceQueryResult, standardUserDataResult] = await Promise.allSettled([
            UserProfileClientForConfluencePromise,
            super.makeRequest(cloudId, userId)
        ]);
        if (standardUserDataResult.status === 'rejected') {
            (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
                customData: {
                    success: false
                }
            });
            return Promise.reject(standardUserDataResult.reason);
        }
        // If the External Collaboration query was successful and External Collaboration is entitled
        // and this user is an External user, then add our custom Lozenge to the standard user profile
        // data
        const customLozenges = [];
        if (userProfileClientForConfluenceQueryResult.status === 'fulfilled') {
            const confluenceUserResponse = userProfileClientForConfluenceQueryResult.value.data;
            if ((0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(confluenceUserResponse) && confluenceUserResponse?.user?.confluence?.permissionType === (0, $ldOrZ.SitePermissionType).EXTERNAL) customLozenges.push({
                ...(0, $9fywD.ExternalUserLozengeProps),
                key: 'ExternalUserLozenge'
            });
        }
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
            customData: {
                success: true
            }
        });
        return {
            ...standardUserDataResult.value,
            customLozenges: customLozenges
        };
    }
}
module.exports["UserProfileClientForConfluence"] = $e0ed8187aad1d5de$export$8e0680112f77975e;

});

parcelRegister("ldOrZ", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $0709253cacc9fe3a$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $0709253cacc9fe3a$export$8995abb8169b2cb8;

});

parcelRegister("2A84u", function(module, exports) {

var $ay9Uu = parcelRequire("ay9Uu");

const $ab1c6257ac115bcc$export$8322eea6a290b246 = (0, $ay9Uu.default);
module.exports["UserProfileClientForConfluenceQuery"] = $ab1c6257ac115bcc$export$8322eea6a290b246;

});

parcelRegister("ay9Uu", function(module, exports) {
/**
 * @generated SignedSource<<c8072e566be2615c9f169051b183f1d7>>
 * @relayHash e3b7fcde55b949bf8d80bddd9a0ac180
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee7894fc24fdc7e2f211db85d0b9ca04c99930331a3373b4aec2e287d771850d
const $bb661b120eec94ae$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": false
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "userId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UserProfileClientForConfluenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UserProfileClientForConfluenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e3b7fcde55b949bf8d80bddd9a0ac180",
            "id": "ee7894fc24fdc7e2f211db85d0b9ca04c99930331a3373b4aec2e287d771850d",
            "metadata": {},
            "name": "UserProfileClientForConfluenceQuery",
            "operationKind": "query",
            "text": "query UserProfileClientForConfluenceQuery($userId:ID){user:confluence_atlassianUser(current:false,id:$userId){id,confluence{permissionType}},entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$bb661b120eec94ae$var$node.hash = "f636f7ede64e4c0d1757767b061d53b5";
var $bb661b120eec94ae$export$2e2bcd8739ae039 = $bb661b120eec94ae$var$node;
module.exports["default"] = $bb661b120eec94ae$export$2e2bcd8739ae039;

});

parcelRegister("9jSPN", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $5487d57e41530957$export$c2710940b43dcf08 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.PROFILE_CARD_QUERY_CUSTOM_KEY)
});
module.exports["PROFILE_CARD_QUERY_METRIC"] = $5487d57e41530957$export$c2710940b43dcf08;

});

parcelRegister("bedVD", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lpNn5 = parcelRequire("lpNn5");

const $e4e11ee9fe4a88c9$var$i18n = (0, $kSwu1.defineMessages)({
    follow: {
        id: "profile.card.follow",
        defaultMessage: "Follow"
    },
    unfollow: {
        id: "profile.card.unfollow",
        defaultMessage: "Unfollow"
    },
    followTooltip: {
        id: "profile.card.follow.tooltip",
        defaultMessage: "See activity in feed"
    },
    unfollowTooltip: {
        id: "profile.card.unfollow.tooltip",
        defaultMessage: "Stop seeing activity in feed"
    }
});
const $e4e11ee9fe4a88c9$export$d258f317c876c5dc = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { followed: followed } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== followed || $[1] !== intl) {
        t1 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollowTooltip : $e4e11ee9fe4a88c9$var$i18n.followTooltip);
        $[0] = followed;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== followed || $[4] !== intl) {
        t2 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollow : $e4e11ee9fe4a88c9$var$i18n.follow);
        $[3] = followed;
        $[4] = intl;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t1 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t1,
            position: "bottom",
            testId: "feed-follow-tooltip"
        }, t3);
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};
module.exports["FeedFollow"] = $e4e11ee9fe4a88c9$export$d258f317c876c5dc;

});

parcelRegister("4GlQ9", function(module, exports) {

var $k7Nop = parcelRequire("k7Nop");


var $hOSkW = parcelRequire("hOSkW");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");

const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery = (0, $hOSkW.default);
const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation = (0, $k7Nop.default);
const $e2d6f47b8e3454eb$var$isUserHasNoAccessError = (error)=>error?.graphQLErrors?.some((gqlError)=>gqlError?.path?.includes('getFeedUserConfig') && gqlError?.message?.includes('User not permitted to access Confluence'));
let $e2d6f47b8e3454eb$export$8631e45fce8db7c6 = false;
function $e2d6f47b8e3454eb$export$438df56e0ed352e6() {
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { data: data, loading: queryLoading, error: feedConfigError } = (0, $jMyy4.useQueryInterop)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery, {
        skip: !isLicensed || $e2d6f47b8e3454eb$export$8631e45fce8db7c6,
        onError: (error)=>$e2d6f47b8e3454eb$export$8631e45fce8db7c6 = $e2d6f47b8e3454eb$var$isUserHasNoAccessError(error),
        __callerPackage__: "profile"
    });
    const [mutateFeedFollow, { error: mutationError }] = (0, $308Wd.useMutationInterop)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation, {
        refetchQueries: [
            {
                query: $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery
            }
        ],
        __callerPackage__: "profile"
    });
    const followedUsersRaw = data?.getFeedUserConfig?.accountIds;
    const followedUsers = (0, $cozmU.useMemo)(()=>followedUsersRaw?.map((id)=>id ?? null) ?? [], [
        followedUsersRaw
    ]);
    const getToggleFollowUser = (0, $cozmU.useCallback)((accountId, following, source)=>async ()=>{
            if (!accountId) return;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'feedFollow',
                    source: source,
                    attributes: {
                        id: accountId,
                        settingType: 'user',
                        actionType: following ? 'unfollow' : 'follow'
                    }
                }
            }).fire();
            try {
                if (following) await mutateFeedFollow({
                    variables: {
                        unfollow: [
                            accountId
                        ]
                    }
                });
                else await mutateFeedFollow({
                    variables: {
                        follow: [
                            accountId
                        ]
                    }
                });
            } catch  {
            // noop since the hook consumer logs the error through <ErrorDisplay>
            // mutateFeedFollow() has the potential to throw an error;
            // since we do not provide an onError callback to the useMutation hook
            // we need to catch the error here as a safety net.
            }
        }, [
        mutateFeedFollow,
        createAnalyticsEvent
    ]);
    return (0, $cozmU.useMemo)(()=>({
            renderFeedFollow: !(queryLoading || feedConfigError || $e2d6f47b8e3454eb$export$8631e45fce8db7c6) && isLicensed,
            loading: queryLoading,
            getToggleFollowUser: getToggleFollowUser,
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            followedUsers: followedUsers
        }), [
        queryLoading,
        feedConfigError,
        isLicensed,
        getToggleFollowUser,
        mutationError,
        followedUsers
    ]);
}
module.exports["useFeedFollow"] = $e2d6f47b8e3454eb$export$438df56e0ed352e6;

});

parcelRegister("k7Nop", function(module, exports) {
/**
 * @generated SignedSource<<faabaa80182918f5d00c229b25800acb>>
 * @relayHash 564d8ad9d36377c3d791529bbbb8a24b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d32fc5b6758b0cdbd537bc59e7432e83998cce61163ae34755c64a402dc367c
const $2274f77c1a29b092$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "follow"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "unfollow"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "followUsers",
                            "variableName": "follow"
                        },
                        {
                            "kind": "Variable",
                            "name": "unfollowUsers",
                            "variableName": "unfollow"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "SetFeedUserConfigPayload",
            "kind": "LinkedField",
            "name": "setFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFeedFollowFeedFollowMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFeedFollowFeedFollowMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "564d8ad9d36377c3d791529bbbb8a24b",
            "id": "5d32fc5b6758b0cdbd537bc59e7432e83998cce61163ae34755c64a402dc367c",
            "metadata": {},
            "name": "useFeedFollowFeedFollowMutation",
            "operationKind": "mutation",
            "text": "mutation useFeedFollowFeedFollowMutation($follow:[ID],$unfollow:[ID]){setFeedUserConfig(input:{followUsers:$follow,unfollowUsers:$unfollow}){success}}"
        }
    };
}();
$2274f77c1a29b092$var$node.hash = "7ecf9b28db7400fffab67e3a3c52027c";
var $2274f77c1a29b092$export$2e2bcd8739ae039 = $2274f77c1a29b092$var$node;
module.exports["default"] = $2274f77c1a29b092$export$2e2bcd8739ae039;

});

parcelRegister("hOSkW", function(module, exports) {
/**
 * @generated SignedSource<<597a7b2d7b3333c8532a887f4cdcbd48>>
 * @relayHash bc87c04b481deeaeaae914ab875dc44e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 11f28c2ff5a1dd7dd27036b76ee213cfc4cc4dc180b6462f1906390361cc096b
const $eeb53afb4cc8b670$var$node = function() {
    var v0 = [
        {
            "concreteType": "FollowingFeedGetUserConfig",
            "kind": "LinkedField",
            "name": "getFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "accountIds"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeedFollowFeedFollowQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeedFollowFeedFollowQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "bc87c04b481deeaeaae914ab875dc44e",
            "id": "11f28c2ff5a1dd7dd27036b76ee213cfc4cc4dc180b6462f1906390361cc096b",
            "metadata": {},
            "name": "useFeedFollowFeedFollowQuery",
            "operationKind": "query",
            "text": "query useFeedFollowFeedFollowQuery{getFeedUserConfig{accountIds}}"
        }
    };
}();
$eeb53afb4cc8b670$var$node.hash = "73bdcd7f6c8309a4d0a16e77fd4c5fed";
var $eeb53afb4cc8b670$export$2e2bcd8739ae039 = $eeb53afb4cc8b670$var$node;
module.exports["default"] = $eeb53afb4cc8b670$export$2e2bcd8739ae039;

});

parcelRegister("bSvtO", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");

const $45ca38ec521afdf7$var$initialState = {
    hasContentChanged: false,
    isCommentContentReady: false
};
const $45ca38ec521afdf7$export$53ac33307b5acee9 = ()=>({
        hasContentChanged: false,
        isCommentContentReady: false
    });
const $45ca38ec521afdf7$export$e324594224ef24da = {
    onChange: (hasChanges)=>({ setState: setState })=>{
            setState({
                hasContentChanged: hasChanges
            });
        },
    resetContentChanged: ()=>({ setState: setState })=>{
            setState({
                hasContentChanged: false
            });
        },
    onCommentContentReady: ()=>({ setState: setState })=>{
            setState({
                isCommentContentReady: true
            });
        }
};
const $45ca38ec521afdf7$var$CommentsContentStore = (0, $8s9DV.createStore)({
    initialState: $45ca38ec521afdf7$var$initialState,
    actions: $45ca38ec521afdf7$export$e324594224ef24da,
    name: 'CommentsContentStore'
});
const $45ca38ec521afdf7$export$ef1bfc0b6758ca67 = (0, $kBr4q.createHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$e2038e591f93e866 = (0, $kBr4q.createActionsHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$1756d05b0495e6b = (0, $kBr4q.createStateHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$dbffca2f0193dbd0 = ()=>(0, $c6StJ.defaultRegistry).getStore($45ca38ec521afdf7$var$CommentsContentStore).storeState.getState();
module.exports["useCommentsContentActions"] = $45ca38ec521afdf7$export$e2038e591f93e866;
module.exports["useCommentsContentState"] = $45ca38ec521afdf7$export$1756d05b0495e6b;
module.exports["getCommentsContentState"] = $45ca38ec521afdf7$export$dbffca2f0193dbd0;

});

parcelRegister("cMvMc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f2899d935411e961$export$fb31a121515f224d = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "_Vqh0",
    name: "CommentWarningDialog",
    loader: async ()=>(await (parcelRequire("7NKS7"))).CommentWarningDialog
});
module.exports["CommentWarningDialog"] = $f2899d935411e961$export$fb31a121515f224d;

});

parcelRegister("7NKS7", function(module, exports) {

let $5ae177c72d819b7b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5ae177c72d819b7b$var$load("hhss7"),
    $5ae177c72d819b7b$var$load("cqNU4")
]).then(()=>parcelRequire('9c4UU'));

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("3gdp3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2e8b2cdb4a7b2569268a3fe6ec068354>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25fd434ab2c22b25$var$_react = $25fd434ab2c22b25$var$_interopRequireDefault((parcelRequire("cozmU")));

var $25fd434ab2c22b25$var$_iconNew = $25fd434ab2c22b25$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $25fd434ab2c22b25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/notepad
 * Usage guidance:
 * Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25fd434ab2c22b25$var$NotepadIcon = (props)=>/*#__PURE__*/ $25fd434ab2c22b25$var$_react.default.createElement($25fd434ab2c22b25$var$_iconNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$25fd434ab2c22b25$var$NotepadIcon.displayName = 'NotepadIcon';
var $25fd434ab2c22b25$var$_default = module.exports.default = $25fd434ab2c22b25$var$NotepadIcon;

});

parcelRegister("8WQTF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $4677820b18a14e4d$export$66feffbad722f9d4 = /*#__PURE__*/ (0, $cozmU.createContext)({
    rendererActions: null,
    pageId: undefined,
    pageAdf: undefined
});
$4677820b18a14e4d$export$66feffbad722f9d4.displayName = 'RendererActionsContext';
const $4677820b18a14e4d$export$c7c5640cf8aff722 = /*#__PURE__*/ (0, $cozmU.createContext)({
    setRendererActions: ()=>{},
    setPageAdf: ()=>{}
});
$4677820b18a14e4d$export$c7c5640cf8aff722.displayName = 'RendererActionsDispatchContext';
const $4677820b18a14e4d$export$a41bfe8d4028fb59 = ({ children: children })=>{
    const [rendererActions, setRendererActions] = (0, $cozmU.useState)(null);
    const [pageId, setPageId] = (0, $cozmU.useState)(undefined);
    const [pageAdf, setPageAdf] = (0, $cozmU.useState)(undefined);
    const providerValue = (0, $cozmU.useMemo)(()=>({
            rendererActions: rendererActions,
            pageId: pageId,
            pageAdf: pageAdf
        }), [
        rendererActions,
        pageId,
        pageAdf
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            setRendererActions: (actions, newPageId)=>{
                setRendererActions(actions);
                setPageId(newPageId);
            },
            setPageAdf: (newPageAdf)=>{
                setPageAdf(newPageAdf);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4677820b18a14e4d$export$66feffbad722f9d4.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4677820b18a14e4d$export$c7c5640cf8aff722.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $4677820b18a14e4d$export$55249bdd00e8a5d6 = ()=>{
    return (0, $cozmU.useContext)($4677820b18a14e4d$export$66feffbad722f9d4);
};
const $4677820b18a14e4d$export$6e9863dfedeaae60 = ()=>{
    return (0, $cozmU.useContext)($4677820b18a14e4d$export$c7c5640cf8aff722);
};
module.exports["RendererActionsProvider"] = $4677820b18a14e4d$export$a41bfe8d4028fb59;
module.exports["useRendererActions"] = $4677820b18a14e4d$export$55249bdd00e8a5d6;
module.exports["useRendererActionsDispatch"] = $4677820b18a14e4d$export$6e9863dfedeaae60;

});

parcelRegister("jJK3p", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $jyPfN = parcelRequire("jyPfN");


var $cPER9 = parcelRequire("cPER9");


var $a6t12 = parcelRequire("a6t12");

parcelRequire("dD7ks");
var $4N3op = parcelRequire("4N3op");

const $5c1fbd48d7d200d4$var$linkStyles = (0, $buxP3.xcss)({
    textDecoration: 'underline',
    display: 'inline-block',
    cursor: 'pointer'
});
const $5c1fbd48d7d200d4$var$i18n = (0, $kSwu1.defineMessages)({
    profileLinkName: {
        id: "profile.link.name",
        defaultMessage: "{fullName} profile"
    }
});
const $5c1fbd48d7d200d4$export$a2a4245643e0242b = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { userId: userId, fullName: fullName, isAnonymous: t1, onUserLinkClick: onUserLinkClick, className: className, style: style, behavior: t2, position: t3, offset: offset, ariaLabel: ariaLabel, isUnderlinedByDefault: t4 } = t0;
    const isAnonymous = t1 === undefined ? false : t1;
    const behavior = t2 === undefined ? "link" : t2;
    const position = t3 === undefined ? "bottom-start" : t3;
    const isUnderlinedByDefault = t4 === undefined ? true : t4;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const intl = (0, $kSwu1.useIntl)();
    const t5 = userId ?? "";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            type: "USER",
            payload: {
                userId: t5
            }
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const { href: teamsAppPersonProfileUrl } = (0, $4N3op.useNavigateToTeamsApp)(t6);
    let t7;
    if ($[2] !== ariaLabel || $[3] !== behavior || $[4] !== className || $[5] !== fullName || $[6] !== intl || $[7] !== isAnonymous || $[8] !== isUnderlinedByDefault || $[9] !== offset || $[10] !== onUserLinkClick || $[11] !== position || $[12] !== style || $[13] !== teamsAppPersonProfileUrl || $[14] !== userId) {
        t7 = ()=>{
            if (behavior === "card") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: isAnonymous,
                userId: userId,
                position: position,
                offset: offset,
                ariaLabel: ariaLabel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                style: style,
                xcss: $5c1fbd48d7d200d4$var$linkStyles
            }, fullName));
            else {
                const linkStyle = {
                    ...style,
                    ...isUnderlinedByDefault ? {
                        textDecoration: "underline"
                    } : {}
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cPER9.PeopleLink), {
                    target: "_blank",
                    onClick: onUserLinkClick,
                    href: teamsAppPersonProfileUrl,
                    className: className,
                    style: linkStyle,
                    "data-testid": "profile-link",
                    "aria-label": ariaLabel || intl.formatMessage($5c1fbd48d7d200d4$var$i18n.profileLinkName, {
                        fullName: fullName
                    })
                }, fullName);
            }
        };
        $[2] = ariaLabel;
        $[3] = behavior;
        $[4] = className;
        $[5] = fullName;
        $[6] = intl;
        $[7] = isAnonymous;
        $[8] = isUnderlinedByDefault;
        $[9] = offset;
        $[10] = onUserLinkClick;
        $[11] = position;
        $[12] = style;
        $[13] = teamsAppPersonProfileUrl;
        $[14] = userId;
        $[15] = t7;
    } else t7 = $[15];
    const renderNameComponent = t7;
    let t8;
    if ($[16] !== fullName || $[17] !== hasViewUserProfilePermission || $[18] !== isAnonymous || $[19] !== renderNameComponent || $[20] !== userId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isAnonymous || !userId || userId === "" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "profile.anonymous.name",
            defaultMessage: "Anonymous"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, hasViewUserProfilePermission ? renderNameComponent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, fullName)));
        $[16] = fullName;
        $[17] = hasViewUserProfilePermission;
        $[18] = isAnonymous;
        $[19] = renderNameComponent;
        $[20] = userId;
        $[21] = t8;
    } else t8 = $[21];
    return t8;
};
module.exports["ProfileLink"] = $5c1fbd48d7d200d4$export$a2a4245643e0242b;

});

parcelRegister("jyPfN", function(module, exports) {

var $foQ4a = parcelRequire("foQ4a");

const $10d1e40b190a4139$export$5a38a817745a0c6f = ()=>{
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    return {
        canViewUserProfile: !isExternalCollaborator
    };
};
module.exports["useViewUserProfile"] = $10d1e40b190a4139$export$5a38a817745a0c6f;

});

parcelRegister("cPER9", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $8lYIw = parcelRequire("8lYIw");

const $6a5a2957e3d32f84$export$43aa0d4f5c176033 = (props)=>{
    const $ = (0, $bDgLe.c)(10);
    let children;
    let href;
    let otherProps;
    let to;
    if ($[0] !== props) {
        ({ href: href, to: to, children: children, ...otherProps } = props);
        $[0] = props;
        $[1] = children;
        $[2] = href;
        $[3] = otherProps;
        $[4] = to;
    } else {
        children = $[1];
        href = $[2];
        otherProps = $[3];
        to = $[4];
    }
    const url = to || href;
    let t0;
    if ($[5] !== children || $[6] !== otherProps || $[7] !== to || $[8] !== url) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lYIw.Link), {
            href: url,
            to: to,
            ...otherProps
        }, children);
        $[5] = children;
        $[6] = otherProps;
        $[7] = to;
        $[8] = url;
        $[9] = t0;
    } else t0 = $[9];
    return t0;
};
$6a5a2957e3d32f84$export$43aa0d4f5c176033.propTypes = {
    href: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string
};
module.exports["PeopleLink"] = $6a5a2957e3d32f84$export$43aa0d4f5c176033;

});

parcelRegister("8lYIw", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7fpiF = parcelRequire("7fpiF");


var $7zgzO = parcelRequire("7zgzO");


var $dHSeC = parcelRequire("dHSeC");

const $9673d4c78655a9a1$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    const $ = (0, $bDgLe.c)(9);
    const { target: t0, name: name, href: t1, to: t2, params: t3 } = props;
    const target = t0 === undefined ? undefined : t0;
    const href = t1 === undefined ? null : t1;
    const to = t2 === undefined ? null : t2;
    const params = t3 === undefined ? {} : t3;
    const routesContext = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { matchSupportedRoute: matchSupportedRoute, toUrl: toUrl } = routesContext;
    const customPath = href || to;
    if (!customPath && !name) {
        let t4;
        if ($[0] !== props || $[1] !== ref) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
                ...props,
                ref: ref,
                path: ""
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t4;
        } else t4 = $[2];
        return t4;
    }
    const hrefParams = customPath && {
        href: customPath
    };
    const path = toUrl(name, {
        ...params,
        ...hrefParams
    });
    const match = matchSupportedRoute(path);
    let t4;
    if ($[3] !== match || $[4] !== path || $[5] !== props || $[6] !== ref || $[7] !== target) {
        t4 = match && target !== "_blank" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9673d4c78655a9a1$var$WrappedReactRouterLink, {
            ...props,
            ref: ref,
            match: match
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
            ...props,
            ref: ref,
            path: path
        });
        $[3] = match;
        $[4] = path;
        $[5] = props;
        $[6] = ref;
        $[7] = target;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
});
const $9673d4c78655a9a1$var$WrappedAnchor = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, ref)=>{
    const $ = (0, $bDgLe.c)(21);
    let parentProps;
    let path;
    if ($[0] !== t0) {
        ({ path: path, ...parentProps } = t0);
        $[0] = t0;
        $[1] = parentProps;
        $[2] = path;
    } else {
        parentProps = $[1];
        path = $[2];
    }
    const { children: children, className: className, target: t1, testId: testId, style: style, id: id } = parentProps;
    const target = t1 === undefined ? undefined : t1;
    const routesContext = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { onPageReload: onPageReload } = routesContext;
    let t2;
    if ($[3] !== onPageReload || $[4] !== parentProps) {
        t2 = (e)=>{
            onPageReload(e.target.getAttribute("href"), false);
            if (parentProps.onClick) parentProps.onClick(e);
        };
        $[3] = onPageReload;
        $[4] = parentProps;
        $[5] = t2;
    } else t2 = $[5];
    const onAnchorLinkClick = t2;
    let t3;
    if ($[6] !== parentProps) {
        t3 = (e_0)=>{
            parentProps.onContextMenu?.(e_0);
        };
        $[6] = parentProps;
        $[7] = t3;
    } else t3 = $[7];
    const onAnchorContextMenuClick = t3;
    const t4 = target === "_blank" ? "noreferrer" : undefined;
    const t5 = parentProps["aria-label"];
    let t6;
    if ($[8] !== children || $[9] !== className || $[10] !== id || $[11] !== onAnchorContextMenuClick || $[12] !== onAnchorLinkClick || $[13] !== path || $[14] !== ref || $[15] !== style || $[16] !== t4 || $[17] !== t5 || $[18] !== target || $[19] !== testId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
            href: path,
            className: className,
            onClick: onAnchorLinkClick,
            onContextMenu: onAnchorContextMenuClick,
            target: target,
            id: id,
            rel: t4,
            "data-testid": testId,
            ref: ref,
            "aria-label": t5,
            style: style
        }, children);
        $[8] = children;
        $[9] = className;
        $[10] = id;
        $[11] = onAnchorContextMenuClick;
        $[12] = onAnchorLinkClick;
        $[13] = path;
        $[14] = ref;
        $[15] = style;
        $[16] = t4;
        $[17] = t5;
        $[18] = target;
        $[19] = testId;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
});
const $9673d4c78655a9a1$var$WrappedReactRouterLink = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, ref)=>{
    const $ = (0, $bDgLe.c)(22);
    let match;
    let parentProps;
    if ($[0] !== t0) {
        ({ match: match, ...parentProps } = t0);
        $[0] = t0;
        $[1] = match;
        $[2] = parentProps;
    } else {
        match = $[1];
        parentProps = $[2];
    }
    const routesContext = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { children: children, className: className, style: style, id: id } = parentProps;
    const { preloadRoute: preloadRoute } = routesContext;
    let t1;
    if ($[3] !== match || $[4] !== preloadRoute) {
        t1 = async ()=>preloadRoute(match);
        $[3] = match;
        $[4] = preloadRoute;
        $[5] = t1;
    } else t1 = $[5];
    const onMouseDownCapture = t1;
    let t2;
    if ($[6] !== parentProps || $[7] !== routesContext) {
        t2 = (event)=>{
            if (parentProps.onClick) parentProps.onClick(event);
            const details = (0, $dHSeC.getSpaTransitionDetails)(event, routesContext);
            if (!event.defaultPrevented && details?.href) {
                event.preventDefault();
                routesContext.push(details.href);
            }
        };
        $[6] = parentProps;
        $[7] = routesContext;
        $[8] = t2;
    } else t2 = $[8];
    const onClick = t2;
    let t3;
    if ($[9] !== parentProps) {
        t3 = (e)=>{
            parentProps.onContextMenu?.(e);
        };
        $[9] = parentProps;
        $[10] = t3;
    } else t3 = $[10];
    const onContextMenu = t3;
    const t4 = `${match.pathname}${match.search}${match.hash}`;
    const t5 = parentProps["aria-label"];
    let t6;
    if ($[11] !== children || $[12] !== className || $[13] !== id || $[14] !== onClick || $[15] !== onContextMenu || $[16] !== onMouseDownCapture || $[17] !== ref || $[18] !== style || $[19] !== t4 || $[20] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7fpiF.Link), {
            to: t4,
            className: className,
            onClick: onClick,
            onContextMenu: onContextMenu,
            onMouseDownCapture: onMouseDownCapture,
            innerRef: ref,
            id: id,
            "aria-label": t5,
            style: style
        }, children);
        $[11] = children;
        $[12] = className;
        $[13] = id;
        $[14] = onClick;
        $[15] = onContextMenu;
        $[16] = onMouseDownCapture;
        $[17] = ref;
        $[18] = style;
        $[19] = t4;
        $[20] = t5;
        $[21] = t6;
    } else t6 = $[21];
    return t6;
});
module.exports["Link"] = $9673d4c78655a9a1$export$a6c7ac8248d6e38a;

});

parcelRegister("7fpiF", function(module, exports) {

var $KDAt0 = parcelRequire("KDAt0");


var $cgTkH = parcelRequire("cgTkH");


var $cozmU = parcelRequire("cozmU");


var $22s37 = parcelRequire("22s37");




var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");


var $bB0i2 = parcelRequire("bB0i2");

/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $546d8f2c65102c44$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $cgTkH.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $22s37.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KDAt0.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $546d8f2c65102c44$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $cgTkH.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $22s37.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KDAt0.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component);
var $546d8f2c65102c44$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $546d8f2c65102c44$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $22s37.createLocation)(to, null, null, currentLocation) : to;
};
var $546d8f2c65102c44$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $546d8f2c65102c44$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef;
if (typeof $546d8f2c65102c44$var$forwardRef === "undefined") $546d8f2c65102c44$var$forwardRef = $546d8f2c65102c44$var$forwardRefShim;
function $546d8f2c65102c44$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $546d8f2c65102c44$var$LinkAnchor = $546d8f2c65102c44$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $1eVGO.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $eb3ax.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$546d8f2c65102c44$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($546d8f2c65102c44$var$forwardRefShim !== $546d8f2c65102c44$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $546d8f2c65102c44$export$a6c7ac8248d6e38a = $546d8f2c65102c44$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $546d8f2c65102c44$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $1eVGO.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KDAt0.__RouterContext).Consumer, null, function(context) {
        !context && (0, $bB0i2.default)(false);
        var history = context.history;
        var location = $546d8f2c65102c44$var$normalizeToLocation($546d8f2c65102c44$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $eb3ax.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $546d8f2c65102c44$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $22s37.createPath)(context.location) === (0, $22s37.createPath)($546d8f2c65102c44$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($546d8f2c65102c44$var$forwardRefShim !== $546d8f2c65102c44$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(component, props);
    });
});
var $546d8f2c65102c44$var$toType, $546d8f2c65102c44$var$refType;
var $546d8f2c65102c44$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $546d8f2c65102c44$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef;
if (typeof $546d8f2c65102c44$var$forwardRef$1 === "undefined") $546d8f2c65102c44$var$forwardRef$1 = $546d8f2c65102c44$var$forwardRefShim$1;
function $546d8f2c65102c44$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $546d8f2c65102c44$export$b0d92dbee9b5b60d = $546d8f2c65102c44$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $1eVGO.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KDAt0.__RouterContext).Consumer, null, function(context) {
        !context && (0, $bB0i2.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $546d8f2c65102c44$var$normalizeToLocation($546d8f2c65102c44$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $KDAt0.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $546d8f2c65102c44$var$joinClassnames(className, activeClassName);
            style = (0, $eb3ax.default)({}, style, activeStyle);
        }
        var props = (0, $eb3ax.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($546d8f2c65102c44$var$forwardRefShim$1 !== $546d8f2c65102c44$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($546d8f2c65102c44$export$a6c7ac8248d6e38a, props);
    });
});
var $546d8f2c65102c44$var$ariaCurrentType;
 //# sourceMappingURL=react-router-dom.js.map
module.exports["Link"] = $546d8f2c65102c44$export$a6c7ac8248d6e38a;

});

parcelRegister("22s37", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $5hfGv = parcelRequire("5hfGv");


var $ucZb7 = parcelRequire("ucZb7");



var $bB0i2 = parcelRequire("bB0i2");

function $17c186b078d80207$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $17c186b078d80207$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $17c186b078d80207$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $17c186b078d80207$var$stripBasename(path, prefix) {
    return $17c186b078d80207$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $17c186b078d80207$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $17c186b078d80207$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $17c186b078d80207$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $17c186b078d80207$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $17c186b078d80207$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $eb3ax.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $5hfGv.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $17c186b078d80207$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $ucZb7.default)(a.state, b.state);
}
function $17c186b078d80207$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $17c186b078d80207$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $17c186b078d80207$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $17c186b078d80207$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $17c186b078d80207$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $17c186b078d80207$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $17c186b078d80207$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $17c186b078d80207$var$PopStateEvent = 'popstate';
var $17c186b078d80207$var$HashChangeEvent = 'hashchange';
function $17c186b078d80207$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $17c186b078d80207$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$17c186b078d80207$var$canUseDOM && (0, $bB0i2.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $17c186b078d80207$var$supportsHistory();
    var needsHashChangeListener = !$17c186b078d80207$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $17c186b078d80207$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $17c186b078d80207$var$stripTrailingSlash($17c186b078d80207$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $17c186b078d80207$var$stripBasename(path, basename);
        return $17c186b078d80207$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $17c186b078d80207$var$createTransitionManager();
    function setState(nextState) {
        (0, $eb3ax.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($17c186b078d80207$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($17c186b078d80207$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($17c186b078d80207$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $17c186b078d80207$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($17c186b078d80207$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($17c186b078d80207$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($17c186b078d80207$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($17c186b078d80207$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $17c186b078d80207$var$HashChangeEvent$1 = 'hashchange';
var $17c186b078d80207$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $17c186b078d80207$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $17c186b078d80207$var$stripLeadingSlash,
        decodePath: $17c186b078d80207$var$addLeadingSlash
    },
    slash: {
        encodePath: $17c186b078d80207$var$addLeadingSlash,
        decodePath: $17c186b078d80207$var$addLeadingSlash
    }
};
function $17c186b078d80207$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $17c186b078d80207$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $17c186b078d80207$var$pushHashPath(path) {
    window.location.hash = path;
}
function $17c186b078d80207$var$replaceHashPath(path) {
    window.location.replace($17c186b078d80207$var$stripHash(window.location.href) + '#' + path);
}
function $17c186b078d80207$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$17c186b078d80207$var$canUseDOM && (0, $bB0i2.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $17c186b078d80207$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $17c186b078d80207$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $17c186b078d80207$var$stripTrailingSlash($17c186b078d80207$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $17c186b078d80207$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($17c186b078d80207$var$getHashPath());
        if (basename) path = $17c186b078d80207$var$stripBasename(path, basename);
        return $17c186b078d80207$export$90c043f1c57770b8(path);
    }
    var transitionManager = $17c186b078d80207$var$createTransitionManager();
    function setState(nextState) {
        (0, $eb3ax.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $17c186b078d80207$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $17c186b078d80207$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $17c186b078d80207$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($17c186b078d80207$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($17c186b078d80207$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $17c186b078d80207$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $17c186b078d80207$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $17c186b078d80207$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $17c186b078d80207$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $17c186b078d80207$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $17c186b078d80207$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $17c186b078d80207$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $17c186b078d80207$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($17c186b078d80207$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $17c186b078d80207$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $17c186b078d80207$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $17c186b078d80207$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($17c186b078d80207$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($17c186b078d80207$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($17c186b078d80207$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $17c186b078d80207$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $17c186b078d80207$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $17c186b078d80207$var$createTransitionManager();
    function setState(nextState) {
        (0, $eb3ax.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $17c186b078d80207$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $17c186b078d80207$export$90c043f1c57770b8(entry, undefined, createKey()) : $17c186b078d80207$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $17c186b078d80207$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $17c186b078d80207$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}
module.exports["createPath"] = $17c186b078d80207$export$fe53371bee54353d;
module.exports["createLocation"] = $17c186b078d80207$export$90c043f1c57770b8;
module.exports["createBrowserHistory"] = $17c186b078d80207$export$719fc203c4e16dee;
module.exports["createHashHistory"] = $17c186b078d80207$export$b71fdd3798280242;

});

parcelRegister("a6t12", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kNIYN = parcelRequire("kNIYN");


var $9DHhW = parcelRequire("9DHhW");


var $hSs5g = parcelRequire("hSs5g");


var $9zU5G = parcelRequire("9zU5G");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $jyPfN = parcelRequire("jyPfN");


var $jlIaF = parcelRequire("jlIaF");


var $bQm3c = parcelRequire("bQm3c");


var $gqqjz = parcelRequire("gqqjz");

parcelRequire("6OL2O");
var $5t3NX = parcelRequire("5t3NX");

parcelRequire("dD7ks");
var $4N3op = parcelRequire("4N3op");


var $bedVD = parcelRequire("bedVD");


var $l7wqU = parcelRequire("l7wqU");


var $4GlQ9 = parcelRequire("4GlQ9");


var $bumSD = parcelRequire("bumSD");


var $4qzKl = parcelRequire("4qzKl");


var $gj42z = parcelRequire("gj42z");

const $3d0f3ea3171aff68$var$i18n = (0, $kSwu1.defineMessages)({
    viewProfile: {
        id: "profile.card.viewProfile",
        defaultMessage: "View profile"
    }
});
const $3d0f3ea3171aff68$export$98f80b73da7beaf4 = ({ push: push, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: ()=>(0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(userId).then(push),
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, '', (0, $jlIaF.CONTEXT_PATH))
    });
const $3d0f3ea3171aff68$export$4f94384af0327320 = ({ navigate: navigate, url: url })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: navigate,
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: url
    });
const $3d0f3ea3171aff68$export$d114163e55e8b2c5 = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, userId: userId, followedUsers: followedUsers })=>{
    const followed = !!(userId && followedUsers?.includes(userId));
    return {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        }),
        id: 'feed-follow-user',
        callback: getToggleFollowUser(userId, followed, 'profileCard'),
        shouldRender: (userData)=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId && userData?.status === 'active'
    };
};
const $3d0f3ea3171aff68$export$ba990269c861f33b = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, followedRef: followedRef, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l7wqU.FeedFollowAction), {
            userId: userId
        }),
        id: 'feed-follow-user',
        callback: ()=>getToggleFollowUser(userId, followedRef.current, 'profileCard')(),
        shouldRender: ()=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId
    });
const $3d0f3ea3171aff68$export$59abd6feb7dc8540 = ({ position: position = 'bottom-start', userId: userId, isAnonymous: isAnonymous = false, canViewProfile: canViewProfile = true, children: children, trigger: trigger = 'hover', fullName: fullName, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, ariaLabel: ariaLabel, agent: agent, fullWidthTrigger: fullWidthTrigger })=>{
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const { userId: loggedInUserId, cloudId: cloudId, featureFlags: featureFlags, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const reportingLines = (0, $4N3op.useNavigateToTeamsApp)({
        type: 'LANDING'
    });
    const getReportingLinesUserProfile = (clickedUserId)=>(0, $5t3NX.getNavigateToTeamsApp)(orgId || '', {
            type: 'USER',
            payload: {
                userId: clickedUserId
            }
        });
    const userProfile = (0, $4N3op.useNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId || ''
        }
    });
    const reportingLinesProfileUrl = reportingLines.href;
    const { feedConfigError: feedConfigError, followedUsers: followedUsers, getToggleFollowUser: getToggleFollowUser, mutationError: mutationError, renderFeedFollow: renderFeedFollow } = (0, $4GlQ9.useFeedFollow)();
    const viewProfileAction = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$4f94384af0327320({
            navigate: userProfile.onNavigate,
            url: userProfile.href
        }), [
        userProfile
    ]);
    const followUserAction = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$d114163e55e8b2c5({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            userId: userId,
            followedUsers: followedUsers
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId,
        followedUsers
    ]);
    // The card snapshots the actions, so the follow callback reads the latest follow state
    // from this ref (updated on every render) instead of a value captured when the action
    // was built. This keeps repeated follow/unfollow toggles in the correct direction.
    const followedRef = (0, $cozmU.useRef)(false);
    followedRef.current = !!(userId && followedUsers?.includes(userId));
    const followUserActionNext = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$ba990269c861f33b({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            followedRef: followedRef,
            userId: userId
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId
    ]);
    // Should display profile?
    if (isAnonymous || !canViewProfile || !userId || !loggedInUserId || !hasViewUserProfilePermission) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    const reportingLinesClickCallback = (clickedUserId_0)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'profileCardWrapper',
                action: 'clicked',
                actionSubject: 'viewProfile',
                actionSubjectId: 'userProfileCard',
                attributes: {
                    clickTarget: 'userReportingLine'
                }
            }
        }).fire();
        getReportingLinesUserProfile(clickedUserId_0).onNavigate();
        return false;
    };
    if (// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
    (0, $9wGTI.fg)('people-teams_migrate-user-profile-card') || (0, $6mKj3.expValEquals)('pt_user_profile_card_migration_exp', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
        feedConfigError: feedConfigError,
        mutationError: mutationError,
        showErrorFlag: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9zU5G.UserProfileCardWithTrigger), {
        cloudId: cloudId,
        orgId: orgId || '',
        userId: userId,
        viewerId: loggedInUserId,
        placement: position,
        offset: offset,
        trigger: trigger,
        fullWidthTrigger: fullWidthTrigger,
        actions: [
            followUserActionNext
        ],
        isAgent: Boolean(agent),
        agent: agent ? {
            ...agent,
            resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags)
        } : undefined,
        ...disabledAriaAttributes ? {} : {
            ariaLabel: ariaLabel
        },
        testId: "profileCardTrigger"
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            showErrorFlag: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSs5g.default), {
            cloudId: cloudId,
            userId: userId,
            resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
            position: position,
            trigger: trigger,
            actions: [
                viewProfileAction,
                followUserAction
            ],
            reportingLinesProfileUrl: reportingLinesProfileUrl,
            onReportingLinesClick: (user)=>reportingLinesClickCallback(user.accountIdentifier),
            addFlag: (flag)=>flags.showFlag(flag),
            prepopulatedData: {
                fullName: fullName
            },
            disabledAriaAttributes: disabledAriaAttributes,
            onVisibilityChange: onVisibilityChange,
            offset: offset,
            testId: "profileCardTrigger",
            viewingUserId: loggedInUserId,
            ...disabledAriaAttributes ? {} : {
                ariaLabel: ariaLabel
            }
        }, children)));
};
module.exports["ProfileCardWrapper"] = $3d0f3ea3171aff68$export$59abd6feb7dc8540;

});

parcelRegister("6OL2O", function(module, exports) {
$parcel$export(module.exports, "getNavigateToTeamsApp", () => (parcelRequire("5t3NX")).getNavigateToTeamsApp);

var $5t3NX = parcelRequire("5t3NX");


});

parcelRegister("5t3NX", function(module, exports) {

var $hMCZS = parcelRequire("hMCZS");

const $57c6b51502cb940c$export$cfadab73fb247145 = (orgId, navActionPayload, shouldOpenInSameTab)=>{
    return (0, $hMCZS.navigateToTeamsApp)({
        hostProduct: 'confluence',
        orgId: orgId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["getNavigateToTeamsApp"] = $57c6b51502cb940c$export$cfadab73fb247145;

});

parcelRegister("dD7ks", function(module, exports) {
$parcel$export(module.exports, "useNavigateToTeamsApp", () => (parcelRequire("4N3op")).useNavigateToTeamsApp);

var $4N3op = parcelRequire("4N3op");


});

parcelRegister("4N3op", function(module, exports) {

var $hMCZS = parcelRequire("hMCZS");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");

const $bf6b29a56d69bf9f$export$520a42ab062954ec = (navActionPayload, shouldOpenInSameTab)=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    return (0, $hMCZS.navigateToTeamsApp)({
        push: push,
        hostProduct: 'confluence',
        orgId: orgId,
        cloudId: cloudId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["useNavigateToTeamsApp"] = $bf6b29a56d69bf9f$export$520a42ab062954ec;

});

parcelRegister("l7wqU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bedVD = parcelRequire("bedVD");


var $4GlQ9 = parcelRequire("4GlQ9");

const $460a3972eab8fd69$export$38809e1c08e05a16 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { userId: userId } = t0;
    const { followedUsers: followedUsers } = (0, $4GlQ9.useFeedFollow)();
    let t1;
    if ($[0] !== followedUsers || $[1] !== userId) {
        t1 = userId && followedUsers?.includes(userId);
        $[0] = followedUsers;
        $[1] = userId;
        $[2] = t1;
    } else t1 = $[2];
    const followed = !!t1;
    let t2;
    if ($[3] !== followed) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        });
        $[3] = followed;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
module.exports["FeedFollowAction"] = $460a3972eab8fd69$export$38809e1c08e05a16;

});

parcelRegister("4qzKl", function(module, exports) {
// TODO: remove once @confluence-classic/confluence-urls is added to next

var $jlIaF = parcelRequire("jlIaF");

const $7b986e69785602e5$export$3b6a64cfeda8b00 = (accountId, src, context = '')=>{
    if (!accountId) return '';
    return `${context}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$5f1a0e9946984804 = async (accountId, src)=>{
    if (!accountId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$cb80ef5511478588 = (teamId, src, context = '')=>{
    if (!teamId) return '';
    return `${context}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$470c1413f7223a06 = async (teamId, src)=>{
    if (!teamId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
// Replacement for the getAttributeNames DOM API since it's not supported by IE
const $7b986e69785602e5$var$getAttributeNames = (element)=>Array.from(element.attributes).map((attribute)=>attribute.name);
// Return only DOM elements that have the data-account-id attribute
const $7b986e69785602e5$var$withAccountId = (element)=>element.getAttribute('data-account-id');
// Returns React props that can be used to recreate a DOM element
const $7b986e69785602e5$var$getReactPropsFromDOMElement = (element)=>{
    const attributeToProp = {
        class: 'className'
    };
    const props = {};
    $7b986e69785602e5$var$getAttributeNames(element).forEach((attribute)=>{
        props[attributeToProp[attribute] || attribute] = element.getAttribute(attribute);
    });
    props.dangerouslySetInnerHTML = {
        __html: element.innerHTML
    };
    return props;
};
function $7b986e69785602e5$export$a98860edfb97e545(userElements) {
    return userElements.filter($7b986e69785602e5$var$withAccountId).map((element)=>{
        const props = $7b986e69785602e5$var$getReactPropsFromDOMElement(element);
        // Set this attribute to stop the old user profile hovers from binding
        props['data-user-hover-bound'] = 'true';
        // Ensure that links go to the same location as the profile card
        props.href = $7b986e69785602e5$export$3b6a64cfeda8b00(props['data-account-id'], null);
        const placeholder = window.document.createElement('span');
        if (!element.parentNode) return {};
        element.parentNode.replaceChild(placeholder, element);
        return {
            props: props,
            placeholder: placeholder
        };
    });
}
module.exports["getAtlassianPeopleProfileUrl"] = $7b986e69785602e5$export$3b6a64cfeda8b00;
module.exports["getAtlassianPeopleProfileUrlAsync"] = $7b986e69785602e5$export$5f1a0e9946984804;
module.exports["getTeamUrl"] = $7b986e69785602e5$export$cb80ef5511478588;
module.exports["replaceUserElementsWithPlaceholders"] = $7b986e69785602e5$export$a98860edfb97e545;

});

parcelRegister("gj42z", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $kSwu1 = parcelRequire("kSwu1");


var $b3j2Y = parcelRequire("b3j2Y");


var $gqqjz = parcelRequire("gqqjz");

const $3ade761a05c1a959$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    followMutationErrorTitle: {
        id: "profile.card.feed.follow.mutation.error.title",
        defaultMessage: "We\u2019re having trouble doing that"
    },
    followMutationErrorDescription: {
        id: "profile.card.feed.follow.mutation.error.description",
        defaultMessage: "Try following or unfollowing this user again "
    }
});
const $3ade761a05c1a959$export$cb92340e76dc7cda = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { feedConfigError: feedConfigError, mutationError: mutationError, showErrorFlag: showErrorFlag } = t0;
    let t1;
    if ($[0] !== feedConfigError) {
        t1 = feedConfigError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: feedConfigError
        }) : null;
        $[0] = feedConfigError;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== mutationError || $[3] !== showErrorFlag) {
        t2 = mutationError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: mutationError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: [
                (0, $gqqjz.FlagsStateContainer)
            ]
        }, (flags)=>{
            if (showErrorFlag) flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorDescription)
            });
            return null;
        })) : null;
        $[2] = mutationError;
        $[3] = showErrorFlag;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["FeedFollowErrorDisplay"] = $3ade761a05c1a959$export$cb92340e76dc7cda;

});

parcelRegister("cLo2u", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $bDgLe.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("2O7Qv", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $a33Aa.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("bCECL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $kLlYX = parcelRequire("kLlYX");


var $cow67 = parcelRequire("cow67");


var $3gdp3 = parcelRequire("3gdp3");


var $hMaHH = parcelRequire("hMaHH");


var $d4GYd = parcelRequire("d4GYd");


var $bDjVc = parcelRequire("bDjVc");


var $lBKFk = parcelRequire("lBKFk");


var $kWSTb = parcelRequire("kWSTb");


var $2hJf7 = parcelRequire("2hJf7");


var $9zxkL = parcelRequire("9zxkL");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");


var $5tsXU = parcelRequire("5tsXU");


var $hT3jf = parcelRequire("hT3jf");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { type: type, emoji: emoji, color: color, subType: subType, height: t1, isMarkdownMode: t2 } = t0;
    const height = t1 === undefined ? 16 : t1;
    const isMarkdownMode = t2 === undefined ? false : t2;
    const isLivePage = type === "page" && subType === "live" || type === "liveDoc";
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) {
        const t3 = emoji || "";
        let t4;
        if ($[0] !== height || $[1] !== t3 || $[2] !== type) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: t3,
                contentType: type,
                context: "contentMenu",
                height: height,
                wrapper: $b2e0c504f331f5cc$var$_temp
            });
            $[0] = height;
            $[1] = t3;
            $[2] = type;
            $[3] = t4;
        } else t4 = $[3];
        return t4;
    }
    if ((0, $hT3jf.isSmartFolder)({
        type: type,
        subType: subType
    })) {
        let t3;
        if ($[4] !== color) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tsXU.ManagedFolderClosedIcon), {
                label: "",
                size: "small",
                color: color,
                testId: "icons.content-icon.label.managed-folder"
            });
            $[4] = color;
            $[5] = t3;
        } else t3 = $[5];
        return t3;
    }
    const actualType = isLivePage && isMarkdownMode ? "markdown" : isLivePage ? "liveDoc" : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    let t3;
    if ($[6] !== Icon || $[7] !== color || $[8] !== label.id) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: "",
            color: color,
            testId: label.id
        });
        $[6] = Icon;
        $[7] = color;
        $[8] = label.id;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16, isMarkdownMode: isMarkdownMode = false })=>{
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: type,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    if ((0, $hT3jf.isSmartFolder)({
        type: type,
        subType: subType
    })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tsXU.ManagedFolderClosedIcon), {
        label: "",
        size: "small",
        color: color,
        testId: "icons.content-icon.label.managed-folder"
    });
    const actualType = isLivePage && isMarkdownMode ? 'markdown' : isLivePage ? 'liveDoc' : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $kSwu1.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    slide: {
        id: "icons.content-icon.label.slide",
        defaultMessage: "Slide"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    },
    markdown: {
        id: "icons.content-icon.label.markdown",
        defaultMessage: "Markdown"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    slide: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))),
        label: $b2e0c504f331f5cc$var$i18n.slide
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9zxkL))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3gdp3))),
        label: $b2e0c504f331f5cc$var$i18n.note
    },
    markdown: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cow67))),
        label: $b2e0c504f331f5cc$var$i18n.markdown
    }
};
function $b2e0c504f331f5cc$var$_temp(t0) {
    const { children: children } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
    }, children);
}
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
   * Why do emojis need to be 'sanitized'? Originally emoji content properties
   * (emoji-title-published, emoji-title-draft) were a part of a REST API
   * where the value would be JSON and not just a string.  This is why emoji
   * values come through with extra quotes and we have to clean that up.
   * A URL with quotes is not a valid URL.
   * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
   * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
   */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});

parcelRegister("5tsXU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/**
 * Custom icon for a managed (synced) closed folder.
 * Renders a folder with a circle badge in the bottom-right corner.
 * Uses currentColor so the icon responds to theming and dark mode.
 */ const $3216f3fcd316d4ef$export$75f34eec99819e9c = ({ label: label, size: size = 'medium', color: color, testId: testId })=>{
    const dimensions = size === 'small' ? 16 : 24;
    const fillColor = color || 'currentColor';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        "data-testid": testId,
        width: dimensions,
        height: dimensions,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        "aria-hidden": !label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.31055 2.75H13C14.1046 2.75 15 3.64543 15 4.75V10H13.5V7.5H2.5V13C2.5 13.2761 2.72386 13.5 3 13.5H10V15H3C1.89543 15 1 14.1046 1 13V3C1 1.89543 1.89543 1 3 1H6.56055L8.31055 2.75ZM3 2.5C2.72386 2.5 2.5 2.72386 2.5 3V6H13.5V4.75C13.5 4.47386 13.2761 4.25 13 4.25H7.68945L5.93945 2.5H3Z",
        fill: fillColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15.75 13.75C15.75 14.8546 14.8546 15.75 13.75 15.75C12.6454 15.75 11.75 14.8546 11.75 13.75C11.75 12.6454 12.6454 11.75 13.75 11.75C14.8546 11.75 15.75 12.6454 15.75 13.75Z",
        fill: fillColor
    }));
};
module.exports["ManagedFolderClosedIcon"] = $3216f3fcd316d4ef$export$75f34eec99819e9c;

});

parcelRegister("hT3jf", function(module, exports) {
/**
 * Returns true if the given content item is a smart (MANAGED) folder.
 *
 * A smart folder is a folder whose `subType` is `"managed"` (the AGG schema
 * returns this value lowercased). Regular folders do not have a subType
 * (it is null or absent).
 *
 * The comparison is case-insensitive to defensively handle any future schema
 * casing changes from the backend.
 *
 * @param content - Any object that may have a `type` and/or `subType` field.
 */ const $13b7c969ce4fb521$export$9aceb9df64593567 = (content)=>{
    return content.type === 'folder' && content.subType?.toLowerCase() === 'managed';
};
module.exports["isSmartFolder"] = $13b7c969ce4fb521$export$9aceb9df64593567;

});

parcelRegister("kvJHJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $gXfti = parcelRequire("gXfti");


var $knAY5 = parcelRequire("knAY5");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $8W4Gr = parcelRequire("8W4Gr");


var $2O7Qv = parcelRequire("2O7Qv");


var $18R9N = parcelRequire("18R9N");

const $d2938061b4a1e388$var$noop = ()=>{};
const $d2938061b4a1e388$var$EMBEDDED_PREFIX = 'embedded-';
const $d2938061b4a1e388$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { customData: customData = {}, onComplete: onComplete = $d2938061b4a1e388$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of Props guarantees that exactly one of `metricKey` or `metric`
    // is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$d2938061b4a1e388$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    // Capture before onComplete or a deferred paint callback can start another interaction.
    const binding = props.metric ? (0, $8W4Gr.getPageSegmentUFOBinding)(props.metric) : undefined;
    const stopTimeRef = (0, $cozmU.useRef)(stopTime);
    const customDataRef = (0, $cozmU.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $cozmU.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $cozmU.useCallback)(()=>{
        onComplete();
        let finalCustomData;
        if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
        else finalCustomData = customDataRef.current;
        const data = {
            ...finalCustomData,
            viewTransitionSource: (0, $lXYVJ.getViewTransitionSource)(),
            ...typeof stopTimeRef.current === 'number' ? {
                stopTime: stopTimeRef.current
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        };
        // An imperative start has no embedded context; retain its captured key and owner.
        if (binding && (binding.key === prefixedKey || binding.key === resolvedKey)) // Preserve React end-mark timing; stopTime is metadata on this API.
        (0, $8W4Gr.reportPageSegmentEndToUFO)(binding, {
            customData: data
        });
        else {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${prefixedKey}`);
            (0, $2O7Qv.addCustomTimingForMetric)(prefixedKey);
            (0, $gXfti.addUFOCustomData)(data);
        }
    }, [
        binding,
        onComplete,
        prefixedKey,
        resolvedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $d2938061b4a1e388$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($d2938061b4a1e388$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $d2938061b4a1e388$export$a267cdf45880b07b;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("tgs13", function(module, exports) {
const $2e9fe66aaea8de6a$export$f09b8e10e3913161 = 2419200;
const $2e9fe66aaea8de6a$export$885b9d72bc39ecdb = 2592000000;
const $2e9fe66aaea8de6a$export$6ec716a28918c083 = 31536000;
module.exports["TWENTY_EIGHT_DAYS_IN_SECONDS"] = $2e9fe66aaea8de6a$export$f09b8e10e3913161;
module.exports["THREE_HUNDRED_SIXTY_FIVE_DAYS_IN_SECONDS"] = $2e9fe66aaea8de6a$export$6ec716a28918c083;

});

parcelRegister("fgRQY", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $40c43516853cc93d$export$951d3821f04440e9 = (elementRef, onSeen, t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const threshold = t0 === undefined ? 1 : t0;
    const observerRef = (0, $cozmU.useRef)();
    const hasIntersected = (0, $cozmU.useRef)(false);
    let t1;
    let t2;
    if ($[0] !== elementRef || $[1] !== onSeen || $[2] !== threshold) {
        t1 = ()=>{
            const disconnectObserver = ()=>{
                if (observerRef.current) {
                    observerRef.current.disconnect();
                    observerRef.current = undefined;
                }
            };
            const handleIntersect = (entries)=>{
                if (!hasIntersected.current && entries[0].isIntersecting) {
                    onSeen();
                    hasIntersected.current = true;
                    disconnectObserver();
                }
            };
            observerRef.current = new IntersectionObserver(handleIntersect, {
                threshold: threshold
            });
            if (elementRef.current) observerRef.current.observe(elementRef.current);
            return disconnectObserver;
        };
        t2 = [
            onSeen,
            elementRef,
            threshold
        ];
        $[0] = elementRef;
        $[1] = onSeen;
        $[2] = threshold;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
};
module.exports["useElementSeenCallback"] = $40c43516853cc93d$export$951d3821f04440e9;

});

parcelRegister("71GjD", function(module, exports) {
/**
 * Feature attribution enum for tracking feature usage/attribution
 *
 * @note All feature codes are intended to be 8 characters or less in length
 *
 * @see https://hello.atlassian.net/wiki/x/lQxt9Q
 */ var $9d2fac30cbee1d6f$export$661babcb078ff919 = /*#__PURE__*/ function(FeatureCode) {
    /** Confluence Home Feeds (Following and Popular) **/ FeatureCode["HOME_FEED"] = "HOMEFEED";
    /** Confluence End of Page Recommendations (Related Pages) **/ FeatureCode["EOP_REC"] = "EOPREC";
    /** Confluence End of Page Recommendations (Related Pages) Hover Card **/ FeatureCode["EOP_REC_CARD"] = "EOPCARD";
    /** Confluence Page Tree **/ FeatureCode["PAGE_TREE"] = "PAGETREE";
    /** Confluence Page Tree Card **/ FeatureCode["PAGE_TREE_CARD"] = "TREECARD";
    /** Following Feed email **/ FeatureCode["FOLLOWING_FEED_EMAIL"] = "FLLWEML";
    /** Popular Feed email **/ FeatureCode["POPULAR_FEED_EMAIL"] = "PPLREML";
    FeatureCode["ADMIN_KEY_EMAIL"] = "ADMINEML";
    FeatureCode["ATTACHMENT_EMAILS"] = "ATTCHEML";
    FeatureCode["BATCH_EMAIL"] = "BATCHEML";
    FeatureCode["BLOG_CREATED_EMAIL"] = "BLOGEML";
    FeatureCode["BULK_ARCHIVE_EMAIL"] = "BLKAREML";
    FeatureCode["BULK_OWNER_CHANGE_EMAIL"] = "BLKOWEML";
    FeatureCode["CONFLUENCE_WRAPPED_EMAIL"] = "WRAPEML";
    FeatureCode["CONTACT_ADMINISTRATORS_EMAIL"] = "CTADMEML";
    FeatureCode["CONTENT_OWNER_CHANGE_EMAIL"] = "OWNREML";
    FeatureCode["CONTENT_REDACTION_EMAIL"] = "RDCTDEML";
    FeatureCode["EXCO_ADDED_TO_SPACE_EMAIL"] = "EXCASEML";
    FeatureCode["EXCO_REQUEST_ACCESS_EMAIL"] = "EXCRAEML";
    FeatureCode["EXCO_SPACE_READY_EMAIL"] = "EXCSREML";
    FeatureCode["IMPORTER_NOTIFICATIONS"] = "IMPRTNTF";
    FeatureCode["LIVE_PAGE_PUBLISHED_EMAIL"] = "LPPEML";
    FeatureCode["MENTIONS_EMAIL"] = "MNTNEML";
    FeatureCode["PAGE_CREATED_EMAIL"] = "PAGEEML";
    FeatureCode["REMINDER_EMAIL"] = "RMNDREML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_EMAILS"] = "REQACEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_SLACK"] = "REQACSLK";
    FeatureCode["TASKS_EMAIL"] = "TASKEML";
    FeatureCode["TEAM_CALENDAR_EMAIL"] = "CLNDREML";
    FeatureCode["WHITEBOARD_CREATED_EMAIL"] = "WTBRDEML";
    FeatureCode["CONTENT_REDACTION_IN_APP"] = "RDCTDAPP";
    FeatureCode["DAILY_DIGEST_EMAIL"] = "DIGSTEML";
    FeatureCode["MENTIONS_REMINDER_EMAIL"] = "MNTNREML";
    FeatureCode["PUBLIC_LINK_EMAIL"] = "PBLNKEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_IN_APP"] = "REQACAPP";
    FeatureCode["SHARE_AND_RESTRICT_DIALOG"] = "SRDIALOG";
    FeatureCode["ROVO_CHAT_LINK"] = "ROVOCHAT";
    FeatureCode["ROVO_EXTENSION_LINK"] = "ROVOEXT";
    FeatureCode["SEND_TO_DESKTOP_EMAIL"] = "SNDDSKEML";
    return FeatureCode;
}({});
const $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd = 'atl_f';
module.exports["FeatureCode"] = $9d2fac30cbee1d6f$export$661babcb078ff919;
module.exports["FEATURE_CODES_QUERY_PARAM"] = $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd;

});

parcelRegister("AXitC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7tW57 = parcelRequire("7tW57");

const $e95f65381b50496d$export$ab112bfcbe68934f = (0, $cozmU.createContext)({
    id: '',
    title: {
        text: '',
        emoji: ''
    },
    type: 'page',
    subType: null,
    status: undefined,
    createdBy: {
        displayName: '',
        profilePicture: '',
        accountId: ''
    },
    ownedBy: {
        displayName: '',
        profilePicture: '',
        accountId: ''
    },
    space: {
        spaceKey: '',
        name: ''
    },
    lastAction: {
        when: '',
        action: 'visited'
    },
    editorVersion: '',
    isStarred: false,
    links: {
        webui: '',
        editui: ''
    },
    history: {
        ownedBy: {
            displayName: ''
        }
    },
    creatorId: '',
    likesCount: 0,
    commentsCount: 0,
    setIsMenuOpen: ()=>{},
    isMenuOpen: false,
    setSelectedMenuItems: ()=>{},
    selectedMenuItems: {
        [(0, $7tW57.QuickActionsEnum).WatchButton]: false
    },
    appearance: 'grid',
    isViewed: false,
    setIsViewed: ()=>{},
    smallCard: false
});
module.exports["PageCardContext"] = $e95f65381b50496d$export$ab112bfcbe68934f;

});

parcelRegister("7tW57", function(module, exports) {
var $2151245063608b19$export$fbac647384aa1326 = /*#__PURE__*/ function(QuickActionsEnum) {
    QuickActionsEnum["WatchButton"] = "WATCH";
    return QuickActionsEnum;
}({});
module.exports["QuickActionsEnum"] = $2151245063608b19$export$fbac647384aa1326;

});

parcelRegister("dDr80", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $dYA5q = parcelRequire("dYA5q");


var $AXitC = parcelRequire("AXitC");

const $e6de9c0e17433620$export$60332b2344f7fe41 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isMenuOpen: isMenuOpen, isFolderHoverCard: isFolderHoverCard, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_30huDKOeNX _0bjKvD8fU6 _1mT5xdRAKS _0KLXrulfZc",
            __cmplp.isMenuOpen ? "_2FQ0Ox7dHp" : "_2FQ0OxdnbC",
            !__cmplp.isFolderHoverCard && "_46URyz7zJH _06ZIf37zJH _0ReiIH7zJH _2U1j4nHZdu _1mn8dVHZdu _4gEIokHZdu _2U5WHpzwhj _4mPnyfzwhj _3fSdSTzwhj",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e6de9c0e17433620$export$70b207c5186d7ade = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { StyledCard: t1, children: children, isHoverPageCard: isHoverPageCard, isListitem: isListitem, onClick: onClick } = t0;
    const StyledCard = t1 === undefined ? $e6de9c0e17433620$export$60332b2344f7fe41 : t1;
    const { isMenuOpen: isMenuOpen, setIsViewed: setIsViewed, type: type, subType: subType, status: status } = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    const styledCardRef = (0, $cozmU.useRef)(null);
    let t2;
    if ($[0] !== setIsViewed) {
        t2 = ()=>{
            setIsViewed(true);
        };
        $[0] = setIsViewed;
        $[1] = t2;
    } else t2 = $[1];
    const handleMouseEnter = t2;
    const isFolderHoverCard = isHoverPageCard && type === "folder";
    const isLivePage = subType === "live" && status !== "archived";
    let t3;
    if ($[2] !== isFolderHoverCard || $[3] !== onClick) {
        t3 = (e)=>{
            onClick?.();
            isFolderHoverCard && e.stopPropagation();
        };
        $[2] = isFolderHoverCard;
        $[3] = onClick;
        $[4] = t3;
    } else t3 = $[4];
    const t4 = isListitem ? "listitem" : undefined;
    let t5;
    if ($[5] !== children || $[6] !== isLivePage) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dYA5q.LivePagePreloader), {
            isLivePage: isLivePage
        }, children);
        $[5] = children;
        $[6] = isLivePage;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== StyledCard || $[9] !== handleMouseEnter || $[10] !== isFolderHoverCard || $[11] !== isMenuOpen || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(StyledCard, {
            ref: styledCardRef,
            isMenuOpen: isMenuOpen,
            onMouseEnter: handleMouseEnter,
            onFocus: handleMouseEnter,
            isFolderHoverCard: isFolderHoverCard,
            onClick: t3,
            "data-testid": "page-card-card-container",
            role: t4
        }, t5);
        $[8] = StyledCard;
        $[9] = handleMouseEnter;
        $[10] = isFolderHoverCard;
        $[11] = isMenuOpen;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
};
module.exports["Card"] = $e6de9c0e17433620$export$60332b2344f7fe41;
module.exports["PageCardContainer"] = $e6de9c0e17433620$export$70b207c5186d7ade;

});

parcelRegister("dYA5q", function(module, exports) {
/* LivePagePreloader.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $9wGTI = parcelRequire("9wGTI");


var $7W8i8 = parcelRequire("7W8i8");


var $39rFu = parcelRequire("39rFu");

const $15ad27b3337f3f82$var$logger = (0, $7W8i8.getLogger)('LivePagePreloader');
const $15ad27b3337f3f82$export$6eca3633b04cd128 = ({ isLivePage: isLivePage, children: children })=>{
    const { livePageComponentsPreloader: livePageComponentsPreloader } = (0, $39rFu.useEditPageLoadingActions)();
    const [isPreloading, setIsPreloading] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!isPreloading || !isLivePage) return;
        const preloadComponents = ()=>{
            livePageComponentsPreloader?.().catch((error)=>{
                $15ad27b3337f3f82$var$logger.error`Preloading live page components failed ${error}`;
            }).finally(()=>{
                setIsPreloading(false);
            });
        };
        preloadComponents();
    }, [
        isPreloading,
        isLivePage,
        livePageComponentsPreloader
    ]);
    const triggerPreload = (0, $cozmU.useCallback)(()=>{
        if (isLivePage && !isPreloading) setIsPreloading(true);
    }, [
        isLivePage,
        isPreloading
    ]); // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
    if (!isLivePage || !(0, $9wGTI.fg)('confluence_perf_preload_livepage_assets')) return children;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box // presentation role here to tell screen readers that this is not interactive
    ), {
        role: "presentation",
        onMouseEnter: triggerPreload,
        onFocus: triggerPreload,
        xcss: (0, $w6R6I.cx)($15ad27b3337f3f82$var$styles.box)
    }, children);
};
const $15ad27b3337f3f82$var$styles = {
    box: "_0jFU0VN91d _39xV02N91d"
};
module.exports["LivePagePreloader"] = $15ad27b3337f3f82$export$6eca3633b04cd128;

});

parcelRegister("aoeyL", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");


var $bCECL = parcelRequire("bCECL");


var $AXitC = parcelRequire("AXitC");

const $293a049c82938ad0$var$iconBorderStyles = (0, $buxP3.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    height: '32px',
    width: '32px'
});
const $293a049c82938ad0$export$a1ea799cb5c1b499 = ()=>{
    const $ = (0, $bDgLe.c)(9);
    const { type: type, title: t0, appearance: appearance, subType: subType } = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    const { emoji: emoji } = t0;
    const isCompactEndOfPage = appearance === "compact-end-of-page";
    const t1 = !isCompactEndOfPage && $293a049c82938ad0$var$iconBorderStyles;
    let t2;
    if ($[0] !== t1) {
        t2 = [
            t1
        ];
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== emoji || $[3] !== subType || $[4] !== type) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCECL.ContentIcon), {
            type: type,
            emoji: emoji,
            subType: subType
        });
        $[2] = emoji;
        $[3] = subType;
        $[4] = type;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t2 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            alignItems: "center",
            justifyContent: "center",
            xcss: t2
        }, t3);
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
};
module.exports["ContentIcon"] = $293a049c82938ad0$export$a1ea799cb5c1b499;

});

parcelRegister("9CEYG", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9GVkD = parcelRequire("9GVkD");


var $jlIaF = parcelRequire("jlIaF");


var $56QzY = parcelRequire("56QzY");


var $dPJCf = parcelRequire("dPJCf");


var $lpPVE = parcelRequire("lpPVE");


var $AXitC = parcelRequire("AXitC");


var $jsaQN = parcelRequire("jsaQN");


var $cxMI6 = parcelRequire("cxMI6");

const $ba0d74007085c540$var$PageLinkComponent = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "a" : t5;
        const { compact: compact, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1mT5xdWVPG _0jFU0VN91d _39xV02N91d _2IhTondnbC _3OE6xYdnbC _1UtDYzjOvk _42Yu6BdnbC _1OMQbx7dHp",
            __cmplp.compact ? "_25uIpAZqHV" : "_25uIpA0RdW",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ba0d74007085c540$export$cf060141faaf6cdf = (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { compact: compact, shouldHideFolder: shouldHideFolder, featureAttributionCode: featureAttributionCode, onCardClick: onCardClick } = t0;
    const context = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    const { id: id, type: type, status: status, title: t1, links: t2 } = context;
    const { text: text } = t1;
    const { webui: webui } = t2;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jsaQN.usePageCardAnalyticsEvents)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    let t3;
    if ($[0] !== context || $[1] !== createAnalyticsEvent || $[2] !== id || $[3] !== status || $[4] !== type) {
        t3 = (action, includeNavdex)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: action,
                    actionSubject: (0, $cxMI6.isSpacePageCard)(context) ? "spacePageCard" : "globalPageCard",
                    attributes: {
                        ...includeNavdex && {
                            navdexPointType: (0, $56QzY.START_TOUCH)
                        },
                        contentType: type,
                        contentId: id,
                        contentStatus: status ?? null
                    }
                }
            }).fire();
        };
        $[0] = context;
        $[1] = createAnalyticsEvent;
        $[2] = id;
        $[3] = status;
        $[4] = type;
        $[5] = t3;
    } else t3 = $[5];
    const fireAnalyticsEvent = t3;
    let t4;
    if ($[6] !== featureAttributionCode || $[7] !== fireAnalyticsEvent || $[8] !== onCardClick || $[9] !== push || $[10] !== webui) {
        t4 = (e)=>{
            fireAnalyticsEvent("clicked", true);
            onCardClick?.();
            if (featureAttributionCode) {
                e.preventDefault();
                if (e.metaKey || e.ctrlKey) window.open((0, $lpPVE.generatePathWithFeatureCodesQueryParam)(`${(0, $jlIaF.CONTEXT_PATH)}${webui}`, [
                    featureAttributionCode
                ]));
                else push((0, $lpPVE.generatePathWithFeatureCodesQueryParam)(`${(0, $jlIaF.CONTEXT_PATH)}${webui}`, [
                    featureAttributionCode
                ]));
            }
        };
        $[6] = featureAttributionCode;
        $[7] = fireAnalyticsEvent;
        $[8] = onCardClick;
        $[9] = push;
        $[10] = webui;
        $[11] = t4;
    } else t4 = $[11];
    const handlePageCardClick = t4;
    let t5;
    if ($[12] !== fireAnalyticsEvent) {
        t5 = (e_0)=>{
            e_0.stopPropagation();
            e_0.preventDefault();
            fireAnalyticsEvent("hovered", false);
        };
        $[12] = fireAnalyticsEvent;
        $[13] = t5;
    } else t5 = $[13];
    const handlePageCardHover = t5;
    const shouldRenderLink = !shouldHideFolder || type !== "folder";
    let t6;
    if ($[14] !== compact || $[15] !== handlePageCardClick || $[16] !== handlePageCardHover || $[17] !== shouldRenderLink || $[18] !== text || $[19] !== webui) {
        t6 = shouldRenderLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ba0d74007085c540$var$PageLinkComponent, {
            href: `${(0, $jlIaF.CONTEXT_PATH)}${webui}`,
            onClick: handlePageCardClick,
            onMouseEnter: handlePageCardHover,
            compact: compact
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, text)) : null;
        $[14] = compact;
        $[15] = handlePageCardClick;
        $[16] = handlePageCardHover;
        $[17] = shouldRenderLink;
        $[18] = text;
        $[19] = webui;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
};
module.exports["PageLink"] = $ba0d74007085c540$export$cf060141faaf6cdf;

});

parcelRegister("lpPVE", function(module, exports) {

var $71GjD = parcelRequire("71GjD");

const $d9de10c6417158bd$export$d347e131abf45bea = (href, featureCodes)=>{
    if (!featureCodes.length) return href;
    const [path, queryString] = href.split('?');
    const searchParams = new URLSearchParams(queryString);
    // If the query param already exists, append the new feature codes to the existing ones
    if (searchParams.has((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
        const existingFeatureCodes = searchParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM)) || '';
        const newFeatureCodes = [
            ...new Set([
                ...existingFeatureCodes.split(','),
                ...featureCodes
            ])
        ];
        searchParams.set((0, $71GjD.FEATURE_CODES_QUERY_PARAM), newFeatureCodes.join(','));
    } else searchParams.append((0, $71GjD.FEATURE_CODES_QUERY_PARAM), featureCodes.join(','));
    const newQueryString = searchParams.toString();
    return newQueryString ? `${path}?${newQueryString}` : path;
};
const $d9de10c6417158bd$export$3c2127388df02347 = (queryParams)=>{
    const featureCodes = queryParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM))?.split(',');
    const fromCode = featureCodes?.find((code)=>Object.values((0, $71GjD.FeatureCode)).includes(code));
    return {
        from: fromCode
    };
};
const $d9de10c6417158bd$export$241f453208292937 = (history, location)=>{
    if (!location?.search?.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) return;
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete((0, $71GjD.FEATURE_CODES_QUERY_PARAM));
    const search = searchParams.toString();
    history?.replace?.({
        ...location,
        search: search ? `?${search}` : ''
    });
};
const $d9de10c6417158bd$export$866aaa0a921ee13d = (existingFeatureCodes, featureCodeToCheck)=>{
    return existingFeatureCodes.includes(featureCodeToCheck);
};
const $d9de10c6417158bd$export$84f5742c2ddda28f = (existingFeatureCodes, featureCodeToAdd)=>{
    if ($d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToAdd)) return existingFeatureCodes;
    return [
        ...existingFeatureCodes,
        featureCodeToAdd
    ];
};
const $d9de10c6417158bd$export$f2b1b8a892016485 = (existingFeatureCodes, featureCodeToRemove)=>{
    if (!$d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToRemove)) return existingFeatureCodes;
    return existingFeatureCodes.filter((code)=>code !== featureCodeToRemove);
};
module.exports["generatePathWithFeatureCodesQueryParam"] = $d9de10c6417158bd$export$d347e131abf45bea;
module.exports["getFeatureCodes"] = $d9de10c6417158bd$export$3c2127388df02347;
module.exports["hideFeatureCodesQueryParam"] = $d9de10c6417158bd$export$241f453208292937;

});

parcelRegister("jsaQN", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $7QM6o = parcelRequire("7QM6o");


var $AXitC = parcelRequire("AXitC");

const $c6d4c54e6938616a$export$3acd67f057972c5d = ()=>{
    const $ = (0, $bDgLe.c)(11);
    const { createAnalyticsEvent: akCreateAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { id: id, ranking: ranking, analyticsData: analyticsData, appearance: appearance, type: type } = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    const spaceId = (0, $7QM6o.useSpaceId)();
    let t0;
    if ($[0] !== akCreateAnalyticsEvent || $[1] !== analyticsData?.attributes || $[2] !== analyticsData?.source || $[3] !== appearance || $[4] !== id || $[5] !== ranking || $[6] !== spaceId || $[7] !== type) {
        t0 = (payload)=>{
            payload.data.objectType = type;
            payload.data.objectId = payload.data.objectId ? payload.data.objectId : id;
            payload.data.containerType = "space";
            payload.data.containerId = spaceId;
            if (appearance === "popup-view") payload.data.actionSubjectId = "pageTree";
            payload.data.source = payload.data.source ? payload.data.source : analyticsData?.source;
            payload.data.attributes = {
                ...payload.data.attributes,
                ...analyticsData?.attributes
            };
            if (typeof ranking === "number") payload.data.attributes.ranking = ranking;
            payload.data.attributes.view = appearance;
            return akCreateAnalyticsEvent(payload);
        };
        $[0] = akCreateAnalyticsEvent;
        $[1] = analyticsData?.attributes;
        $[2] = analyticsData?.source;
        $[3] = appearance;
        $[4] = id;
        $[5] = ranking;
        $[6] = spaceId;
        $[7] = type;
        $[8] = t0;
    } else t0 = $[8];
    const createAnalyticsEvent = t0;
    let t1;
    if ($[9] !== createAnalyticsEvent) {
        t1 = {
            createAnalyticsEvent: createAnalyticsEvent
        };
        $[9] = createAnalyticsEvent;
        $[10] = t1;
    } else t1 = $[10];
    return t1;
};
module.exports["usePageCardAnalyticsEvents"] = $c6d4c54e6938616a$export$3acd67f057972c5d;

});

parcelRegister("63k9q", function(module, exports) {
/* Title.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $AXitC = parcelRequire("AXitC");

'use no memo';
const $601474ee7590553b$var$baseStyle = null;
const $601474ee7590553b$var$defaultStyle = null;
const $601474ee7590553b$var$singleLineStyle = null;
const $601474ee7590553b$var$appearanceTitleStyles = {
    grid: "_1DCdHi1Y8M",
    list: "_2sNsIgmnOE _1kk5Tku7m9",
    'compact-list': "",
    'end-of-page': "_2sNsIgd8bj",
    'compact-end-of-page': "_2sNsIg7NXe"
};
const $601474ee7590553b$export$f99233281efd08a0 = ({ singleLine: singleLine, ariaLevelOverride: ariaLevelOverride })=>{
    const { id: id, title: { text: text }, appearance: appearance } = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: `content-title-${id}`,
        role: "heading",
        "aria-level": ariaLevelOverride ?? 2,
        className: (0, $hekY6.default)([
            "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _2xIroY98eZ _497WNwYbGa _2zndICT6kp _1UtDYzy7kJ _3WzCGi98eZ _32C2rk98eZ _0DCa9D98eZ _4DXJrK98eZ _0NqVRtYbGa _0i9AWAYbGa _3932vvYbGa _4yBLMOYbGa _3BKYwu6wH8 _0mm6KQ6wH8 _02cRtH6wH8 _2QcX5c6wH8 _0CMRbky7kJ _10n1R5y7kJ _0clgaMy7kJ _2nTuUYy7kJ",
            "_2sNsIg1kXk",
            $601474ee7590553b$var$appearanceTitleStyles[appearance],
            singleLine && "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _39HuIbz8Lp _1ANEUSLRg7 _4ouGXIdnbC"
        ])
    }, text);
};
module.exports["Title"] = $601474ee7590553b$export$f99233281efd08a0;

});

parcelRegister("kzTi3", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $71GjD = parcelRequire("71GjD");


var $AXitC = parcelRequire("AXitC");


var $dDr80 = parcelRequire("dDr80");

var $aoeyL = parcelRequire("aoeyL");

var $9CEYG = parcelRequire("9CEYG");

var $kvdak = parcelRequire("kvdak");

var $eSkJX = parcelRequire("eSkJX");

var $63k9q = parcelRequire("63k9q");

const $defe7c171d25eb25$var$StyledCard = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $dDr80.Card) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _1bHrqEN91d _0jFU0VN91d",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $defe7c171d25eb25$var$StyledCardWithHover = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $defe7c171d25eb25$var$StyledCard : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1eOmH6sumd",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $defe7c171d25eb25$var$GridCard = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYEMJXG _3iDTPbQ4SZ _0aFT5vbt8w _39xV02GJbM _0jFU0V7Kmv _0NUa3re7g8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $defe7c171d25eb25$var$Header = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: 'space.100'
});
const $defe7c171d25eb25$var$HeaderSmallCard = (0, $buxP3.xcss)({
    marginBottom: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $defe7c171d25eb25$var$IconContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _3138421Y8M",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $defe7c171d25eb25$var$TitlesContainer = (0, $buxP3.xcss)({
    overflow: 'hidden',
    overflowWrap: 'break-word',
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.050'
});
const $defe7c171d25eb25$var$TitlesContainerSmallCard = (0, $buxP3.xcss)({
    whiteSpace: 'nowrap'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $defe7c171d25eb25$var$TitleContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _2sNsIg7NXe _3iDTPbgJ9S _4Gn54R7LI7 _1U1ZhbbI28",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $defe7c171d25eb25$var$SubtitleContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIg7NXe _3iDTPbQ4SZ _42Yu6BdnbC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $defe7c171d25eb25$var$FooterContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNOdnbC _1bHrqEIZbP _3iDTPbQ4SZ _0hPCNLz9WS",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $defe7c171d25eb25$var$FooterBigCard = (0, $buxP3.xcss)({
    marginTop: 'space.200'
});
const $defe7c171d25eb25$var$Footer = (0, $buxP3.xcss)({
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
});
const $defe7c171d25eb25$export$6a5a043d6c50f30e = (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { showCardsAsListitem: t1 } = t0;
    const showCardsAsListitem = t1 === undefined ? true : t1;
    const { smallCard: smallCard } = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    const t2 = smallCard ? $defe7c171d25eb25$var$StyledCardWithHover : $defe7c171d25eb25$var$StyledCard;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9CEYG.PageLink), {
            featureAttributionCode: (0, $71GjD.FeatureCode).EOP_REC
        });
        $[0] = t3;
    } else t3 = $[0];
    let t4;
    if ($[1] !== smallCard) {
        t4 = [
            $defe7c171d25eb25$var$Header,
            ...smallCard ? [
                $defe7c171d25eb25$var$HeaderSmallCard
            ] : []
        ];
        $[1] = smallCard;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($defe7c171d25eb25$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aoeyL.ContentIcon), null));
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== smallCard) {
        t6 = [
            $defe7c171d25eb25$var$TitlesContainer,
            ...smallCard ? [
                $defe7c171d25eb25$var$TitlesContainerSmallCard
            ] : []
        ];
        $[4] = smallCard;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($defe7c171d25eb25$var$TitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $63k9q.Title), {
            ariaLevelOverride: 3
        }));
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($defe7c171d25eb25$var$SubtitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eSkJX.Subtitle), null));
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] !== t6) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t6
        }, t7, t8);
        $[8] = t6;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== t4 || $[11] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t4
        }, t5, t9);
        $[10] = t4;
        $[11] = t9;
        $[12] = t10;
    } else t10 = $[12];
    let t11;
    if ($[13] !== smallCard) {
        t11 = [
            $defe7c171d25eb25$var$Footer,
            ...smallCard ? [] : [
                $defe7c171d25eb25$var$FooterBigCard
            ]
        ];
        $[13] = smallCard;
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvdak.RecommendationStrategy), null);
        $[15] = t12;
    } else t12 = $[15];
    let t13;
    if ($[16] !== t11) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($defe7c171d25eb25$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t11
        }, t12));
        $[16] = t11;
        $[17] = t13;
    } else t13 = $[17];
    let t14;
    if ($[18] !== t10 || $[19] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($defe7c171d25eb25$var$GridCard, {
            "data-testid": "page-card-end-of-page-view"
        }, t10, t13);
        $[18] = t10;
        $[19] = t13;
        $[20] = t14;
    } else t14 = $[20];
    let t15;
    if ($[21] !== showCardsAsListitem || $[22] !== t14 || $[23] !== t2) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dDr80.PageCardContainer), {
            StyledCard: t2,
            isListitem: showCardsAsListitem
        }, t3, t14);
        $[21] = showCardsAsListitem;
        $[22] = t14;
        $[23] = t2;
        $[24] = t15;
    } else t15 = $[24];
    return t15;
};
module.exports["EndOfPageView"] = $defe7c171d25eb25$export$6a5a043d6c50f30e;

});

parcelRegister("kvdak", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $ds2zu = parcelRequire("ds2zu");


var $dVbiN = parcelRequire("dVbiN");


var $fayTW = parcelRequire("fayTW");


var $kTb7m = parcelRequire("kTb7m");


var $AXitC = parcelRequire("AXitC");


var $c9Olr = parcelRequire("c9Olr");

const $8a88bacc20f8ad66$var$i18n = (0, $kSwu1.defineMessages)({
    BEHAVIORAL: {
        id: "page-card.rec.strategy.behavioral",
        defaultMessage: "Read with this"
    },
    CONTENT_TO_CONTENT: {
        id: "page-card.rec.strategy.content-to-content",
        defaultMessage: "More like this"
    },
    STRUCTURAL: {
        id: "page-card.rec.strategy.structural",
        defaultMessage: "Grouped with this"
    },
    LINKED_CONTENT: {
        id: "page-card.rec.strategy.linked-content",
        defaultMessage: "Linked from this"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8a88bacc20f8ad66$var$StrategyContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIg7NXe _3iDTPbQ4SZ _0hPCNLDIqT _1kk5Tkf7mX _1UtDYzZpcK",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $8a88bacc20f8ad66$var$StrategyText = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _2XsHFM2ADO _1ANEUSLRg7 _39HuIbz8Lp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $8a88bacc20f8ad66$var$Icons = {
    BEHAVIORAL: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ds2zu))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: ""
    }),
    CONTENT_TO_CONTENT: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dVbiN))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: ""
    }),
    STRUCTURAL: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fayTW))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }),
    LINKED_CONTENT: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: ""
    })
};
const $8a88bacc20f8ad66$export$96fa1e7da452e6c0 = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { recommendationStrategy: recommendationStrategy } = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            "STRUCTURAL",
            "BEHAVIORAL",
            "CONTENT_TO_CONTENT",
            "LINKED_CONTENT"
        ];
        $[0] = t0;
    } else t0 = $[0];
    const validRecommendationStrategies = t0;
    const Icon = recommendationStrategy && validRecommendationStrategies.includes(recommendationStrategy) && $8a88bacc20f8ad66$var$Icons[recommendationStrategy];
    let t1;
    if ($[1] !== Icon || $[2] !== recommendationStrategy) {
        t1 = recommendationStrategy && validRecommendationStrategies.includes(recommendationStrategy) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8a88bacc20f8ad66$var$StrategyContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, Icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8a88bacc20f8ad66$var$StrategyText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $8a88bacc20f8ad66$var$i18n[recommendationStrategy])))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c9Olr.LastAction), null);
        $[1] = Icon;
        $[2] = recommendationStrategy;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["RecommendationStrategy"] = $8a88bacc20f8ad66$export$96fa1e7da452e6c0;

});

parcelRegister("fayTW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8904d7ecd8870c62b721c48cdb04560c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0b2dcda52076574$var$_react = $b0b2dcda52076574$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b0b2dcda52076574$var$_iconNew = $b0b2dcda52076574$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $b0b2dcda52076574$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsSchema".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/assets-schema
 * Usage guidance:
 * Reserved for representing schema in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0b2dcda52076574$var$AssetsSchemaIcon = (props)=>/*#__PURE__*/ $b0b2dcda52076574$var$_react.default.createElement($b0b2dcda52076574$var$_iconNew.default, Object.assign({
        name: "AssetsSchemaIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.75 11a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m0-8a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M3 13.5a2 2 0 0 1-2-2V0h1.5v4H8v1.5H2.5v6a.5.5 0 0 0 .5.5h5v1.5zm9.75-4a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5m0-8a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5"/>`
    }, props));
$b0b2dcda52076574$var$AssetsSchemaIcon.displayName = 'AssetsSchemaIcon';
var $b0b2dcda52076574$var$_default = module.exports.default = $b0b2dcda52076574$var$AssetsSchemaIcon;

});

parcelRegister("c9Olr", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $kA6Zo = parcelRequire("kA6Zo");


var $1YXTQ = parcelRequire("1YXTQ");


var $AXitC = parcelRequire("AXitC");

const $5445257a17f279b7$var$i18n = (0, $kSwu1.defineMessages)({
    edited: {
        id: "page-card.action.you.edited",
        defaultMessage: "You edited {timeAgo}"
    },
    visited: {
        id: "page-card.action.you.visited",
        defaultMessage: "You visited {timeAgo}"
    },
    updated: {
        id: "page-card.action.updated",
        defaultMessage: "Updated {timeAgo}"
    },
    created: {
        id: "page-card.action.created",
        defaultMessage: "Created {timeAgo}"
    },
    createdByYou: {
        id: "page-card.action.created.by.me",
        defaultMessage: "You created {timeAgo}"
    },
    ownedByYou: {
        id: "page-card.action.owned.by.me",
        defaultMessage: "You became owner {timeAgo}"
    },
    liked: {
        id: "page-card.action.liked",
        defaultMessage: "You liked {timeAgo}"
    },
    commented: {
        id: "page-card.action.commented",
        defaultMessage: "You commented {timeAgo}"
    }
});
const $5445257a17f279b7$var$LastActionContainerStyles = (0, $buxP3.xcss)({
    font: 'font.body.small',
    color: 'color.text.subtle'
});
const $5445257a17f279b7$var$lastActionTextBaseStyles = null;
const $5445257a17f279b7$var$separatorStyles = (0, $buxP3.xcss)({
    margin: 'space.050'
});
const $5445257a17f279b7$export$6d375014d3e4edb5 = (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { isInlineAction: t1, appearance: appearance } = t0;
    const isInlineAction = t1 === undefined ? false : t1;
    const { lastAction: t2 } = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    const { action: action, when: when } = t2;
    let t3;
    if ($[0] !== appearance) {
        t3 = appearance === "list" ? {
            justifyContent: "end"
        } : {};
        $[0] = appearance;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== action || $[3] !== isInlineAction || $[4] !== when) {
        t4 = action && when ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, isInlineAction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $5445257a17f279b7$var$separatorStyles
        }, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _1ANEUSLRg7 _39HuIbz8Lp _1UtDYzKYuM"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$5445257a17f279b7$var$i18n[action],
            values: {
                timeAgo: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1YXTQ.TimeAgo), {
                    date: when,
                    usePrepositions: true
                })
            }
        }))) : null;
        $[2] = action;
        $[3] = isInlineAction;
        $[4] = when;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t3 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            alignItems: "center",
            xcss: $5445257a17f279b7$var$LastActionContainerStyles,
            ...t3
        }, t4);
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
};
module.exports["LastAction"] = $5445257a17f279b7$export$6d375014d3e4edb5;

});

parcelRegister("eSkJX", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $1NBp8 = parcelRequire("1NBp8");


var $56QzY = parcelRequire("56QzY");


var $jJK3p = parcelRequire("jJK3p");


var $AXitC = parcelRequire("AXitC");


var $jsaQN = parcelRequire("jsaQN");


var $cxMI6 = parcelRequire("cxMI6");

const $2476ccb0e5f98391$var$i18n = (0, $kSwu1.defineMessages)({
    createdBy: {
        id: "page-card.created.by",
        defaultMessage: "Created by {creator}"
    },
    creatorProfilePictureAlt: {
        id: "page-card.creator.image.label",
        defaultMessage: "Profile picture"
    },
    ownedBy: {
        id: "page-card.owned.by",
        defaultMessage: "Owned by {owner}"
    },
    ownerProfilePictureAlt: {
        id: "page-card.owner.image.label",
        defaultMessage: "Profile picture"
    }
});
const $2476ccb0e5f98391$var$linkStyle = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2476ccb0e5f98391$var$CreatorContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { compact: compact, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIg7NXe _4bt5LAoWuR _2WAcuGoWuR _42Yu6BdnbC _1ANEUSLRg7 _3iDTPbQ4SZ _0hPCNLDIqT _17lj8p1Y8M _1UtDYzZpcK _1mT5xdRAKS _36J1771Y8M _4nTk44nQyn _1YaocbnQyn _0gKGieKYuM _0LWC4wu7m9 _1SMQPTLRg7 _09AWy0z8Lp _1EjoPeKYuM _1BrKNsKYuM _1E1xWzKYuM _3bFj0TKYuM",
            __cmplp.compact && "_2SjabCnQyn _3y1XktnQyn _2oI5unLRg7 _2bqyXyz8Lp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2476ccb0e5f98391$var$OwnerContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { compact: compact, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIg7NXe _4bt5LAoWuR _2WAcuGoWuR _42Yu6BdnbC _1ANEUSLRg7 _3iDTPbQ4SZ _0hPCNLDIqT _17lj8p1Y8M _1UtDYzZpcK _1mT5xdRAKS _36J1771Y8M _4nTk44nQyn _1YaocbnQyn _0gKGieKYuM _0LWC4wu7m9 _1SMQPTLRg7 _09AWy0z8Lp _1EjoPeKYuM _1BrKNsKYuM _1E1xWzKYuM _3bFj0TKYuM",
            __cmplp.compact && "_2SjabCnQyn _3y1XktnQyn _2oI5unLRg7 _2bqyXyz8Lp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2476ccb0e5f98391$var$SpaceLink = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { compact: compact, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIg7NXe _4bt5LAoWuR _2WAcuGoWuR _42Yu6B7dHp _39HuIbz8Lp _1UtDYzZpcK _1mT5xdRAKS _36J1771Y8M _4nTk44nQyn _1YaocbnQyn _0gKGieKYuM _0LWC4wu7m9 _1SMQPTLRg7 _09AWy0z8Lp _1EjoPeKYuM _1BrKNsKYuM _1E1xWzKYuM _3bFj0TKYuM",
            __cmplp.compact ? "_0TAcaWZqHV" : "_0TAcaWUNDJ",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2476ccb0e5f98391$var$Creator = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { displayName: displayName, accountId: accountId } = t0;
    const { appearance: appearance } = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    const compact = appearance === "compact-list";
    let t1;
    if ($[0] !== accountId || $[1] !== displayName) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$2476ccb0e5f98391$var$i18n.createdBy,
            values: {
                creator: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJK3p.ProfileLink), {
                    userId: accountId,
                    fullName: displayName,
                    referralSource: "pageCard"
                })
            }
        });
        $[0] = accountId;
        $[1] = displayName;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== compact || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2476ccb0e5f98391$var$CreatorContainer, {
            compact: compact
        }, t1);
        $[3] = compact;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
const $2476ccb0e5f98391$var$Owner = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { displayName: displayName, accountId: accountId } = t0;
    const { appearance: appearance } = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    const compact = appearance === "compact-list";
    let t1;
    if ($[0] !== accountId || $[1] !== displayName) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$2476ccb0e5f98391$var$i18n.ownedBy,
            values: {
                owner: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJK3p.ProfileLink), {
                    userId: accountId,
                    fullName: displayName,
                    referralSource: "pageCard"
                })
            }
        });
        $[0] = accountId;
        $[1] = displayName;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== compact || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2476ccb0e5f98391$var$OwnerContainer, {
            compact: compact
        }, t1);
        $[3] = compact;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
const $2476ccb0e5f98391$var$Space = (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { name: name, spaceKey: spaceKey } = t0;
    const context = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    const { appearance: appearance } = context;
    const compact = appearance === "compact-list";
    const endOfPage = appearance === "end-of-page";
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jsaQN.usePageCardAnalyticsEvents)();
    let t1;
    if ($[0] !== appearance || $[1] !== context || $[2] !== createAnalyticsEvent) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: (0, $cxMI6.isSpacePageCard)(context) ? "spacePageCardSpace" : "globalPageCardSpace",
                    attributes: {
                        navdexPointType: (0, $56QzY.START_TOUCH),
                        appearance: appearance
                    }
                }
            }).fire();
        };
        $[0] = appearance;
        $[1] = context;
        $[2] = createAnalyticsEvent;
        $[3] = t1;
    } else t1 = $[3];
    const handleClick = t1;
    let t2;
    if ($[4] !== spaceKey) {
        t2 = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        });
        $[4] = spaceKey;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== handleClick || $[7] !== name || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: t2,
            onClick: handleClick
        }, name);
        $[6] = handleClick;
        $[7] = name;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== compact || $[11] !== endOfPage || $[12] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2476ccb0e5f98391$var$SpaceLink, {
            compact: compact,
            endOfPage: endOfPage
        }, t3);
        $[10] = compact;
        $[11] = endOfPage;
        $[12] = t3;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
};
const $2476ccb0e5f98391$export$cf345ef34cd72655 = ()=>{
    const $ = (0, $bDgLe.c)(6);
    const data = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    if ((0, $cxMI6.isSpacePageCard)(data)) {
        let t0;
        if ($[0] !== data.createdBy || $[1] !== data.ownedBy || $[2] !== data.type) {
            t0 = data?.ownedBy && data?.type !== "blogpost" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2476ccb0e5f98391$var$Owner, data.ownedBy) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2476ccb0e5f98391$var$Creator, data.createdBy);
            $[0] = data.createdBy;
            $[1] = data.ownedBy;
            $[2] = data.type;
            $[3] = t0;
        } else t0 = $[3];
        return t0;
    } else {
        let t0;
        if ($[4] !== data.space) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2476ccb0e5f98391$var$Space, data.space);
            $[4] = data.space;
            $[5] = t0;
        } else t0 = $[5];
        return t0;
    }
};
module.exports["Subtitle"] = $2476ccb0e5f98391$export$cf345ef34cd72655;

});

parcelRegister("jb4sa", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $AXitC = parcelRequire("AXitC");


var $7tW57 = parcelRequire("7tW57");

const $18021647e567f5f6$export$6890bd4131e19e85 = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { appearance: appearance, data: data, ranking: ranking, analyticsData: analyticsData, children: children, smallCard: smallCard } = t0;
    const [isMenuOpen, setIsMenuOpen] = (0, $cozmU.useState)(false);
    const [isViewed, setIsViewed] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            [(0, $7tW57.QuickActionsEnum).WatchButton]: false
        };
        $[0] = t1;
    } else t1 = $[0];
    const [selectedMenuItems, setSelectedMenuItems] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] !== analyticsData || $[2] !== appearance || $[3] !== data || $[4] !== isMenuOpen || $[5] !== isViewed || $[6] !== ranking || $[7] !== selectedMenuItems || $[8] !== smallCard) {
        t2 = {
            ...data,
            appearance: appearance,
            setIsMenuOpen: setIsMenuOpen,
            isMenuOpen: isMenuOpen,
            ranking: ranking,
            setSelectedMenuItems: setSelectedMenuItems,
            selectedMenuItems: selectedMenuItems,
            analyticsData: analyticsData,
            isViewed: isViewed,
            setIsViewed: setIsViewed,
            smallCard: smallCard
        };
        $[1] = analyticsData;
        $[2] = appearance;
        $[3] = data;
        $[4] = isMenuOpen;
        $[5] = isViewed;
        $[6] = ranking;
        $[7] = selectedMenuItems;
        $[8] = smallCard;
        $[9] = t2;
    } else t2 = $[9];
    const pageCardContextValue = t2;
    let t3;
    if ($[10] !== children || $[11] !== pageCardContextValue) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $AXitC.PageCardContext).Provider, {
            value: pageCardContextValue
        }, children);
        $[10] = children;
        $[11] = pageCardContextValue;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
}, (prevProps, nextProps)=>prevProps.appearance === nextProps.appearance && prevProps.data.isStarred === nextProps.data.isStarred);
module.exports["PageCardContextProvider"] = $18021647e567f5f6$export$6890bd4131e19e85;

});

parcelRegister("fOasY", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kz1Yj = parcelRequire("kz1Yj");


var $2wCqQ = parcelRequire("2wCqQ");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $4hCFw = parcelRequire("4hCFw");


var $cFVPs = parcelRequire("cFVPs");


var $71GjD = parcelRequire("71GjD");


var $bQm3c = parcelRequire("bQm3c");


var $AXitC = parcelRequire("AXitC");


var $5BwjK = parcelRequire("5BwjK");

var $qaY7H = parcelRequire("qaY7H");

var $aoeyL = parcelRequire("aoeyL");

var $c9Olr = parcelRequire("c9Olr");

var $dDr80 = parcelRequire("dDr80");

var $9CEYG = parcelRequire("9CEYG");

var $1R1bQ = parcelRequire("1R1bQ");

var $eSkJX = parcelRequire("eSkJX");

var $63k9q = parcelRequire("63k9q");

const $9c44b8c40f625697$var$styles = (0, $buxP3.xcss)({
    width: '400px'
});
const $9c44b8c40f625697$var$headerStyle = (0, $buxP3.xcss)({
    width: '100%',
    overflowWrap: 'break-word',
    wordBreak: 'break-all',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $9c44b8c40f625697$var$headerIconStyle = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    alignSelf: 'flex-start'
});
const $9c44b8c40f625697$var$titleStyles = (0, $buxP3.xcss)({
    font: 'font.heading.medium',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    overflowWrap: 'break-word',
    display: '-webkit-box',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
    textAlign: 'start',
    WebkitBoxPack: 'start'
});
const $9c44b8c40f625697$var$aiSnippetStyles = {
    container: "_4kiQYAJgOI _2fwxA57p2s _1mOMTklpBW"
};
const $9c44b8c40f625697$export$28f0f82c7dd8d86e = (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { shouldUseAutomationDiscovery: shouldUseAutomationDiscovery, snippet: snippet, isEndOfPage: t1, contentId: contentId, contentType: contentType, onLoadComplete: onLoadComplete, shouldUseAISnippetPlatformComponent: t2, onCardClick: onCardClick } = t0;
    const isEndOfPage = t1 === undefined ? false : t1;
    const shouldUseAISnippetPlatformComponent = t2 === undefined ? false : t2;
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { excerpt: excerpt } = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    const { trackAIResultAction: trackAIResultAction } = (0, $cFVPs.useAIEventsInstrumentation)();
    let t3;
    if ($[0] !== isEndOfPage || $[1] !== shouldUseAISnippetPlatformComponent || $[2] !== snippet || $[3] !== trackAIResultAction) {
        t3 = ()=>{
            if (snippet || shouldUseAISnippetPlatformComponent) trackAIResultAction("aiSnippetCardClicked", {
                attributes: {
                    source: isEndOfPage ? "endOfPageRecommendations" : "pageTree"
                }
            });
        };
        $[0] = isEndOfPage;
        $[1] = shouldUseAISnippetPlatformComponent;
        $[2] = snippet;
        $[3] = trackAIResultAction;
        $[4] = t3;
    } else t3 = $[4];
    const handlePopupClick = t3;
    const t4 = isEndOfPage ? (0, $71GjD.FeatureCode).EOP_REC_CARD : (0, $71GjD.FeatureCode).PAGE_TREE_CARD;
    let t5;
    if ($[5] !== onCardClick || $[6] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9CEYG.PageLink), {
            shouldHideFolder: true,
            featureAttributionCode: t4,
            onCardClick: onCardClick
        });
        $[5] = onCardClick;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $9c44b8c40f625697$var$headerIconStyle,
            as: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aoeyL.ContentIcon), null));
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            alignBlock: "center",
            alignInline: "start",
            shouldWrap: false,
            grow: "fill",
            space: "space.100"
        }, t6, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            xcss: $9c44b8c40f625697$var$headerStyle,
            alignBlock: "start",
            alignInline: "start",
            grow: "fill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $9c44b8c40f625697$var$titleStyles,
            as: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $63k9q.Title), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eSkJX.Subtitle), null)));
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== cloudId || $[11] !== contentId || $[12] !== contentType || $[13] !== excerpt || $[14] !== isEndOfPage || $[15] !== onLoadComplete || $[16] !== userId) {
        t8 = excerpt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $9c44b8c40f625697$var$aiSnippetStyles.container
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hCFw.AISnippetWithRelayEnvironment), {
            contentId: contentId,
            contentType: contentType,
            cloudId: cloudId,
            source: isEndOfPage ? "endOfPageRecommendations" : "pageTree",
            onLoadComplete: onLoadComplete,
            fallbackText: excerpt,
            from: isEndOfPage ? (0, $71GjD.FeatureCode).EOP_REC_CARD : (0, $71GjD.FeatureCode).PAGE_TREE_CARD,
            userId: userId ?? undefined
        }));
        $[10] = cloudId;
        $[11] = contentId;
        $[12] = contentType;
        $[13] = excerpt;
        $[14] = isEndOfPage;
        $[15] = onLoadComplete;
        $[16] = userId;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c9Olr.LastAction), null);
        $[18] = t9;
    } else t9 = $[18];
    let t10;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1R1bQ.SocialProof), null);
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== isEndOfPage) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            alignBlock: "center",
            spread: "space-between",
            shouldWrap: false,
            grow: "fill",
            space: "space.200"
        }, t9, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            alignBlock: "center",
            space: "space.100"
        }, t10, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5BwjK.AudioPlaylistButton), {
            isEndOfPage: isEndOfPage
        })));
        $[20] = isEndOfPage;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== t11 || $[23] !== t8) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            padding: "space.200",
            xcss: $9c44b8c40f625697$var$styles,
            testId: "page-card-popup-view"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            alignBlock: "start",
            alignInline: "start",
            grow: "fill",
            space: "space.200"
        }, t7, t8, t11));
        $[22] = t11;
        $[23] = t8;
        $[24] = t12;
    } else t12 = $[24];
    let t13;
    if ($[25] !== shouldUseAutomationDiscovery) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $qaY7H.AutomationDiscoveryMessage), {
            shouldUseAutomationDiscovery: shouldUseAutomationDiscovery
        });
        $[25] = shouldUseAutomationDiscovery;
        $[26] = t13;
    } else t13 = $[26];
    let t14;
    if ($[27] !== handlePopupClick || $[28] !== t12 || $[29] !== t13 || $[30] !== t5) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dDr80.PageCardContainer), {
            isHoverPageCard: true,
            onClick: handlePopupClick
        }, t5, t12, t13);
        $[27] = handlePopupClick;
        $[28] = t12;
        $[29] = t13;
        $[30] = t5;
        $[31] = t14;
    } else t14 = $[31];
    return t14;
};
module.exports["PopupViewWithAISnippet"] = $9c44b8c40f625697$export$28f0f82c7dd8d86e;

});

parcelRegister("5BwjK", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9LRH4 = parcelRequire("9LRH4");


var $JTIzG = parcelRequire("JTIzG");


var $7aRa9 = parcelRequire("7aRa9");


var $bQm3c = parcelRequire("bQm3c");


var $AXitC = parcelRequire("AXitC");

const $38667f05992adc43$var$WrappedButton = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { flags: flags, isEndOfPage: isEndOfPage } = t0;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { isAudioV3Enabled: isAudioV3Enabled } = (0, $JTIzG.useAudioFeatureFlags)();
    const { id: id, type: type, title: title } = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    let t1;
    if ($[0] !== cloudId || $[1] !== flags || $[2] !== id || $[3] !== isAudioV3Enabled || $[4] !== isEndOfPage || $[5] !== title || $[6] !== type) {
        t1 = cloudId && type === "page" && isAudioV3Enabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9LRH4.ModifyPlaylistButton), {
            cloudId: cloudId,
            contentId: id,
            contentType: type,
            title: title.text,
            subtle: true,
            flagsOverride: flags,
            actionSource: isEndOfPage ? "endOfPageRecommendations" : "pageTree"
        });
        $[0] = cloudId;
        $[1] = flags;
        $[2] = id;
        $[3] = isAudioV3Enabled;
        $[4] = isEndOfPage;
        $[5] = title;
        $[6] = type;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
};
const $38667f05992adc43$export$dbccb879127f2ec0 = (0, $7aRa9.withFlags)($38667f05992adc43$var$WrappedButton);
module.exports["AudioPlaylistButton"] = $38667f05992adc43$export$dbccb879127f2ec0;

});

parcelRegister("9LRH4", function(module, exports) {

var $1jBc5 = parcelRequire("1jBc5");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $1sCHt = parcelRequire("1sCHt");


var $3yAls = parcelRequire("3yAls");


var $jInUM = parcelRequire("jInUM");


var $e3DmL = parcelRequire("e3DmL");


var $iMnC5 = parcelRequire("iMnC5");


var $4iiGe = parcelRequire("4iiGe");


var $d5gEx = parcelRequire("d5gEx");


var $baYrV = parcelRequire("baYrV");


var $5Oglp = parcelRequire("5Oglp");


var $bqcqm = parcelRequire("bqcqm");


var $kZLou = parcelRequire("kZLou");

const $22c4b6a425a07534$var$messages = (0, $kSwu1.defineMessages)({
    addToPlaylistText: {
        id: "ai-audio.playlist.button.addToPlaylist-label",
        defaultMessage: "Add to playlist"
    },
    removeFromPlaylistText: {
        id: "ai-audio.playlist.button.removeFromPlaylist-label",
        defaultMessage: "Remove from playlist"
    },
    inPlaylistText: {
        id: "ai-audio.playlist.button.inPlaylist-label",
        defaultMessage: "Added to playlist"
    }
});
const $22c4b6a425a07534$var$styles = {
    container: "_0jFU0VUofl _39xV02Uofl"
};
const $22c4b6a425a07534$export$76382f4393cd85be = ({ testId: testId, cloudId: //for testing
cloudId, contentId: //needed to generate ari
contentId, contentType: //needed to mutate
contentType, trackType: //needed to mutate and for ari
trackType = 'BRIEFING', circle: //optional default: NARRATION or BRIEFING
circle, subtle: //optional to apply circle shape
subtle, flagsOverride: //optional to apply subtle treatment
flagsOverride, iconColor: //optional override for context
iconColor, actionSource: //optional override for icon color
actionSource //optional, allows us to track the source of the button click
 })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { addTrack: addTrack, isAdding: isAdding } = (0, $kZLou.useContextMenuActions)(cloudId, flagsOverride);
    const { activeContent: activeContent, isPlaying: isPlaying } = (0, $bqcqm.useAudioPlayerStore)();
    const { sendTrackEvent: sendTrackEvent } = (0, $4iiGe.usePlatformInstrumentation)();
    const isSuggestion = actionSource === 'playlistSuggestions';
    const addToPlaylist = (0, $cozmU.useCallback)(async ()=>{
        const addingPlayingTrack = isPlaying && activeContent.contentId === contentId;
        await addTrack((0, $5Oglp.getConfluenceContentAri)(cloudId, contentId, contentType)?.toString() || '', activeContent.supportingContent.map((content)=>content.ari) || [], trackType, {
            top: addingPlayingTrack || false,
            trackSource: (0, $baYrV.TrackSourceType).WEB
        }).catch((error)=>{
            sendTrackEvent({
                eventType: 'track',
                action: 'error',
                actionSubject: 'playlistItemAdd',
                actionSubjectId: 'playlist',
                source: 'playlist',
                attributes: {
                    error: error,
                    contentType: contentType,
                    trackType: trackType,
                    ...actionSource && {
                        actionSource: actionSource
                    }
                }
            });
        }).then(()=>{
            sendTrackEvent({
                eventType: 'track',
                action: 'added',
                actionSubject: 'playlistItem',
                actionSubjectId: 'playlist',
                source: 'playlist',
                attributes: {
                    contentType: contentType,
                    trackType: trackType,
                    ...actionSource && {
                        actionSource: actionSource
                    },
                    ...isSuggestion && {
                        isSuggestion: isSuggestion
                    }
                }
            });
        });
    }, [
        cloudId,
        contentId,
        contentType,
        trackType,
        addTrack,
        activeContent.supportingContent,
        activeContent.contentId,
        isPlaying,
        actionSource,
        sendTrackEvent,
        isSuggestion
    ]);
    const tooltipOptions = {
        content: formatMessage($22c4b6a425a07534$var$messages.addToPlaylistText),
        position: 'bottom',
        hideTooltipOnClick: true
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3yAls))), {
                ...iconProps,
                color: iconColor ? iconColor : undefined
            }),
        testId: testId && `${testId}-add`,
        label: formatMessage($22c4b6a425a07534$var$messages.addToPlaylistText),
        tooltip: tooltipOptions,
        onClick: addToPlaylist,
        isTooltipDisabled: false,
        isDisabled: isAdding || !contentId,
        shape: circle ? 'circle' : undefined,
        appearance: subtle ? 'subtle' : undefined,
        "data-vc": "add-to-playlist-button"
    });
};
const $22c4b6a425a07534$export$ce1b020c3f0567a5 = ({ testId: testId, title: //for testing
title, cloudId: //for success flag text
cloudId, contentId: //needed to generate ari
contentId, contentType: //needed to mutate
contentType, trackType: //needed to mutate and for ari
trackType, circle: //optional default: NARRATION or BRIEFING
circle, subtle: //optional to apply circle shape
subtle, flagsOverride: //optional to apply subtle treatment
flagsOverride, iconColor: //optional override for context
iconColor, playlist: //optional override for icon color
playlist //modify playlist button will provide a list of items in the playlist
 })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { removeTrack: removeTrack, isRemoving: isRemoving } = (0, $kZLou.useContextMenuActions)(cloudId, flagsOverride);
    const { activeContent: activeContent } = (0, $bqcqm.useAudioPlayerStore)();
    const { sendTrackEvent: sendTrackEvent } = (0, $4iiGe.usePlatformInstrumentation)();
    const removeFromPlaylist = (0, $cozmU.useCallback)(async ()=>{
        await removeTrack((0, $5Oglp.getConfluenceContentAri)(cloudId, contentId, contentType)?.toString() || '', activeContent.supportingContent.map((content)=>content.ari) || [], trackType || 'BRIEFING', title, {
            //type conversion because uggghhhhh relay fields
            playlist: playlist
        }).catch((error)=>{
            sendTrackEvent({
                eventType: 'track',
                action: 'error',
                actionSubject: 'playlistItemRemove',
                actionSubjectId: 'playlist',
                source: 'playlist',
                attributes: {
                    error: error,
                    contentType: contentType,
                    trackType: trackType,
                    itemPosition: playlist?.findIndex((item)=>item.title === title) ?? -1,
                    totalPlaylistSize: playlist?.length ?? 0
                }
            });
        }).then(()=>{
            sendTrackEvent({
                eventType: 'track',
                action: 'removed',
                actionSubject: 'playlistItem',
                actionSubjectId: 'playlist',
                source: 'playlist',
                attributes: {
                    contentType: contentType,
                    trackType: trackType,
                    itemPosition: playlist?.findIndex((item)=>item.title === title) ?? -1,
                    totalPlaylistSize: playlist?.length ?? 0
                }
            });
        });
    }, [
        cloudId,
        contentId,
        contentType,
        trackType,
        title,
        removeTrack,
        activeContent.supportingContent,
        playlist,
        sendTrackEvent
    ]);
    const tooltipOptions = {
        content: formatMessage($22c4b6a425a07534$var$messages.removeFromPlaylistText),
        position: 'bottom',
        hideTooltipOnClick: true
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e3DmL))), {
                ...iconProps,
                color: iconColor ? iconColor : undefined
            }),
        testId: testId && `${testId}-remove`,
        label: formatMessage($22c4b6a425a07534$var$messages.removeFromPlaylistText),
        tooltip: tooltipOptions,
        onClick: removeFromPlaylist,
        isTooltipDisabled: false,
        isDisabled: isRemoving || !contentId,
        shape: circle ? 'circle' : undefined,
        appearance: subtle ? 'subtle' : undefined,
        "data-vc": "remove-from-playlist-button"
    });
};
const $22c4b6a425a07534$export$9c768a8c290b2144 = ({ testId: testId, circle: circle, subtle: subtle, iconColor: iconColor })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const tooltipOptions = {
        content: formatMessage($22c4b6a425a07534$var$messages.inPlaylistText),
        position: 'bottom',
        hideTooltipOnClick: true
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jInUM))), {
                ...iconProps,
                color: iconColor ? iconColor : undefined
            }),
        testId: testId && `${testId}-added`,
        label: formatMessage($22c4b6a425a07534$var$messages.inPlaylistText),
        tooltip: tooltipOptions,
        isTooltipDisabled: false,
        shape: circle ? 'circle' : undefined,
        appearance: subtle ? 'subtle' : undefined,
        "data-vc": "in-playlist-button"
    });
};
const $22c4b6a425a07534$export$1d966ac7ff8e1b07 = ({ testId: testId, title: // test ID
title, round: //text for remove flag
round, subtle: //applies rounded treatment
subtle, _defaultEngagement_do_not_use: //applies subtle treatment
_defaultEngagement_do_not_use = false, cloudId: cloudId, contentId: //needed to generate ari
contentId, contentType: //needed to mutate
contentType, trackType: //needed to mutate and for ari
trackType, flagsOverride: //optional default: NARRATION or BRIEFING
flagsOverride, iconColor: //optional override for context
iconColor, actionSource: //optional override for icon color
actionSource //optional, allows us to track the source of the button click
 })=>{
    const playlist = (0, $6SsN4.useLazyLoadQuery)((0, $1jBc5.default), {
        cloudId: cloudId
    }, {
        fetchPolicy: 'store-or-network'
    });
    const playlistItems = (0, $cozmU.useMemo)(()=>{
        const tracks = playlist.confluence_getPlaylist?.tracks?.nodes || [];
        return tracks.filter((track)=>{
            const mainContent = track.mainContent;
            const hasMainContent = !!mainContent;
            const hasValidStatus = mainContent?.status === 'current' || mainContent?.status === 'draft';
            return hasMainContent && hasValidStatus;
        }).map((track)=>{
            const mainContent = track.mainContent;
            const supportingContent = track.supportingContent;
            const creator = mainContent.history?.createdBy || mainContent.history?.ownedBy;
            const avatarUrl = creator?.profilePicture?.path || undefined;
            return {
                contentId: mainContent.id,
                spaceKey: mainContent.space?.key || '',
                contentType: mainContent.type || '',
                title: mainContent.title || undefined,
                author: creator?.displayName || undefined,
                avatarUrl: avatarUrl,
                mainContentLink: mainContent.links?.base + mainContent.links?.webui || '',
                supportingContent: supportingContent?.length > 0 ? supportingContent.map((content)=>({
                        ari: content.ari,
                        link: content.links?.base + content.links?.webui || ''
                    })) : [],
                subtype: mainContent.subType || '',
                emojiId: mainContent.properties?.nodes?.[0]?.value || undefined
            };
        });
    }, [
        playlist
    ]);
    const isInPlaylist = (0, $cozmU.useMemo)(()=>{
        if (!playlist?.confluence_getPlaylist?.tracks?.nodes) return false;
        const nodes = playlist.confluence_getPlaylist.tracks.nodes; // @ts-ignore nodes isn't strongly typed
        const matchPlaylist = (node)=>{
            return trackType ? node?.mainContent?.id === contentId && node.type === trackType : node?.mainContent?.id === contentId;
        };
        return nodes.find(matchPlaylist);
    }, [
        playlist,
        contentId,
        trackType
    ]);
    const [isEngaged, setIsEngaged] = (0, $cozmU.useState)(_defaultEngagement_do_not_use);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: "audio-player-changeboarding-step-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box // Set the state to true when the mouse enters or the element receives focus
    ), {
        onMouseEnter: ()=>setIsEngaged(true),
        onFocus: ()=>setIsEngaged(true),
        onMouseLeave: ()=>setIsEngaged(false),
        onBlur: ()=>setIsEngaged(false),
        xcss: $22c4b6a425a07534$var$styles.container,
        "data-vc": "modify-playlist-button"
    }, isInPlaylist ? !isEngaged ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22c4b6a425a07534$export$9c768a8c290b2144, {
        testId: testId,
        circle: round,
        subtle: subtle,
        iconColor: iconColor
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22c4b6a425a07534$export$ce1b020c3f0567a5, {
        iconColor: iconColor,
        testId: testId,
        cloudId: cloudId,
        contentId: contentId,
        contentType: contentType,
        trackType: isInPlaylist?.type,
        title: title,
        circle: round,
        subtle: subtle,
        flagsOverride: flagsOverride,
        playlist: playlistItems
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22c4b6a425a07534$export$76382f4393cd85be, {
        iconColor: iconColor,
        testId: testId,
        cloudId: cloudId,
        contentId: contentId,
        contentType: contentType,
        trackType: trackType,
        circle: round,
        subtle: subtle,
        flagsOverride: flagsOverride,
        actionSource: actionSource
    }))));
};
const $22c4b6a425a07534$export$a239151f44937f5c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22c4b6a425a07534$export$1d966ac7ff8e1b07, props)));
};
module.exports["ModifyPlaylistButton"] = $22c4b6a425a07534$export$a239151f44937f5c;

});

parcelRegister("1jBc5", function(module, exports) {
/**
 * @generated SignedSource<<3fa2ab08668e7e1a87d7fd7d2eec1cf5>>
 * @relayHash 4ff9aaaf0a17446292cb5bcf157ca63f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9293b3482731c86d63a262f87b08644097858ca089736b9c015c73d51827e8f9
const $7d1c28ea3113888e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "title"
    }, v5 = {
        "kind": "ScalarField",
        "name": "status"
    }, v6 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "key"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = [
        v8 /*: any*/ ,
        v9 /*: any*/ 
    ], v11 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "base"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v12 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\"])"
    }, v13 = {
        "kind": "ScalarField",
        "name": "ari"
    }, v14 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v8 /*: any*/ ,
        v9 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ModifyPlaylistButtonsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluencePlaylist",
                    "kind": "LinkedField",
                    "name": "confluence_getPlaylist",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluencePaginatedTracks",
                            "kind": "LinkedField",
                            "name": "tracks",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceTrack",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "mainContent",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "Space",
                                                    "kind": "LinkedField",
                                                    "name": "space",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": v10 /*: any*/ 
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "ownedBy",
                                                            "plural": false,
                                                            "selections": v10 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "supportingContent",
                                            "plural": true,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ModifyPlaylistButtonsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluencePlaylist",
                    "kind": "LinkedField",
                    "name": "confluence_getPlaylist",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluencePaginatedTracks",
                            "kind": "LinkedField",
                            "name": "tracks",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceTrack",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "mainContent",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "Space",
                                                    "kind": "LinkedField",
                                                    "name": "space",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": v14 /*: any*/ 
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "ownedBy",
                                                            "plural": false,
                                                            "selections": v14 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "supportingContent",
                                            "plural": true,
                                            "selections": [
                                                v13 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9293b3482731c86d63a262f87b08644097858ca089736b9c015c73d51827e8f9",
            "metadata": {},
            "name": "ModifyPlaylistButtonsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7d1c28ea3113888e$var$node.hash = "a4b44bf820e6a02841e5bff2e755e4d2";
var $7d1c28ea3113888e$export$2e2bcd8739ae039 = $7d1c28ea3113888e$var$node;
module.exports["default"] = $7d1c28ea3113888e$export$2e2bcd8739ae039;

});

parcelRegister("jInUM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::58ac4b68c142e5fee8d46f7a305aca85>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e5a4ad575468ac21$var$_react = $e5a4ad575468ac21$var$_interopRequireDefault((parcelRequire("cozmU")));

var $e5a4ad575468ac21$var$_iconNew = $e5a4ad575468ac21$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $e5a4ad575468ac21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PlaylistAdded".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/playlist-added
 * Usage guidance:
 * Indicating when things have been added to your playlist (feature)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e5a4ad575468ac21$var$PlaylistAddedIcon = (props)=>/*#__PURE__*/ $e5a4ad575468ac21$var$_react.default.createElement($e5a4ad575468ac21$var$_iconNew.default, Object.assign({
        name: "PlaylistAddedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.69.058a2.63 2.63 0 0 1 3.116 2.024l.406 1.912h1.165a2.626 2.626 0 0 1 2.626 2.626v6.754A2.626 2.626 0 0 1 13.377 16H6.623a2.626 2.626 0 0 1-2.626-2.626v-.112a2.63 2.63 0 0 1-2.532-2.08L.062 4.578a2.627 2.627 0 0 1 2.023-3.115zm.467 11.013L7.97 9.544l-1.184.923 1.751 2.251a.75.75 0 0 0 1.162.027l3.752-4.377-1.14-.977zm1.18-8.677a1.126 1.126 0 0 0-1.335-.867L2.397 2.93c-.608.13-.997.727-.867 1.335l1.404 6.605c.11.517.558.874 1.063.89V6.62a2.626 2.626 0 0 1 2.626-2.627h4.055z"/>`
    }, props));
$e5a4ad575468ac21$var$PlaylistAddedIcon.displayName = 'PlaylistAddedIcon';
var $e5a4ad575468ac21$var$_default = module.exports.default = $e5a4ad575468ac21$var$PlaylistAddedIcon;

});

parcelRegister("baYrV", function(module, exports) {
var $a5f240ac0ec91afb$export$5e6f69005d6ec968 = /*#__PURE__*/ function(TrackSourceType) {
    TrackSourceType["WEB"] = "WEB";
    TrackSourceType["MOBILE"] = "MOBILE";
    TrackSourceType["UNKNOWN"] = "UNKNOWN";
    return TrackSourceType;
}({});
module.exports["TrackSourceType"] = $a5f240ac0ec91afb$export$5e6f69005d6ec968;

});

parcelRegister("5Oglp", function(module, exports) {

var $5BvyC = parcelRequire("5BvyC");

var $8jDil = parcelRequire("8jDil");

var $7GbwS = parcelRequire("7GbwS");

const $582b8decdf5802e0$export$6a2f2c83863e9bfe = (siteId, contentId, contentType)=>{
    try {
        switch(contentType){
            case 'page':
                return (0, $8jDil.ConfluencePageAri).create({
                    siteId: siteId,
                    pageId: contentId
                });
            case 'blogpost':
                return (0, $5BvyC.ConfluenceBlogpostAri).create({
                    siteId: siteId,
                    blogpostId: contentId
                });
            case 'whiteboard':
                return (0, $7GbwS.ConfluenceWhiteboardAri).create({
                    siteId: siteId,
                    whiteboardId: contentId
                });
        }
    } catch  {
        return undefined;
    }
    return undefined;
};
module.exports["getConfluenceContentAri"] = $582b8decdf5802e0$export$6a2f2c83863e9bfe;

});

parcelRegister("bqcqm", function(module, exports) {

var $g4Rov = parcelRequire("g4Rov");


var $4uGyl = parcelRequire("4uGyl");

const $16bd5dfd5e029c20$export$cba1cb68876d4742 = ()=>{
    const state = (0, $g4Rov.useAtom)((0, $4uGyl.audioPlayerState));
    return {
        // State
        isOpen: state.isOpen,
        isPlaying: state.isPlaying,
        isHidden: state.isHidden,
        isPaused: state.isPaused,
        activeContent: state.activeContent,
        activeFeature: state.activeFeature,
        activeMenu: state.activeMenu,
        activeAudioContainerMode: state.activeAudioContainerMode,
        pendingContent: state.pendingContent,
        cloudId: state.cloudId,
        customization: state.customization,
        playlistDefaultExpanded: state.playlistDefaultExpanded,
        playImmediately: state.playImmediately,
        playlistHasUnavailableContent: state.playlistHasUnavailableContent,
        hasOpenDropdownMenu: state.hasOpenDropdownMenu,
        openAudioPlayer: // Actions
        $4uGyl.openAudioPlayer,
        closeAudioPlayer: $4uGyl.closeAudioPlayer,
        hideAudioPlayer: $4uGyl.hideAudioPlayer,
        activatePendingContent: $4uGyl.activatePendingContent,
        clearPendingContent: $4uGyl.clearPendingContent,
        setIsPlaying: $4uGyl.setIsPlaying,
        setIsPaused: $4uGyl.setIsPaused,
        updatePlayerState: $4uGyl.updatePlayerState,
        setActiveFeature: $4uGyl.setActiveFeature,
        setActiveMenu: $4uGyl.setActiveMenu,
        setActiveAudioContainerMode: $4uGyl.setActiveAudioContainerMode,
        setCustomization: $4uGyl.setCustomization,
        getCustomization: $4uGyl.getCustomization,
        setPlaybackSpeed: $4uGyl.setPlaybackSpeed,
        getSupportingContent: $4uGyl.getSupportingContent,
        setSupportingContent: $4uGyl.setSupportingContent,
        resetPlaylistDefaultExpanded: $4uGyl.resetPlaylistDefaultExpanded,
        resetPlayImmediately: $4uGyl.resetPlayImmediately,
        setPlaylistHasUnavailableContent: $4uGyl.setPlaylistHasUnavailableContent,
        setHasOpenDropdownMenu: $4uGyl.setHasOpenDropdownMenu
    };
};
module.exports["useAudioPlayerStore"] = $16bd5dfd5e029c20$export$cba1cb68876d4742;

});

parcelRegister("g4Rov", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $avHQ3 = parcelRequire("avHQ3");

function $bb4670134a009960$var$defaultCompare(a, b) {
    return a === b;
}
function $bb4670134a009960$var$identity(snapshot) {
    return snapshot;
}
function $bb4670134a009960$var$useSelectorWithCompare(selector, compare) {
    const previous = (0, $cozmU.useRef)(undefined);
    return (snapshot)=>{
        const next = selector(snapshot);
        return previous.current && compare(previous.current, next) ? previous.current : previous.current = next;
    };
}
/**
 * A React hook that subscribes to the `store` and selects a value from the
 * store's snapshot via a selector function, with an optional compare function.
 *
 * @example
 *
 * ```ts
 * function Component() {
 *   const count = useSelector(store, (s) => s.count);
 *
 *   return <div>{count}</div>;
 * }
 * ```
 *
 * @param store The store, created from `createStore(…)`
 * @param selector A function which takes in the `snapshot` and returns a
 *   selected value
 * @param compare An optional function which compares the selected value to the
 *   previous value
 * @returns The selected value
 */ /**
 * A React hook that subscribes to the `store` and selects a value from the
 * store's snapshot via an optional selector function (identity by default),
 * with an optional compare function.
 *
 * @example
 *
 * ```ts
 * function Component() {
 *   const countSnapshot = useSelector(store);
 *
 *   return <div>{countSnapshot.context.count}</div>;
 * }
 * ```
 *
 * @param store The store, created from `createStore(…)`
 * @param selector An optional function which takes in the `snapshot` and
 *   returns a selected value
 * @param compare An optional function which compares the selected value to the
 *   previous value
 * @returns The selected value
 */ function $bb4670134a009960$export$2105062e25df4afe(store, selector = $bb4670134a009960$var$identity, compare = $bb4670134a009960$var$defaultCompare) {
    const selectorWithCompare = $bb4670134a009960$var$useSelectorWithCompare(selector, compare);
    return (0, $cozmU.useSyncExternalStore)((0, $cozmU.useCallback)((handleStoreChange)=>store.subscribe(handleStoreChange).unsubscribe, [
        store
    ]), ()=>selectorWithCompare(store.get()), ()=>selectorWithCompare(store.get()));
}
const $bb4670134a009960$export$6ccbb43953eebf8 = function useStoreImpl(definition) {
    const storeRef = (0, $cozmU.useRef)(undefined);
    if (!storeRef.current) storeRef.current = (0, $avHQ3.a)(definition);
    return storeRef.current;
};
/**
 * A React hook that subscribes to the `atom` and returns the current value of
 * the atom.
 *
 * @example
 *
 * ```ts
 * const atom = createAtom(0);
 *
 * const Component = () => {
 *   const count = useAtom(atom);
 *
 *   return (
 *     <div>
 *       <div>{count}</div>
 *       <button onClick={() => atom.set((c) => c + 1)}>Increment</button>
 *     </div>
 *   );
 * };
 * ```
 *
 * @param atom The atom, created from `createAtom(…)`
 * @param selector An optional function which takes in the `snapshot` and
 *   returns a selected value
 * @param compare An optional function which compares the selected value to the
 *   previous value
 */ function $bb4670134a009960$export$83cf7ae8bb57e7ed(atom, selector = $bb4670134a009960$var$identity, compare = $bb4670134a009960$var$defaultCompare) {
    const state = $bb4670134a009960$export$2105062e25df4afe(atom, selector, compare);
    return state;
}
/**
 * Creates a custom hook that returns the selected value and the store from a
 * store configuration object.
 *
 * @example
 *
 * ```ts
 * const useCountStore = createStoreHook({
 *   context: { count: 0 },
 *   on: {
 *     inc: (context, event: { by: number }) => ({
 *       ...context,
 *       count: context.count + event.by
 *     })
 *   }
 * });
 *
 * function Component() {
 *   const [count, store] = useCountStore(s => s.context.count);
 *
 *   return (
 *     <div>
 *       {count}
 *       <button onClick={() => store.trigger.inc({ by: 1 })}>+</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * @param definition The store configuration object
 * @returns A custom hook that returns [selectedValue, store]
 */ function $bb4670134a009960$export$671dba69185d0304(definition) {
    const store = (0, $avHQ3.a)(definition);
    function useStoreHook(selector, compare = $bb4670134a009960$var$defaultCompare) {
        // If no selector provided, return full snapshot
        if (!selector) {
            const snapshot = $bb4670134a009960$export$2105062e25df4afe(store, $bb4670134a009960$var$identity, $bb4670134a009960$var$defaultCompare);
            return [
                snapshot,
                store
            ];
        }
        // Use selector with comparison
        const selectedValue = $bb4670134a009960$export$2105062e25df4afe(store, selector ?? $bb4670134a009960$var$identity, compare);
        return [
            selectedValue,
            store
        ];
    }
    return useStoreHook;
}
module.exports["useAtom"] = $bb4670134a009960$export$83cf7ae8bb57e7ed;

});

parcelRegister("avHQ3", function(module, exports) {
/* eslint-disable */ function $7a6ece0c8507ae3c$var$createReactiveSystem({ update: update, notify: notify, unwatched: unwatched }) {
    let currentVersion = 0;
    return {
        link: link,
        unlink: unlink,
        propagate: propagate,
        checkDirty: checkDirty,
        endTracking: endTracking,
        startTracking: startTracking,
        shallowPropagate: shallowPropagate
    };
    function link(dep, sub) {
        const prevDep = sub._depsTail;
        if (prevDep !== undefined && prevDep.dep === dep) return;
        const nextDep = prevDep !== undefined ? prevDep.nextDep : sub._deps;
        if (nextDep !== undefined && nextDep.dep === dep) {
            nextDep.version = currentVersion;
            sub._depsTail = nextDep;
            return;
        }
        const prevSub = dep._subsTail;
        if (prevSub !== undefined && prevSub.version === currentVersion && prevSub.sub === sub) return;
        const newLink = sub._depsTail = dep._subsTail = {
            version: currentVersion,
            dep: dep,
            sub: sub,
            prevDep: prevDep,
            nextDep: nextDep,
            prevSub: prevSub,
            nextSub: undefined
        };
        if (nextDep !== undefined) nextDep.prevDep = newLink;
        if (prevDep !== undefined) prevDep.nextDep = newLink;
        else sub._deps = newLink;
        if (prevSub !== undefined) prevSub.nextSub = newLink;
        else dep._subs = newLink;
    }
    function unlink(link, sub = link.sub) {
        const dep = link.dep;
        const prevDep = link.prevDep;
        const nextDep = link.nextDep;
        const nextSub = link.nextSub;
        const prevSub = link.prevSub;
        if (nextDep !== undefined) nextDep.prevDep = prevDep;
        else sub._depsTail = prevDep;
        if (prevDep !== undefined) prevDep.nextDep = nextDep;
        else sub._deps = nextDep;
        if (nextSub !== undefined) nextSub.prevSub = prevSub;
        else dep._subsTail = prevSub;
        if (prevSub !== undefined) prevSub.nextSub = nextSub;
        else if ((dep._subs = nextSub) === undefined) unwatched(dep);
        return nextDep;
    }
    function propagate(link) {
        let next = link.nextSub;
        let stack;
        top: do {
            const sub = link.sub;
            let flags = sub._flags;
            if (!(flags & 60)) sub._flags = flags | 32;
            else if (!(flags & 12)) flags = 0;
            else if (!(flags & 4)) sub._flags = flags & -9 | 32;
            else if (!(flags & 48) && isValidLink(link, sub)) {
                sub._flags = flags | 40;
                flags &= 1;
            } else flags = 0;
            if (flags & 2) notify(sub);
            if (flags & 1) {
                const subSubs = sub._subs;
                if (subSubs !== undefined) {
                    const nextSub = (link = subSubs).nextSub;
                    if (nextSub !== undefined) {
                        stack = {
                            value: next,
                            prev: stack
                        };
                        next = nextSub;
                    }
                    continue;
                }
            }
            if ((link = next) !== undefined) {
                next = link.nextSub;
                continue;
            }
            while(stack !== undefined){
                link = stack.value;
                stack = stack.prev;
                if (link !== undefined) {
                    next = link.nextSub;
                    continue top;
                }
            }
            break;
        }while (true);
    }
    function startTracking(sub) {
        ++currentVersion;
        sub._depsTail = undefined;
        sub._flags = sub._flags & -57 | 4;
    }
    function endTracking(sub) {
        const depsTail = sub._depsTail;
        let toRemove = depsTail !== undefined ? depsTail.nextDep : sub._deps;
        while(toRemove !== undefined)toRemove = unlink(toRemove, sub);
        sub._flags &= -5;
    }
    function checkDirty(link, sub) {
        let stack;
        let checkDepth = 0;
        top: do {
            const dep = link.dep;
            const flags = dep._flags;
            let dirty = false;
            if (sub._flags & 16) dirty = true;
            else if ((flags & 17) === 17) {
                if (update(dep)) {
                    const subs = dep._subs;
                    if (subs.nextSub !== undefined) shallowPropagate(subs);
                    dirty = true;
                }
            } else if ((flags & 33) === 33) {
                if (link.nextSub !== undefined || link.prevSub !== undefined) stack = {
                    value: link,
                    prev: stack
                };
                link = dep._deps;
                sub = dep;
                ++checkDepth;
                continue;
            }
            if (!dirty) {
                const nextDep = link.nextDep;
                if (nextDep !== undefined) {
                    link = nextDep;
                    continue;
                }
            }
            while(checkDepth--){
                const firstSub = sub._subs;
                const hasMultipleSubs = firstSub.nextSub !== undefined;
                if (hasMultipleSubs) {
                    link = stack.value;
                    stack = stack.prev;
                } else link = firstSub;
                if (dirty) {
                    if (update(sub)) {
                        if (hasMultipleSubs) shallowPropagate(firstSub);
                        sub = link.sub;
                        continue;
                    }
                } else sub._flags &= -33;
                sub = link.sub;
                const nextDep = link.nextDep;
                if (nextDep !== undefined) {
                    link = nextDep;
                    continue top;
                }
                dirty = false;
            }
            return dirty;
        }while (true);
    }
    function shallowPropagate(link) {
        do {
            const sub = link.sub;
            const flags = sub._flags;
            if ((flags & 48) === 32) {
                sub._flags = flags | 16;
                if (flags & 2) notify(sub);
            }
        }while ((link = link.nextSub) !== undefined);
    }
    function isValidLink(checkLink, sub) {
        let link = sub._depsTail;
        while(link !== undefined){
            if (link === checkLink) return true;
            link = link.prevDep;
        }
        return false;
    }
}
function $7a6ece0c8507ae3c$var$toObserver(nextHandler, errorHandler, completionHandler) {
    const isObserver = typeof nextHandler === 'object';
    const self = isObserver ? nextHandler : undefined;
    return {
        next: (isObserver ? nextHandler.next : nextHandler)?.bind(self),
        error: (isObserver ? nextHandler.error : errorHandler)?.bind(self),
        complete: (isObserver ? nextHandler.complete : completionHandler)?.bind(self)
    };
}
const $7a6ece0c8507ae3c$var$queuedEffects = [];
const { link: $7a6ece0c8507ae3c$var$link, unlink: $7a6ece0c8507ae3c$var$unlink, propagate: $7a6ece0c8507ae3c$var$propagate, checkDirty: $7a6ece0c8507ae3c$var$checkDirty, endTracking: $7a6ece0c8507ae3c$var$endTracking, startTracking: $7a6ece0c8507ae3c$var$startTracking, shallowPropagate: $7a6ece0c8507ae3c$var$shallowPropagate } = $7a6ece0c8507ae3c$var$createReactiveSystem({
    update (atom) {
        return atom._update();
    },
    notify (effect) {
        $7a6ece0c8507ae3c$var$queuedEffects[$7a6ece0c8507ae3c$var$queuedEffectsLength++] = effect;
    },
    unwatched (atom) {
        let toRemove = atom._deps;
        if (toRemove !== undefined) {
            atom._flags = 17;
            do toRemove = $7a6ece0c8507ae3c$var$unlink(toRemove, atom);
            while (toRemove !== undefined);
        }
    }
});
let $7a6ece0c8507ae3c$var$notifyIndex = 0;
let $7a6ece0c8507ae3c$var$queuedEffectsLength = 0;
let $7a6ece0c8507ae3c$var$activeSub;
function $7a6ece0c8507ae3c$var$flush() {
    while($7a6ece0c8507ae3c$var$notifyIndex < $7a6ece0c8507ae3c$var$queuedEffectsLength){
        const effect = $7a6ece0c8507ae3c$var$queuedEffects[$7a6ece0c8507ae3c$var$notifyIndex];
        $7a6ece0c8507ae3c$var$queuedEffects[$7a6ece0c8507ae3c$var$notifyIndex++] = undefined;
        effect.notify();
    }
    $7a6ece0c8507ae3c$var$notifyIndex = 0;
    $7a6ece0c8507ae3c$var$queuedEffectsLength = 0;
}
function $7a6ece0c8507ae3c$export$2d1720544b23b823(getValue, options) {
    const atom = $7a6ece0c8507ae3c$export$f1e1789686576879(()=>{
        getValue().then((data)=>{
            if (atom._update({
                status: 'done',
                data: data
            })) {
                const subs = atom._subs;
                if (subs !== undefined) {
                    $7a6ece0c8507ae3c$var$propagate(subs);
                    $7a6ece0c8507ae3c$var$shallowPropagate(subs);
                    $7a6ece0c8507ae3c$var$flush();
                }
            }
        }, (error)=>{
            if (atom._update({
                status: 'error',
                error: error
            })) {
                const subs = atom._subs;
                if (subs !== undefined) {
                    $7a6ece0c8507ae3c$var$propagate(subs);
                    $7a6ece0c8507ae3c$var$shallowPropagate(subs);
                    $7a6ece0c8507ae3c$var$flush();
                }
            }
        });
        return {
            status: 'pending'
        };
    }, options);
    return atom;
}
function $7a6ece0c8507ae3c$export$f1e1789686576879(valueOrFn, options) {
    const isComputed = typeof valueOrFn === 'function';
    const getter = valueOrFn;
    // Create plain object atom
    const atom = {
        _snapshot: isComputed ? undefined : valueOrFn,
        _subs: undefined,
        _subsTail: undefined,
        _flags: 0,
        get () {
            if ($7a6ece0c8507ae3c$var$activeSub !== undefined) $7a6ece0c8507ae3c$var$link(atom, $7a6ece0c8507ae3c$var$activeSub);
            return atom._snapshot;
        },
        subscribe (observerOrFn) {
            const obs = $7a6ece0c8507ae3c$var$toObserver(observerOrFn);
            const observed = {
                current: false
            };
            const e = $7a6ece0c8507ae3c$var$effect(()=>{
                atom.get();
                if (!observed.current) observed.current = true;
                else obs.next?.(atom._snapshot);
            });
            return {
                unsubscribe: ()=>{
                    e.stop();
                }
            };
        },
        _update (getValue) {
            const prevSub = $7a6ece0c8507ae3c$var$activeSub;
            const compare = options?.compare ?? Object.is;
            $7a6ece0c8507ae3c$var$activeSub = atom;
            $7a6ece0c8507ae3c$var$startTracking(atom);
            try {
                const oldValue = atom._snapshot;
                const read = (atom)=>atom.get();
                const newValue = typeof getValue === 'function' ? getValue(oldValue) : getValue === undefined && isComputed ? getter(read) : getValue;
                if (oldValue === undefined || !compare(oldValue, newValue)) {
                    atom._snapshot = newValue;
                    return true;
                }
                return false;
            } finally{
                $7a6ece0c8507ae3c$var$activeSub = prevSub;
                $7a6ece0c8507ae3c$var$endTracking(atom);
            }
        }
    };
    if (isComputed) Object.assign(atom, {
        _deps: undefined,
        _depsTail: undefined,
        _flags: 17,
        get () {
            const flags = this._flags;
            if (flags & 16 || flags & 32 && $7a6ece0c8507ae3c$var$checkDirty(atom._deps, atom)) {
                if (atom._update()) {
                    const subs = atom._subs;
                    if (subs !== undefined) $7a6ece0c8507ae3c$var$shallowPropagate(subs);
                }
            } else if (flags & 32) atom._flags = flags & -33;
            if ($7a6ece0c8507ae3c$var$activeSub !== undefined) $7a6ece0c8507ae3c$var$link(atom, $7a6ece0c8507ae3c$var$activeSub);
            return atom._snapshot;
        }
    });
    else Object.assign(atom, {
        set (valueOrFn) {
            if (atom._update(valueOrFn)) {
                const subs = atom._subs;
                if (subs !== undefined) {
                    $7a6ece0c8507ae3c$var$propagate(subs);
                    $7a6ece0c8507ae3c$var$shallowPropagate(subs);
                    $7a6ece0c8507ae3c$var$flush();
                }
            }
        }
    });
    return atom;
}
function $7a6ece0c8507ae3c$var$effect(fn) {
    const run = ()=>{
        const prevSub = $7a6ece0c8507ae3c$var$activeSub;
        $7a6ece0c8507ae3c$var$activeSub = effectObj;
        $7a6ece0c8507ae3c$var$startTracking(effectObj);
        try {
            return fn();
        } finally{
            $7a6ece0c8507ae3c$var$activeSub = prevSub;
            $7a6ece0c8507ae3c$var$endTracking(effectObj);
        }
    };
    const effectObj = {
        _deps: undefined,
        _depsTail: undefined,
        _flags: 2,
        notify () {
            const flags = this._flags;
            if (flags & 16 || flags & 32 && $7a6ece0c8507ae3c$var$checkDirty(this._deps, this)) run();
            else if (flags & 32) this._flags = flags & -33;
        },
        stop () {
            $7a6ece0c8507ae3c$var$startTracking(this);
            $7a6ece0c8507ae3c$var$endTracking(this);
        }
    };
    run();
    return effectObj;
}
const $7a6ece0c8507ae3c$var$symbolObservable = (()=>typeof Symbol === 'function' && Symbol.observable || '@@observable')();
const $7a6ece0c8507ae3c$var$inspectionObservers = new WeakMap();
function $7a6ece0c8507ae3c$var$createStoreCore(logic, emits) {
    let listeners;
    const initialSnapshot = logic.getInitialSnapshot();
    let currentSnapshot = initialSnapshot;
    const atom = $7a6ece0c8507ae3c$export$f1e1789686576879(currentSnapshot);
    const emit = (ev)=>{
        if (!listeners) return;
        const type = ev.type;
        const typeListeners = listeners.get(type);
        if (typeListeners) typeListeners.forEach((listener)=>listener(ev));
    };
    const transition = logic.transition;
    function receive(event) {
        const [nextSnapshot, effects] = transition(currentSnapshot, event);
        currentSnapshot = nextSnapshot;
        $7a6ece0c8507ae3c$var$inspectionObservers.get(store)?.forEach((observer)=>{
            observer.next?.({
                type: '@xstate.snapshot',
                event: event,
                snapshot: nextSnapshot,
                actorRef: store,
                rootId: store.sessionId
            });
        });
        atom.set(nextSnapshot);
        for (const effect of effects)if (typeof effect === 'function') effect();
        else {
            // handle the inherent effect first
            emits?.[effect.type]?.(effect);
            emit(effect);
        }
    }
    const store = {
        get _snapshot () {
            return atom._snapshot;
        },
        on (emittedEventType, handler) {
            if (!listeners) listeners = new Map();
            let eventListeners = listeners.get(emittedEventType);
            if (!eventListeners) {
                eventListeners = new Set();
                listeners.set(emittedEventType, eventListeners);
            }
            const wrappedHandler = handler.bind(undefined);
            eventListeners.add(wrappedHandler);
            return {
                unsubscribe () {
                    eventListeners.delete(wrappedHandler);
                }
            };
        },
        transition: logic.transition,
        // TODO: fix this
        sessionId: $7a6ece0c8507ae3c$var$uniqueId(),
        send (event) {
            $7a6ece0c8507ae3c$var$inspectionObservers.get(store)?.forEach((observer)=>{
                observer.next?.({
                    type: '@xstate.event',
                    event: event,
                    sourceRef: undefined,
                    actorRef: store,
                    rootId: store.sessionId
                });
            });
            receive(event);
        },
        getSnapshot () {
            return currentSnapshot;
        },
        get () {
            return atom.get();
        },
        getInitialSnapshot () {
            return initialSnapshot;
        },
        subscribe: atom.subscribe.bind(atom),
        [$7a6ece0c8507ae3c$var$symbolObservable] () {
            return this;
        },
        inspect: (observerOrFn)=>{
            const observer = $7a6ece0c8507ae3c$var$toObserver(observerOrFn);
            $7a6ece0c8507ae3c$var$inspectionObservers.set(store, $7a6ece0c8507ae3c$var$inspectionObservers.get(store) ?? new Set());
            $7a6ece0c8507ae3c$var$inspectionObservers.get(store).add(observer);
            observer.next?.({
                type: '@xstate.actor',
                actorRef: store,
                rootId: store.sessionId
            });
            observer.next?.({
                type: '@xstate.snapshot',
                snapshot: initialSnapshot,
                event: {
                    type: '@xstate.init'
                },
                actorRef: store,
                rootId: store.sessionId
            });
            return {
                unsubscribe () {
                    return $7a6ece0c8507ae3c$var$inspectionObservers.get(store)?.delete(observer);
                }
            };
        },
        trigger: new Proxy({}, {
            get: (_, eventType)=>{
                return (payload)=>{
                    store.send({
                        ...payload,
                        type: eventType
                    });
                };
            }
        }),
        select (selector, equalityFn = Object.is) {
            return $7a6ece0c8507ae3c$export$f1e1789686576879(()=>selector(store.get().context), {
                compare: equalityFn
            });
        }
    };
    return store;
}
/**
 * Creates a **store** that has its own internal state and can be sent events
 * that update its internal state based on transitions.
 *
 * @example
 *
 * ```ts
 * const store = createStore({
 *   context: { count: 0, name: 'Ada' },
 *   on: {
 *     inc: (context, event: { by: number }) => ({
 *       ...context,
 *       count: context.count + event.by
 *     })
 *   }
 * });
 *
 * store.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 *
 * store.send({ type: 'inc', by: 5 });
 * // Logs { context: { count: 5, name: 'Ada' }, status: 'active', ... }
 * ```
 *
 * @param config - The store configuration object
 * @param config.context - The initial state of the store
 * @param config.on - An object mapping event types to transition functions
 * @param config.emits - An object mapping emitted event types to handlers
 * @returns A store instance with methods to send events and subscribe to state
 *   changes
 */ function $7a6ece0c8507ae3c$export$407448d2b89b1813(definitionOrLogic) {
    if ('transition' in definitionOrLogic) return $7a6ece0c8507ae3c$var$createStoreCore(definitionOrLogic);
    const transition = $7a6ece0c8507ae3c$export$db3b6bfb95261072(definitionOrLogic.on);
    const logic = {
        getInitialSnapshot: ()=>({
                status: 'active',
                context: definitionOrLogic.context,
                output: undefined,
                error: undefined
            }),
        transition: transition
    };
    return $7a6ece0c8507ae3c$var$createStoreCore(logic, definitionOrLogic.emits);
}
function $7a6ece0c8507ae3c$var$_createStoreConfig(definition) {
    return definition;
}
const $7a6ece0c8507ae3c$export$4368d992c4eafac0 = $7a6ece0c8507ae3c$var$_createStoreConfig;
/**
 * Creates a `Store` with a provided producer (such as Immer's `producer(…)` A
 * store has its own internal state and can receive events.
 *
 * @example
 *
 * ```ts
 * import { produce } from 'immer';
 *
 * const store = createStoreWithProducer(produce, {
 *   context: { count: 0 },
 *   on: {
 *     inc: (context, event: { by: number }) => {
 *       context.count += event.by;
 *     }
 *   }
 * });
 *
 * store.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 *
 * store.send({ type: 'inc', by: 5 });
 * // Logs { context: { count: 5 }, status: 'active', ... }
 * ```
 */ function $7a6ece0c8507ae3c$export$8b22cf2602fb60ce(producer, config) {
    const transition = $7a6ece0c8507ae3c$export$db3b6bfb95261072(config.on, producer);
    const logic = {
        getInitialSnapshot: ()=>({
                status: 'active',
                context: config.context,
                output: undefined,
                error: undefined
            }),
        transition: transition
    };
    return $7a6ece0c8507ae3c$var$createStoreCore(logic, config.emits);
}
/**
 * Creates a store transition function that handles state updates based on
 * events.
 *
 * @param transitions - An object mapping event types to transition functions
 * @param producer - Optional producer function (e.g., Immer's produce) for
 *   immutable updates
 * @returns A transition function that takes a snapshot and event and returns a
 *   new snapshot with effects
 */ function $7a6ece0c8507ae3c$export$db3b6bfb95261072(transitions, producer) {
    return (snapshot, event)=>{
        const currentContext = snapshot.context;
        const assigner = transitions?.[event.type];
        const effects = [];
        const enqueue = {
            emit: new Proxy({}, {
                get: (_, eventType)=>{
                    return (payload)=>{
                        effects.push({
                            ...payload,
                            type: eventType
                        });
                    };
                }
            }),
            effect: (fn)=>{
                effects.push(fn);
            }
        };
        if (!assigner) return [
            snapshot,
            effects
        ];
        const nextContext = producer ? producer(currentContext, (draftContext)=>assigner(draftContext, event, enqueue)) : assigner(currentContext, event, enqueue) ?? currentContext;
        return [
            nextContext === currentContext ? snapshot : {
                ...snapshot,
                context: nextContext
            },
            effects
        ];
    };
}
/**
 * Generates a unique 6-character identifier.
 *
 * @returns A random string identifier
 */ function $7a6ece0c8507ae3c$var$uniqueId() {
    return Math.random().toString(36).slice(6);
}
module.exports["e"] = $7a6ece0c8507ae3c$export$f1e1789686576879;
module.exports["a"] = $7a6ece0c8507ae3c$export$407448d2b89b1813;

});

parcelRegister("4uGyl", function(module, exports) {

var $avHQ3 = parcelRequire("avHQ3");


var $88ZOv = parcelRequire("88ZOv");


var $5srEY = parcelRequire("5srEY");

const $e43f2e74c6d69717$var$DEFAULT_AUDIO_FEATURE = (0, $88ZOv.AudioFeatureType).BRIEFING;
const $e43f2e74c6d69717$var$DEFAULT_CUSTOMIZATION = {
    tone: 'PROFESSIONAL',
    length: 'SHORT',
    playbackSpeed: 1.0
};
const $e43f2e74c6d69717$var$initialState = {
    activeContent: {
        contentId: '',
        spaceKey: '',
        contentType: '',
        subType: '',
        title: '',
        author: '',
        avatarUrl: '',
        supportingContent: [],
        interimSupportingContent: undefined,
        mainContentLink: '',
        emojiId: undefined
    },
    activeFeature: $e43f2e74c6d69717$var$DEFAULT_AUDIO_FEATURE,
    activeAudioContainerMode: (0, $5srEY.AUDIO_CONTAINER_MODES).EXPANDED,
    pendingContent: null,
    isOpen: false,
    isHidden: false,
    isPlaying: false,
    isPaused: false,
    product: '',
    cloudId: '',
    activationId: '',
    customization: $e43f2e74c6d69717$var$DEFAULT_CUSTOMIZATION,
    playlistDefaultExpanded: false,
    playImmediately: false,
    playlistHasUnavailableContent: false,
    returnFocusRef: undefined,
    hasOpenDropdownMenu: false
};
const $e43f2e74c6d69717$export$cdbb2fdff9747f37 = (0, $avHQ3.e)($e43f2e74c6d69717$var$initialState);
const $e43f2e74c6d69717$export$4bf748e973a0a732 = (activeContent)=>{
    $e43f2e74c6d69717$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            activeContent: activeContent,
            // Reset playback states when switching to a new track
            isPlaying: false,
            isPaused: false
        }));
};
const $e43f2e74c6d69717$export$30d2a851f8b14636 = (activeFeature)=>{
    $e43f2e74c6d69717$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            activeFeature: activeFeature
        }));
};
const $e43f2e74c6d69717$export$fa9442b044bf53f8 = (activeMenu)=>{
    $e43f2e74c6d69717$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            activeMenu: activeMenu
        }));
};
const $e43f2e74c6d69717$export$8ce6f8a1db2bbc43 = (activeAudioContainerMode)=>{
    $e43f2e74c6d69717$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            activeAudioContainerMode: activeAudioContainerMode
        }));
};
const $e43f2e74c6d69717$export$dfa73cfe44e75105 = (contentToOpen, options)=>{
    $e43f2e74c6d69717$export$cdbb2fdff9747f37.set((prevState)=>{
        // Check if the content is already active
        const isAlreadyActive = prevState.activeContent.contentId === contentToOpen.contentId;
        // Check if the content is already pending
        const isAlreadyPending = prevState.pendingContent?.contentId === contentToOpen.contentId;
        const updates = {};
        updates.isHidden = false;
        updates.playImmediately = options?.playImmediately || false;
        updates.playlistDefaultExpanded = options?.expandPlaylist || false;
        if (options?.playImmediately && !isAlreadyActive) {
            updates.isPaused = false;
            updates.isPlaying = false;
        }
        if (options?.returnFocusRef) updates.returnFocusRef = options.returnFocusRef;
        // Handle expandPlaylist logic
        if (options?.expandPlaylist) {
            // If player is not open, set active content and open the playlist
            if (!prevState.isOpen) return {
                ...prevState,
                activeContent: contentToOpen,
                isOpen: true,
                ...updates
            };
            // If player is already open, just expand the playlist (don't change active content)
            return {
                ...prevState,
                ...updates
            };
        }
        // If content is already active or pending, only apply updates (like expandPlaylist)
        if (isAlreadyActive || isAlreadyPending) return {
            ...prevState,
            ...updates
        };
        // If the player is uninitialized or playImmediately is true, set the new content as active
        if (options?.isUninitialized || options?.playImmediately) return {
            ...prevState,
            activeContent: contentToOpen,
            isOpen: true,
            ...updates
        };
        // If player is already open, set new content as pending
        if (prevState.isOpen) return {
            ...prevState,
            pendingContent: contentToOpen,
            ...updates
        };
        // Otherwise, set as active content and open player
        return {
            ...prevState,
            activeContent: contentToOpen,
            isOpen: true,
            ...updates
        };
    });
    // Expand audio player every time it's opened
    $e43f2e74c6d69717$export$8ce6f8a1db2bbc43((0, $5srEY.AUDIO_CONTAINER_MODES).EXPANDED);
};
const $e43f2e74c6d69717$export$dba664cdc5e8fbf4 = ()=>{
    $e43f2e74c6d69717$export$cdbb2fdff9747f37.set((prevState)=>{
        if (prevState.pendingContent) return {
            ...prevState,
            activeContent: prevState.pendingContent,
            pendingContent: null,
            isPlaying: false,
            isPaused: false
        };
        return prevState;
    });
};
const $e43f2e74c6d69717$export$feb15da72003eb0f = ()=>{
    $e43f2e74c6d69717$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            pendingContent: null
        }));
};
const $e43f2e74c6d69717$export$c7e4afd074cdd19a = ()=>{
    const returnFocusRef = $e43f2e74c6d69717$export$cdbb2fdff9747f37.get().returnFocusRef;
    $e43f2e74c6d69717$export$cdbb2fdff9747f37.set($e43f2e74c6d69717$var$initialState);
    // Restore focus to the element that opened the player
    if (returnFocusRef?.current) returnFocusRef.current.focus();
};
const $e43f2e74c6d69717$export$31868bc8d4b01126 = ()=>{
    const returnFocusRef = $e43f2e74c6d69717$export$cdbb2fdff9747f37.get().returnFocusRef;
    $e43f2e74c6d69717$export$cdbb2fdff9747f37.set((prevState)=>{
        // If the player is not playing or paused, reset the state
        // This works like the closeAudioPlayer action
        if (!prevState.isPaused && !prevState.isPlaying) return $e43f2e74c6d69717$var$initialState;
        if (!prevState.isOpen) return prevState;
        let updates = {};
        // If the player is playing, pause it before hiding
        if (prevState.isPlaying) {
            updates.isPlaying = false;
            updates.isPaused = true;
        }
        updates.isHidden = true;
        return {
            ...prevState,
            ...updates
        };
    });
    // Restore focus to the element that opened the player
    if (returnFocusRef?.current) returnFocusRef.current.focus();
};
const $e43f2e74c6d69717$export$92debfee183fcd0e = (isPlaying)=>{
    $e43f2e74c6d69717$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            isPlaying: isPlaying
        }));
};
const $e43f2e74c6d69717$export$8e7c7df046bd1f47 = (isPaused)=>{
    $e43f2e74c6d69717$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            isPaused: isPaused
        }));
};
const $e43f2e74c6d69717$export$36bd232e206b82e1 = (updates)=>{
    $e43f2e74c6d69717$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            ...updates
        }));
};
const $e43f2e74c6d69717$export$5163deecba0c25e4 = (newCustomization)=>{
    $e43f2e74c6d69717$export$cdbb2fdff9747f37.set((prevState)=>{
        const { customization: customization } = prevState;
        const updatedCustomization = {
            ...customization,
            ...newCustomization
        };
        return {
            ...prevState,
            customization: updatedCustomization
        };
    });
};
const $e43f2e74c6d69717$export$c690cb8c8df11c13 = ()=>{
    return $e43f2e74c6d69717$export$cdbb2fdff9747f37.get().customization;
};
const $e43f2e74c6d69717$export$b0260ee5b3758cdc = ()=>{
    return $e43f2e74c6d69717$export$cdbb2fdff9747f37.get().activeContent;
};
const $e43f2e74c6d69717$export$c51fb0a0341d4b0 = (supportingContent)=>{
    $e43f2e74c6d69717$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            activeContent: {
                ...prevState.activeContent,
                supportingContent: supportingContent
            }
        }));
};
const $e43f2e74c6d69717$export$ef9379a59560cce = ()=>{
    return $e43f2e74c6d69717$export$cdbb2fdff9747f37.get().activeContent.supportingContent;
};
const $e43f2e74c6d69717$export$850d40cfba439ef9 = (playbackSpeed)=>{
    $e43f2e74c6d69717$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            customization: {
                ...prevState.customization,
                playbackSpeed: playbackSpeed
            }
        }));
};
const $e43f2e74c6d69717$export$18002003a6a1c3dc = (trackSource)=>{
    $e43f2e74c6d69717$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            activeContent: {
                ...prevState.activeContent,
                trackSource: trackSource
            }
        }));
};
const $e43f2e74c6d69717$export$edf8a27e5cc7e9c9 = ()=>{
    $e43f2e74c6d69717$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            playlistDefaultExpanded: false
        }));
};
const $e43f2e74c6d69717$export$b957626ce4248e62 = ()=>{
    $e43f2e74c6d69717$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            playImmediately: false
        }));
};
const $e43f2e74c6d69717$export$f92764dfe9fadc13 = (playlistHasUnavailableContent)=>{
    $e43f2e74c6d69717$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            playlistHasUnavailableContent: playlistHasUnavailableContent
        }));
};
const $e43f2e74c6d69717$export$59cd009f1d71f635 = (interimSupportingContent)=>{
    $e43f2e74c6d69717$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            activeContent: {
                ...prevState.activeContent,
                interimSupportingContent: interimSupportingContent
            }
        }));
};
const $e43f2e74c6d69717$export$180601d0db32d2bd = ()=>{
    return $e43f2e74c6d69717$export$cdbb2fdff9747f37.get().activeContent.interimSupportingContent;
};
const $e43f2e74c6d69717$export$910c8d652cada2b = (activeSupportingContent, localAdditionalResources)=>{
    // Handle null/undefined arrays by treating them as empty arrays
    const activeContent = activeSupportingContent || [];
    const localContent = localAdditionalResources || [];
    const haveSourceCountsChanged = localContent.length !== activeContent.length;
    const haveSourceContentsChanged = activeContent.some((resource, index)=>localContent?.[index]?.ari !== resource.ari);
    return haveSourceCountsChanged || haveSourceContentsChanged;
};
const $e43f2e74c6d69717$export$a8e7cbd331c29c84 = (hasOpenDropdownMenu)=>{
    $e43f2e74c6d69717$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            hasOpenDropdownMenu: hasOpenDropdownMenu
        }));
};
module.exports["audioPlayerState"] = $e43f2e74c6d69717$export$cdbb2fdff9747f37;
module.exports["setActiveContent"] = $e43f2e74c6d69717$export$4bf748e973a0a732;
module.exports["setActiveFeature"] = $e43f2e74c6d69717$export$30d2a851f8b14636;
module.exports["setActiveMenu"] = $e43f2e74c6d69717$export$fa9442b044bf53f8;
module.exports["setActiveAudioContainerMode"] = $e43f2e74c6d69717$export$8ce6f8a1db2bbc43;
module.exports["openAudioPlayer"] = $e43f2e74c6d69717$export$dfa73cfe44e75105;
module.exports["activatePendingContent"] = $e43f2e74c6d69717$export$dba664cdc5e8fbf4;
module.exports["clearPendingContent"] = $e43f2e74c6d69717$export$feb15da72003eb0f;
module.exports["closeAudioPlayer"] = $e43f2e74c6d69717$export$c7e4afd074cdd19a;
module.exports["hideAudioPlayer"] = $e43f2e74c6d69717$export$31868bc8d4b01126;
module.exports["setIsPlaying"] = $e43f2e74c6d69717$export$92debfee183fcd0e;
module.exports["setIsPaused"] = $e43f2e74c6d69717$export$8e7c7df046bd1f47;
module.exports["updatePlayerState"] = $e43f2e74c6d69717$export$36bd232e206b82e1;
module.exports["setCustomization"] = $e43f2e74c6d69717$export$5163deecba0c25e4;
module.exports["getCustomization"] = $e43f2e74c6d69717$export$c690cb8c8df11c13;
module.exports["getActiveContent"] = $e43f2e74c6d69717$export$b0260ee5b3758cdc;
module.exports["setSupportingContent"] = $e43f2e74c6d69717$export$c51fb0a0341d4b0;
module.exports["getSupportingContent"] = $e43f2e74c6d69717$export$ef9379a59560cce;
module.exports["setPlaybackSpeed"] = $e43f2e74c6d69717$export$850d40cfba439ef9;
module.exports["setTrackSource"] = $e43f2e74c6d69717$export$18002003a6a1c3dc;
module.exports["resetPlaylistDefaultExpanded"] = $e43f2e74c6d69717$export$edf8a27e5cc7e9c9;
module.exports["resetPlayImmediately"] = $e43f2e74c6d69717$export$b957626ce4248e62;
module.exports["setPlaylistHasUnavailableContent"] = $e43f2e74c6d69717$export$f92764dfe9fadc13;
module.exports["setInterimSupportingContent"] = $e43f2e74c6d69717$export$59cd009f1d71f635;
module.exports["getInterimSupportingContent"] = $e43f2e74c6d69717$export$180601d0db32d2bd;
module.exports["isSourceContentDiverged"] = $e43f2e74c6d69717$export$910c8d652cada2b;
module.exports["setHasOpenDropdownMenu"] = $e43f2e74c6d69717$export$a8e7cbd331c29c84;

});

parcelRegister("88ZOv", function(module, exports) {
var $a95ebde304e4c255$export$1e95f84c3271729c = /*#__PURE__*/ function(AudioFeatureType) {
    AudioFeatureType["BRIEFING"] = "briefing";
    AudioFeatureType["NARRATION"] = "narration";
    return AudioFeatureType;
}({});
module.exports["AudioFeatureType"] = $a95ebde304e4c255$export$1e95f84c3271729c;

});

parcelRegister("5srEY", function(module, exports) {
const $187775616b513e64$export$f14c697305877ebc = {
    EXPANDED: {
        name: 'expanded',
        width: 380
    },
    MINIFIED: {
        name: 'minified',
        width: 274
    }
};
module.exports["AUDIO_CONTAINER_MODES"] = $187775616b513e64$export$f14c697305877ebc;

});

parcelRegister("kZLou", function(module, exports) {

var $a9zER = parcelRequire("a9zER");


var $dH8un = parcelRequire("dH8un");


var $8otRK = parcelRequire("8otRK");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $baYrV = parcelRequire("baYrV");


var $bLh2e = parcelRequire("bLh2e");


var $4uGyl = parcelRequire("4uGyl");

const $c5de0d0015e4ec4b$var$messages = (0, $kSwu1.defineMessages)({
    reorderSuccessTitle: {
        id: "ai-audio.playlist.reorder-success-description",
        defaultMessage: "Moved {title}"
    },
    reorderErrorDescription: {
        id: "ai-audio.playlist.reorder-error-description",
        defaultMessage: "Failed to move item in playlist"
    },
    removeSuccess: {
        id: "ai-audio.playlist.remove-success",
        defaultMessage: "Removed from playlist"
    },
    errorTitle: {
        id: "ai-audio.playlist.error",
        defaultMessage: "Something went wrong"
    },
    removeSuccessDescription: {
        id: "ai-audio.playlist.remove-success-description",
        defaultMessage: "{title} has been removed from your playlist."
    },
    removeSuccessEmptyDescription: {
        id: "ai-audio.playlist.remove-success-empty-description",
        defaultMessage: "{title} has been removed from your playlist. Your playlist is now empty."
    },
    removeErrorDescription: {
        id: "ai-audio.playlist.remove-error-description",
        defaultMessage: "Failed to remove item from playlist."
    },
    addSuccess: {
        id: "ai-audio.playlist.add-success",
        defaultMessage: "Added to playlist"
    },
    addError: {
        id: "ai-audio.playlist.add-error",
        defaultMessage: "Something went wrong"
    },
    addSuccessDescription: {
        id: "ai-audio.playlist.add-success-description",
        defaultMessage: "{title} has been added to your playlist. Listen anywhere on Confluence or the mobile app."
    },
    addErrorDescription: {
        id: "ai-audio.playlist.add-error-description",
        defaultMessage: "Failed to add item to playlist."
    },
    addErrorContentTooShort: {
        id: "ai-audio.playlist.add-error-content-too-short",
        defaultMessage: "This content is too short to add to the playlist. Add more content and try again."
    },
    playAction: {
        id: "ai-audio.playlist.add-success.play-action",
        defaultMessage: "Play"
    },
    openPlaylistAction: {
        id: "ai-audio.playlist.add-success.open-playlist-action",
        defaultMessage: "Open playlist"
    }
});
/**
 * Helper function to check if a track node matches the given track parameters
 */ const $c5de0d0015e4ec4b$var$isMatchingTrack = (node, mainSource, trackType, supportingSources)=>{
    if (node?.getValue('mainSource') !== mainSource || node?.getValue('type') !== trackType) return false;
    const nodeSupportingSources = node?.getValue('supportingSources') || [];
    // Check that arrays have the same length first
    if (nodeSupportingSources.length !== supportingSources.length) return false;
    // Then check that all elements match
    return nodeSupportingSources.every((source, index)=>source === supportingSources[index]);
};
const $c5de0d0015e4ec4b$export$fb508b9bcc816326 = (cloudId, flagsOverride)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const contextFlags = (0, $bLh2e.useFlags)();
    const flags = flagsOverride ?? contextFlags;
    const [removeTrackMutation, isRemoveMutationInFlight] = (0, $6SsN4.useMutation)((0, $8otRK.default));
    const [reorderTrackMutation, isReorderMutationInFlight] = (0, $6SsN4.useMutation)((0, $dH8un.default));
    const removeTrack = (0, $cozmU.useCallback)((mainSource, supportingSources, trackType, title, options)=>{
        const showFlags = options?.showFlags ?? true;
        return new Promise((resolve, reject)=>{
            removeTrackMutation({
                variables: {
                    cloudId: cloudId,
                    input: {
                        mainSource: mainSource,
                        supportingSources: supportingSources,
                        trackType: trackType
                    }
                },
                onCompleted: (response)=>{
                    const success = response.confluence_removeTrack?.success;
                    const errors = response.confluence_removeTrack?.errors;
                    const nextTrackThatIsNotBeingRemoved = options?.playlist && options.playlist.length > 0 ? //this is not perfect. This exists because if we remove the top item of the playlist the item the player will load will be the one we just removed.
                    //however, since we can have a narration and a briefing (and because this function take a mainSource ari instead of a contentID)
                    //this is the best check at my disposal
                    options?.playlist.find((item)=>item.title !== title) : undefined;
                    const trackContent = {
                        contentId: '',
                        spaceKey: '',
                        contentType: '',
                        title: '',
                        author: '',
                        avatarUrl: '',
                        mainContentLink: '',
                        supportingContent: [],
                        subType: '',
                        emojiId: undefined
                    };
                    const successActions = [
                        {
                            content: formatMessage($c5de0d0015e4ec4b$var$messages.openPlaylistAction),
                            onClick: ()=>{
                                if (nextTrackThatIsNotBeingRemoved) (0, $4uGyl.openAudioPlayer)(nextTrackThatIsNotBeingRemoved, {
                                    expandPlaylist: true
                                });
                                else (0, $4uGyl.openAudioPlayer)(trackContent, {
                                    expandPlaylist: true
                                });
                            }
                        }
                    ];
                    if (success) {
                        resolve(true);
                        if (!flags || !title || !showFlags) return;
                        // TODO: Make sure that if there is one item in the array, it is the one we just removed
                        const isEmptyAfterRemoval = (options?.playlist && options.playlist.length <= 1) ?? false;
                        flags.showFlag({
                            type: 'success-circle',
                            title: formatMessage($c5de0d0015e4ec4b$var$messages.removeSuccess),
                            description: isEmptyAfterRemoval ? formatMessage($c5de0d0015e4ec4b$var$messages.removeSuccessEmptyDescription, {
                                title: title
                            }) : formatMessage($c5de0d0015e4ec4b$var$messages.removeSuccessDescription, {
                                title: title
                            }),
                            close: 'auto',
                            actions: isEmptyAfterRemoval ? [] : successActions
                        });
                    } else {
                        const errorMessage = errors?.[0]?.message || 'Failed to remove track';
                        reject(new Error(errorMessage));
                        if (flags && showFlags) flags.showFlag({
                            title: formatMessage($c5de0d0015e4ec4b$var$messages.errorTitle),
                            description: formatMessage($c5de0d0015e4ec4b$var$messages.removeErrorDescription),
                            type: 'error',
                            close: 'auto'
                        });
                    }
                },
                onError: (error)=>{
                    reject(error);
                    if (flags && showFlags) flags.showFlag({
                        title: formatMessage($c5de0d0015e4ec4b$var$messages.errorTitle),
                        description: formatMessage($c5de0d0015e4ec4b$var$messages.removeErrorDescription),
                        type: 'error',
                        close: 'auto'
                    });
                },
                updater: (store)=>{
                    // Update the Relay store to remove the track from the cache
                    // This ensures the UI updates immediately without refetching
                    const playlistRecord = store.getRoot().getLinkedRecord('confluence_getPlaylist', {
                        cloudId: cloudId
                    });
                    if (playlistRecord) {
                        const tracksRecord = playlistRecord.getLinkedRecord('tracks');
                        if (tracksRecord) {
                            const nodes = tracksRecord.getLinkedRecords('nodes');
                            if (nodes) {
                                const updatedNodes = nodes.filter((node)=>{
                                    // If the nodes mainSource  is undefined, we should remove it.
                                    if (node.getValue('mainSource') === undefined) return false;
                                    return !$c5de0d0015e4ec4b$var$isMatchingTrack(node, mainSource, trackType, supportingSources);
                                });
                                tracksRecord.setLinkedRecords(updatedNodes, 'nodes');
                            }
                        }
                    }
                }
            });
        });
    }, [
        removeTrackMutation,
        cloudId,
        flags,
        formatMessage
    ]);
    const [addTrackMutation, isAddMutationInFlight] = (0, $6SsN4.useMutation)((0, $a9zER.default));
    const addTrack = (0, $cozmU.useCallback)((mainSource, supportingSources = [], trackType, options)=>{
        const top = options?.top ?? false;
        const showFlags = options?.showFlags ?? true;
        return new Promise((resolve, reject)=>{
            addTrackMutation({
                variables: {
                    cloudId: cloudId,
                    input: {
                        track: {
                            mainSource: mainSource,
                            supportingSources: supportingSources,
                            // This option allows us to persist the original track source when the track was first added to the playlist
                            trackSource: options?.trackSource ?? (0, $baYrV.TrackSourceType).WEB,
                            trackType: trackType || 'BRIEFING'
                        },
                        ...top && {
                            top: true
                        }
                    }
                },
                onCompleted: (response)=>{
                    const success = response.confluence_addTrack?.success;
                    const errors = response.confluence_addTrack?.errors;
                    const title = response.confluence_addTrack?.track?.mainContent?.title;
                    const track = response.confluence_addTrack?.track;
                    const mainContent = track?.mainContent;
                    if (success) {
                        resolve(true);
                        if (flags && title && showFlags) {
                            const creator = mainContent.history?.createdBy || mainContent.history?.ownedBy;
                            const trackContent = mainContent ? {
                                contentId: mainContent.id || '',
                                spaceKey: mainContent.space?.key || '',
                                contentType: mainContent.type || '',
                                title: mainContent.title || '',
                                author: creator?.displayName || '',
                                avatarUrl: creator?.profilePicture?.path || '',
                                mainContentLink: mainContent.links?.base + mainContent.links?.webui || '',
                                supportingContent: track?.supportingContent?.map((content)=>({
                                        ari: content.ari,
                                        link: content.links?.base + content.links?.webui || ''
                                    })) || [],
                                subType: mainContent.subType || '',
                                emojiId: mainContent.properties?.nodes?.[0]?.value || undefined,
                                trackSource: track?.trackSource || (0, $baYrV.TrackSourceType).WEB
                            } : null;
                            flags.showFlag({
                                title: formatMessage($c5de0d0015e4ec4b$var$messages.addSuccess),
                                description: formatMessage($c5de0d0015e4ec4b$var$messages.addSuccessDescription, {
                                    title: title
                                }),
                                type: 'success-circle',
                                close: 'auto',
                                actions: [
                                    {
                                        content: formatMessage($c5de0d0015e4ec4b$var$messages.playAction),
                                        onClick: ()=>{
                                            if (trackContent && track) {
                                                const trackMainSource = track.mainSource;
                                                const trackSupportingSources = track.supportingSources || [];
                                                const trackType = track.type;
                                                if (trackMainSource && trackType) addTrack(trackMainSource, trackSupportingSources, trackType, {
                                                    top: true,
                                                    showFlags: false,
                                                    // The flag action will always be on web
                                                    trackSource: (0, $baYrV.TrackSourceType).WEB
                                                });
                                                (0, $4uGyl.openAudioPlayer)(trackContent, {
                                                    playImmediately: true,
                                                    expandPlaylist: false
                                                });
                                            }
                                        }
                                    },
                                    {
                                        content: formatMessage($c5de0d0015e4ec4b$var$messages.openPlaylistAction),
                                        onClick: ()=>{
                                            // Use the new track whenever possible, otherwise fall back to current active content
                                            if (trackContent) (0, $4uGyl.openAudioPlayer)(trackContent, {
                                                expandPlaylist: true
                                            });
                                        }
                                    }
                                ]
                            });
                        }
                    } else {
                        const errorMessage = errors?.[0]?.message || 'Failed to add track';
                        const isContentTooShort = errors?.[0]?.extensions?.statusCode === 400 && errors?.[0]?.message === 'Context size is too small';
                        let description = formatMessage($c5de0d0015e4ec4b$var$messages.addErrorDescription);
                        if (isContentTooShort) description = formatMessage($c5de0d0015e4ec4b$var$messages.addErrorContentTooShort);
                        reject(new Error(errorMessage));
                        if (flags && showFlags) flags.showFlag({
                            title: formatMessage($c5de0d0015e4ec4b$var$messages.addError),
                            description: description,
                            type: 'error',
                            close: 'auto'
                        });
                    }
                },
                onError: ()=>{
                    reject(new Error('Failed to add track'));
                    if (flags && showFlags) flags.showFlag({
                        title: formatMessage($c5de0d0015e4ec4b$var$messages.addError),
                        description: formatMessage($c5de0d0015e4ec4b$var$messages.addErrorDescription),
                        type: 'error',
                        close: 'auto'
                    });
                },
                updater: (store)=>{
                    // Update the Relay store to add/move the track in the playlist
                    const payload = store.getRootField('confluence_addTrack');
                    const newTrack = payload?.getLinkedRecord('track');
                    if (!payload?.getValue('success') || !newTrack) return;
                    const playlist = store.getRoot().getLinkedRecord('confluence_getPlaylist', {
                        cloudId: cloudId
                    });
                    const tracks = playlist?.getLinkedRecord('tracks');
                    if (!tracks) return;
                    const nodes = tracks.getLinkedRecords('nodes') || [];
                    // Remove existing track if present, then add the new track
                    const filteredNodes = nodes.filter((node)=>!$c5de0d0015e4ec4b$var$isMatchingTrack(node, mainSource, trackType, supportingSources));
                    const updatedNodes = top ? [
                        newTrack,
                        ...filteredNodes
                    ] : [
                        ...filteredNodes,
                        newTrack
                    ];
                    tracks.setLinkedRecords(updatedNodes, 'nodes');
                }
            });
        });
    }, [
        cloudId,
        addTrackMutation,
        flags,
        formatMessage
    ]);
    /**
   * • Target track - The track being repositioned
   * • Reference track - The track that serves as the anchor point. The target track will be placed immediately after
   *    the reference track. If no reference track is specified, the target track moves to the beginning of the playlist.
   */ const reorderTrack = (0, $cozmU.useCallback)((targetTrack, referenceTrack, title)=>{
        return new Promise((resolve, reject)=>{
            reorderTrackMutation({
                variables: {
                    cloudId: cloudId,
                    input: {
                        targetTrack: targetTrack,
                        referenceTrack: referenceTrack
                    }
                },
                updater: (store)=>{
                    const playlistRecord = store.getRoot().getLinkedRecord('confluence_getPlaylist', {
                        cloudId: cloudId
                    });
                    if (!playlistRecord) return;
                    const tracksRecord = playlistRecord.getLinkedRecord('tracks');
                    if (!tracksRecord) return;
                    const nodes = tracksRecord.getLinkedRecords('nodes');
                    if (!nodes) return;
                    const targetIndex = nodes.findIndex((node)=>$c5de0d0015e4ec4b$var$isMatchingTrack(node, targetTrack.mainSource, targetTrack.trackType, targetTrack.supportingSources || []));
                    if (targetIndex === -1) return;
                    let referenceIndex = -1;
                    if (referenceTrack) referenceIndex = nodes.findIndex((node)=>$c5de0d0015e4ec4b$var$isMatchingTrack(node, referenceTrack.mainSource, referenceTrack.trackType, referenceTrack.supportingSources || []));
                    const newNodes = [
                        ...nodes
                    ];
                    const [movedTrack] = newNodes.splice(targetIndex, 1);
                    const adjustedReferenceIndex = referenceIndex > targetIndex ? referenceIndex - 1 : referenceIndex;
                    const insertPosition = referenceIndex === -1 ? 0 : adjustedReferenceIndex + 1;
                    newNodes.splice(insertPosition, 0, movedTrack);
                    tracksRecord.setLinkedRecords(newNodes, 'nodes');
                },
                onCompleted: (response)=>{
                    const success = response.confluence_reorderTracks?.success;
                    const errors = response.confluence_reorderTracks?.errors;
                    if (success) {
                        resolve(true);
                        if (flags && title) flags.showFlag({
                            title: formatMessage($c5de0d0015e4ec4b$var$messages.reorderSuccessTitle, {
                                title: title
                            }),
                            type: 'success-circle',
                            close: 'auto'
                        });
                    } else {
                        const errorMessage = errors?.[0]?.message || 'Failed to reorder track';
                        reject(new Error(errorMessage));
                        if (flags) flags.showFlag({
                            title: formatMessage($c5de0d0015e4ec4b$var$messages.errorTitle),
                            description: formatMessage($c5de0d0015e4ec4b$var$messages.reorderErrorDescription),
                            type: 'error',
                            close: 'auto'
                        });
                    }
                },
                onError: (error)=>{
                    reject(error);
                    if (flags) flags.showFlag({
                        title: formatMessage($c5de0d0015e4ec4b$var$messages.errorTitle),
                        description: formatMessage($c5de0d0015e4ec4b$var$messages.reorderErrorDescription),
                        type: 'error',
                        close: 'auto'
                    });
                }
            });
        });
    }, [
        reorderTrackMutation,
        cloudId,
        flags,
        formatMessage
    ]);
    return {
        removeTrack: removeTrack,
        isRemoving: isRemoveMutationInFlight,
        isDisabled: isRemoveMutationInFlight || isReorderMutationInFlight,
        addTrack: addTrack,
        isAdding: isAddMutationInFlight,
        reorderTrack: reorderTrack
    };
};
module.exports["useContextMenuActions"] = $c5de0d0015e4ec4b$export$fb508b9bcc816326;

});

parcelRegister("a9zER", function(module, exports) {
/**
 * @generated SignedSource<<15278897a881e314ebcea4159fadb9f0>>
 * @relayHash 7de130ea996241735986cdfa83620b3a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0a5d42f9dcff48d113d89112783d0430391298268b28ba9e3e274438c2972e91
const $a204a97aeef0d94b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "ConfluenceAddTrackPayloadError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            },
            {
                "concreteType": "ConfluenceAddTrackPayloadErrorExtension",
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "statusCode"
                    }
                ]
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "ScalarField",
        "name": "mainSource"
    }, v7 = {
        "kind": "ScalarField",
        "name": "trackSource"
    }, v8 = {
        "kind": "ScalarField",
        "name": "supportingSources"
    }, v9 = {
        "kind": "ScalarField",
        "name": "ari"
    }, v10 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "base"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "title"
    }, v12 = {
        "kind": "ScalarField",
        "name": "status"
    }, v13 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v16 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v17 = [
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ], v18 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\"])"
    }, v19 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContextMenuActionsAddTrackMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceAddTrackPayload",
                    "kind": "LinkedField",
                    "name": "confluence_addTrack",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceTrack",
                            "kind": "LinkedField",
                            "name": "track",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "supportingContent",
                                    "plural": true,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "mainContent",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v17 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": v17 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v18 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContextMenuActionsAddTrackMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceAddTrackPayload",
                    "kind": "LinkedField",
                    "name": "confluence_addTrack",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceTrack",
                            "kind": "LinkedField",
                            "name": "track",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "supportingContent",
                                    "plural": true,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "mainContent",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v19 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": v19 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v18 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0a5d42f9dcff48d113d89112783d0430391298268b28ba9e3e274438c2972e91",
            "metadata": {},
            "name": "useContextMenuActionsAddTrackMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$a204a97aeef0d94b$var$node.hash = "0981d661679191cac56da39dadd5e417";
var $a204a97aeef0d94b$export$2e2bcd8739ae039 = $a204a97aeef0d94b$var$node;
module.exports["default"] = $a204a97aeef0d94b$export$2e2bcd8739ae039;

});

parcelRegister("dH8un", function(module, exports) {
/**
 * @generated SignedSource<<ffb88657a4f2e2ff19e00ec4b003e059>>
 * @relayHash 6dbdbe4a62543b90fa6c0a2b3bb68c6f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 08d80dad1041c3f20d85c84d8afb8c5ec82779d04c25add523b3c8f265d56e74
const $f2c674cc161fec1f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceReorderTrackPayload",
            "kind": "LinkedField",
            "name": "confluence_reorderTracks",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "ConfluenceReorderTrackPayloadError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        },
                        {
                            "concreteType": "ConfluenceReorderTrackPayloadErrorExtension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "statusCode"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContextMenuActionsReorderTrackMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContextMenuActionsReorderTrackMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "08d80dad1041c3f20d85c84d8afb8c5ec82779d04c25add523b3c8f265d56e74",
            "metadata": {},
            "name": "useContextMenuActionsReorderTrackMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$f2c674cc161fec1f$var$node.hash = "5739afa9f8b36d85167f2ad0033521ff";
var $f2c674cc161fec1f$export$2e2bcd8739ae039 = $f2c674cc161fec1f$var$node;
module.exports["default"] = $f2c674cc161fec1f$export$2e2bcd8739ae039;

});

parcelRegister("8otRK", function(module, exports) {
/**
 * @generated SignedSource<<68092f5ed51529183b3c5faef9e021c4>>
 * @relayHash 090a309bae12fcddd73edaf12962aaa3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID db1e2dd71d5da02d4d53f36625768a7dc322cd38beb182692d3f32ad6195812c
const $21516e8e4c058c6e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceRemoveTrackPayload",
            "kind": "LinkedField",
            "name": "confluence_removeTrack",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "ConfluenceRemoveTrackPayloadError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        },
                        {
                            "concreteType": "ConfluenceRemoveTrackPayloadErrorExtension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "statusCode"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContextMenuActionsRemoveTrackMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContextMenuActionsRemoveTrackMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "db1e2dd71d5da02d4d53f36625768a7dc322cd38beb182692d3f32ad6195812c",
            "metadata": {},
            "name": "useContextMenuActionsRemoveTrackMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$21516e8e4c058c6e$var$node.hash = "a82da56f002288d2c61caae485db7176";
var $21516e8e4c058c6e$export$2e2bcd8739ae039 = $21516e8e4c058c6e$var$node;
module.exports["default"] = $21516e8e4c058c6e$export$2e2bcd8739ae039;

});

parcelRegister("bLh2e", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $de393f374f798bfc$export$378702fe95b742bd = (0, $cozmU.createContext)({
    flags: undefined
});
$de393f374f798bfc$export$378702fe95b742bd.displayName = 'FlagsProviderContext';
const $de393f374f798bfc$export$2879604e6aec4ab = ()=>{
    const context = (0, $cozmU.useContext)($de393f374f798bfc$export$378702fe95b742bd);
    return context.flags;
};
module.exports["FlagsProviderContext"] = $de393f374f798bfc$export$378702fe95b742bd;
module.exports["useFlags"] = $de393f374f798bfc$export$2879604e6aec4ab;

});

parcelRegister("JTIzG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

var $27a67c702eae1a5a$export$419c8aa8913e9327 = /*#__PURE__*/ function(BriefingNudgeExperimentState) {
    BriefingNudgeExperimentState["CONTROL"] = "control";
    BriefingNudgeExperimentState["NUDGE"] = "nudge";
    BriefingNudgeExperimentState["NUDGE_AUTOPLAY"] = "nudge_autoplay";
    return BriefingNudgeExperimentState;
}({});
const $27a67c702eae1a5a$export$df5bf03825b93c3d = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled, isAtlassianHostedLLMOnlyEnabled: isAtlassianHostedLLMOnlyEnabled } = (0, $bQm3c.useSessionData)();
    // Deferred: MediaSource is unavailable during SSR
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setAudioSupportedByBrowser(typeof MediaSource !== 'undefined' && MediaSource.isTypeSupported('audio/mpeg'));
    }, []);
    const { isAIPolicyEnabled: isAIPolicyEnabled, isAudioV3EnabledForPolicy: isAudioV3EnabledForPolicy, isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled } = (0, $cozmU.useMemo)(()=>{
        const aiPolicyEnabled = !isAtlassianHostedLLMOnlyEnabled && isAdminHubAIEnabled && isAIEarlyAccessEnabled;
        const audioV3EnabledForPolicy = aiPolicyEnabled && (0, $6mKj3.isExperimentEnabled)('confluence_audio_v3');
        return {
            isAIPolicyEnabled: aiPolicyEnabled,
            isAudioV3EnabledForPolicy: audioV3EnabledForPolicy,
            // Keep byline visibility stable through SSR and hydration. ListenByline checks browser
            // support after hydration and disables its trigger when audio playback is unsupported.
            isAudioBylineEntrypointEnabled: audioV3EnabledForPolicy
        };
    }, [
        isAdminHubAIEnabled,
        isAIEarlyAccessEnabled,
        isAtlassianHostedLLMOnlyEnabled
    ]);
    const isAudioV3Enabled = isAudioV3EnabledForPolicy && audioSupportedByBrowser;
    const audioBriefingNudgeExperimentState = (0, $cozmU.useMemo)(()=>{
        if (!isAudioV3Enabled) return "control";
        if ((0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge')) return "nudge";
        else if ((0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge_autoplay')) return "nudge_autoplay";
        else return "control";
    }, [
        isAudioV3Enabled
    ]);
    return {
        isAIPolicyAndBrowserSupportEnabled: isAIPolicyEnabled && audioSupportedByBrowser,
        isAudioV3Enabled: isAudioV3Enabled,
        isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled,
        audioBriefingNudgeExperimentState: audioBriefingNudgeExperimentState
    };
};
module.exports["BriefingNudgeExperimentState"] = $27a67c702eae1a5a$export$419c8aa8913e9327;
module.exports["useAudioFeatureFlags"] = $27a67c702eae1a5a$export$df5bf03825b93c3d;

});

parcelRegister("qaY7H", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $tgs13 = parcelRequire("tgs13");


var $4hf0X = parcelRequire("4hf0X");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $cLo2u = parcelRequire("cLo2u");


var $AXitC = parcelRequire("AXitC");

const $2d4afef340cfe0b2$var$getIsPageUpdatedOlderThan365Days = (lastModifiedDate)=>{
    const getPageUpdatedInSeconds = (lastModifiedRaw)=>{
        const lastModifiedDate = new Date(lastModifiedRaw);
        return (Date.now() - lastModifiedDate.getTime()) / 1000;
    };
    return getPageUpdatedInSeconds(lastModifiedDate) > (0, $tgs13.THREE_HUNDRED_SIXTY_FIVE_DAYS_IN_SECONDS);
};
const $2d4afef340cfe0b2$var$AutomationDiscoveryMessageInner = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { shouldUseAutomationDiscovery: shouldUseAutomationDiscovery } = t0;
    const { status: status, lastAction: t1, type: type } = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    const { when: when } = t1;
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    let t2;
    if ($[0] !== shouldUseAutomationDiscovery || $[1] !== status || $[2] !== type || $[3] !== when) {
        t2 = shouldUseAutomationDiscovery && type === "page" && status !== "draft" && $2d4afef340cfe0b2$var$getIsPageUpdatedOlderThan365Days(when);
        $[0] = shouldUseAutomationDiscovery;
        $[1] = status;
        $[2] = type;
        $[3] = when;
        $[4] = t2;
    } else t2 = $[4];
    const shouldRender = t2;
    let t3;
    if ($[5] !== shouldRender || $[6] !== spaceKey) {
        t3 = shouldRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hf0X.LazyAutomationDiscoveryHoverPageTitleMessage), {
            spaceKey: spaceKey
        });
        $[5] = shouldRender;
        $[6] = spaceKey;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3);
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
};
const $2d4afef340cfe0b2$export$162d8a771575bc85 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).AUTOMATION_FOR_CONFLUENCE
})($2d4afef340cfe0b2$var$AutomationDiscoveryMessageInner);
module.exports["AutomationDiscoveryMessage"] = $2d4afef340cfe0b2$export$162d8a771575bc85;

});

parcelRegister("4hf0X", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0831fbd07aa65085$export$24022e96df95ff7e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "IH0no",
    name: "LazyAutomationDiscoveryHoverPageTitleMessage",
    loader: async ()=>(await (parcelRequire("5BMSy"))).AutomationDiscoveryHoverPageTitleMessage
});
module.exports["LazyAutomationDiscoveryHoverPageTitleMessage"] = $0831fbd07aa65085$export$24022e96df95ff7e;

});

parcelRegister("5BMSy", function(module, exports) {

let $415652cc5994f21b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $415652cc5994f21b$var$load("hhss7"),
    $415652cc5994f21b$var$load("1NKZf")
]).then(()=>parcelRequire('byS2e'));

});

parcelRegister("1R1bQ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $c8bBH = parcelRequire("c8bBH");


var $eDtFr = parcelRequire("eDtFr");


var $kz1Yj = parcelRequire("kz1Yj");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");


var $AXitC = parcelRequire("AXitC");

const $0e708e5e8b7bc139$var$i18n = (0, $kSwu1.defineMessages)({
    likes: {
        id: "page-card.social.likes",
        defaultMessage: "likes"
    },
    comments: {
        id: "page-card.social.comments",
        defaultMessage: "comments"
    }
});
const $0e708e5e8b7bc139$var$socialProofContainerStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtlest'
});
const $0e708e5e8b7bc139$var$countStyles = (0, $buxP3.xcss)({
    font: 'font.body.small',
    marginLeft: 'space.025',
    fontWeight: 'font.weight.regular'
});
const $0e708e5e8b7bc139$export$d0fb2e88e6204069 = ()=>{
    const $ = (0, $bDgLe.c)(9);
    const { likesCount: likesCount, commentsCount: commentsCount } = (0, $cozmU.useContext)((0, $AXitC.PageCardContext));
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== intl || $[1] !== likesCount) {
        t0 = likesCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            alignItems: "center",
            columnGap: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
            label: intl.formatMessage($0e708e5e8b7bc139$var$i18n.likes)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            xcss: $0e708e5e8b7bc139$var$countStyles
        }, likesCount)) : null;
        $[0] = intl;
        $[1] = likesCount;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== commentsCount || $[4] !== intl) {
        t1 = commentsCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            alignItems: "center",
            columnGap: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
            label: intl.formatMessage($0e708e5e8b7bc139$var$i18n.comments)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            xcss: $0e708e5e8b7bc139$var$countStyles
        }, commentsCount)) : null;
        $[3] = commentsCount;
        $[4] = intl;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== t0 || $[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            alignItems: "center",
            xcss: $0e708e5e8b7bc139$var$socialProofContainerStyles,
            columnGap: "space.150"
        }, t0, t1);
        $[6] = t0;
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
};
module.exports["SocialProof"] = $0e708e5e8b7bc139$export$d0fb2e88e6204069;

});

parcelRegister("bnSPF", function(module, exports) {
const $76e54e1c758c6257$var$CARD_NODE_TYPES = new Set([
    'inlineCard',
    'blockCard',
    'embedCard'
]);
function $76e54e1c758c6257$export$17ea34445ac2b9ee(doc, includeLinkMarks = false) {
    if (!doc) return [];
    const countByUrl = new Map();
    const addUrl = (url)=>{
        if (typeof url === 'string' && url) countByUrl.set(url, (countByUrl.get(url) ?? 0) + 1);
    };
    function walk(node) {
        if ($76e54e1c758c6257$var$CARD_NODE_TYPES.has(node.type)) addUrl(node.attrs?.url);
        if (includeLinkMarks) addUrl(node.marks?.find((mark)=>mark?.type === 'link')?.attrs?.href);
        if (Array.isArray(node.content)) node.content.forEach(walk);
    }
    walk(doc);
    return Array.from(countByUrl, ([url, count], occurrenceIndex)=>({
            url: url,
            occurrenceIndex: occurrenceIndex,
            count: count
        }));
}
module.exports["extractSmartLinksFromAdf"] = $76e54e1c758c6257$export$17ea34445ac2b9ee;

});

parcelRegister("5J49L", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kDhla = parcelRequire("kDhla");


var $8WQTF = parcelRequire("8WQTF");

const $6b155e8150ddb3e3$var$EMPTY_PAGE_ADF = {
    adf: null,
    contentId: undefined
};
function $6b155e8150ddb3e3$export$bac928e80dac4527(contentId) {
    const { pageAdf: rendererPageAdf, pageId: rendererContentId } = (0, $8WQTF.useRendererActions)();
    const { fullPageEditorPresetAPI: fullPageEditorPresetAPI } = (0, $kDhla.useFullPageEditorApiState)();
    const [editorPageAdf, setEditorPageAdf] = (0, $cozmU.useState)($6b155e8150ddb3e3$var$EMPTY_PAGE_ADF);
    const hasCurrentRendererAdf = Boolean(rendererPageAdf && rendererContentId && (!contentId || rendererContentId === contentId));
    (0, $cozmU.useEffect)(()=>{
        if (hasCurrentRendererAdf || !fullPageEditorPresetAPI || !contentId) return;
        let active = true;
        fullPageEditorPresetAPI.core.actions.requestDocument((doc)=>{
            if (active && doc) setEditorPageAdf({
                adf: doc,
                contentId: contentId
            });
        }, {
            alwaysFire: true
        });
        return ()=>{
            active = false;
        };
    }, [
        contentId,
        fullPageEditorPresetAPI,
        hasCurrentRendererAdf
    ]);
    if (hasCurrentRendererAdf && rendererPageAdf && rendererContentId) return {
        adf: rendererPageAdf,
        contentId: rendererContentId
    };
    return !contentId || editorPageAdf.contentId === contentId ? editorPageAdf : $6b155e8150ddb3e3$var$EMPTY_PAGE_ADF;
}
module.exports["usePageAdf"] = $6b155e8150ddb3e3$export$bac928e80dac4527;

});

parcelRegister("6oZiN", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $jhwJP = parcelRequire("jhwJP");

const $fd94ae0dd1a4bd51$var$i18nBase = (0, $kSwu1.defineMessages)({
    title: {
        id: "page-recommendations.eop.title",
        defaultMessage: "Related content"
    },
    feedback: {
        id: "page-recommendations.eop.feedback.button",
        defaultMessage: "Give feedback"
    },
    info: {
        id: "page-recommendations.eop.feedback.info",
        defaultMessage: "These suggestions are automatically generated based on content that is viewed or organized together. Suggestions update over time and respect content restrictions."
    },
    hide: {
        id: "page-recommendations.eop.feedback.hide",
        defaultMessage: "Hide for everyone..."
    },
    modal_title: {
        id: "page-recommendations.eop.hide.modal.title",
        defaultMessage: "Hide related content for <b>everyone</b>?"
    },
    modal_cancel: {
        id: "page-recommendations.eop.hide.modal.cancel",
        defaultMessage: "Cancel"
    },
    modal_hide: {
        id: "page-recommendations.eop.hide.modal.hide.button",
        defaultMessage: "Hide for everyone"
    },
    modal_info: {
        id: "page-recommendations.eop.hide.modal.info",
        defaultMessage: "Suggestions for this content will be hidden from everyone."
    },
    modal_info_show: {
        id: "page-recommendations.eop.hide.modal.info.show",
        defaultMessage: "You can show related content again under advanced details."
    },
    space_setting_info: {
        id: "page-recommendations.eop.space.setting.info",
        defaultMessage: "Related content automatically generates suggestions based on content viewed or organized together. These will appear as a series of cards at the bottom of some pages, and may update over time."
    },
    space_setting_hide_toggle: {
        id: "page-recommendations.eop.space.setting.hide.toggle",
        defaultMessage: "Related content"
    },
    space_setting_default: {
        id: "page-recommendations.eop.space.setting.default",
        defaultMessage: "Default behavior"
    },
    space_setting_hidden: {
        id: "page-recommendations.eop.space.setting.default.hidden",
        defaultMessage: "Hidden on each page"
    },
    space_setting_shown: {
        id: "page-recommendations.eop.space.setting.default.shown",
        defaultMessage: "Shown on each page"
    },
    feedbackMessage: {
        id: "page-recommendations.related.pages.space.settings.feedback.section",
        defaultMessage: "What do you think of related content?"
    },
    feedbackButtonText: {
        id: "page-recommendations.related.pages.space.settings.feedback.button.text",
        defaultMessage: "Give feedback"
    },
    feedbackTitle: {
        id: "page-recommendations.feedback.title.v2",
        defaultMessage: "Thank you for trying out related content"
    },
    feedbackDescription: {
        id: "page-recommendations.feedback.description",
        defaultMessage: "How satisfied are you with related content?"
    },
    feedbackFollowup: {
        id: "page-recommendations.feedback.followup",
        defaultMessage: "Thanks for the feedback! What do you like about it? What could be improved?"
    },
    feedbackSecondFollowup: {
        id: "page-recommendations.feedback.followup.second",
        defaultMessage: "Any feedback on related content for this specific item?"
    },
    feedbackConfirmation: {
        id: "page-recommendations.feedback.confirmation",
        defaultMessage: "Feedback submitted"
    },
    feedbackConfirmationDescription: {
        id: "page-recommendations.feedback.confirmation.description.v2",
        defaultMessage: "Thank you for helping us improve related content!"
    },
    feedbackSubmit: {
        id: "page-recommendations.feedback.submit",
        defaultMessage: "Submit"
    },
    feedbackCancel: {
        id: "page-recommendations.feedback.cancel",
        defaultMessage: "Cancel"
    },
    terrible: {
        id: "page-recommendations.feedback.rating.terrible",
        defaultMessage: "terrible"
    },
    bad: {
        id: "page-recommendations.feedback.rating.bad",
        defaultMessage: "bad"
    },
    okay: {
        id: "page-recommendations.feedback.rating.okay",
        defaultMessage: "okay"
    },
    good: {
        id: "page-recommendations.feedback.rating.good",
        defaultMessage: "good"
    },
    great: {
        id: "page-recommendations.feedback.rating.great",
        defaultMessage: "great"
    },
    expandButton: {
        id: "page-recommendations.eop.expand.button",
        defaultMessage: "Expand"
    },
    collapseButton: {
        id: "page-recommendations.eop.collapse.button",
        defaultMessage: "Collapse"
    },
    infoButton: {
        id: "page-recommendations.eop.info",
        defaultMessage: "More info"
    },
    adminConfigFeedbackTitle: {
        id: "page-recommendations.admin-config.feedback.title",
        defaultMessage: "Help us improve Confluence"
    },
    adminConfigFeedbackSummaryPlaceholder: {
        id: "page-recommendations.admin-config.feedback.summary.placeholder",
        defaultMessage: "What did we do well? What could be improved?"
    }
});
const $fd94ae0dd1a4bd51$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    space_setting_hidden: {
        id: "page-recommendations.eop.space.setting.default.hidden.livedocs",
        defaultMessage: "Hidden on each page or live doc"
    },
    space_setting_shown: {
        id: "page-recommendations.eop.space.setting.default.shown.livedocs",
        defaultMessage: "Shown on each page or live doc"
    }
});
const $fd94ae0dd1a4bd51$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($fd94ae0dd1a4bd51$var$i18nBase, $fd94ae0dd1a4bd51$var$i18nLiveDocs);
module.exports["i18n"] = $fd94ae0dd1a4bd51$export$a7357cdd1f0b0168;

});

parcelRegister("lOxqc", function(module, exports) {

var $cxMI6 = parcelRequire("cxMI6");

const $550abe5a694aeafb$export$45bb2daf3af483ad = 'TWG';
const $550abe5a694aeafb$var$contentIdOf = (node)=>node.pageId ?? node.blogPostId ?? undefined;
const $550abe5a694aeafb$var$AUTHORITY_SCORE_RANK = {
    VERY_HIGH: 3,
    HIGH: 2,
    MEDIUM: 1,
    LOW: 0
};
const $550abe5a694aeafb$var$DEFAULT_AUTHORITY_SCORE = 'LOW';
// RETURN column names from `buildTwgRecsCypher`.
const $550abe5a694aeafb$var$ENTITY_COLUMN_KEY = 'entity';
const $550abe5a694aeafb$var$AUTHORITY_COLUMN_KEY = 'auth';
// Score is the last segment of the auth node's ARI (`.../authority-score/MEDIUM`);
// missing/unrecognised falls back to LOW so ranking is always defined.
const $550abe5a694aeafb$var$parseAuthorityScore = (authAri)=>{
    const score = authAri?.split('/').pop()?.toUpperCase();
    return score && score in $550abe5a694aeafb$var$AUTHORITY_SCORE_RANK ? score : $550abe5a694aeafb$var$DEFAULT_AUTHORITY_SCORE;
};
// Content statuses that cc-smarts would never recommend. We filter these out of the
// TWG results so treatment doesn't surface drafts/archived/trashed/etc. that control
// can't (the graph traversal isn't status-filtered, unlike the cc-smarts backend).
const $550abe5a694aeafb$var$NON_CURRENT_STATUSES = new Set([
    'archived',
    'deleted',
    'draft',
    'historical',
    'trashed'
]);
// Keep CURRENT and unknown/absent status (ConfluenceBlogPost.status is nullable and may
// not hydrate), dropping only definitively non-current content. Lenient on purpose so a
// blog whose status doesn't resolve isn't silently dropped.
const $550abe5a694aeafb$var$isCurrentContent = (node)=>{
    const status = node.pageStatus ?? node.blogPostStatus;
    return !status || !$550abe5a694aeafb$var$NON_CURRENT_STATUSES.has(String(status).toLowerCase());
};
const $550abe5a694aeafb$export$7440bc9de8627a49 = (data)=>{
    const seen = new Set();
    const nodes = [];
    // Each edge is one row; iterate per-row so the `entity` and `auth` columns stay paired.
    const edges = data?.graphStore_cypherQueryV2?.edges ?? [];
    for (const edge of edges){
        let node;
        let authorityScore = $550abe5a694aeafb$var$DEFAULT_AUTHORITY_SCORE;
        // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity -- bounded by RETURN column count
        for (const column of edge?.node?.columns ?? []){
            if (column?.key === $550abe5a694aeafb$var$AUTHORITY_COLUMN_KEY) authorityScore = $550abe5a694aeafb$var$parseAuthorityScore(column?.value?.id);
            else if (column?.key === $550abe5a694aeafb$var$ENTITY_COLUMN_KEY) // Relay's multi-fragment union type doesn't allow direct field access.
            node = column?.value?.data;
        }
        const contentId = node ? $550abe5a694aeafb$var$contentIdOf(node) : undefined;
        if (node && contentId && $550abe5a694aeafb$var$isCurrentContent(node) && !seen.has(contentId)) {
            seen.add(contentId);
            nodes.push({
                ...node,
                authorityScore: authorityScore
            });
        }
    }
    // Stable sort (ES2019+): equal-score nodes keep their traversal order.
    return [
        ...nodes
    ].sort((a, b)=>$550abe5a694aeafb$var$AUTHORITY_SCORE_RANK[b.authorityScore] - $550abe5a694aeafb$var$AUTHORITY_SCORE_RANK[a.authorityScore]);
};
// Map an AGG content node onto the `content` shape transformGlobalContent expects.
// Renames: webUi->webui, subtype->subType, owner.user.name->displayName,
// owner.user.accountId->creatorId, properties->emoji.nodes. `type` is derived from
// which id is present (the AGG enum is `PAGE`/`BLOG_POST`, which wouldn't match the
// card's lower-case, no-underscore content types and would render the wrong icon).
const $550abe5a694aeafb$var$toGlobalContentShape = (node)=>{
    const status = node.pageStatus ?? node.blogPostStatus;
    return {
        id: $550abe5a694aeafb$var$contentIdOf(node) ?? '',
        title: node.title ?? '',
        type: node.blogPostId ? 'blogpost' : 'page',
        subType: node.subtype ?? undefined,
        status: status ? String(status).toLowerCase() : undefined,
        links: {
            webui: node.links?.webUi ?? ''
        },
        space: {
            id: node.space?.id ?? '',
            key: node.space?.key ?? '',
            alias: node.space?.alias ?? '',
            name: node.space?.name ?? ''
        },
        creatorId: node.owner?.user?.accountId ?? '',
        history: {
            ownedBy: {
                displayName: node.owner?.user?.name ?? ''
            }
        },
        emoji: {
            nodes: node.properties ?? []
        }
    };
};
const $550abe5a694aeafb$export$a7ad6e153f92c731 = (data)=>{
    return $550abe5a694aeafb$export$7440bc9de8627a49(data).map((node)=>{
        const card = (0, $cxMI6.transformGlobalContent)($550abe5a694aeafb$var$toGlobalContentShape(node));
        // Parity with the cc-smarts transformer: zero these + stamp a strategy.
        card.likesCount = 0;
        card.commentsCount = 0;
        card.recommendationStrategy = $550abe5a694aeafb$export$45bb2daf3af483ad;
        return card;
    });
};
module.exports["TWG_STRATEGY"] = $550abe5a694aeafb$export$45bb2daf3af483ad;
module.exports["transformTwgRecs"] = $550abe5a694aeafb$export$a7ad6e153f92c731;

});

parcelRegister("jc6xl", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $2rapj = parcelRequire("2rapj");


var $lOxqc = parcelRequire("lOxqc");


var $ky8L5 = parcelRequire("ky8L5");

const $362c0e733b0222dd$export$7018f964cac4cdb1 = (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { entityId: entityId, entityType: entityType, spaceKey: spaceKey, skip: t1 } = t0;
    const skip = t1 === undefined ? false : t1;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t2;
    if ($[0] !== cloudId || $[1] !== entityId || $[2] !== entityType || $[3] !== skip) {
        t2 = skip || !(0, $ky8L5.isTwgSupportedContentType)(entityType) || !cloudId || !entityId;
        $[0] = cloudId;
        $[1] = entityId;
        $[2] = entityType;
        $[3] = skip;
        $[4] = t2;
    } else t2 = $[4];
    const shouldSkip = t2;
    let t3;
    if ($[5] !== cloudId || $[6] !== entityId || $[7] !== entityType || $[8] !== shouldSkip) {
        t3 = shouldSkip ? "" : (0, $ky8L5.buildTwgRecsCypher)((0, $ky8L5.buildTwgContentAri)(cloudId, entityId, entityType));
        $[5] = cloudId;
        $[6] = entityId;
        $[7] = entityType;
        $[8] = shouldSkip;
        $[9] = t3;
    } else t3 = $[9];
    const cypherQuery = t3;
    let t4;
    if ($[10] !== cypherQuery || $[11] !== spaceKey) {
        t4 = {
            cypherQuery: cypherQuery,
            first: (0, $ky8L5.MAX_TWG_RECS),
            key: spaceKey,
            keyString: spaceKey
        };
        $[10] = cypherQuery;
        $[11] = spaceKey;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== cloudId || $[14] !== shouldSkip) {
        t5 = shouldSkip ? undefined : {
            headers: {
                "X-Query-Context": (0, $ky8L5.buildTwgQueryContext)(cloudId)
            }
        };
        $[13] = cloudId;
        $[14] = shouldSkip;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== shouldSkip || $[17] !== t4 || $[18] !== t5) {
        t6 = {
            variables: t4,
            interopApolloAggClient: true,
            context: t5,
            errorPolicy: "all",
            fetchPolicy: "cache-first",
            skip: shouldSkip
        };
        $[16] = shouldSkip;
        $[17] = t4;
        $[18] = t5;
        $[19] = t6;
    } else t6 = $[19];
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $2rapj.default), {
        ...t6,
        __callerPackage__: "page-recommendations"
    });
    let t7;
    if ($[20] !== data) {
        t7 = (0, $lOxqc.transformTwgRecs)(data);
        $[20] = data;
        $[21] = t7;
    } else t7 = $[21];
    const pageCardData = t7;
    const isEnabled = Boolean(data?.getRecommendedPagesSpaceStatus?.recommendedPagesEnabled && data?.getRecommendedPagesSpaceStatus?.defaultBehavior === "SHOWN");
    const t8 = data?.space?.id ?? undefined;
    let t9;
    if ($[22] !== error || $[23] !== isEnabled || $[24] !== loading || $[25] !== pageCardData || $[26] !== shouldSkip || $[27] !== t8) {
        t9 = {
            pageCardData: pageCardData,
            spaceId: t8,
            isEnabled: isEnabled,
            loading: loading,
            error: error,
            skip: shouldSkip
        };
        $[22] = error;
        $[23] = isEnabled;
        $[24] = loading;
        $[25] = pageCardData;
        $[26] = shouldSkip;
        $[27] = t8;
        $[28] = t9;
    } else t9 = $[28];
    return t9;
};
module.exports["useTwgRecommendationData"] = $362c0e733b0222dd$export$7018f964cac4cdb1;

});


//# sourceMappingURL=EndOfPageRecommendation.056b2d97.js.map
